// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23052c65%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
* Bootstrap  v5.3.1 (https://getbootstrap.com/)
* Copyright 2011-2023 The Bootstrap Authors
* Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
*/
:root, [data-bs-theme=light] {
  --bs-blue:#0d6efd;
  --bs-indigo:#6610f2;
  --bs-purple:#6f42c1;
  --bs-pink:#d63384;
  --bs-red:#dc3545;
  --bs-orange:#fd7e14;
  --bs-yellow:#ffc107;
  --bs-green:#198754;
  --bs-teal:#20c997;
  --bs-cyan:#0dcaf0;
  --bs-black:#000;
  --bs-white:#fff;
  --bs-gray:#6c757d;
  --bs-gray-dark:#343a40;
  --bs-gray-100:#f8f9fa;
  --bs-gray-200:#e9ecef;
  --bs-gray-300:#dee2e6;
  --bs-gray-400:#ced4da;
  --bs-gray-500:#adb5bd;
  --bs-gray-600:#6c757d;
  --bs-gray-700:#495057;
  --bs-gray-800:#343a40;
  --bs-gray-900:#212529;
  --bs-primary:#0d6efd;
  --bs-secondary:#6c757d;
  --bs-success:#198754;
  --bs-info:#0dcaf0;
  --bs-warning:#ffc107;
  --bs-danger:#dc3545;
  --bs-light:#f8f9fa;
  --bs-dark:#212529;
  --bs-primary-rgb:13,110,253;
  --bs-secondary-rgb:108,117,125;
  --bs-success-rgb:25,135,84;
  --bs-info-rgb:13,202,240;
  --bs-warning-rgb:255,193,7;
  --bs-danger-rgb:220,53,69;
  --bs-light-rgb:248,249,250;
  --bs-dark-rgb:33,37,41;
  --bs-primary-text-emphasis:#052c65;
  --bs-secondary-text-emphasis:#2b2f32;
  --bs-success-text-emphasis:#0a3622;
  --bs-info-text-emphasis:#055160;
  --bs-warning-text-emphasis:#664d03;
  --bs-danger-text-emphasis:#58151c;
  --bs-light-text-emphasis:#495057;
  --bs-dark-text-emphasis:#495057;
  --bs-primary-bg-subtle:#cfe2ff;
  --bs-secondary-bg-subtle:#e2e3e5;
  --bs-success-bg-subtle:#d1e7dd;
  --bs-info-bg-subtle:#cff4fc;
  --bs-warning-bg-subtle:#fff3cd;
  --bs-danger-bg-subtle:#f8d7da;
  --bs-light-bg-subtle:#fcfcfd;
  --bs-dark-bg-subtle:#ced4da;
  --bs-primary-border-subtle:#9ec5fe;
  --bs-secondary-border-subtle:#c4c8cb;
  --bs-success-border-subtle:#a3cfbb;
  --bs-info-border-subtle:#9eeaf9;
  --bs-warning-border-subtle:#ffe69c;
  --bs-danger-border-subtle:#f1aeb5;
  --bs-light-border-subtle:#e9ecef;
  --bs-dark-border-subtle:#adb5bd;
  --bs-white-rgb:255,255,255;
  --bs-black-rgb:0,0,0;
  --bs-font-sans-serif:system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  --bs-gradient:linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family:var(--bs-font-sans-serif);
  --bs-body-font-size:1rem;
  --bs-body-font-weight:400;
  --bs-body-line-height:1.5;
  --bs-body-color:#212529;
  --bs-body-color-rgb:33,37,41;
  --bs-body-bg:#fff;
  --bs-body-bg-rgb:255,255,255;
  --bs-emphasis-color:#000;
  --bs-emphasis-color-rgb:0,0,0;
  --bs-secondary-color:rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb:33,37,41;
  --bs-secondary-bg:#e9ecef;
  --bs-secondary-bg-rgb:233,236,239;
  --bs-tertiary-color:rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb:33,37,41;
  --bs-tertiary-bg:#f8f9fa;
  --bs-tertiary-bg-rgb:248,249,250;
  --bs-heading-color:inherit;
  --bs-link-color:#0d6efd;
  --bs-link-color-rgb:13,110,253;
  --bs-link-decoration:underline;
  --bs-link-hover-color:#0a58ca;
  --bs-link-hover-color-rgb:10,88,202;
  --bs-code-color:#d63384;
  --bs-highlight-bg:#fff3cd;
  --bs-border-width:1px;
  --bs-border-style:solid;
  --bs-border-color:#dee2e6;
  --bs-border-color-translucent:rgba(0, 0, 0, 0.175);
  --bs-border-radius:0.375rem;
  --bs-border-radius-sm:0.25rem;
  --bs-border-radius-lg:0.5rem;
  --bs-border-radius-xl:1rem;
  --bs-border-radius-xxl:2rem;
  --bs-border-radius-2xl:var(--bs-border-radius-xxl);
  --bs-border-radius-pill:50rem;
  --bs-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg:0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset:inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width:0.25rem;
  --bs-focus-ring-opacity:0.25;
  --bs-focus-ring-color:rgba(13, 110, 253, 0.25);
  --bs-form-valid-color:#198754;
  --bs-form-valid-border-color:#198754;
  --bs-form-invalid-color:#dc3545;
  --bs-form-invalid-border-color:#dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color:#dee2e6;
  --bs-body-color-rgb:222,226,230;
  --bs-body-bg:#212529;
  --bs-body-bg-rgb:33,37,41;
  --bs-emphasis-color:#fff;
  --bs-emphasis-color-rgb:255,255,255;
  --bs-secondary-color:rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb:222,226,230;
  --bs-secondary-bg:#343a40;
  --bs-secondary-bg-rgb:52,58,64;
  --bs-tertiary-color:rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb:222,226,230;
  --bs-tertiary-bg:#2b3035;
  --bs-tertiary-bg-rgb:43,48,53;
  --bs-primary-text-emphasis:#6ea8fe;
  --bs-secondary-text-emphasis:#a7acb1;
  --bs-success-text-emphasis:#75b798;
  --bs-info-text-emphasis:#6edff6;
  --bs-warning-text-emphasis:#ffda6a;
  --bs-danger-text-emphasis:#ea868f;
  --bs-light-text-emphasis:#f8f9fa;
  --bs-dark-text-emphasis:#dee2e6;
  --bs-primary-bg-subtle:#031633;
  --bs-secondary-bg-subtle:#161719;
  --bs-success-bg-subtle:#051b11;
  --bs-info-bg-subtle:#032830;
  --bs-warning-bg-subtle:#332701;
  --bs-danger-bg-subtle:#2c0b0e;
  --bs-light-bg-subtle:#343a40;
  --bs-dark-bg-subtle:#1a1d20;
  --bs-primary-border-subtle:#084298;
  --bs-secondary-border-subtle:#41464b;
  --bs-success-border-subtle:#0f5132;
  --bs-info-border-subtle:#087990;
  --bs-warning-border-subtle:#997404;
  --bs-danger-border-subtle:#842029;
  --bs-light-border-subtle:#495057;
  --bs-dark-border-subtle:#343a40;
  --bs-heading-color:inherit;
  --bs-link-color:#6ea8fe;
  --bs-link-hover-color:#8bb9fe;
  --bs-link-color-rgb:110,168,254;
  --bs-link-hover-color-rgb:139,185,254;
  --bs-code-color:#e685b5;
  --bs-border-color:#495057;
  --bs-border-color-translucent:rgba(255, 255, 255, 0.15);
  --bs-form-valid-color:#75b798;
  --bs-form-valid-border-color:#75b798;
  --bs-form-invalid-color:#ea868f;
  --bs-form-invalid-border-color:#ea868f;
}

*, ::after, ::before {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}
body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

.h1, h1 {
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  .h1, h1 {
    font-size: 2.5rem;
  }
}
.h2, h2 {
  font-size: calc(1.325rem + 0.9vw);
}

@media (min-width: 1200px) {
  .h2, h2 {
    font-size: 2rem;
  }
}
.h3, h3 {
  font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {
  .h3, h3 {
    font-size: 1.75rem;
  }
}
.h4, h4 {
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  .h4, h4 {
    font-size: 1.5rem;
  }
}
.h5, h5 {
  font-size: 1.25rem;
}

.h6, h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol, ul {
  padding-left: 2rem;
}

dl, ol, ul {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol, ol ul, ul ol, ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b, strong {
  font-weight: bolder;
}

.small, small {
  font-size: 0.875em;
}

.mark, mark {
  padding: 0.1875em;
  background-color: var(--bs-highlight-bg);
}

sub, sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}

a:hover {
  --bs-link-color-rgb:var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

code, kbd, pre, samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img, svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

tbody, td, tfoot, th, thead, tr {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

button, input, optgroup, select, textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button, select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

[type=button], [type=reset], [type=submit], button {
  -webkit-appearance: button;
}

[type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-fields-wrapper, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-text, ::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container, .container-fluid, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
  --bs-gutter-x:1.5rem;
  --bs-gutter-y:0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container, .container-md, .container-sm {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container, .container-lg, .container-md, .container-sm {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs:0;
  --bs-breakpoint-sm:576px;
  --bs-breakpoint-md:768px;
  --bs-breakpoint-lg:992px;
  --bs-breakpoint-xl:1200px;
  --bs-breakpoint-xxl:1400px;
}

.row {
  --bs-gutter-x:1.5rem;
  --bs-gutter-y:0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0, .gx-0 {
  --bs-gutter-x:0;
}

.g-0, .gy-0 {
  --bs-gutter-y:0;
}

.g-1, .gx-1 {
  --bs-gutter-x:0.25rem;
}

.g-1, .gy-1 {
  --bs-gutter-y:0.25rem;
}

.g-2, .gx-2 {
  --bs-gutter-x:0.5rem;
}

.g-2, .gy-2 {
  --bs-gutter-y:0.5rem;
}

.g-3, .gx-3 {
  --bs-gutter-x:1rem;
}

.g-3, .gy-3 {
  --bs-gutter-y:1rem;
}

.g-4, .gx-4 {
  --bs-gutter-x:1.5rem;
}

.g-4, .gy-4 {
  --bs-gutter-y:1.5rem;
}

.g-5, .gx-5 {
  --bs-gutter-x:3rem;
}

.g-5, .gy-5 {
  --bs-gutter-y:3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0, .gx-sm-0 {
    --bs-gutter-x:0;
  }
  .g-sm-0, .gy-sm-0 {
    --bs-gutter-y:0;
  }
  .g-sm-1, .gx-sm-1 {
    --bs-gutter-x:0.25rem;
  }
  .g-sm-1, .gy-sm-1 {
    --bs-gutter-y:0.25rem;
  }
  .g-sm-2, .gx-sm-2 {
    --bs-gutter-x:0.5rem;
  }
  .g-sm-2, .gy-sm-2 {
    --bs-gutter-y:0.5rem;
  }
  .g-sm-3, .gx-sm-3 {
    --bs-gutter-x:1rem;
  }
  .g-sm-3, .gy-sm-3 {
    --bs-gutter-y:1rem;
  }
  .g-sm-4, .gx-sm-4 {
    --bs-gutter-x:1.5rem;
  }
  .g-sm-4, .gy-sm-4 {
    --bs-gutter-y:1.5rem;
  }
  .g-sm-5, .gx-sm-5 {
    --bs-gutter-x:3rem;
  }
  .g-sm-5, .gy-sm-5 {
    --bs-gutter-y:3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0, .gx-md-0 {
    --bs-gutter-x:0;
  }
  .g-md-0, .gy-md-0 {
    --bs-gutter-y:0;
  }
  .g-md-1, .gx-md-1 {
    --bs-gutter-x:0.25rem;
  }
  .g-md-1, .gy-md-1 {
    --bs-gutter-y:0.25rem;
  }
  .g-md-2, .gx-md-2 {
    --bs-gutter-x:0.5rem;
  }
  .g-md-2, .gy-md-2 {
    --bs-gutter-y:0.5rem;
  }
  .g-md-3, .gx-md-3 {
    --bs-gutter-x:1rem;
  }
  .g-md-3, .gy-md-3 {
    --bs-gutter-y:1rem;
  }
  .g-md-4, .gx-md-4 {
    --bs-gutter-x:1.5rem;
  }
  .g-md-4, .gy-md-4 {
    --bs-gutter-y:1.5rem;
  }
  .g-md-5, .gx-md-5 {
    --bs-gutter-x:3rem;
  }
  .g-md-5, .gy-md-5 {
    --bs-gutter-y:3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0, .gx-lg-0 {
    --bs-gutter-x:0;
  }
  .g-lg-0, .gy-lg-0 {
    --bs-gutter-y:0;
  }
  .g-lg-1, .gx-lg-1 {
    --bs-gutter-x:0.25rem;
  }
  .g-lg-1, .gy-lg-1 {
    --bs-gutter-y:0.25rem;
  }
  .g-lg-2, .gx-lg-2 {
    --bs-gutter-x:0.5rem;
  }
  .g-lg-2, .gy-lg-2 {
    --bs-gutter-y:0.5rem;
  }
  .g-lg-3, .gx-lg-3 {
    --bs-gutter-x:1rem;
  }
  .g-lg-3, .gy-lg-3 {
    --bs-gutter-y:1rem;
  }
  .g-lg-4, .gx-lg-4 {
    --bs-gutter-x:1.5rem;
  }
  .g-lg-4, .gy-lg-4 {
    --bs-gutter-y:1.5rem;
  }
  .g-lg-5, .gx-lg-5 {
    --bs-gutter-x:3rem;
  }
  .g-lg-5, .gy-lg-5 {
    --bs-gutter-y:3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0, .gx-xl-0 {
    --bs-gutter-x:0;
  }
  .g-xl-0, .gy-xl-0 {
    --bs-gutter-y:0;
  }
  .g-xl-1, .gx-xl-1 {
    --bs-gutter-x:0.25rem;
  }
  .g-xl-1, .gy-xl-1 {
    --bs-gutter-y:0.25rem;
  }
  .g-xl-2, .gx-xl-2 {
    --bs-gutter-x:0.5rem;
  }
  .g-xl-2, .gy-xl-2 {
    --bs-gutter-y:0.5rem;
  }
  .g-xl-3, .gx-xl-3 {
    --bs-gutter-x:1rem;
  }
  .g-xl-3, .gy-xl-3 {
    --bs-gutter-y:1rem;
  }
  .g-xl-4, .gx-xl-4 {
    --bs-gutter-x:1.5rem;
  }
  .g-xl-4, .gy-xl-4 {
    --bs-gutter-y:1.5rem;
  }
  .g-xl-5, .gx-xl-5 {
    --bs-gutter-x:3rem;
  }
  .g-xl-5, .gy-xl-5 {
    --bs-gutter-y:3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0, .gx-xxl-0 {
    --bs-gutter-x:0;
  }
  .g-xxl-0, .gy-xxl-0 {
    --bs-gutter-y:0;
  }
  .g-xxl-1, .gx-xxl-1 {
    --bs-gutter-x:0.25rem;
  }
  .g-xxl-1, .gy-xxl-1 {
    --bs-gutter-y:0.25rem;
  }
  .g-xxl-2, .gx-xxl-2 {
    --bs-gutter-x:0.5rem;
  }
  .g-xxl-2, .gy-xxl-2 {
    --bs-gutter-y:0.5rem;
  }
  .g-xxl-3, .gx-xxl-3 {
    --bs-gutter-x:1rem;
  }
  .g-xxl-3, .gy-xxl-3 {
    --bs-gutter-y:1rem;
  }
  .g-xxl-4, .gx-xxl-4 {
    --bs-gutter-x:1.5rem;
  }
  .g-xxl-4, .gy-xxl-4 {
    --bs-gutter-y:1.5rem;
  }
  .g-xxl-5, .gx-xxl-5 {
    --bs-gutter-x:3rem;
  }
  .g-xxl-5, .gy-xxl-5 {
    --bs-gutter-y:3rem;
  }
}
.table {
  --bs-table-color-type:initial;
  --bs-table-bg-type:initial;
  --bs-table-color-state:initial;
  --bs-table-bg-state:initial;
  --bs-table-color:var(--bs-body-color);
  --bs-table-bg:var(--bs-body-bg);
  --bs-table-border-color:var(--bs-border-color);
  --bs-table-accent-bg:transparent;
  --bs-table-striped-color:var(--bs-body-color);
  --bs-table-striped-bg:rgba(0, 0, 0, 0.05);
  --bs-table-active-color:var(--bs-body-color);
  --bs-table-active-bg:rgba(0, 0, 0, 0.1);
  --bs-table-hover-color:var(--bs-body-color);
  --bs-table-hover-bg:rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type:var(--bs-table-striped-color);
  --bs-table-bg-type:var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(2n) {
  --bs-table-color-type:var(--bs-table-striped-color);
  --bs-table-bg-type:var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state:var(--bs-table-active-color);
  --bs-table-bg-state:var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state:var(--bs-table-hover-color);
  --bs-table-bg-state:var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color:#000;
  --bs-table-bg:#cfe2ff;
  --bs-table-border-color:#bacbe6;
  --bs-table-striped-bg:#c5d7f2;
  --bs-table-striped-color:#000;
  --bs-table-active-bg:#bacbe6;
  --bs-table-active-color:#000;
  --bs-table-hover-bg:#bfd1ec;
  --bs-table-hover-color:#000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color:#000;
  --bs-table-bg:#e2e3e5;
  --bs-table-border-color:#cbccce;
  --bs-table-striped-bg:#d7d8da;
  --bs-table-striped-color:#000;
  --bs-table-active-bg:#cbccce;
  --bs-table-active-color:#000;
  --bs-table-hover-bg:#d1d2d4;
  --bs-table-hover-color:#000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color:#000;
  --bs-table-bg:#d1e7dd;
  --bs-table-border-color:#bcd0c7;
  --bs-table-striped-bg:#c7dbd2;
  --bs-table-striped-color:#000;
  --bs-table-active-bg:#bcd0c7;
  --bs-table-active-color:#000;
  --bs-table-hover-bg:#c1d6cc;
  --bs-table-hover-color:#000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color:#000;
  --bs-table-bg:#cff4fc;
  --bs-table-border-color:#badce3;
  --bs-table-striped-bg:#c5e8ef;
  --bs-table-striped-color:#000;
  --bs-table-active-bg:#badce3;
  --bs-table-active-color:#000;
  --bs-table-hover-bg:#bfe2e9;
  --bs-table-hover-color:#000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color:#000;
  --bs-table-bg:#fff3cd;
  --bs-table-border-color:#e6dbb9;
  --bs-table-striped-bg:#f2e7c3;
  --bs-table-striped-color:#000;
  --bs-table-active-bg:#e6dbb9;
  --bs-table-active-color:#000;
  --bs-table-hover-bg:#ece1be;
  --bs-table-hover-color:#000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color:#000;
  --bs-table-bg:#f8d7da;
  --bs-table-border-color:#dfc2c4;
  --bs-table-striped-bg:#eccccf;
  --bs-table-striped-color:#000;
  --bs-table-active-bg:#dfc2c4;
  --bs-table-active-color:#000;
  --bs-table-hover-bg:#e5c7ca;
  --bs-table-hover-color:#000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color:#000;
  --bs-table-bg:#f8f9fa;
  --bs-table-border-color:#dfe0e1;
  --bs-table-striped-bg:#ecedee;
  --bs-table-striped-color:#000;
  --bs-table-active-bg:#dfe0e1;
  --bs-table-active-color:#000;
  --bs-table-hover-bg:#e5e6e7;
  --bs-table-hover-color:#000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color:#fff;
  --bs-table-bg:#212529;
  --bs-table-border-color:#373b3e;
  --bs-table-striped-bg:#2c3034;
  --bs-table-striped-color:#fff;
  --bs-table-active-bg:#373b3e;
  --bs-table-active-color:#fff;
  --bs-table-hover-bg:#323539;
  --bs-table-hover-color:#fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}

.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}

.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-lg, .form-control-plaintext.form-control-sm {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + var(--bs-border-width) * 2);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + var(--bs-border-width) * 2);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + var(--bs-border-width) * 2);
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + var(--bs-border-width) * 2);
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + var(--bs-border-width) * 2);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + var(--bs-border-width) * 2);
  padding: 0.375rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + var(--bs-border-width) * 2);
}

.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + var(--bs-border-width) * 2);
}

.form-select {
  --bs-form-select-bg-img:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}

.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}

.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg:var(--bs-body-bg);
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image:url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image:url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image:url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input:disabled ~ .form-check-label, .form-check-input[disabled] ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  --bs-form-switch-bg:url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg:url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg:url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}

.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check:disabled + .btn, .btn-check[disabled] + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg:url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}

.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}

.form-floating > .form-control, .form-floating > .form-control-plaintext, .form-floating > .form-select {
  height: calc(3.5rem + var(--bs-border-width) * 2);
  min-height: calc(3.5rem + var(--bs-border-width) * 2);
  line-height: 1.25;
}

.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control, .form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}

.form-floating > .form-control-plaintext::placeholder, .form-floating > .form-control::placeholder {
  color: transparent;
}

.form-floating > .form-control-plaintext:focus, .form-floating > .form-control-plaintext:not(:placeholder-shown), .form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control-plaintext:-webkit-autofill, .form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control-plaintext ~ label, .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}

.form-floating > .form-control:disabled ~ label, .form-floating > :disabled ~ label {
  color: #6c757d;
}

.form-floating > .form-control:disabled ~ label::after, .form-floating > :disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control, .input-group > .form-floating, .input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus, .input-group > .form-floating:focus-within, .input-group > .form-select:focus {
  z-index: 5;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .btn, .input-group-lg > .form-control, .input-group-lg > .form-select, .input-group-lg > .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .btn, .input-group-sm > .form-control, .input-group-sm > .form-select, .input-group-sm > .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select, .input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3), .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select, .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4), .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control, .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select, .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .form-floating:not(:first-child) > .form-control, .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.is-valid ~ .valid-feedback, .is-valid ~ .valid-tooltip, .was-validated :valid ~ .valid-feedback, .was-validated :valid ~ .valid-tooltip {
  display: block;
}

.form-control.is-valid, .was-validated .form-control:valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-control.is-valid:focus, .was-validated .form-control:valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.form-select.is-valid, .was-validated .form-select:valid {
  border-color: var(--bs-form-valid-border-color);
}

.form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"], .was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon:url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-select.is-valid:focus, .was-validated .form-select:valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.form-control-color.is-valid, .was-validated .form-control-color:valid {
  width: calc(3rem + 1.5em + 0.75rem);
}

.form-check-input.is-valid, .was-validated .form-check-input:valid {
  border-color: var(--bs-form-valid-border-color);
}

.form-check-input.is-valid:checked, .was-validated .form-check-input:valid:checked {
  background-color: var(--bs-form-valid-color);
}

.form-check-input.is-valid:focus, .was-validated .form-check-input:valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.form-check-input.is-valid ~ .form-check-label, .was-validated .form-check-input:valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.input-group > .form-control:not(:focus).is-valid, .input-group > .form-floating:not(:focus-within).is-valid, .input-group > .form-select:not(:focus).is-valid, .was-validated .input-group > .form-control:not(:focus):valid, .was-validated .input-group > .form-floating:not(:focus-within):valid, .was-validated .input-group > .form-select:not(:focus):valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.is-invalid ~ .invalid-feedback, .is-invalid ~ .invalid-tooltip, .was-validated :invalid ~ .invalid-feedback, .was-validated :invalid ~ .invalid-tooltip {
  display: block;
}

.form-control.is-invalid, .was-validated .form-control:invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-control.is-invalid:focus, .was-validated .form-control:invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.form-select.is-invalid, .was-validated .form-select:invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"], .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon:url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-select.is-invalid:focus, .was-validated .form-select:invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.form-control-color.is-invalid, .was-validated .form-control-color:invalid {
  width: calc(3rem + 1.5em + 0.75rem);
}

.form-check-input.is-invalid, .was-validated .form-check-input:invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.form-check-input.is-invalid:checked, .was-validated .form-check-input:invalid:checked {
  background-color: var(--bs-form-invalid-color);
}

.form-check-input.is-invalid:focus, .was-validated .form-check-input:invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.form-check-input.is-invalid ~ .form-check-label, .was-validated .form-check-input:invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.input-group > .form-control:not(:focus).is-invalid, .input-group > .form-floating:not(:focus-within).is-invalid, .input-group > .form-select:not(:focus).is-invalid, .was-validated .input-group > .form-control:not(:focus):invalid, .was-validated .input-group > .form-floating:not(:focus-within):invalid, .was-validated .input-group > .form-select:not(:focus):invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x:0.75rem;
  --bs-btn-padding-y:0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size:1rem;
  --bs-btn-font-weight:400;
  --bs-btn-line-height:1.5;
  --bs-btn-color:var(--bs-body-color);
  --bs-btn-bg:transparent;
  --bs-btn-border-width:var(--bs-border-width);
  --bs-btn-border-color:transparent;
  --bs-btn-border-radius:var(--bs-border-radius);
  --bs-btn-hover-border-color:transparent;
  --bs-btn-box-shadow:inset 0 1px 0 rgba(255, 255, 255, 0.15),0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity:0.65;
  --bs-btn-focus-box-shadow:0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}

.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}

.btn-check:checked + .btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check) + .btn:active:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color:#fff;
  --bs-btn-bg:#0d6efd;
  --bs-btn-border-color:#0d6efd;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#0b5ed7;
  --bs-btn-hover-border-color:#0a58ca;
  --bs-btn-focus-shadow-rgb:49,132,253;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#0a58ca;
  --bs-btn-active-border-color:#0a53be;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#fff;
  --bs-btn-disabled-bg:#0d6efd;
  --bs-btn-disabled-border-color:#0d6efd;
}

.btn-secondary {
  --bs-btn-color:#fff;
  --bs-btn-bg:#6c757d;
  --bs-btn-border-color:#6c757d;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#5c636a;
  --bs-btn-hover-border-color:#565e64;
  --bs-btn-focus-shadow-rgb:130,138,145;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#565e64;
  --bs-btn-active-border-color:#51585e;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#fff;
  --bs-btn-disabled-bg:#6c757d;
  --bs-btn-disabled-border-color:#6c757d;
}

.btn-success {
  --bs-btn-color:#fff;
  --bs-btn-bg:#198754;
  --bs-btn-border-color:#198754;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#157347;
  --bs-btn-hover-border-color:#146c43;
  --bs-btn-focus-shadow-rgb:60,153,110;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#146c43;
  --bs-btn-active-border-color:#13653f;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#fff;
  --bs-btn-disabled-bg:#198754;
  --bs-btn-disabled-border-color:#198754;
}

.btn-info {
  --bs-btn-color:#000;
  --bs-btn-bg:#0dcaf0;
  --bs-btn-border-color:#0dcaf0;
  --bs-btn-hover-color:#000;
  --bs-btn-hover-bg:#31d2f2;
  --bs-btn-hover-border-color:#25cff2;
  --bs-btn-focus-shadow-rgb:11,172,204;
  --bs-btn-active-color:#000;
  --bs-btn-active-bg:#3dd5f3;
  --bs-btn-active-border-color:#25cff2;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#000;
  --bs-btn-disabled-bg:#0dcaf0;
  --bs-btn-disabled-border-color:#0dcaf0;
}

.btn-warning {
  --bs-btn-color:#000;
  --bs-btn-bg:#ffc107;
  --bs-btn-border-color:#ffc107;
  --bs-btn-hover-color:#000;
  --bs-btn-hover-bg:#ffca2c;
  --bs-btn-hover-border-color:#ffc720;
  --bs-btn-focus-shadow-rgb:217,164,6;
  --bs-btn-active-color:#000;
  --bs-btn-active-bg:#ffcd39;
  --bs-btn-active-border-color:#ffc720;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#000;
  --bs-btn-disabled-bg:#ffc107;
  --bs-btn-disabled-border-color:#ffc107;
}

.btn-danger {
  --bs-btn-color:#fff;
  --bs-btn-bg:#dc3545;
  --bs-btn-border-color:#dc3545;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#bb2d3b;
  --bs-btn-hover-border-color:#b02a37;
  --bs-btn-focus-shadow-rgb:225,83,97;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#b02a37;
  --bs-btn-active-border-color:#a52834;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#fff;
  --bs-btn-disabled-bg:#dc3545;
  --bs-btn-disabled-border-color:#dc3545;
}

.btn-light {
  --bs-btn-color:#000;
  --bs-btn-bg:#f8f9fa;
  --bs-btn-border-color:#f8f9fa;
  --bs-btn-hover-color:#000;
  --bs-btn-hover-bg:#d3d4d5;
  --bs-btn-hover-border-color:#c6c7c8;
  --bs-btn-focus-shadow-rgb:211,212,213;
  --bs-btn-active-color:#000;
  --bs-btn-active-bg:#c6c7c8;
  --bs-btn-active-border-color:#babbbc;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#000;
  --bs-btn-disabled-bg:#f8f9fa;
  --bs-btn-disabled-border-color:#f8f9fa;
}

.btn-dark {
  --bs-btn-color:#fff;
  --bs-btn-bg:#212529;
  --bs-btn-border-color:#212529;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#424649;
  --bs-btn-hover-border-color:#373b3e;
  --bs-btn-focus-shadow-rgb:66,70,73;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#4d5154;
  --bs-btn-active-border-color:#373b3e;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#fff;
  --bs-btn-disabled-bg:#212529;
  --bs-btn-disabled-border-color:#212529;
}

.btn-outline-primary {
  --bs-btn-color:#0d6efd;
  --bs-btn-border-color:#0d6efd;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#0d6efd;
  --bs-btn-hover-border-color:#0d6efd;
  --bs-btn-focus-shadow-rgb:13,110,253;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#0d6efd;
  --bs-btn-active-border-color:#0d6efd;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#0d6efd;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#0d6efd;
  --bs-gradient:none;
}

.btn-outline-secondary {
  --bs-btn-color:#6c757d;
  --bs-btn-border-color:#6c757d;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#6c757d;
  --bs-btn-hover-border-color:#6c757d;
  --bs-btn-focus-shadow-rgb:108,117,125;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#6c757d;
  --bs-btn-active-border-color:#6c757d;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#6c757d;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#6c757d;
  --bs-gradient:none;
}

.btn-outline-success {
  --bs-btn-color:#198754;
  --bs-btn-border-color:#198754;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#198754;
  --bs-btn-hover-border-color:#198754;
  --bs-btn-focus-shadow-rgb:25,135,84;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#198754;
  --bs-btn-active-border-color:#198754;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#198754;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#198754;
  --bs-gradient:none;
}

.btn-outline-info {
  --bs-btn-color:#0dcaf0;
  --bs-btn-border-color:#0dcaf0;
  --bs-btn-hover-color:#000;
  --bs-btn-hover-bg:#0dcaf0;
  --bs-btn-hover-border-color:#0dcaf0;
  --bs-btn-focus-shadow-rgb:13,202,240;
  --bs-btn-active-color:#000;
  --bs-btn-active-bg:#0dcaf0;
  --bs-btn-active-border-color:#0dcaf0;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#0dcaf0;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#0dcaf0;
  --bs-gradient:none;
}

.btn-outline-warning {
  --bs-btn-color:#ffc107;
  --bs-btn-border-color:#ffc107;
  --bs-btn-hover-color:#000;
  --bs-btn-hover-bg:#ffc107;
  --bs-btn-hover-border-color:#ffc107;
  --bs-btn-focus-shadow-rgb:255,193,7;
  --bs-btn-active-color:#000;
  --bs-btn-active-bg:#ffc107;
  --bs-btn-active-border-color:#ffc107;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#ffc107;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#ffc107;
  --bs-gradient:none;
}

.btn-outline-danger {
  --bs-btn-color:#dc3545;
  --bs-btn-border-color:#dc3545;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#dc3545;
  --bs-btn-hover-border-color:#dc3545;
  --bs-btn-focus-shadow-rgb:220,53,69;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#dc3545;
  --bs-btn-active-border-color:#dc3545;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#dc3545;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#dc3545;
  --bs-gradient:none;
}

.btn-outline-light {
  --bs-btn-color:#f8f9fa;
  --bs-btn-border-color:#f8f9fa;
  --bs-btn-hover-color:#000;
  --bs-btn-hover-bg:#f8f9fa;
  --bs-btn-hover-border-color:#f8f9fa;
  --bs-btn-focus-shadow-rgb:248,249,250;
  --bs-btn-active-color:#000;
  --bs-btn-active-bg:#f8f9fa;
  --bs-btn-active-border-color:#f8f9fa;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#f8f9fa;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#f8f9fa;
  --bs-gradient:none;
}

.btn-outline-dark {
  --bs-btn-color:#212529;
  --bs-btn-border-color:#212529;
  --bs-btn-hover-color:#fff;
  --bs-btn-hover-bg:#212529;
  --bs-btn-hover-border-color:#212529;
  --bs-btn-focus-shadow-rgb:33,37,41;
  --bs-btn-active-color:#fff;
  --bs-btn-active-bg:#212529;
  --bs-btn-active-border-color:#212529;
  --bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#212529;
  --bs-btn-disabled-bg:transparent;
  --bs-btn-disabled-border-color:#212529;
  --bs-gradient:none;
}

.btn-link {
  --bs-btn-font-weight:400;
  --bs-btn-color:var(--bs-link-color);
  --bs-btn-bg:transparent;
  --bs-btn-border-color:transparent;
  --bs-btn-hover-color:var(--bs-link-hover-color);
  --bs-btn-hover-border-color:transparent;
  --bs-btn-active-color:var(--bs-link-hover-color);
  --bs-btn-active-border-color:transparent;
  --bs-btn-disabled-color:#6c757d;
  --bs-btn-disabled-border-color:transparent;
  --bs-btn-box-shadow:0 0 0 #000;
  --bs-btn-focus-shadow-rgb:49,132,253;
  text-decoration: underline;
}

.btn-link:focus-visible {
  color: var(--bs-btn-color);
}

.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-group-lg > .btn, .btn-lg {
  --bs-btn-padding-y:0.5rem;
  --bs-btn-padding-x:1rem;
  --bs-btn-font-size:1.25rem;
  --bs-btn-border-radius:var(--bs-border-radius-lg);
}

.btn-group-sm > .btn, .btn-sm {
  --bs-btn-padding-y:0.25rem;
  --bs-btn-padding-x:0.5rem;
  --bs-btn-font-size:0.875rem;
  --bs-btn-border-radius:var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}
.dropdown, .dropdown-center, .dropend, .dropstart, .dropup, .dropup-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex:1000;
  --bs-dropdown-min-width:10rem;
  --bs-dropdown-padding-x:0;
  --bs-dropdown-padding-y:0.5rem;
  --bs-dropdown-spacer:0.125rem;
  --bs-dropdown-font-size:1rem;
  --bs-dropdown-color:var(--bs-body-color);
  --bs-dropdown-bg:var(--bs-body-bg);
  --bs-dropdown-border-color:var(--bs-border-color-translucent);
  --bs-dropdown-border-radius:var(--bs-border-radius);
  --bs-dropdown-border-width:var(--bs-border-width);
  --bs-dropdown-inner-border-radius:calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg:var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y:0.5rem;
  --bs-dropdown-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-dropdown-link-color:var(--bs-body-color);
  --bs-dropdown-link-hover-color:var(--bs-body-color);
  --bs-dropdown-link-hover-bg:var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color:#fff;
  --bs-dropdown-link-active-bg:#0d6efd;
  --bs-dropdown-link-disabled-color:var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x:1rem;
  --bs-dropdown-item-padding-y:0.25rem;
  --bs-dropdown-header-color:#6c757d;
  --bs-dropdown-header-padding-x:1rem;
  --bs-dropdown-header-padding-y:0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position:start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position:end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position:start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position:end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position:start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position:end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position:start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position:end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position:start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position:end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position:start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position:end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}

.dropdown-item:focus, .dropdown-item:hover {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color:#dee2e6;
  --bs-dropdown-bg:#343a40;
  --bs-dropdown-border-color:var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color:#dee2e6;
  --bs-dropdown-link-hover-color:#fff;
  --bs-dropdown-divider-bg:var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg:rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color:#fff;
  --bs-dropdown-link-active-bg:#0d6efd;
  --bs-dropdown-link-disabled-color:#adb5bd;
  --bs-dropdown-header-color:#adb5bd;
}

.btn-group, .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group-vertical > .btn, .btn-group > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group-vertical > .btn-check:checked + .btn, .btn-group-vertical > .btn-check:focus + .btn, .btn-group-vertical > .btn.active, .btn-group-vertical > .btn:active, .btn-group-vertical > .btn:focus, .btn-group-vertical > .btn:hover, .btn-group > .btn-check:checked + .btn, .btn-group > .btn-check:focus + .btn, .btn-group > .btn.active, .btn-group > .btn:active, .btn-group > .btn:focus, .btn-group > .btn:hover {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}

.btn-group > .btn-group:not(:first-child), .btn-group > :not(.btn-check:first-child) + .btn {
  margin-left: calc(var(--bs-border-width) * -1);
}

.btn-group > .btn-group:not(:last-child) > .btn, .btn-group > .btn.dropdown-toggle-split:first-child, .btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:not(:first-child) > .btn, .btn-group > .btn:nth-child(n+3), .btn-group > :not(.btn-check) + .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-group-sm > .btn + .dropdown-toggle-split, .btn-sm + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-group-lg > .btn + .dropdown-toggle-split, .btn-lg + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn, .btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn-group:not(:first-child), .btn-group-vertical > .btn:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}

.btn-group-vertical > .btn-group:not(:last-child) > .btn, .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn-group:not(:first-child) > .btn, .btn-group-vertical > .btn ~ .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x:1rem;
  --bs-nav-link-padding-y:0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color:var(--bs-link-color);
  --bs-nav-link-hover-color:var(--bs-link-hover-color);
  --bs-nav-link-disabled-color:var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: 0 0;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:focus, .nav-link:hover {
  color: var(--bs-nav-link-hover-color);
}

.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width:var(--bs-border-width);
  --bs-nav-tabs-border-color:var(--bs-border-color);
  --bs-nav-tabs-border-radius:var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color:var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color:var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg:var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color:var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius:var(--bs-border-radius);
  --bs-nav-pills-link-active-color:#fff;
  --bs-nav-pills-link-active-bg:#0d6efd;
}

.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap:1rem;
  --bs-nav-underline-border-width:0.125rem;
  --bs-nav-underline-link-active-color:var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}

.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}

.nav-underline .nav-link:focus, .nav-underline .nav-link:hover {
  border-bottom-color: currentcolor;
}

.nav-underline .nav-link.active, .nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill .nav-item, .nav-fill > .nav-link {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item, .nav-justified > .nav-link {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link, .nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x:0;
  --bs-navbar-padding-y:0.5rem;
  --bs-navbar-color:rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color:rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color:rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color:rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y:0.3125rem;
  --bs-navbar-brand-margin-end:1rem;
  --bs-navbar-brand-font-size:1.25rem;
  --bs-navbar-brand-color:rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color:rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x:0.5rem;
  --bs-navbar-toggler-padding-y:0.25rem;
  --bs-navbar-toggler-padding-x:0.75rem;
  --bs-navbar-toggler-font-size:1.25rem;
  --bs-navbar-toggler-icon-bg:url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color:rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius:var(--bs-border-radius);
  --bs-navbar-toggler-focus-width:0.25rem;
  --bs-navbar-toggler-transition:box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar > .container, .navbar > .container-fluid, .navbar > .container-lg, .navbar > .container-md, .navbar > .container-sm, .navbar > .container-xl, .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

.navbar-brand:focus, .navbar-brand:hover {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x:0;
  --bs-nav-link-padding-y:0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color:var(--bs-navbar-color);
  --bs-nav-link-hover-color:var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color:var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}

.navbar-text a, .navbar-text a:focus, .navbar-text a:hover {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark, .navbar[data-bs-theme=dark] {
  --bs-navbar-color:rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color:rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color:rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color:#fff;
  --bs-navbar-brand-color:#fff;
  --bs-navbar-brand-hover-color:#fff;
  --bs-navbar-toggler-border-color:rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg:url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg:url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y:1rem;
  --bs-card-spacer-x:1rem;
  --bs-card-title-spacer-y:0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width:var(--bs-border-width);
  --bs-card-border-color:var(--bs-border-color-translucent);
  --bs-card-border-radius:var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y:0.5rem;
  --bs-card-cap-padding-x:1rem;
  --bs-card-cap-bg:rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg:var(--bs-body-bg);
  --bs-card-img-overlay-padding:1rem;
  --bs-card-group-margin:0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card > .card-header + .list-group, .card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img, .card-img-bottom, .card-img-top {
  width: 100%;
}

.card-img, .card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img, .card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-header, .card-group > .card:not(:last-child) .card-img-top {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-footer, .card-group > .card:not(:last-child) .card-img-bottom {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-header, .card-group > .card:not(:first-child) .card-img-top {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-footer, .card-group > .card:not(:first-child) .card-img-bottom {
    border-bottom-left-radius: 0;
  }
}
.accordion {
  --bs-accordion-color:var(--bs-body-color);
  --bs-accordion-bg:var(--bs-body-bg);
  --bs-accordion-transition:color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,border-radius 0.15s ease;
  --bs-accordion-border-color:var(--bs-border-color);
  --bs-accordion-border-width:var(--bs-border-width);
  --bs-accordion-border-radius:var(--bs-border-radius);
  --bs-accordion-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x:1.25rem;
  --bs-accordion-btn-padding-y:1rem;
  --bs-accordion-btn-color:var(--bs-body-color);
  --bs-accordion-btn-bg:var(--bs-accordion-bg);
  --bs-accordion-btn-icon:url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width:1.25rem;
  --bs-accordion-btn-icon-transform:rotate(-180deg);
  --bs-accordion-btn-icon-transition:transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon:url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-border-color:#86b7fe;
  --bs-accordion-btn-focus-box-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x:1.25rem;
  --bs-accordion-body-padding-y:1rem;
  --bs-accordion-active-color:var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg:var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon:url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon:url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x:0;
  --bs-breadcrumb-padding-y:0;
  --bs-breadcrumb-margin-bottom:1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color:var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x:0.5rem;
  --bs-breadcrumb-item-active-color:var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/");
}

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x:0.75rem;
  --bs-pagination-padding-y:0.375rem;
  --bs-pagination-font-size:1rem;
  --bs-pagination-color:var(--bs-link-color);
  --bs-pagination-bg:var(--bs-body-bg);
  --bs-pagination-border-width:var(--bs-border-width);
  --bs-pagination-border-color:var(--bs-border-color);
  --bs-pagination-border-radius:var(--bs-border-radius);
  --bs-pagination-hover-color:var(--bs-link-hover-color);
  --bs-pagination-hover-bg:var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color:var(--bs-border-color);
  --bs-pagination-focus-color:var(--bs-link-hover-color);
  --bs-pagination-focus-bg:var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color:#fff;
  --bs-pagination-active-bg:#0d6efd;
  --bs-pagination-active-border-color:#0d6efd;
  --bs-pagination-disabled-color:var(--bs-secondary-color);
  --bs-pagination-disabled-bg:var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color:var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}

.active > .page-link, .page-link.active {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}

.disabled > .page-link, .page-link.disabled {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x:1.5rem;
  --bs-pagination-padding-y:0.75rem;
  --bs-pagination-font-size:1.25rem;
  --bs-pagination-border-radius:var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x:0.5rem;
  --bs-pagination-padding-y:0.25rem;
  --bs-pagination-font-size:0.875rem;
  --bs-pagination-border-radius:var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x:0.65em;
  --bs-badge-padding-y:0.35em;
  --bs-badge-font-size:0.75em;
  --bs-badge-font-weight:700;
  --bs-badge-color:#fff;
  --bs-badge-border-radius:var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg:transparent;
  --bs-alert-padding-x:1rem;
  --bs-alert-padding-y:1rem;
  --bs-alert-margin-bottom:1rem;
  --bs-alert-color:inherit;
  --bs-alert-border-color:transparent;
  --bs-alert-border:var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius:var(--bs-border-radius);
  --bs-alert-link-color:inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color:var(--bs-primary-text-emphasis);
  --bs-alert-bg:var(--bs-primary-bg-subtle);
  --bs-alert-border-color:var(--bs-primary-border-subtle);
  --bs-alert-link-color:var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color:var(--bs-secondary-text-emphasis);
  --bs-alert-bg:var(--bs-secondary-bg-subtle);
  --bs-alert-border-color:var(--bs-secondary-border-subtle);
  --bs-alert-link-color:var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color:var(--bs-success-text-emphasis);
  --bs-alert-bg:var(--bs-success-bg-subtle);
  --bs-alert-border-color:var(--bs-success-border-subtle);
  --bs-alert-link-color:var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color:var(--bs-info-text-emphasis);
  --bs-alert-bg:var(--bs-info-bg-subtle);
  --bs-alert-border-color:var(--bs-info-border-subtle);
  --bs-alert-link-color:var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color:var(--bs-warning-text-emphasis);
  --bs-alert-bg:var(--bs-warning-bg-subtle);
  --bs-alert-border-color:var(--bs-warning-border-subtle);
  --bs-alert-link-color:var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color:var(--bs-danger-text-emphasis);
  --bs-alert-bg:var(--bs-danger-bg-subtle);
  --bs-alert-border-color:var(--bs-danger-border-subtle);
  --bs-alert-link-color:var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color:var(--bs-light-text-emphasis);
  --bs-alert-bg:var(--bs-light-bg-subtle);
  --bs-alert-border-color:var(--bs-light-border-subtle);
  --bs-alert-link-color:var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color:var(--bs-dark-text-emphasis);
  --bs-alert-bg:var(--bs-dark-bg-subtle);
  --bs-alert-border-color:var(--bs-dark-border-subtle);
  --bs-alert-link-color:var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress, .progress-stacked {
  --bs-progress-height:1rem;
  --bs-progress-font-size:0.75rem;
  --bs-progress-bg:var(--bs-secondary-bg);
  --bs-progress-border-radius:var(--bs-border-radius);
  --bs-progress-box-shadow:var(--bs-box-shadow-inset);
  --bs-progress-bar-color:#fff;
  --bs-progress-bar-bg:#0d6efd;
  --bs-progress-bar-transition:width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}
.list-group {
  --bs-list-group-color:var(--bs-body-color);
  --bs-list-group-bg:var(--bs-body-bg);
  --bs-list-group-border-color:var(--bs-border-color);
  --bs-list-group-border-width:var(--bs-border-width);
  --bs-list-group-border-radius:var(--bs-border-radius);
  --bs-list-group-item-padding-x:1rem;
  --bs-list-group-item-padding-y:0.5rem;
  --bs-list-group-action-color:var(--bs-secondary-color);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-tertiary-bg);
  --bs-list-group-action-active-color:var(--bs-body-color);
  --bs-list-group-action-active-bg:var(--bs-secondary-bg);
  --bs-list-group-disabled-color:var(--bs-secondary-color);
  --bs-list-group-disabled-bg:var(--bs-body-bg);
  --bs-list-group-active-color:#fff;
  --bs-list-group-active-bg:#0d6efd;
  --bs-list-group-active-border-color:#0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:focus, .list-group-item-action:hover {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color:var(--bs-primary-text-emphasis);
  --bs-list-group-bg:var(--bs-primary-bg-subtle);
  --bs-list-group-border-color:var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-primary-border-subtle);
  --bs-list-group-active-color:var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg:var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color:var(--bs-secondary-text-emphasis);
  --bs-list-group-bg:var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color:var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-secondary-border-subtle);
  --bs-list-group-active-color:var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg:var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color:var(--bs-success-text-emphasis);
  --bs-list-group-bg:var(--bs-success-bg-subtle);
  --bs-list-group-border-color:var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-success-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-success-border-subtle);
  --bs-list-group-active-color:var(--bs-success-bg-subtle);
  --bs-list-group-active-bg:var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color:var(--bs-info-text-emphasis);
  --bs-list-group-bg:var(--bs-info-bg-subtle);
  --bs-list-group-border-color:var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-info-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-info-border-subtle);
  --bs-list-group-active-color:var(--bs-info-bg-subtle);
  --bs-list-group-active-bg:var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color:var(--bs-warning-text-emphasis);
  --bs-list-group-bg:var(--bs-warning-bg-subtle);
  --bs-list-group-border-color:var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-warning-border-subtle);
  --bs-list-group-active-color:var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg:var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color:var(--bs-danger-text-emphasis);
  --bs-list-group-bg:var(--bs-danger-bg-subtle);
  --bs-list-group-border-color:var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-danger-border-subtle);
  --bs-list-group-active-color:var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg:var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color:var(--bs-light-text-emphasis);
  --bs-list-group-bg:var(--bs-light-bg-subtle);
  --bs-list-group-border-color:var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-light-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-light-border-subtle);
  --bs-list-group-active-color:var(--bs-light-bg-subtle);
  --bs-list-group-active-bg:var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color:var(--bs-dark-text-emphasis);
  --bs-list-group-bg:var(--bs-dark-bg-subtle);
  --bs-list-group-border-color:var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color:var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg:var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color:var(--bs-emphasis-color);
  --bs-list-group-action-active-bg:var(--bs-dark-border-subtle);
  --bs-list-group-active-color:var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg:var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color:var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color:#000;
  --bs-btn-close-bg:url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity:0.5;
  --bs-btn-close-hover-opacity:0.75;
  --bs-btn-close-focus-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity:1;
  --bs-btn-close-disabled-opacity:0.25;
  --bs-btn-close-white-filter:invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close.disabled, .btn-close:disabled {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex:1090;
  --bs-toast-padding-x:0.75rem;
  --bs-toast-padding-y:0.5rem;
  --bs-toast-spacing:1.5rem;
  --bs-toast-max-width:350px;
  --bs-toast-font-size:0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg:rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width:var(--bs-border-width);
  --bs-toast-border-color:var(--bs-border-color-translucent);
  --bs-toast-border-radius:var(--bs-border-radius);
  --bs-toast-box-shadow:var(--bs-box-shadow);
  --bs-toast-header-color:var(--bs-secondary-color);
  --bs-toast-header-bg:rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color:var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex:1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex:1055;
  --bs-modal-width:500px;
  --bs-modal-padding:1rem;
  --bs-modal-margin:0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg:var(--bs-body-bg);
  --bs-modal-border-color:var(--bs-border-color-translucent);
  --bs-modal-border-width:var(--bs-border-width);
  --bs-modal-border-radius:var(--bs-border-radius-lg);
  --bs-modal-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius:calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x:1rem;
  --bs-modal-header-padding-y:1rem;
  --bs-modal-header-padding:1rem 1rem;
  --bs-modal-header-border-color:var(--bs-border-color);
  --bs-modal-header-border-width:var(--bs-border-width);
  --bs-modal-title-line-height:1.5;
  --bs-modal-footer-gap:0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color:var(--bs-border-color);
  --bs-modal-footer-border-width:var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex:1050;
  --bs-backdrop-bg:#000;
  --bs-backdrop-opacity:0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin:1.75rem;
    --bs-modal-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width:300px;
  }
}
@media (min-width: 992px) {
  .modal-lg, .modal-xl {
    --bs-modal-width:800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width:1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-footer, .modal-fullscreen .modal-header {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-footer, .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-footer, .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-footer, .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-footer, .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-footer, .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex:1080;
  --bs-tooltip-max-width:200px;
  --bs-tooltip-padding-x:0.5rem;
  --bs-tooltip-padding-y:0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size:0.875rem;
  --bs-tooltip-color:var(--bs-body-bg);
  --bs-tooltip-bg:var(--bs-emphasis-color);
  --bs-tooltip-border-radius:var(--bs-border-radius);
  --bs-tooltip-opacity:0.9;
  --bs-tooltip-arrow-width:0.8rem;
  --bs-tooltip-arrow-height:0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow, .bs-tooltip-top .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .bs-tooltip-top .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow, .bs-tooltip-end .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .bs-tooltip-end .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow, .bs-tooltip-bottom .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .bs-tooltip-bottom .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow, .bs-tooltip-start .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .bs-tooltip-start .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex:1070;
  --bs-popover-max-width:276px;
  --bs-popover-font-size:0.875rem;
  --bs-popover-bg:var(--bs-body-bg);
  --bs-popover-border-width:var(--bs-border-width);
  --bs-popover-border-color:var(--bs-border-color-translucent);
  --bs-popover-border-radius:var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius:calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-popover-header-padding-x:1rem;
  --bs-popover-header-padding-y:0.5rem;
  --bs-popover-header-font-size:1rem;
  --bs-popover-header-color:inherit;
  --bs-popover-header-bg:var(--bs-secondary-bg);
  --bs-popover-body-padding-x:1rem;
  --bs-popover-body-padding-y:1rem;
  --bs-popover-body-color:var(--bs-body-color);
  --bs-popover-arrow-width:1rem;
  --bs-popover-arrow-height:0.5rem;
  --bs-popover-arrow-border:var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}

.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::after, .popover .popover-arrow::before {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow, .bs-popover-top > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-top > .popover-arrow::before {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .bs-popover-top > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow, .bs-popover-end > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-end > .popover-arrow::before {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .bs-popover-end > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow, .bs-popover-bottom > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-bottom > .popover-arrow::before {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .bs-popover-bottom > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .bs-popover-bottom .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow, .bs-popover-start > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-start > .popover-arrow::before {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .bs-popover-start > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item-next, .carousel-item-prev, .carousel-item.active {
  display: block;
}

.active.carousel-item-end, .carousel-item-next:not(.carousel-item-start) {
  transform: translateX(100%);
}

.active.carousel-item-start, .carousel-item-prev:not(.carousel-item-end) {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item-next.carousel-item-start, .carousel-fade .carousel-item-prev.carousel-item-end, .carousel-fade .carousel-item.active {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-end, .carousel-fade .active.carousel-item-start {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-end, .carousel-fade .active.carousel-item-start {
    transition: none;
  }
}
.carousel-control-next, .carousel-control-prev {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: 0 0;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-next, .carousel-control-prev {
    transition: none;
  }
}
.carousel-control-next:focus, .carousel-control-next:hover, .carousel-control-prev:focus, .carousel-control-prev:hover {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-next-icon, .carousel-control-prev-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-next-icon, .carousel-dark .carousel-control-prev-icon {
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark] .carousel .carousel-control-prev-icon, [data-bs-theme=dark].carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon {
  filter: invert(1) grayscale(100);
}

[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}

[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-border, .spinner-grow {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  --bs-spinner-width:2rem;
  --bs-spinner-height:2rem;
  --bs-spinner-vertical-align:-0.125em;
  --bs-spinner-border-width:0.25em;
  --bs-spinner-animation-speed:0.75s;
  --bs-spinner-animation-name:spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width:1rem;
  --bs-spinner-height:1rem;
  --bs-spinner-border-width:0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width:2rem;
  --bs-spinner-height:2rem;
  --bs-spinner-vertical-align:-0.125em;
  --bs-spinner-animation-speed:0.75s;
  --bs-spinner-animation-name:spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width:1rem;
  --bs-spinner-height:1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border, .spinner-grow {
    --bs-spinner-animation-speed:1.5s;
  }
}
.offcanvas, .offcanvas-lg, .offcanvas-md, .offcanvas-sm, .offcanvas-xl, .offcanvas-xxl {
  --bs-offcanvas-zindex:1045;
  --bs-offcanvas-width:400px;
  --bs-offcanvas-height:30vh;
  --bs-offcanvas-padding-x:1rem;
  --bs-offcanvas-padding-y:1rem;
  --bs-offcanvas-color:var(--bs-body-color);
  --bs-offcanvas-bg:var(--bs-body-bg);
  --bs-offcanvas-border-width:var(--bs-border-width);
  --bs-offcanvas-border-color:var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-offcanvas-transition:transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height:1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.show:not(.hiding), .offcanvas-sm.showing {
    transform: none;
  }
  .offcanvas-sm.hiding, .offcanvas-sm.show, .offcanvas-sm.showing {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height:auto;
    --bs-offcanvas-border-width:0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.show:not(.hiding), .offcanvas-md.showing {
    transform: none;
  }
  .offcanvas-md.hiding, .offcanvas-md.show, .offcanvas-md.showing {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height:auto;
    --bs-offcanvas-border-width:0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.show:not(.hiding), .offcanvas-lg.showing {
    transform: none;
  }
  .offcanvas-lg.hiding, .offcanvas-lg.show, .offcanvas-lg.showing {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height:auto;
    --bs-offcanvas-border-width:0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.show:not(.hiding), .offcanvas-xl.showing {
    transform: none;
  }
  .offcanvas-xl.hiding, .offcanvas-xl.show, .offcanvas-xl.showing {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height:auto;
    --bs-offcanvas-border-width:0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.show:not(.hiding), .offcanvas-xxl.showing {
    transform: none;
  }
  .offcanvas-xxl.hiding, .offcanvas-xxl.show, .offcanvas-xxl.showing {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height:auto;
    --bs-offcanvas-border-width:0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.show:not(.hiding), .offcanvas.showing {
  transform: none;
}

.offcanvas.hiding, .offcanvas.show, .offcanvas.showing {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary:focus, .link-primary:hover {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary:focus, .link-secondary:hover {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success:focus, .link-success:hover {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-info:focus, .link-info:hover {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning:focus, .link-warning:hover {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger:focus, .link-danger:hover {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-light:focus, .link-light:hover {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark:focus, .link-dark:hover {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis:focus, .link-body-emphasis:hover {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}

.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}

@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}
.icon-link-hover:focus-visible > .bi, .icon-link-hover:hover > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio:100%;
}

.ratio-4x3 {
  --bs-aspect-ratio:75%;
}

.ratio-16x9 {
  --bs-aspect-ratio:56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio:42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden, .visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption), .visually-hidden:not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color:rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color:rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color:rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color:rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color:rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color:rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color:rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color:rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity:1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity:0.1;
}

.border-opacity-25 {
  --bs-border-opacity:0.25;
}

.border-opacity-50 {
  --bs-border-opacity:0.5;
}

.border-opacity-75 {
  --bs-border-opacity:0.75;
}

.border-opacity-100 {
  --bs-border-opacity:1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.text-primary {
  --bs-text-opacity:1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity:1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity:1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity:1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity:1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity:1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity:1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity:1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity:1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity:1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity:1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity:1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity:1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity:1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity:1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity:1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity:1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity:1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity:0.25;
}

.text-opacity-50 {
  --bs-text-opacity:0.5;
}

.text-opacity-75 {
  --bs-text-opacity:0.75;
}

.text-opacity-100 {
  --bs-text-opacity:1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity:0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity:0.1;
}

.link-opacity-25 {
  --bs-link-opacity:0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity:0.25;
}

.link-opacity-50 {
  --bs-link-opacity:0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity:0.5;
}

.link-opacity-75 {
  --bs-link-opacity:0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity:0.75;
}

.link-opacity-100 {
  --bs-link-opacity:1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity:1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity:1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity:0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity:0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity:0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity:0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity:0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity:0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity:0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity:0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity:0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity:0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity:1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity:1;
}

.bg-primary {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity:1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity:1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity:0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity:0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity:0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity:0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity:1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
  user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
  user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap/dist/css/bootstrap.min.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAC;;;;CAAA;AAId;EAA4B,iBAAA;EAAkB,mBAAA;EAAoB,mBAAA;EAAoB,iBAAA;EAAkB,gBAAA;EAAiB,mBAAA;EAAoB,mBAAA;EAAoB,kBAAA;EAAmB,iBAAA;EAAkB,iBAAA;EAAkB,eAAA;EAAgB,eAAA;EAAgB,iBAAA;EAAkB,sBAAA;EAAuB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,qBAAA;EAAsB,oBAAA;EAAqB,sBAAA;EAAuB,oBAAA;EAAqB,iBAAA;EAAkB,oBAAA;EAAqB,mBAAA;EAAoB,kBAAA;EAAmB,iBAAA;EAAkB,2BAAA;EAA4B,8BAAA;EAA+B,0BAAA;EAA2B,wBAAA;EAAyB,0BAAA;EAA2B,yBAAA;EAA0B,0BAAA;EAA2B,sBAAA;EAAuB,kCAAA;EAAmC,oCAAA;EAAqC,kCAAA;EAAmC,+BAAA;EAAgC,kCAAA;EAAmC,iCAAA;EAAkC,gCAAA;EAAiC,+BAAA;EAAgC,8BAAA;EAA+B,gCAAA;EAAiC,8BAAA;EAA+B,2BAAA;EAA4B,8BAAA;EAA+B,6BAAA;EAA8B,4BAAA;EAA6B,2BAAA;EAA4B,kCAAA;EAAmC,oCAAA;EAAqC,kCAAA;EAAmC,+BAAA;EAAgC,kCAAA;EAAmC,iCAAA;EAAkC,gCAAA;EAAiC,+BAAA;EAAgC,0BAAA;EAA2B,oBAAA;EAAqB,wMAAA;EAAyM,kGAAA;EAAmG,wFAAA;EAAyF,+CAAA;EAAgD,wBAAA;EAAyB,yBAAA;EAA0B,yBAAA;EAA0B,uBAAA;EAAwB,4BAAA;EAA6B,iBAAA;EAAkB,4BAAA;EAA6B,wBAAA;EAAyB,6BAAA;EAA8B,2CAAA;EAA4C,iCAAA;EAAkC,yBAAA;EAA0B,iCAAA;EAAkC,yCAAA;EAA0C,gCAAA;EAAiC,wBAAA;EAAyB,gCAAA;EAAiC,0BAAA;EAA2B,uBAAA;EAAwB,8BAAA;EAA+B,8BAAA;EAA+B,6BAAA;EAA8B,mCAAA;EAAoC,uBAAA;EAAwB,yBAAA;EAA0B,qBAAA;EAAsB,uBAAA;EAAwB,yBAAA;EAA0B,kDAAA;EAAmD,2BAAA;EAA4B,6BAAA;EAA8B,4BAAA;EAA6B,0BAAA;EAA2B,2BAAA;EAA4B,kDAAA;EAAmD,6BAAA;EAA8B,iDAAA;EAAkD,0DAAA;EAA2D,mDAAA;EAAoD,0DAAA;EAA2D,6BAAA;EAA8B,4BAAA;EAA6B,8CAAA;EAA+C,6BAAA;EAA8B,oCAAA;EAAqC,+BAAA;EAAgC,sCAAA;AAuHxjH;;AAvH+lH;EAAqB,kBAAA;EAAkB,uBAAA;EAAwB,+BAAA;EAAgC,oBAAA;EAAqB,yBAAA;EAA0B,wBAAA;EAAyB,mCAAA;EAAoC,8CAAA;EAA+C,oCAAA;EAAqC,yBAAA;EAA0B,8BAAA;EAA+B,4CAAA;EAA6C,mCAAA;EAAoC,wBAAA;EAAyB,6BAAA;EAA8B,kCAAA;EAAmC,oCAAA;EAAqC,kCAAA;EAAmC,+BAAA;EAAgC,kCAAA;EAAmC,iCAAA;EAAkC,gCAAA;EAAiC,+BAAA;EAAgC,8BAAA;EAA+B,gCAAA;EAAiC,8BAAA;EAA+B,2BAAA;EAA4B,8BAAA;EAA+B,6BAAA;EAA8B,4BAAA;EAA6B,2BAAA;EAA4B,kCAAA;EAAmC,oCAAA;EAAqC,kCAAA;EAAmC,+BAAA;EAAgC,kCAAA;EAAmC,iCAAA;EAAkC,gCAAA;EAAiC,+BAAA;EAAgC,0BAAA;EAA2B,uBAAA;EAAwB,6BAAA;EAA8B,+BAAA;EAAgC,qCAAA;EAAsC,uBAAA;EAAwB,yBAAA;EAA0B,uDAAA;EAAwD,6BAAA;EAA8B,oCAAA;EAAqC,+BAAA;EAAgC,sCAAA;AA6KtrK;;AA7K6tK;EAAmB,sBAAA;AAiLhvK;;AAjLswK;EAA8C;IAAM,uBAAA;EAsLxzK;AACF;AAvLk1K;EAAK,SAAA;EAAS,uCAAA;EAAuC,mCAAA;EAAmC,uCAAA;EAAuC,uCAAA;EAAuC,2BAAA;EAA2B,qCAAA;EAAqC,mCAAA;EAAmC,8BAAA;EAA8B,wCAAA;AAmMznL;;AAnMiqL;EAAG,cAAA;EAAc,cAAA;EAAc,SAAA;EAAS,wCAAA;EAAwC,aAAA;AA2MjvL;;AA3M6vL;EAA0C,aAAA;EAAa,qBAAA;EAAoB,gBAAA;EAAgB,gBAAA;EAAgB,8BAAA;AAmNx2L;;AAnNs4L;EAAO,iCAAA;AAuN74L;;AAvN86L;EAA0B;IAAO,iBAAA;EA4N78L;AACF;AA7Ni+L;EAAO,iCAAA;AAgOx+L;;AAhOwgM;EAA0B;IAAO,eAAA;EAqOviM;AACF;AAtOyjM;EAAO,+BAAA;AAyOhkM;;AAzO8lM;EAA0B;IAAO,kBAAA;EA8O7nM;AACF;AA/OkpM;EAAO,iCAAA;AAkPzpM;;AAlPyrM;EAA0B;IAAO,iBAAA;EAuPxtM;AACF;AAxP4uM;EAAO,kBAAA;AA2PnvM;;AA3PqwM;EAAO,eAAA;AA+P5wM;;AA/P2xM;EAAE,aAAA;EAAa,mBAAA;AAoQ1yM;;AApQ6zM;EAAY,yCAAA;EAAyC,iCAAA;EAAiC,YAAA;EAAkD,8BAAA;AA4Qr8M;;AA5Qm+M;EAAQ,mBAAA;EAAmB,kBAAA;EAAkB,oBAAA;AAkRhhN;;AAlRoiN;EAAM,kBAAA;AAsR1iN;;AAtR4jN;EAAS,aAAA;EAAa,mBAAA;AA2RllN;;AA3RqmN;EAAwB,gBAAA;AA+R7nN;;AA/R6oN;EAAG,gBAAA;AAmShpN;;AAnSgqN;EAAG,qBAAA;EAAoB,cAAA;AAwSvrN;;AAxSqsN;EAAW,gBAAA;AA4ShtN;;AA5SguN;EAAS,mBAAA;AAgTzuN;;AAhT4vN;EAAa,kBAAA;AAoTzwN;;AApT0xN;EAAW,iBAAA;EAAgB,wCAAA;AAyTrzN;;AAzT61N;EAAQ,kBAAA;EAAkB,iBAAA;EAAgB,cAAA;EAAc,wBAAA;AAgUr5N;;AAhU66N;EAAI,eAAA;AAoUj7N;;AApU+7N;EAAI,WAAA;AAwUn8N;;AAxU68N;EAAE,gEAAA;EAA8D,0BAAA;AA6U7gO;;AA7UuiO;EAAQ,kDAAA;AAiV/iO;;AAjVkmO;EAA4D,cAAA;EAAc,qBAAA;AAsV5qO;;AAtVisO;EAAkB,qCAAA;EAAqC,cAAA;AA2VxvO;;AA3VswO;EAAI,cAAA;EAAc,aAAA;EAAa,mBAAA;EAAmB,cAAA;EAAc,kBAAA;AAmWt0O;;AAnWu1O;EAAS,kBAAA;EAAkB,cAAA;EAAc,kBAAA;AAyWh4O;;AAzWk5O;EAAK,kBAAA;EAAiB,2BAAA;EAA2B,qBAAA;AA+Wn8O;;AA/Ww9O;EAAO,cAAA;AAmX/9O;;AAnX6+O;EAAI,2BAAA;EAAyB,kBAAA;EAAiB,wBAAA;EAAwB,sCAAA;EAAsC,sBAAA;AA2XzlP;;AA3X8mP;EAAQ,UAAA;EAAU,cAAA;AAgYhoP;;AAhY8oP;EAAO,gBAAA;AAoYrpP;;AApYqqP;EAAQ,sBAAA;AAwY7qP;;AAxYmsP;EAAM,oBAAA;EAAoB,yBAAA;AA6Y7tP;;AA7YsvP;EAAQ,mBAAA;EAAkB,sBAAA;EAAqB,gCAAA;EAAgC,gBAAA;AAoZr0P;;AApZq1P;EAAG,mBAAA;EAAmB,gCAAA;AAyZ32P;;AAzZ24P;EAA2B,qBAAA;EAAqB,mBAAA;EAAmB,eAAA;AA+Z98P;;AA/Z69P;EAAM,qBAAA;AAman+P;;AAnaw/P;EAAO,gBAAA;AAua//P;;AAva+gQ;EAAiC,UAAA;AA2ahjQ;;AA3a0jQ;EAAsC,SAAA;EAAS,oBAAA;EAAoB,kBAAA;EAAkB,oBAAA;AAkb/oQ;;AAlbmqQ;EAAc,oBAAA;AAsbjrQ;;AAtbqsQ;EAAc,eAAA;AA0bntQ;;AA1bkuQ;EAAO,iBAAA;AA8bzuQ;;AA9b0vQ;EAAgB,UAAA;AAkc1wQ;;AAlcoxQ;EAA0I,wBAAA;AAsc95Q;;AAtcq7Q;EAAgD,0BAAA;AA0cr+Q;;AA1c+/Q;EAA4G,eAAA;AA8c3mR;;AA9c0nR;EAAmB,UAAA;EAAU,kBAAA;AAmdvpR;;AAndyqR;EAAS,gBAAA;AAudlrR;;AAvdksR;EAAS,YAAA;EAAY,UAAA;EAAU,SAAA;EAAS,SAAA;AA8d1uR;;AA9dmvR;EAAO,WAAA;EAAW,WAAA;EAAW,UAAA;EAAU,qBAAA;EAAoB,iCAAA;EAAgC,oBAAA;AAue90R;;AAvek2R;EAA0B;IAAO,iBAAA;EA4ej4R;AACF;AA7eq5R;EAAS,WAAA;AAgf95R;;AAhfy6R;EAA+O,UAAA;AAofxpS;;AApfkqS;EAA4B,YAAA;AAwf9rS;;AAxf0sS;EAAc,6BAAA;EAA6B,oBAAA;AA6frvS;;AA7fywS;EAA4B,wBAAA;AAigBryS;;AAjgB6zS;EAA+B,UAAA;AAqgB51S;;AArgB06S;EAAuB,aAAA;EAAa,0BAAA;AA+gB98S;;AA/gBw+S;EAAO,qBAAA;AAmhB/+S;;AAnhBogT;EAAO,SAAA;AAuhB3gT;;AAvhBohT;EAAQ,kBAAA;EAAkB,eAAA;AA4hB9iT;;AA5hB6jT;EAAS,wBAAA;AAgiBtkT;;AAhiB8lT;EAAS,wBAAA;AAoiBvmT;;AApiB8nT;EAAM,kBAAA;EAAkB,gBAAA;AAyiBtpT;;AAziBsqT;EAAW,iCAAA;EAAiC,gBAAA;EAAgB,gBAAA;AA+iBluT;;AA/iBkvT;EAA0B;IAAW,eAAA;EAojBrxT;AACF;AArjBuyT;EAAW,iCAAA;EAAiC,gBAAA;EAAgB,gBAAA;AA0jBn2T;;AA1jBm3T;EAA0B;IAAW,iBAAA;EA+jBt5T;AACF;AAhkB06T;EAAW,iCAAA;EAAiC,gBAAA;EAAgB,gBAAA;AAqkBt+T;;AArkBs/T;EAA0B;IAAW,eAAA;EA0kBzhU;AACF;AA3kB2iU;EAAW,iCAAA;EAAiC,gBAAA;EAAgB,gBAAA;AAglBvmU;;AAhlBunU;EAA0B;IAAW,iBAAA;EAqlB1pU;AACF;AAtlB8qU;EAAW,iCAAA;EAAiC,gBAAA;EAAgB,gBAAA;AA2lB1uU;;AA3lB0vU;EAA0B;IAAW,eAAA;EAgmB7xU;AACF;AAjmB+yU;EAAW,iCAAA;EAAiC,gBAAA;EAAgB,gBAAA;AAsmB32U;;AAtmB23U;EAA0B;IAAW,iBAAA;EA2mB95U;AACF;AA5mBk7U;EAAe,eAAA;EAAe,gBAAA;AAgnBh9U;;AAhnBg+U;EAAa,eAAA;EAAe,gBAAA;AAqnB5/U;;AArnB4gV;EAAkB,qBAAA;AAynB9hV;;AAznBmjV;EAAmC,oBAAA;AA6nBtlV;;AA7nBymV;EAAY,kBAAA;EAAiB,yBAAA;AAkoBtoV;;AAloB+pV;EAAY,mBAAA;EAAmB,kBAAA;AAuoB9rV;;AAvoBgtV;EAAwB,gBAAA;AA2oBxuV;;AA3oBwvV;EAAmB,iBAAA;EAAiB,mBAAA;EAAmB,kBAAA;EAAiB,cAAA;AAkpBh0V;;AAlpB80V;EAA2B,aAAA;AAspBz2V;;AAtpBs3V;EAAW,eAAA;EAAe,YAAA;AA2pBh5V;;AA3pB45V;EAAe,gBAAA;EAAe,mCAAA;EAAmC,2DAAA;EAA2D,sCAAA;EAAsC,eAAA;EAAe,YAAA;AAoqB7kW;;AApqBylW;EAAQ,qBAAA;AAwqBjmW;;AAxqBsnW;EAAY,qBAAA;EAAoB,cAAA;AA6qBtpW;;AA7qBoqW;EAAgB,kBAAA;EAAiB,gCAAA;AAkrBrsW;;AAlrBquW;EAAmG,oBAAA;EAAqB,eAAA;EAAgB,WAAA;EAAW,6CAAA;EAA4C,4CAAA;EAA2C,kBAAA;EAAkB,iBAAA;AA4rBj+W;;AA5rBk/W;EAAyB;IAAyB,gBAAA;EAisBliX;AACF;AAlsBqjX;EAAyB;IAAuC,gBAAA;EAssBnnX;AACF;AAvsBsoX;EAAyB;IAAqD,gBAAA;EA2sBltX;AACF;AA5sBquX;EAA0B;IAAmE,iBAAA;EAgtBh0X;AACF;AAjtBo1X;EAA0B;IAAkF,iBAAA;EAqtB97X;AACF;AAttBk9X;EAAM,oBAAA;EAAqB,wBAAA;EAAyB,wBAAA;EAAyB,wBAAA;EAAyB,yBAAA;EAA0B,0BAAA;AA8tBllY;;AA9tB6mY;EAAK,oBAAA;EAAqB,eAAA;EAAgB,aAAA;EAAa,eAAA;EAAe,yCAAA;EAAyC,6CAAA;EAA4C,4CAAA;AAwuBxwY;;AAxuBmzY;EAAO,cAAA;EAAc,WAAA;EAAW,eAAA;EAAe,6CAAA;EAA4C,4CAAA;EAA2C,8BAAA;AAivBz7Y;;AAjvBu9Y;EAAK,SAAA;AAqvB59Y;;AArvBw+Y;EAAiB,cAAA;EAAc,WAAA;AA0vBvgZ;;AA1vBkhZ;EAAc,cAAA;EAAc,WAAA;AA+vB9iZ;;AA/vByjZ;EAAc,cAAA;EAAc,UAAA;AAowBrlZ;;AApwB+lZ;EAAc,cAAA;EAAc,qBAAA;AAywB3nZ;;AAzwBgpZ;EAAc,cAAA;EAAc,UAAA;AA8wB5qZ;;AA9wBsrZ;EAAc,cAAA;EAAc,UAAA;AAmxBltZ;;AAnxB4tZ;EAAc,cAAA;EAAc,qBAAA;AAwxBxvZ;;AAxxB6wZ;EAAU,cAAA;EAAc,WAAA;AA6xBryZ;;AA7xBgzZ;EAAO,cAAA;EAAc,kBAAA;AAkyBr0Z;;AAlyBu1Z;EAAO,cAAA;EAAc,mBAAA;AAuyB52Z;;AAvyB+3Z;EAAO,cAAA;EAAc,UAAA;AA4yBp5Z;;AA5yB85Z;EAAO,cAAA;EAAc,mBAAA;AAizBn7Z;;AAjzBs8Z;EAAO,cAAA;EAAc,mBAAA;AAszB39Z;;AAtzB8+Z;EAAO,cAAA;EAAc,UAAA;AA2zBnga;;AA3zB6ga;EAAO,cAAA;EAAc,mBAAA;AAg0Blia;;AAh0Bqja;EAAO,cAAA;EAAc,mBAAA;AAq0B1ka;;AAr0B6la;EAAO,cAAA;EAAc,UAAA;AA00Blna;;AA10B4na;EAAQ,cAAA;EAAc,mBAAA;AA+0Blpa;;AA/0Bqqa;EAAQ,cAAA;EAAc,mBAAA;AAo1B3ra;;AAp1B8sa;EAAQ,cAAA;EAAc,WAAA;AAy1Bpua;;AAz1B+ua;EAAU,wBAAA;AA61Bzva;;AA71Bixa;EAAU,yBAAA;AAi2B3xa;;AAj2Boza;EAAU,gBAAA;AAq2B9za;;AAr2B80a;EAAU,yBAAA;AAy2Bx1a;;AAz2Bi3a;EAAU,yBAAA;AA62B33a;;AA72Bo5a;EAAU,gBAAA;AAi3B95a;;AAj3B86a;EAAU,yBAAA;AAq3Bx7a;;AAr3Bi9a;EAAU,yBAAA;AAy3B39a;;AAz3Bo/a;EAAU,gBAAA;AA63B9/a;;AA73B8gb;EAAW,yBAAA;AAi4Bzhb;;AAj4Bkjb;EAAW,yBAAA;AAq4B7jb;;AAr4Bslb;EAAW,eAAA;AAy4Bjmb;;AAz4Binb;EAAW,eAAA;AA64B5nb;;AA74B4ob;EAAW,qBAAA;AAi5Bvpb;;AAj5B6qb;EAAW,qBAAA;AAq5Bxrb;;AAr5B8sb;EAAW,oBAAA;AAy5Bztb;;AAz5B8ub;EAAW,oBAAA;AA65Bzvb;;AA75B8wb;EAAW,kBAAA;AAi6Bzxb;;AAj6B4yb;EAAW,kBAAA;AAq6Bvzb;;AAr6B00b;EAAW,oBAAA;AAy6Br1b;;AAz6B02b;EAAW,oBAAA;AA66Br3b;;AA76B04b;EAAW,kBAAA;AAi7Br5b;;AAj7Bw6b;EAAW,kBAAA;AAq7Bn7b;;AAr7Bs8b;EAAyB;IAAQ,SAAA;EA07Br+b;EA17Bi/b;IAAoB,cAAA;IAAc,WAAA;EA87Bnhc;EA97B8hc;IAAiB,cAAA;IAAc,WAAA;EAk8B7jc;EAl8Bwkc;IAAiB,cAAA;IAAc,UAAA;EAs8Bvmc;EAt8Binc;IAAiB,cAAA;IAAc,qBAAA;EA08Bhpc;EA18Bqqc;IAAiB,cAAA;IAAc,UAAA;EA88Bpsc;EA98B8sc;IAAiB,cAAA;IAAc,UAAA;EAk9B7uc;EAl9Buvc;IAAiB,cAAA;IAAc,qBAAA;EAs9Btxc;EAt9B2yc;IAAa,cAAA;IAAc,WAAA;EA09Bt0c;EA19Bi1c;IAAU,cAAA;IAAc,kBAAA;EA89Bz2c;EA99B23c;IAAU,cAAA;IAAc,mBAAA;EAk+Bn5c;EAl+Bs6c;IAAU,cAAA;IAAc,UAAA;EAs+B97c;EAt+Bw8c;IAAU,cAAA;IAAc,mBAAA;EA0+Bh+c;EA1+Bm/c;IAAU,cAAA;IAAc,mBAAA;EA8+B3gd;EA9+B8hd;IAAU,cAAA;IAAc,UAAA;EAk/Btjd;EAl/Bgkd;IAAU,cAAA;IAAc,mBAAA;EAs/Bxld;EAt/B2md;IAAU,cAAA;IAAc,mBAAA;EA0/Bnod;EA1/Bspd;IAAU,cAAA;IAAc,UAAA;EA8/B9qd;EA9/Bwrd;IAAW,cAAA;IAAc,mBAAA;EAkgCjtd;EAlgCoud;IAAW,cAAA;IAAc,mBAAA;EAsgC7vd;EAtgCgxd;IAAW,cAAA;IAAc,WAAA;EA0gCzyd;EA1gCozd;IAAa,cAAA;EA6gCj0d;EA7gC+0d;IAAa,wBAAA;EAghC51d;EAhhCo3d;IAAa,yBAAA;EAmhCj4d;EAnhC05d;IAAa,gBAAA;EAshCv6d;EAthCu7d;IAAa,yBAAA;EAyhCp8d;EAzhC69d;IAAa,yBAAA;EA4hC1+d;EA5hCmge;IAAa,gBAAA;EA+hChhe;EA/hCgie;IAAa,yBAAA;EAkiC7ie;EAliCske;IAAa,yBAAA;EAqiCnle;EAriC4me;IAAa,gBAAA;EAwiCzne;EAxiCyoe;IAAc,yBAAA;EA2iCvpe;EA3iCgre;IAAc,yBAAA;EA8iC9re;EA9iCute;IAAiB,eAAA;EAijCxue;EAjjCwve;IAAiB,eAAA;EAojCzwe;EApjCyxe;IAAiB,qBAAA;EAujC1ye;EAvjCg0e;IAAiB,qBAAA;EA0jCj1e;EA1jCu2e;IAAiB,oBAAA;EA6jCx3e;EA7jC64e;IAAiB,oBAAA;EAgkC95e;EAhkCm7e;IAAiB,kBAAA;EAmkCp8e;EAnkCu9e;IAAiB,kBAAA;EAskCx+e;EAtkC2/e;IAAiB,oBAAA;EAykC5gf;EAzkCiif;IAAiB,oBAAA;EA4kCljf;EA5kCukf;IAAiB,kBAAA;EA+kCxlf;EA/kC2mf;IAAiB,kBAAA;EAklC5nf;AACF;AAnlCkpf;EAAyB;IAAQ,SAAA;EAulCjrf;EAvlC6rf;IAAoB,cAAA;IAAc,WAAA;EA2lC/tf;EA3lC0uf;IAAiB,cAAA;IAAc,WAAA;EA+lCzwf;EA/lCoxf;IAAiB,cAAA;IAAc,UAAA;EAmmCnzf;EAnmC6zf;IAAiB,cAAA;IAAc,qBAAA;EAumC51f;EAvmCi3f;IAAiB,cAAA;IAAc,UAAA;EA2mCh5f;EA3mC05f;IAAiB,cAAA;IAAc,UAAA;EA+mCz7f;EA/mCm8f;IAAiB,cAAA;IAAc,qBAAA;EAmnCl+f;EAnnCu/f;IAAa,cAAA;IAAc,WAAA;EAunClhgB;EAvnC6hgB;IAAU,cAAA;IAAc,kBAAA;EA2nCrjgB;EA3nCukgB;IAAU,cAAA;IAAc,mBAAA;EA+nC/lgB;EA/nCkngB;IAAU,cAAA;IAAc,UAAA;EAmoC1ogB;EAnoCopgB;IAAU,cAAA;IAAc,mBAAA;EAuoC5qgB;EAvoC+rgB;IAAU,cAAA;IAAc,mBAAA;EA2oCvtgB;EA3oC0ugB;IAAU,cAAA;IAAc,UAAA;EA+oClwgB;EA/oC4wgB;IAAU,cAAA;IAAc,mBAAA;EAmpCpygB;EAnpCuzgB;IAAU,cAAA;IAAc,mBAAA;EAupC/0gB;EAvpCk2gB;IAAU,cAAA;IAAc,UAAA;EA2pC13gB;EA3pCo4gB;IAAW,cAAA;IAAc,mBAAA;EA+pC75gB;EA/pCg7gB;IAAW,cAAA;IAAc,mBAAA;EAmqCz8gB;EAnqC49gB;IAAW,cAAA;IAAc,WAAA;EAuqCr/gB;EAvqCgghB;IAAa,cAAA;EA0qC7ghB;EA1qC2hhB;IAAa,wBAAA;EA6qCxihB;EA7qCgkhB;IAAa,yBAAA;EAgrC7khB;EAhrCsmhB;IAAa,gBAAA;EAmrCnnhB;EAnrCmohB;IAAa,yBAAA;EAsrChphB;EAtrCyqhB;IAAa,yBAAA;EAyrCtrhB;EAzrC+shB;IAAa,gBAAA;EA4rC5thB;EA5rC4uhB;IAAa,yBAAA;EA+rCzvhB;EA/rCkxhB;IAAa,yBAAA;EAksC/xhB;EAlsCwzhB;IAAa,gBAAA;EAqsCr0hB;EArsCq1hB;IAAc,yBAAA;EAwsCn2hB;EAxsC43hB;IAAc,yBAAA;EA2sC14hB;EA3sCm6hB;IAAiB,eAAA;EA8sCp7hB;EA9sCo8hB;IAAiB,eAAA;EAitCr9hB;EAjtCq+hB;IAAiB,qBAAA;EAotCt/hB;EAptC4giB;IAAiB,qBAAA;EAutC7hiB;EAvtCmjiB;IAAiB,oBAAA;EA0tCpkiB;EA1tCyliB;IAAiB,oBAAA;EA6tC1miB;EA7tC+niB;IAAiB,kBAAA;EAguChpiB;EAhuCmqiB;IAAiB,kBAAA;EAmuCpriB;EAnuCusiB;IAAiB,oBAAA;EAsuCxtiB;EAtuC6uiB;IAAiB,oBAAA;EAyuC9viB;EAzuCmxiB;IAAiB,kBAAA;EA4uCpyiB;EA5uCuziB;IAAiB,kBAAA;EA+uCx0iB;AACF;AAhvC81iB;EAAyB;IAAQ,SAAA;EAovC73iB;EApvCy4iB;IAAoB,cAAA;IAAc,WAAA;EAwvC36iB;EAxvCs7iB;IAAiB,cAAA;IAAc,WAAA;EA4vCr9iB;EA5vCg+iB;IAAiB,cAAA;IAAc,UAAA;EAgwC//iB;EAhwCygjB;IAAiB,cAAA;IAAc,qBAAA;EAowCxijB;EApwC6jjB;IAAiB,cAAA;IAAc,UAAA;EAwwC5ljB;EAxwCsmjB;IAAiB,cAAA;IAAc,UAAA;EA4wCrojB;EA5wC+ojB;IAAiB,cAAA;IAAc,qBAAA;EAgxC9qjB;EAhxCmsjB;IAAa,cAAA;IAAc,WAAA;EAoxC9tjB;EApxCyujB;IAAU,cAAA;IAAc,kBAAA;EAwxCjwjB;EAxxCmxjB;IAAU,cAAA;IAAc,mBAAA;EA4xC3yjB;EA5xC8zjB;IAAU,cAAA;IAAc,UAAA;EAgyCt1jB;EAhyCg2jB;IAAU,cAAA;IAAc,mBAAA;EAoyCx3jB;EApyC24jB;IAAU,cAAA;IAAc,mBAAA;EAwyCn6jB;EAxyCs7jB;IAAU,cAAA;IAAc,UAAA;EA4yC98jB;EA5yCw9jB;IAAU,cAAA;IAAc,mBAAA;EAgzCh/jB;EAhzCmgkB;IAAU,cAAA;IAAc,mBAAA;EAozC3hkB;EApzC8ikB;IAAU,cAAA;IAAc,UAAA;EAwzCtkkB;EAxzCglkB;IAAW,cAAA;IAAc,mBAAA;EA4zCzmkB;EA5zC4nkB;IAAW,cAAA;IAAc,mBAAA;EAg0CrpkB;EAh0CwqkB;IAAW,cAAA;IAAc,WAAA;EAo0CjskB;EAp0C4skB;IAAa,cAAA;EAu0CztkB;EAv0CuukB;IAAa,wBAAA;EA00CpvkB;EA10C4wkB;IAAa,yBAAA;EA60CzxkB;EA70CkzkB;IAAa,gBAAA;EAg1C/zkB;EAh1C+0kB;IAAa,yBAAA;EAm1C51kB;EAn1Cq3kB;IAAa,yBAAA;EAs1Cl4kB;EAt1C25kB;IAAa,gBAAA;EAy1Cx6kB;EAz1Cw7kB;IAAa,yBAAA;EA41Cr8kB;EA51C89kB;IAAa,yBAAA;EA+1C3+kB;EA/1CoglB;IAAa,gBAAA;EAk2CjhlB;EAl2CiilB;IAAc,yBAAA;EAq2C/ilB;EAr2CwklB;IAAc,yBAAA;EAw2CtllB;EAx2C+mlB;IAAiB,eAAA;EA22CholB;EA32CgplB;IAAiB,eAAA;EA82CjqlB;EA92CirlB;IAAiB,qBAAA;EAi3ClslB;EAj3CwtlB;IAAiB,qBAAA;EAo3CzulB;EAp3C+vlB;IAAiB,oBAAA;EAu3ChxlB;EAv3CqylB;IAAiB,oBAAA;EA03CtzlB;EA13C20lB;IAAiB,kBAAA;EA63C51lB;EA73C+2lB;IAAiB,kBAAA;EAg4Ch4lB;EAh4Cm5lB;IAAiB,oBAAA;EAm4Cp6lB;EAn4Cy7lB;IAAiB,oBAAA;EAs4C18lB;EAt4C+9lB;IAAiB,kBAAA;EAy4Ch/lB;EAz4CmgmB;IAAiB,kBAAA;EA44CphmB;AACF;AA74C0imB;EAA0B;IAAQ,SAAA;EAi5C1kmB;EAj5CslmB;IAAoB,cAAA;IAAc,WAAA;EAq5CxnmB;EAr5CmomB;IAAiB,cAAA;IAAc,WAAA;EAy5ClqmB;EAz5C6qmB;IAAiB,cAAA;IAAc,UAAA;EA65C5smB;EA75CstmB;IAAiB,cAAA;IAAc,qBAAA;EAi6CrvmB;EAj6C0wmB;IAAiB,cAAA;IAAc,UAAA;EAq6CzymB;EAr6CmzmB;IAAiB,cAAA;IAAc,UAAA;EAy6Cl1mB;EAz6C41mB;IAAiB,cAAA;IAAc,qBAAA;EA66C33mB;EA76Cg5mB;IAAa,cAAA;IAAc,WAAA;EAi7C36mB;EAj7Cs7mB;IAAU,cAAA;IAAc,kBAAA;EAq7C98mB;EAr7Cg+mB;IAAU,cAAA;IAAc,mBAAA;EAy7Cx/mB;EAz7C2gnB;IAAU,cAAA;IAAc,UAAA;EA67CninB;EA77C6inB;IAAU,cAAA;IAAc,mBAAA;EAi8CrknB;EAj8CwlnB;IAAU,cAAA;IAAc,mBAAA;EAq8ChnnB;EAr8CmonB;IAAU,cAAA;IAAc,UAAA;EAy8C3pnB;EAz8CqqnB;IAAU,cAAA;IAAc,mBAAA;EA68C7rnB;EA78CgtnB;IAAU,cAAA;IAAc,mBAAA;EAi9CxunB;EAj9C2vnB;IAAU,cAAA;IAAc,UAAA;EAq9CnxnB;EAr9C6xnB;IAAW,cAAA;IAAc,mBAAA;EAy9CtznB;EAz9Cy0nB;IAAW,cAAA;IAAc,mBAAA;EA69Cl2nB;EA79Cq3nB;IAAW,cAAA;IAAc,WAAA;EAi+C94nB;EAj+Cy5nB;IAAa,cAAA;EAo+Ct6nB;EAp+Co7nB;IAAa,wBAAA;EAu+Cj8nB;EAv+Cy9nB;IAAa,yBAAA;EA0+Ct+nB;EA1+C+/nB;IAAa,gBAAA;EA6+C5goB;EA7+C4hoB;IAAa,yBAAA;EAg/CzioB;EAh/CkkoB;IAAa,yBAAA;EAm/C/koB;EAn/CwmoB;IAAa,gBAAA;EAs/CrnoB;EAt/CqooB;IAAa,yBAAA;EAy/ClpoB;EAz/C2qoB;IAAa,yBAAA;EA4/CxroB;EA5/CitoB;IAAa,gBAAA;EA+/C9toB;EA//C8uoB;IAAc,yBAAA;EAkgD5voB;EAlgDqxoB;IAAc,yBAAA;EAqgDnyoB;EArgD4zoB;IAAiB,eAAA;EAwgD70oB;EAxgD61oB;IAAiB,eAAA;EA2gD92oB;EA3gD83oB;IAAiB,qBAAA;EA8gD/4oB;EA9gDq6oB;IAAiB,qBAAA;EAihDt7oB;EAjhD48oB;IAAiB,oBAAA;EAohD79oB;EAphDk/oB;IAAiB,oBAAA;EAuhDngpB;EAvhDwhpB;IAAiB,kBAAA;EA0hDzipB;EA1hD4jpB;IAAiB,kBAAA;EA6hD7kpB;EA7hDgmpB;IAAiB,oBAAA;EAgiDjnpB;EAhiDsopB;IAAiB,oBAAA;EAmiDvppB;EAniD4qpB;IAAiB,kBAAA;EAsiD7rpB;EAtiDgtpB;IAAiB,kBAAA;EAyiDjupB;AACF;AA1iDuvpB;EAA0B;IAAS,SAAA;EA8iDxxpB;EA9iDoypB;IAAqB,cAAA;IAAc,WAAA;EAkjDv0pB;EAljDk1pB;IAAkB,cAAA;IAAc,WAAA;EAsjDl3pB;EAtjD63pB;IAAkB,cAAA;IAAc,UAAA;EA0jD75pB;EA1jDu6pB;IAAkB,cAAA;IAAc,qBAAA;EA8jDv8pB;EA9jD49pB;IAAkB,cAAA;IAAc,UAAA;EAkkD5/pB;EAlkDsgqB;IAAkB,cAAA;IAAc,UAAA;EAskDtiqB;EAtkDgjqB;IAAkB,cAAA;IAAc,qBAAA;EA0kDhlqB;EA1kDqmqB;IAAc,cAAA;IAAc,WAAA;EA8kDjoqB;EA9kD4oqB;IAAW,cAAA;IAAc,kBAAA;EAklDrqqB;EAllDurqB;IAAW,cAAA;IAAc,mBAAA;EAslDhtqB;EAtlDmuqB;IAAW,cAAA;IAAc,UAAA;EA0lD5vqB;EA1lDswqB;IAAW,cAAA;IAAc,mBAAA;EA8lD/xqB;EA9lDkzqB;IAAW,cAAA;IAAc,mBAAA;EAkmD30qB;EAlmD81qB;IAAW,cAAA;IAAc,UAAA;EAsmDv3qB;EAtmDi4qB;IAAW,cAAA;IAAc,mBAAA;EA0mD15qB;EA1mD66qB;IAAW,cAAA;IAAc,mBAAA;EA8mDt8qB;EA9mDy9qB;IAAW,cAAA;IAAc,UAAA;EAknDl/qB;EAlnD4/qB;IAAY,cAAA;IAAc,mBAAA;EAsnDthrB;EAtnDyirB;IAAY,cAAA;IAAc,mBAAA;EA0nDnkrB;EA1nDslrB;IAAY,cAAA;IAAc,WAAA;EA8nDhnrB;EA9nD2nrB;IAAc,cAAA;EAioDzorB;EAjoDuprB;IAAc,wBAAA;EAooDrqrB;EApoD6rrB;IAAc,yBAAA;EAuoD3srB;EAvoDourB;IAAc,gBAAA;EA0oDlvrB;EA1oDkwrB;IAAc,yBAAA;EA6oDhxrB;EA7oDyyrB;IAAc,yBAAA;EAgpDvzrB;EAhpDg1rB;IAAc,gBAAA;EAmpD91rB;EAnpD82rB;IAAc,yBAAA;EAspD53rB;EAtpDq5rB;IAAc,yBAAA;EAypDn6rB;EAzpD47rB;IAAc,gBAAA;EA4pD18rB;EA5pD09rB;IAAe,yBAAA;EA+pDz+rB;EA/pDkgsB;IAAe,yBAAA;EAkqDjhsB;EAlqD0isB;IAAmB,eAAA;EAqqD7jsB;EArqD6ksB;IAAmB,eAAA;EAwqDhmsB;EAxqDgnsB;IAAmB,qBAAA;EA2qDnosB;EA3qDypsB;IAAmB,qBAAA;EA8qD5qsB;EA9qDkssB;IAAmB,oBAAA;EAirDrtsB;EAjrD0usB;IAAmB,oBAAA;EAorD7vsB;EAprDkxsB;IAAmB,kBAAA;EAurDrysB;EAvrDwzsB;IAAmB,kBAAA;EA0rD30sB;EA1rD81sB;IAAmB,oBAAA;EA6rDj3sB;EA7rDs4sB;IAAmB,oBAAA;EAgsDz5sB;EAhsD86sB;IAAmB,kBAAA;EAmsDj8sB;EAnsDo9sB;IAAmB,kBAAA;EAssDv+sB;AACF;AAvsD6/sB;EAAO,6BAAA;EAA8B,0BAAA;EAA2B,8BAAA;EAA+B,2BAAA;EAA4B,qCAAA;EAAsC,+BAAA;EAAgC,8CAAA;EAA+C,gCAAA;EAAiC,6CAAA;EAA8C,yCAAA;EAA0C,4CAAA;EAA6C,uCAAA;EAAwC,2CAAA;EAA4C,wCAAA;EAAyC,WAAA;EAAW,mBAAA;EAAmB,mBAAA;EAAmB,0CAAA;AA2tDjkuB;;AA3tD2muB;EAAyB,sBAAA;EAAoB,qFAAA;EAAmF,oCAAA;EAAoC,2CAAA;EAA2C,2GAAA;AAmuD1zuB;;AAnuDm6uB;EAAa,uBAAA;AAuuDh7uB;;AAvuDu8uB;EAAa,sBAAA;AA2uDp9uB;;AA3uD0+uB;EAAqB,+DAAA;AA+uD//uB;;AA/uD8jvB;EAAa,iBAAA;AAmvD3kvB;;AAnvD4lvB;EAA4B,wBAAA;AAuvDxnvB;;AAvvD8ovB;EAAgC,sCAAA;AA2vD9qvB;;AA3vDotvB;EAAkC,sCAAA;AA+vDtvvB;;AA/vD4xvB;EAAoC,sBAAA;AAmwDh0vB;;AAnwDs1vB;EAAqC,mBAAA;AAuwD33vB;;AAvwD84vB;EAA2C,mDAAA;EAAoD,6CAAA;AA4wD7+vB;;AA5wD2hwB;EAAuD,mDAAA;EAAoD,6CAAA;AAixDtowB;;AAjxDorwB;EAAc,mDAAA;EAAoD,6CAAA;AAsxDtvwB;;AAtxDoywB;EAA8B,kDAAA;EAAmD,4CAAA;AA2xDr3wB;;AA3xDk6wB;EAAe,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AAyyDvsxB;;AAzyDivxB;EAAiB,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AAuzDxhyB;;AAvzDkkyB;EAAe,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AAq0Dv2yB;;AAr0Di5yB;EAAY,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AAm1DnrzB;;AAn1D6tzB;EAAe,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AAi2Dlg0B;;AAj2D4i0B;EAAc,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AA+2Dh10B;;AA/2D030B;EAAa,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AA63D7p1B;;AA73Dus1B;EAAY,qBAAA;EAAsB,qBAAA;EAAsB,+BAAA;EAAgC,6BAAA;EAA8B,6BAAA;EAA8B,4BAAA;EAA6B,4BAAA;EAA6B,2BAAA;EAA4B,2BAAA;EAA4B,4BAAA;EAA4B,0CAAA;AA24Dz+1B;;AA34Dmh2B;EAAkB,gBAAA;EAAgB,iCAAA;AAg5Drj2B;;AAh5Dsl2B;EAA4B;IAAqB,gBAAA;IAAgB,iCAAA;EAs5Drp2B;AACF;AAv5Dyr2B;EAA4B;IAAqB,gBAAA;IAAgB,iCAAA;EA45Dxv2B;AACF;AA75D4x2B;EAA4B;IAAqB,gBAAA;IAAgB,iCAAA;EAk6D312B;AACF;AAn6D+32B;EAA6B;IAAqB,gBAAA;IAAgB,iCAAA;EAw6D/72B;AACF;AAz6Dm+2B;EAA6B;IAAsB,gBAAA;IAAgB,iCAAA;EA86Dpi3B;AACF;AA/6Dwk3B;EAAY,qBAAA;AAk7Dpl3B;;AAl7Dwm3B;EAAgB,oDAAA;EAAmD,uDAAA;EAAsD,gBAAA;EAAgB,kBAAA;EAAkB,gBAAA;AA07Dnw3B;;AA17Dmx3B;EAAmB,kDAAA;EAAiD,qDAAA;EAAoD,kBAAA;AAg8D343B;;AAh8D653B;EAAmB,mDAAA;EAAkD,sDAAA;EAAqD,mBAAA;AAs8Dvh4B;;AAt8Dyi4B;EAAW,mBAAA;EAAkB,kBAAA;EAAiB,gCAAA;AA48Dvl4B;;AA58Dun4B;EAAc,cAAA;EAAc,WAAA;EAAW,yBAAA;EAAuB,eAAA;EAAe,gBAAA;EAAgB,gBAAA;EAAgB,2BAAA;EAAwE,gBAAA;EAAgB,mCAAA;EAAmC,4BAAA;EAA4B,2DAAA;EAA2D,sCAAA;EAAsC,wEAAA;AA89D594B;;AA99Dii5B;EAAuC;IAAc,gBAAA;EAm+Dpl5B;AACF;AAp+Dum5B;EAAyB,gBAAA;AAu+Dho5B;;AAv+Dgp5B;EAAwD,eAAA;AA2+Dxs5B;;AA3+Dut5B;EAAoB,2BAAA;EAA2B,mCAAA;EAAmC,qBAAA;EAAqB,UAAA;EAAU,kDAAA;AAm/Dx05B;;AAn/Dq35B;EAA2C,eAAA;EAAe,aAAA;EAAa,SAAA;AAy/D575B;;AAz/Dq85B;EAAqC,cAAA;EAAc,UAAA;AA8/Dx/5B;;AA9/D4k6B;EAA2B,gCAAA;EAAgC,UAAA;AAwgEvo6B;;AAxgEip6B;EAAuB,wCAAA;EAAwC,UAAA;AA6gEht6B;;AA7gEsz7B;EAAoC,yBAAA;EAAuB,0BAAA;EAAkD,0BAAA;EAAyB,2BAAA;EAA2B,uCAAA;EAAuC,oBAAA;EAAoB,qBAAA;EAAqB,mBAAA;EAAmB,eAAA;EAAe,+CAAA;EAA+C,gBAAA;EAAgB,qIAAA;AA8iExo8B;;AA9iEsw8B;EAAyH;IAAoC,gBAAA;EAujEj68B;AACF;;AAxjE2i9B;EAAyE,wCAAA;AA+jEpn9B;;AA/jE4p9B;EAAwB,cAAA;EAAc,WAAA;EAAW,mBAAA;EAAkB,gBAAA;EAAgB,gBAAA;EAAgB,2BAAA;EAA2B,6BAAA;EAA6B,yBAAA;EAAyB,sCAAA;AA2kEh19B;;AA3kEs39B;EAA8B,UAAA;AA+kEp59B;;AA/kE859B;EAAgF,gBAAA;EAAgB,eAAA;AAolE9/9B;;AAplE6g+B;EAAiB,6DAAA;EAAkE,uBAAA;EAAqB,mBAAA;EAAkB,yCAAA;AA2lEvo+B;;AA3lEyz+B;EAAuC,uBAAA;EAAqB,wBAAA;EAA+C,yBAAA;AAymEp6+B;;AAzmE47+B;EAAiB,2DAAA;EAAiE,oBAAA;EAAmB,kBAAA;EAAkB,yCAAA;AAgnEnj/B;;AAhnE+t/B;EAAuC,oBAAA;EAAmB,qBAAA;EAA4C,uBAAA;AA8nEr0/B;;AA9nE41/B;EAAsB,8DAAA;AAkoEl3/B;;AAloEq7/B;EAAyB,6DAAA;AAsoE98/B;;AAtoEghgC;EAAyB,2DAAA;AA0oEzigC;;AA1oE0mgC;EAAoB,WAAA;EAAW,0DAAA;EAA+D,iBAAA;AAgpExsgC;;AAhpEwtgC;EAAmD,eAAA;AAopE3wgC;;AAppE0xgC;EAAuC,oBAAA;EAAmB,sCAAA;AAypEp1gC;;AAzpE03gC;EAA0C,oBAAA;EAAmB,sCAAA;AA8pEv7gC;;AA9pE69gC;EAAoC,yDAAA;AAkqEjghC;;AAlqE+jhC;EAAoC,uDAAA;AAsqEnmhC;;AAtqEgqhC;EAAa,+DAAA;EAAwP,cAAA;EAAc,WAAA;EAAW,0CAAA;EAAuC,eAAA;EAAe,gBAAA;EAAgB,gBAAA;EAAgB,2BAAA;EAAwE,gBAAA;EAAgB,mCAAA;EAAmC,mFAAA;EAAiF,4BAAA;EAA4B,yCAAA;EAAwC,0BAAA;EAA0B,2DAAA;EAA2D,sCAAA;EAAsC,wEAAA;AA4rE/5iC;;AA5rEo+iC;EAAuC;IAAa,gBAAA;EAisEthjC;AACF;AAlsEyijC;EAAmB,qBAAA;EAAqB,UAAA;EAAU,kDAAA;AAusE3ljC;;AAvsEwojC;EAA0D,sBAAA;EAAqB,sBAAA;AA4sEvtjC;;AA5sE6ujC;EAAsB,wCAAA;AAgtEnwjC;;AAhtE2yjC;EAA4B,kBAAA;EAAkB,uCAAA;AAqtEz1jC;;AArtEg4jC;EAAgB,oBAAA;EAAmB,uBAAA;EAAsB,oBAAA;EAAmB,mBAAA;EAAkB,yCAAA;AA6tE99jC;;AA7tEugkC;EAAgB,mBAAA;EAAkB,sBAAA;EAAqB,kBAAA;EAAkB,kBAAA;EAAkB,yCAAA;AAquElmkC;;AAruE2okC;EAAkC,+DAAA;AAyuE7qkC;;AAzuEq6kC;EAAY,cAAA;EAAc,kBAAA;EAAkB,mBAAA;EAAmB,uBAAA;AAgvEp+kC;;AAhvE0/kC;EAA8B,WAAA;EAAW,mBAAA;AAqvEnilC;;AArvEsjlC;EAAoB,oBAAA;EAAoB,eAAA;EAAe,iBAAA;AA2vE7mlC;;AA3vE8nlC;EAAsC,YAAA;EAAY,oBAAA;EAAoB,cAAA;AAiwEpslC;;AAjwEktlC;EAAkB,oCAAA;EAAqC,UAAA;EAAU,WAAA;EAAW,kBAAA;EAAiB,mBAAA;EAAgE,gBAAA;EAAgB,yCAAA;EAAyC,+CAAA;EAA+C,4BAAA;EAA4B,2BAAA;EAA2B,wBAAA;EAAwB,2DAAA;EAA2D,iCAAA;EAAoD,yBAAA;AAqxErpmC;;AArxE8qmC;EAAiC,qBAAA;AAyxE/smC;;AAzxEmumC;EAA8B,kBAAA;AA6xEjwmC;;AA7xEmxmC;EAAyB,uBAAA;AAiyE5ymC;;AAjyEm0mC;EAAwB,qBAAA;EAAqB,UAAA;EAAU,kDAAA;AAuyE13mC;;AAvyEu6mC;EAA0B,yBAAA;EAAyB,qBAAA;AA4yE19mC;;AA5yE++mC;EAAyC,gEAAA;AAgzExhnC;;AAhzE+wnC;EAAsC,gEAAA;AAozErznC;;AApzEo9nC;EAA+C,yBAAA;EAAyB,qBAAA;EAAqB,gEAAA;AA0zEjjoC;;AA1zEkyoC;EAA2B,oBAAA;EAAoB,YAAA;EAAY,YAAA;AAg0E71oC;;AAh0Ew2oC;EAA2F,eAAA;EAAe,YAAA;AAq0El9oC;;AAr0E69oC;EAAa,mBAAA;AAy0E1+oC;;AAz0E6/oC;EAA+B,2DAAA;EAA2K,UAAA;EAAU,mBAAA;EAAmB,0CAAA;EAA0C,gCAAA;EAAgC,kBAAA;EAAkB,iDAAA;AAm1Eh0pC;;AAn1Eg3pC;EAAuC;IAA+B,gBAAA;EAw1Ep7pC;AACF;AAz1Eu8pC;EAAqC,2DAAA;AA41E5+pC;;AA51EyoqC;EAAuC,iCAAA;EAAiC,2DAAA;AAi2EjtqC;;AAj2E22qC;EAAgC,oBAAA;EAAoB,eAAA;AAs2E/5qC;;AAt2E86qC;EAAkD,oBAAA;EAAoB,cAAA;AA22Ep/qC;;AA32EkgrC;EAAmB,qBAAA;EAAqB,kBAAA;AAg3E1irC;;AAh3E4jrC;EAAW,kBAAA;EAAkB,sBAAA;EAAmB,oBAAA;AAs3E5mrC;;AAt3EgorC;EAAmD,oBAAA;EAAoB,YAAA;EAAY,aAAA;AA43EntrC;;AA53E+trC;EAA8E,2DAAA;AAg4E7yrC;;AAh4E89rC;EAAY,WAAA;EAAW,cAAA;EAAc,UAAA;EAAuD,gBAAA;EAAgB,6BAAA;AA04E1ksC;;AA14EumsC;EAAkB,UAAA;AA84EznsC;;AA94EmosC;EAAwC,kEAAA;AAk5E3qsC;;AAl5EuusC;EAAoC,kEAAA;AAs5E3wsC;;AAt5Eu0sC;EAA8B,SAAA;AA05Er2sC;;AA15E82sC;EAAkC,WAAA;EAAW,YAAA;EAAY,oBAAA;EAA2C,gBAAA;EAAgB,yBAAA;EAAyB,SAAA;EAAS,mBAAA;EAAkI,oHAAA;EAAA,4GAAA;AAu6EtotC;;AAv6E6utC;EAAuC;IAA0D,wBAAA;IAAA,gBAAA;EA66E50tC;AACF;AA96E+1tC;EAAyC,yBAAA;AAi7Ex4tC;;AAj7Ei6tC;EAA2C,WAAA;EAAW,cAAA;EAAa,kBAAA;EAAkB,eAAA;EAAe,uCAAA;EAAuC,yBAAA;EAAyB,mBAAA;AA27ErkuC;;AA37EwluC;EAA8B,WAAA;EAAW,YAAA;EAAiC,gBAAA;EAAgB,yBAAA;EAAyB,SAAA;EAAS,mBAAA;EAA+H,iHAAA;EAAA,4GAAA;AAu8En1uC;;AAv8E07uC;EAAuC;IAAmD,qBAAA;IAAA,gBAAA;EA68ElhvC;AACF;AA98EqivC;EAAqC,yBAAA;AAi9E1kvC;;AAj9EmmvC;EAA8B,WAAA;EAAW,cAAA;EAAa,kBAAA;EAAkB,eAAA;EAAe,uCAAA;EAAuC,yBAAA;EAAyB,mBAAA;AA29E1vvC;;AA39E6wvC;EAAqB,oBAAA;AA+9ElyvC;;AA/9EszvC;EAA2C,2CAAA;AAm+Ej2vC;;AAn+E44vC;EAAuC,2CAAA;AAu+En7vC;;AAv+E89vC;EAAe,kBAAA;AA2+E7+vC;;AA3+E+/vC;EAAgG,iDAAA;EAAuD,qDAAA;EAA2D,iBAAA;AAi/EjtwC;;AAj/EkuwC;EAAqB,kBAAA;EAAkB,MAAA;EAAM,OAAA;EAAO,UAAA;EAAU,YAAA;EAAY,qBAAA;EAAoB,gBAAA;EAAgB,iBAAA;EAAiB,uBAAA;EAAuB,mBAAA;EAAmB,oBAAA;EAAoB,gDAAA;EAAgD,qBAAA;EAAqB,gEAAA;AAkgFp+wC;;AAlgFiixC;EAAuC;IAAqB,gBAAA;EAugF3lxC;AACF;AAxgF8mxC;EAAoE,qBAAA;AA2gFlrxC;;AA3gFg0xC;EAA8F,kBAAA;AAmhF95xC;;AAnhF0lyC;EAAoM,qBAAA;EAAqB,wBAAA;AA6hFnzyC;;AA7hF00yC;EAAsG,qBAAA;EAAqB,wBAAA;AAkiFr8yC;;AAliF49yC;EAA4B,qBAAA;EAAqB,wBAAA;AAuiF7gzC;;AAviFwszC;EAAmL,2CAAA;EAAyC,8DAAA;AAijFp6zC;;AAjjFwr0C;EAA+M,kBAAA;EAAkB,oBAAA;EAAoB,WAAA;EAAW,aAAA;EAAa,WAAA;EAAW,mCAAA;EAAmC,sCAAA;AAqkFn/0C;;AArkFyh1C;EAAoD,2CAAA;EAAyC,8DAAA;AA0kFtn1C;;AA1kFir1C;EAA6C,sCAAA;AA8kF9t1C;;AA9kFow1C;EAA2E,cAAA;AAklF/01C;;AAllF611C;EAAyF,wCAAA;AAslFt71C;;AAtlF891C;EAAa,kBAAA;EAAkB,aAAA;EAAa,eAAA;EAAe,oBAAA;EAAoB,WAAA;AA8lF7i2C;;AA9lFwj2C;EAAiF,kBAAA;EAAkB,cAAA;EAAc,SAAA;EAAS,YAAA;AAqmFlr2C;;AArmF8r2C;EAA0G,UAAA;AAymFxy2C;;AAzmFkz2C;EAAkB,kBAAA;EAAkB,UAAA;AA8mFt12C;;AA9mFg22C;EAAwB,UAAA;AAknFx32C;;AAlnFk42C;EAAkB,aAAA;EAAa,mBAAA;EAAmB,yBAAA;EAAuB,eAAA;EAAe,gBAAA;EAAgB,gBAAA;EAAgB,2BAAA;EAA2B,kBAAA;EAAkB,mBAAA;EAAmB,uCAAA;EAAuC,2DAAA;EAA2D,sCAAA;AAioF5p3C;;AAjoFks3C;EAAkH,oBAAA;EAAmB,kBAAA;EAAkB,yCAAA;AAuoFz13C;;AAvoFk43C;EAAkH,uBAAA;EAAqB,mBAAA;EAAkB,yCAAA;AA6oF3h4C;;AA7oFok4C;EAA0D,mBAAA;AAipF9n4C;;AAjpFip4C;EAAwV,0BAAA;EAA0B,6BAAA;AAspFng5C;;AAtpFgi5C;EAAyU,0BAAA;EAA0B,6BAAA;AA2pFn45C;;AA3pFg65C;EAA0I,8CAAA;EAA8C,yBAAA;EAAyB,4BAAA;AAiqFjn6C;;AAjqF6o6C;EAAuH,yBAAA;EAAyB,4BAAA;AAsqF7x6C;;AAtqFyz6C;EAAgB,aAAA;EAAa,WAAA;EAAW,mBAAA;EAAkB,kBAAA;EAAiB,iCAAA;AA8qFp46C;;AA9qFq66C;EAAe,kBAAA;EAAkB,SAAA;EAAS,UAAA;EAAU,aAAA;EAAa,eAAA;EAAe,uBAAA;EAAqB,kBAAA;EAAiB,mBAAA;EAAkB,WAAA;EAAW,mCAAA;EAAmC,sCAAA;AA4rF3l7C;;AA5rFio7C;EAA8H,cAAA;AAgsF/v7C;;AAhsF6w7C;EAA0D,+CAAA;EAA+C,oCAAA;EAAmC,yDAAA;EAA2P,4BAAA;EAA4B,2DAAA;EAAyD,gEAAA;AAysFzu8C;;AAzsFqy8C;EAAsE,+CAAA;EAA+C,2DAAA;AA8sF158C;;AA9sFk98C;EAA0E,oCAAA;EAAmC,kFAAA;AAmtF/j9C;;AAntF6o9C;EAAwD,+CAAA;AAutFrs9C;;AAvtFov9C;EAA4N,gEAAA;EAAmQ,uBAAA;EAAuB,+DAAA;EAA6D,2EAAA;AA8tFvy+C;;AA9tF62+C;EAAoE,+CAAA;EAA+C,2DAAA;AAmuFh++C;;AAnuFwh/C;EAAsE,mCAAA;AAuuF9l/C;;AAvuFso/C;EAAkE,+CAAA;AA2uFxs/C;;AA3uFuv/C;EAAkF,4CAAA;AA+uFz0/C;;AA/uFq3/C;EAA8E,2DAAA;AAmvFn8/C;;AAnvF2//C;EAAsG,iCAAA;AAuvFjmgD;;AAvvFkogD;EAAqD,kBAAA;AA2vFvrgD;;AA3vFwsgD;EAAkV,UAAA;AA+vF1hhD;;AA/vFoihD;EAAkB,aAAA;EAAa,WAAA;EAAW,mBAAA;EAAkB,kBAAA;EAAiB,mCAAA;AAuwFjnhD;;AAvwFophD;EAAiB,kBAAA;EAAkB,SAAA;EAAS,UAAA;EAAU,aAAA;EAAa,eAAA;EAAe,uBAAA;EAAqB,kBAAA;EAAiB,mBAAA;EAAkB,WAAA;EAAW,kCAAA;EAAkC,sCAAA;AAqxF30hD;;AArxFi3hD;EAA8I,cAAA;AAyxF//hD;;AAzxF6giD;EAA8D,iDAAA;EAAiD,oCAAA;EAAmC,0DAAA;EAA4U,4BAAA;EAA4B,2DAAA;EAAyD,gEAAA;AAkyFhkjD;;AAlyF4njD;EAA0E,iDAAA;EAAiD,0DAAA;AAuyFvvjD;;AAvyF8yjD;EAA8E,oCAAA;EAAmC,kFAAA;AA4yF/5jD;;AA5yF6+jD;EAA4D,iDAAA;AAgzFzikD;;AAhzF0lkD;EAAoO,iEAAA;EAAoV,uBAAA;EAAuB,+DAAA;EAA6D,2EAAA;AAuzFtulD;;AAvzF4ylD;EAAwE,iDAAA;EAAiD,0DAAA;AA4zFr6lD;;AA5zF49lD;EAA0E,mCAAA;AAg0FtimD;;AAh0F8kmD;EAAsE,iDAAA;AAo0FppmD;;AAp0FqsmD;EAAsF,8CAAA;AAw0F3xmD;;AAx0Fy0mD;EAAkF,0DAAA;AA40F35mD;;AA50Fk9mD;EAA0G,mCAAA;AAg1F5jnD;;AAh1F+lnD;EAAuD,kBAAA;AAo1FtpnD;;AAp1FuqnD;EAA8V,UAAA;AAw1FrgoD;;AAx1F+goD;EAAK,0BAAA;EAA2B,2BAAA;EAA4B,sBAAA;EAAuB,uBAAA;EAAwB,wBAAA;EAAyB,wBAAA;EAAyB,mCAAA;EAAoC,uBAAA;EAAwB,4CAAA;EAA6C,iCAAA;EAAkC,8CAAA;EAA+C,uCAAA;EAAwC,0FAAA;EAA2F,8BAAA;EAA+B,gFAAA;EAAiF,qBAAA;EAAqB,wDAAA;EAAwD,sCAAA;EAAsC,kCAAA;EAAkC,sCAAA;EAAsC,sCAAA;EAAsC,0BAAA;EAA0B,kBAAA;EAAkB,qBAAA;EAAqB,sBAAA;EAAsB,eAAA;EAAe,yBAAA;EAA+C,iBAAA;EAAiB,mEAAA;EAAmE,0CAAA;EAA0C,kCAAA;EAAkC,qIAAA;AA43F/mqD;;AA53F6uqD;EAAuC;IAAK,gBAAA;EAi4FvxqD;AACF;AAl4F0yqD;EAAW,gCAAA;EAAgC,wCAAA;EAAwC,8CAAA;AAu4F73qD;;AAv4F26qD;EAAsB,0BAAA;EAA0B,kCAAA;EAAkC,wCAAA;AA64F7/qD;;AA74FqirD;EAAmB,gCAAA;EAAgC,wCAAA;EAAwC,8CAAA;EAA8C,UAAA;EAAU,0CAAA;AAq5FxrrD;;AAr5FkurD;EAA8B,8CAAA;EAA8C,UAAA;EAAU,0CAAA;AA25FxzrD;;AA35Fk2rD;EAAmG,iCAAA;EAAiC,yCAAA;EAAyC,+CAAA;AAi6F/gsD;;AAj6F8jsD;EAAyK,0CAAA;AAq6FvusD;;AAr6FixsD;EAAmD,mCAAA;EAAmC,oBAAA;EAAoB,2CAAA;EAA2C,iDAAA;EAAiD,uCAAA;AA66Fv9sD;;AA76F8/sD;EAAa,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,oCAAA;EAAqC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AA87F/5tD;;AA97Fs8tD;EAAe,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,qCAAA;EAAsC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AA+8F12uD;;AA/8Fi5uD;EAAa,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,oCAAA;EAAqC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AAg+FlzvD;;AAh+Fy1vD;EAAU,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,oCAAA;EAAqC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AAi/FvvwD;;AAj/F8xwD;EAAa,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,mCAAA;EAAoC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AAkgG9rxD;;AAlgGquxD;EAAY,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,mCAAA;EAAoC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AAmhGpoyD;;AAnhG2qyD;EAAW,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,qCAAA;EAAsC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AAoiG3kzD;;AApiGknzD;EAAU,mBAAA;EAAoB,mBAAA;EAAoB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,kCAAA;EAAmC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,4BAAA;EAA6B,4BAAA;EAA6B,sCAAA;AAqjG9g0D;;AArjGqj0D;EAAqB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,oCAAA;EAAqC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AAskG3/0D;;AAtkG8g1D;EAAuB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,qCAAA;EAAsC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AAulGv91D;;AAvlG0+1D;EAAqB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,mCAAA;EAAoC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AAwmG/62D;;AAxmGk82D;EAAkB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,oCAAA;EAAqC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AAynGr43D;;AAznGw53D;EAAqB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,mCAAA;EAAoC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AA0oG714D;;AA1oGg34D;EAAoB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,mCAAA;EAAoC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AA2pGpz5D;;AA3pGu05D;EAAmB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,qCAAA;EAAsC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AA4qG5w6D;;AA5qG+x6D;EAAkB,sBAAA;EAAuB,6BAAA;EAA8B,yBAAA;EAA0B,yBAAA;EAA0B,mCAAA;EAAoC,kCAAA;EAAmC,0BAAA;EAA2B,0BAAA;EAA2B,oCAAA;EAAqC,2DAAA;EAA4D,+BAAA;EAAgC,gCAAA;EAAiC,sCAAA;EAAuC,kBAAA;AA6rGhu7D;;AA7rGmv7D;EAAU,wBAAA;EAAyB,mCAAA;EAAoC,uBAAA;EAAwB,iCAAA;EAAkC,+CAAA;EAAgD,uCAAA;EAAwC,gDAAA;EAAiD,wCAAA;EAAyC,+BAAA;EAAgC,0CAAA;EAA2C,8BAAA;EAA+B,oCAAA;EAAqC,0BAAA;AA6sGrr8D;;AA7sG+s8D;EAAwB,0BAAA;AAitGvu8D;;AAjtGiw8D;EAAgB,gCAAA;AAqtGjx8D;;AArtGiz8D;EAA2B,yBAAA;EAA0B,uBAAA;EAAwB,0BAAA;EAA2B,iDAAA;AA4tGz58D;;AA5tG288D;EAA2B,0BAAA;EAA2B,yBAAA;EAA0B,2BAAA;EAA4B,iDAAA;AAmuGvj9D;;AAnuGym9D;EAAM,gCAAA;AAuuG/m9D;;AAvuG8o9D;EAAuC;IAAM,gBAAA;EA4uGzr9D;AACF;AA7uG4s9D;EAAiB,UAAA;AAgvG7t9D;;AAhvGuu9D;EAAqB,aAAA;AAovG5v9D;;AApvGyw9D;EAAY,SAAA;EAAS,gBAAA;EAAgB,6BAAA;AA0vG9y9D;;AA1vG009D;EAAuC;IAAY,gBAAA;EA+vG339D;AACF;AAhwG849D;EAAgC,QAAA;EAAQ,YAAA;EAAY,4BAAA;AAqwGl89D;;AArwG699D;EAAuC;IAAgC,gBAAA;EA0wGli+D;AACF;AA3wGqj+D;EAAsE,kBAAA;AA8wG3n+D;;AA9wG6o+D;EAAiB,mBAAA;AAkxG9p+D;;AAlxGir+D;EAAwB,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;EAAW,uBAAA;EAAsB,qCAAA;EAAoC,gBAAA;EAAgB,oCAAA;AA6xG51+D;;AA7xG+3+D;EAA8B,cAAA;AAiyG75+D;;AAjyG26+D;EAAe,yBAAA;EAA0B,6BAAA;EAA8B,yBAAA;EAA0B,8BAAA;EAA+B,6BAAA;EAA8B,4BAAA;EAA6B,wCAAA;EAAyC,kCAAA;EAAmC,6DAAA;EAA8D,mDAAA;EAAoD,iDAAA;EAAkD,wFAAA;EAAyF,2DAAA;EAA4D,qCAAA;EAAsC,0DAAA;EAA2D,6CAAA;EAA8C,mDAAA;EAAoD,iDAAA;EAAkD,oCAAA;EAAqC,oCAAA;EAAqC,0DAAA;EAA2D,iCAAA;EAAkC,oCAAA;EAAqC,kCAAA;EAAmC,mCAAA;EAAoC,qCAAA;EAAsC,kBAAA;EAAkB,kCAAA;EAAkC,aAAA;EAAa,uCAAA;EAAuC,kEAAA;EAAkE,SAAA;EAAS,uCAAA;EAAuC,+BAAA;EAA+B,gBAAA;EAAgB,gBAAA;EAAgB,uCAAA;EAAuC,4BAAA;EAA4B,6EAAA;EAA6E,+CAAA;AA40Gl8hE;;AA50Gi/hE;EAA+B,SAAA;EAAS,OAAA;EAAO,qCAAA;AAk1GhiiE;;AAl1GqkiE;EAAqB,mBAAA;AAs1G1liE;;AAt1G8miE;EAAqC,WAAA;EAAW,OAAA;AA21G9piE;;AA31GqqiE;EAAmB,iBAAA;AA+1GxriE;;AA/1G0siE;EAAmC,QAAA;EAAQ,UAAA;AAo2GrviE;;AAp2G+viE;EAAyB;IAAwB,mBAAA;EAy2G9yiE;EAz2Gk0iE;IAAwC,WAAA;IAAW,OAAA;EA62Gr3iE;EA72G43iE;IAAsB,iBAAA;EAg3Gl5iE;EAh3Go6iE;IAAsC,QAAA;IAAQ,UAAA;EAo3Gl9iE;AACF;AAr3G+9iE;EAAyB;IAAwB,mBAAA;EAy3G9gjE;EAz3GkijE;IAAwC,WAAA;IAAW,OAAA;EA63GrljE;EA73G4ljE;IAAsB,iBAAA;EAg4GlnjE;EAh4GoojE;IAAsC,QAAA;IAAQ,UAAA;EAo4GlrjE;AACF;AAr4G+rjE;EAAyB;IAAwB,mBAAA;EAy4G9ujE;EAz4GkwjE;IAAwC,WAAA;IAAW,OAAA;EA64GrzjE;EA74G4zjE;IAAsB,iBAAA;EAg5Gl1jE;EAh5Go2jE;IAAsC,QAAA;IAAQ,UAAA;EAo5Gl5jE;AACF;AAr5G+5jE;EAA0B;IAAwB,mBAAA;EAy5G/8jE;EAz5Gm+jE;IAAwC,WAAA;IAAW,OAAA;EA65GthkE;EA75G6hkE;IAAsB,iBAAA;EAg6GnjkE;EAh6GqkkE;IAAsC,QAAA;IAAQ,UAAA;EAo6GnnkE;AACF;AAr6GgokE;EAA0B;IAAyB,mBAAA;EAy6GjrkE;EAz6GqskE;IAAyC,WAAA;IAAW,OAAA;EA66GzvkE;EA76GgwkE;IAAuB,iBAAA;EAg7GvxkE;EAh7GyykE;IAAuC,QAAA;IAAQ,UAAA;EAo7Gx1kE;AACF;AAr7Gq2kE;EAAuC,SAAA;EAAS,YAAA;EAAY,aAAA;EAAa,wCAAA;AA27G96kE;;AA37Gs9kE;EAAgC,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;EAAW,aAAA;EAAa,qCAAA;EAAoC,0BAAA;EAAyB,oCAAA;AAs8GzolE;;AAt8G4qlE;EAAsC,cAAA;AA08GltlE;;AA18GgulE;EAAwC,MAAA;EAAM,WAAA;EAAW,UAAA;EAAU,aAAA;EAAa,sCAAA;AAk9GhzlE;;AAl9Gs1lE;EAAiC,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;EAAW,mCAAA;EAAkC,eAAA;EAAe,sCAAA;EAAqC,wBAAA;AA69GthmE;;AA79G6imE;EAAuC,cAAA;AAi+GplmE;;AAj+GkmmE;EAAiC,iBAAA;AAq+GnomE;;AAr+GopmE;EAA0C,MAAA;EAAM,WAAA;EAAW,UAAA;EAAU,aAAA;EAAa,uCAAA;AA6+GtumE;;AA7+G6wmE;EAAmC,qBAAA;EAAqB,oBAAA;EAAmB,uBAAA;EAAsB,WAAA;AAo/G92mE;;AAp/Gy3mE;EAAmC,aAAA;AAw/G55mE;;AAx/Gy6mE;EAAoC,qBAAA;EAAqB,qBAAA;EAAoB,uBAAA;EAAsB,WAAA;EAAW,mCAAA;EAAkC,yBAAA;EAAwB,sCAAA;AAkgHjlnE;;AAlgHsnnE;EAAyC,cAAA;AAsgH/pnE;;AAtgH6qnE;EAAoC,iBAAA;AA0gHjtnE;;AA1gHkunE;EAAkB,SAAA;EAAS,6CAAA;EAA6C,gBAAA;EAAgB,mDAAA;EAAmD,UAAA;AAkhH72nE;;AAlhHu3nE;EAAe,cAAA;EAAc,WAAA;EAAW,4EAAA;EAA4E,WAAA;EAAW,gBAAA;EAAgB,oCAAA;EAAoC,mBAAA;EAAmB,qBAAA;EAAqB,mBAAA;EAAmB,6BAAA;EAA6B,SAAA;EAAS,uDAAA;AAiiH3ooE;;AAjiHisoE;EAA0C,0CAAA;EAA0C,kDAAA;AAsiHrxoE;;AAtiHu0oE;EAA4C,2CAAA;EAA2C,qBAAA;EAAqB,mDAAA;AA4iHn7oE;;AA5iHs+oE;EAAgD,6CAAA;EAA6C,oBAAA;EAAoB,6BAAA;AAkjHvlpE;;AAljHonpE;EAAoB,cAAA;AAsjHxopE;;AAtjHsppE;EAAiB,cAAA;EAAc,gFAAA;EAAgF,gBAAA;EAAgB,mBAAA;EAAkB,sCAAA;EAAsC,mBAAA;AA+jH70pE;;AA/jHg2pE;EAAoB,cAAA;EAAc,4EAAA;EAA4E,oCAAA;AAqkH98pE;;AArkHk/pE;EAAoB,2BAAA;EAA4B,wBAAA;EAAyB,6DAAA;EAA8D,0BAAA;EAA2B,gCAAA;EAAiC,mCAAA;EAAoC,2DAAA;EAA4D,qDAAA;EAAsD,oCAAA;EAAqC,oCAAA;EAAqC,yCAAA;EAA0C,kCAAA;AAolH/7qE;;AAplHk+qE;EAA+B,kBAAA;EAAkB,oBAAA;EAAoB,sBAAA;AA0lHvirE;;AA1lH6jrE;EAAyC,kBAAA;EAAkB,cAAA;AA+lHxnrE;;AA/lHsorE;EAAkX,UAAA;AAmmHx/rE;;AAnmHkgsE;EAAa,aAAA;EAAa,eAAA;EAAe,2BAAA;AAymH3isE;;AAzmHsksE;EAA0B,WAAA;AA6mHhmsE;;AA7mH2msE;EAAW,sCAAA;AAinHtnsE;;AAjnH4psE;EAAqF,8CAAA;AAqnHjvsE;;AArnH+xsE;EAAqJ,0BAAA;EAA0B,6BAAA;AA0nH98sE;;AA1nH2+sE;EAA6G,yBAAA;EAAyB,4BAAA;AA+nHjntE;;AA/nH6otE;EAAuB,wBAAA;EAAuB,uBAAA;AAooH3rtE;;AApoHittE;EAA2G,cAAA;AAwoH5ztE;;AAxoH00tE;EAA0C,eAAA;AA4oHp3tE;;AA5oHm4tE;EAAyE,uBAAA;EAAsB,sBAAA;AAipHl+tE;;AAjpHu/tE;EAAyE,sBAAA;EAAqB,qBAAA;AAspHrluE;;AAtpHymuE;EAAoB,sBAAA;EAAsB,uBAAA;EAAuB,uBAAA;AA4pH1quE;;AA5pHisuE;EAAwD,WAAA;AAgqHzvuE;;AAhqHowuE;EAA4F,6CAAA;AAoqHh2uE;;AApqH64uE;EAAqH,6BAAA;EAA6B,4BAAA;AAyqH/hvE;;AAzqH2jvE;EAAoF,yBAAA;EAAyB,0BAAA;AA8qHxqvE;;AA9qHksvE;EAAK,4BAAA;EAA6B,8BAAA;EAA+B,2BAAA;EAA4B,wCAAA;EAAyC,oDAAA;EAAqD,sDAAA;EAAuD,aAAA;EAAa,eAAA;EAAe,eAAA;EAAe,gBAAA;EAAgB,gBAAA;AA4rH/+vE;;AA5rH+/vE;EAAU,cAAA;EAAc,kEAAA;EAAkE,uCAAA;EAAuC,2CAAA;EAA2C,+BAAA;EAA+B,qBAAA;EAAqB,eAAA;EAAe,SAAA;EAAS,uGAAA;AAwsHvvwE;;AAxsHy1wE;EAAuC;IAAU,gBAAA;EA6sHx4wE;AACF;AA9sH25wE;EAAgC,qCAAA;AAitH37wE;;AAjtHg+wE;EAAwB,UAAA;EAAU,kDAAA;AAstHlgxE;;AAttH+ixE;EAAsC,wCAAA;EAAwC,oBAAA;EAAoB,eAAA;AA4tHjpxE;;AA5tHgqxE;EAAU,iDAAA;EAAkD,iDAAA;EAAkD,mDAAA;EAAoD,0GAAA;EAA2G,wDAAA;EAAyD,8CAAA;EAA+C,sGAAA;EAAuG,oFAAA;AAuuH5nyE;;AAvuHgtyE;EAAoB,yDAAA;EAAyD,yDAAA;EAAyD,wDAAA;EAAwD,yDAAA;AA8uH94yE;;AA9uHu8yE;EAAoD,kBAAA;EAAkB,wDAAA;AAmvH7gzE;;AAnvHqkzE;EAA8D,2CAAA;EAA2C,mDAAA;EAAmD,yDAAA;AAyvHjuzE;;AAzvH0xzE;EAAyB,sDAAA;EAAsD,yBAAA;EAAyB,0BAAA;AA+vHl4zE;;AA/vH45zE;EAAW,oDAAA;EAAqD,qCAAA;EAAsC,qCAAA;AAqwHlg0E;;AArwHwi0E;EAAqB,gDAAA;AAywH7j0E;;AAzwH6m0E;EAAuD,4CAAA;EAA4C,oDAAA;AA8wHht0E;;AA9wHow0E;EAAe,2BAAA;EAA4B,wCAAA;EAAyC,6DAAA;EAA8D,gCAAA;AAqxHt50E;;AArxHs70E;EAAyB,gBAAA;EAAgB,eAAA;EAAe,qEAAA;AA2xH9+0E;;AA3xHmj1E;EAA8D,iCAAA;AA+xHjn1E;;AA/xHkp1E;EAA+D,gBAAA;EAAgB,gDAAA;EAAgD,iCAAA;AAqyHjx1E;;AAryHkz1E;EAAwC,cAAA;EAAc,kBAAA;AA0yHx21E;;AA1yH031E;EAAkD,aAAA;EAAa,YAAA;EAAY,kBAAA;AAgzHr81E;;AAhzHu91E;EAAiE,WAAA;AAozHxh2E;;AApzHmi2E;EAAuB,aAAA;AAwzH1j2E;;AAxzHuk2E;EAAqB,cAAA;AA4zH5l2E;;AA5zH0m2E;EAAQ,uBAAA;EAAwB,4BAAA;EAA6B,0DAAA;EAA2D,+DAAA;EAAgE,kEAAA;EAAmE,8DAAA;EAA+D,qCAAA;EAAsC,iCAAA;EAAkC,mCAAA;EAAoC,6DAAA;EAA8D,mEAAA;EAAoE,qCAAA;EAAsC,qCAAA;EAAsC,qCAAA;EAAsC,qCAAA;EAAsC,oEAAA;EAA2Q,yEAAA;EAA0E,yDAAA;EAA0D,uCAAA;EAAwC,2DAAA;EAA4D,kBAAA;EAAkB,aAAA;EAAa,eAAA;EAAe,mBAAA;EAAmB,8BAAA;EAA8B,8DAAA;AAy1H534E;;AAz1H074E;EAA2J,aAAA;EAAa,kBAAA;EAAkB,mBAAA;EAAmB,8BAAA;AAg2Hvo5E;;AAh2Hqq5E;EAAc,6CAAA;EAA6C,gDAAA;EAAgD,+CAAA;EAA+C,2CAAA;EAA2C,mCAAA;EAAmC,qBAAA;EAAqB,mBAAA;AA02Hl65E;;AA12Hq75E;EAAwC,yCAAA;AA82H795E;;AA92Hsg6E;EAAY,yBAAA;EAA0B,8BAAA;EAA+B,2BAAA;EAA4B,0CAAA;EAA2C,sDAAA;EAAuD,4DAAA;EAA6D,aAAA;EAAa,sBAAA;EAAsB,eAAA;EAAe,gBAAA;EAAgB,gBAAA;AA43Hx06E;;AA53Hw16E;EAAwD,oCAAA;AAg4Hh56E;;AAh4Ho76E;EAA2B,gBAAA;AAo4H/86E;;AAp4H+96E;EAAa,mBAAA;EAAkB,sBAAA;EAAqB,6BAAA;AA04Hnh7E;;AA14Hgj7E;EAAyD,oCAAA;AA84Hzm7E;;AA94H6o7E;EAAiB,gBAAA;EAAgB,YAAA;EAAY,mBAAA;AAo5H1r7E;;AAp5H6s7E;EAAgB,8EAAA;EAA8E,6CAAA;EAA6C,cAAA;EAAc,6BAAA;EAA6B,6BAAA;EAA6B,0EAAA;EAA0E,qDAAA;EAAqD,+CAAA;AA+5H/h8E;;AA/5H8k8E;EAAuC;IAAgB,gBAAA;EAo6Hno8E;AACF;AAr6Hsp8E;EAAsB,qBAAA;AAw6H5q8E;;AAx6His8E;EAAsB,qBAAA;EAAqB,UAAA;EAAU,sDAAA;AA86Htv8E;;AA96H4y8E;EAAqB,qBAAA;EAAqB,YAAA;EAAY,aAAA;EAAa,sBAAA;EAAsB,kDAAA;EAAkD,4BAAA;EAA4B,2BAAA;EAA2B,qBAAA;AAy7H9+8E;;AAz7Hmg9E;EAAmB,yCAAA;EAAwC,gBAAA;AA87H9j9E;;AA97H8k9E;EAAyB;IAAkB,iBAAA;IAAiB,2BAAA;EAo8Hxo9E;EAp8Hmq9E;IAA8B,mBAAA;EAu8Hjs9E;EAv8Hot9E;IAA6C,kBAAA;EA08Hjw9E;EA18Hmx9E;IAAwC,kDAAA;IAAkD,iDAAA;EA88H729E;EA98H859E;IAAqC,iBAAA;EAi9Hn89E;EAj9Ho99E;IAAmC,wBAAA;IAAuB,gBAAA;EAq9H9g+E;EAr9H8h+E;IAAkC,aAAA;EAw9Hhk+E;EAx9H6k+E;IAA6B,gBAAA;IAAgB,aAAA;IAAa,YAAA;IAAY,sBAAA;IAAqB,uBAAA;IAAsB,8BAAA;IAA6B,wCAAA;IAAuC,oBAAA;IAAmB,0BAAA;IAAyB,gBAAA;EAo+H9y+E;EAp+H8z+E;IAA+C,aAAA;EAu+H72+E;EAv+H03+E;IAA6C,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;EA6+H18+E;AACF;AA9+Hg++E;EAAyB;IAAkB,iBAAA;IAAiB,2BAAA;EAm/H1h/E;EAn/Hqj/E;IAA8B,mBAAA;EAs/Hnl/E;EAt/Hsm/E;IAA6C,kBAAA;EAy/Hnp/E;EAz/Hqq/E;IAAwC,kDAAA;IAAkD,iDAAA;EA6/H/v/E;EA7/Hgz/E;IAAqC,iBAAA;EAggIr1/E;EAhgIs2/E;IAAmC,wBAAA;IAAuB,gBAAA;EAogIh6/E;EApgIg7/E;IAAkC,aAAA;EAugIl9/E;EAvgI+9/E;IAA6B,gBAAA;IAAgB,aAAA;IAAa,YAAA;IAAY,sBAAA;IAAqB,uBAAA;IAAsB,8BAAA;IAA6B,wCAAA;IAAuC,oBAAA;IAAmB,0BAAA;IAAyB,gBAAA;EAmhIhsgF;EAnhIgtgF;IAA+C,aAAA;EAshI/vgF;EAthI4wgF;IAA6C,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;EA4hI51gF;AACF;AA7hIk3gF;EAAyB;IAAkB,iBAAA;IAAiB,2BAAA;EAkiI56gF;EAliIu8gF;IAA8B,mBAAA;EAqiIr+gF;EAriIw/gF;IAA6C,kBAAA;EAwiIrihF;EAxiIujhF;IAAwC,kDAAA;IAAkD,iDAAA;EA4iIjphF;EA5iIkshF;IAAqC,iBAAA;EA+iIvuhF;EA/iIwvhF;IAAmC,wBAAA;IAAuB,gBAAA;EAmjIlzhF;EAnjIk0hF;IAAkC,aAAA;EAsjIp2hF;EAtjIi3hF;IAA6B,gBAAA;IAAgB,aAAA;IAAa,YAAA;IAAY,sBAAA;IAAqB,uBAAA;IAAsB,8BAAA;IAA6B,wCAAA;IAAuC,oBAAA;IAAmB,0BAAA;IAAyB,gBAAA;EAkkIlliF;EAlkIkmiF;IAA+C,aAAA;EAqkIjpiF;EArkI8piF;IAA6C,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;EA2kI9uiF;AACF;AA5kIowiF;EAA0B;IAAkB,iBAAA;IAAiB,2BAAA;EAilI/ziF;EAjlI01iF;IAA8B,mBAAA;EAolIx3iF;EAplI24iF;IAA6C,kBAAA;EAulIx7iF;EAvlI08iF;IAAwC,kDAAA;IAAkD,iDAAA;EA2lIpijF;EA3lIqljF;IAAqC,iBAAA;EA8lI1njF;EA9lI2ojF;IAAmC,wBAAA;IAAuB,gBAAA;EAkmIrsjF;EAlmIqtjF;IAAkC,aAAA;EAqmIvvjF;EArmIowjF;IAA6B,gBAAA;IAAgB,aAAA;IAAa,YAAA;IAAY,sBAAA;IAAqB,uBAAA;IAAsB,8BAAA;IAA6B,wCAAA;IAAuC,oBAAA;IAAmB,0BAAA;IAAyB,gBAAA;EAinIr+jF;EAjnIq/jF;IAA+C,aAAA;EAonIpikF;EApnIijkF;IAA6C,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;EA0nIjokF;AACF;AA3nIupkF;EAA0B;IAAmB,iBAAA;IAAiB,2BAAA;EAgoIntkF;EAhoI8ukF;IAA+B,mBAAA;EAmoI7wkF;EAnoIgykF;IAA8C,kBAAA;EAsoI90kF;EAtoIg2kF;IAAyC,kDAAA;IAAkD,iDAAA;EA0oI37kF;EA1oI4+kF;IAAsC,iBAAA;EA6oIlhlF;EA7oImilF;IAAoC,wBAAA;IAAuB,gBAAA;EAipI9llF;EAjpI8mlF;IAAmC,aAAA;EAopIjplF;EAppI8plF;IAA8B,gBAAA;IAAgB,aAAA;IAAa,YAAA;IAAY,sBAAA;IAAqB,uBAAA;IAAsB,8BAAA;IAA6B,wCAAA;IAAuC,oBAAA;IAAmB,0BAAA;IAAyB,gBAAA;EAgqIh4lF;EAhqIg5lF;IAAgD,aAAA;EAmqIh8lF;EAnqI68lF;IAA8C,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;EAyqI9hmF;AACF;AA1qIojmF;EAAe,iBAAA;EAAiB,2BAAA;AA8qIplmF;;AA9qI+mmF;EAA2B,mBAAA;AAkrI1omF;;AAlrI6pmF;EAA0C,kBAAA;AAsrIvsmF;;AAtrIytmF;EAAqC,kDAAA;EAAkD,iDAAA;AA2rIhzmF;;AA3rIi2mF;EAAkC,iBAAA;AA+rIn4mF;;AA/rIo5mF;EAAgC,wBAAA;EAAuB,gBAAA;AAosI38mF;;AApsI29mF;EAA+B,aAAA;AAwsI1/mF;;AAxsIugnF;EAA0B,gBAAA;EAAgB,aAAA;EAAa,YAAA;EAAY,sBAAA;EAAqB,uBAAA;EAAsB,8BAAA;EAA6B,wCAAA;EAAuC,oBAAA;EAAmB,0BAAA;EAAyB,gBAAA;AAqtIrunF;;AArtIqvnF;EAA4C,aAAA;AAytIjynF;;AAztI8ynF;EAA0C,aAAA;EAAa,YAAA;EAAY,UAAA;EAAU,mBAAA;AAguI33nF;;AAhuI84nF;EAAyC,2CAAA;EAA4C,iDAAA;EAAkD,oDAAA;EAAqD,6BAAA;EAA8B,4BAAA;EAA6B,kCAAA;EAAmC,yDAAA;EAA0D,oEAAA;AA2uIluoF;;AA3uIg/oF;EAA0C,oEAAA;AA+uI1hpF;;AA/uIwypF;EAAM,uBAAA;EAAwB,uBAAA;EAAwB,+BAAA;EAAgC,uBAAA;EAAwB,0BAAA;EAA2B,6CAAA;EAA8C,yDAAA;EAA0D,+CAAA;EAAgD,sBAAA;EAAuB,sFAAA;EAAuF,8BAAA;EAA+B,4BAAA;EAA6B,qDAAA;EAAsD,qBAAA;EAAsB,kBAAA;EAAmB,iBAAA;EAAkB,8BAAA;EAA+B,kCAAA;EAAmC,8BAAA;EAA+B,kBAAA;EAAkB,aAAA;EAAa,sBAAA;EAAsB,YAAA;EAAY,6BAAA;EAA6B,2BAAA;EAA2B,qBAAA;EAAqB,mCAAA;EAAmC,2BAAA;EAA2B,qEAAA;EAAqE,2CAAA;AAgxIttrF;;AAhxIiwrF;EAAS,eAAA;EAAe,cAAA;AAqxIzxrF;;AArxIuyrF;EAAkB,mBAAA;EAAmB,sBAAA;AA0xI50rF;;AA1xIk2rF;EAA8B,mBAAA;EAAmB,0DAAA;EAA0D,2DAAA;AAgyI78rF;;AAhyIwgsF;EAA6B,sBAAA;EAAsB,8DAAA;EAA8D,6DAAA;AAsyIznsF;;AAtyIsrsF;EAA8D,aAAA;AA0yIpvsF;;AA1yIiwsF;EAAW,cAAA;EAAc,wDAAA;EAAwD,2BAAA;AAgzIl1sF;;AAhzI62sF;EAAY,4CAAA;EAA4C,iCAAA;AAqzIr6sF;;AArzIs8sF;EAAe,sDAAA;EAAqD,gBAAA;EAAgB,oCAAA;AA2zI1htF;;AA3zI8jtF;EAAsB,gBAAA;AA+zIpltF;;AA/zIomtF;EAAsB,oCAAA;AAm0I1ntF;;AAn0I8ptF;EAAa,kEAAA;EAAkE,gBAAA;EAAgB,+BAAA;EAA+B,uCAAA;EAAuC,4EAAA;AA20In0tF;;AA30I+4tF;EAAyB,wFAAA;AA+0Ix6tF;;AA/0IgguF;EAAa,kEAAA;EAAkE,+BAAA;EAA+B,uCAAA;EAAuC,yEAAA;AAs1IrpuF;;AAt1I8tuF;EAAwB,wFAAA;AA01ItvuF;;AA11I80uF;EAAkB,uDAAA;EAAsD,sDAAA;EAAsD,sDAAA;EAAqD,gBAAA;AAi2IjgvF;;AAj2IihvF;EAAmC,mCAAA;EAAmC,sCAAA;AAs2IvlvF;;AAt2I6nvF;EAAmB,uDAAA;EAAsD,sDAAA;AA22ItsvF;;AA32I2vvF;EAAkB,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,2CAAA;EAA2C,iDAAA;AAq3Ix2vF;;AAr3Iy5vF;EAAyC,WAAA;AAy3Il8vF;;AAz3I68vF;EAAwB,0DAAA;EAA0D,2DAAA;AA83I/hwF;;AA93I0lwF;EAA2B,8DAAA;EAA8D,6DAAA;AAm4InrwF;;AAn4IgvwF;EAAkB,0CAAA;AAu4IlwwF;;AAv4I4ywF;EAAyB;IAAY,aAAA;IAAa,mBAAA;EA64I51wF;EA74I+2wF;IAAkB,SAAA;IAAY,gBAAA;EAi5I74wF;EAj5I65wF;IAAwB,cAAA;IAAc,cAAA;EAq5In8wF;EAr5Ii9wF;IAAmC,0BAAA;IAA0B,6BAAA;EAy5I9gxF;EAz5I2ixF;IAAiG,0BAAA;EA45I5oxF;EA55IsqxF;IAAoG,6BAAA;EA+5I1wxF;EA/5IuyxF;IAAoC,yBAAA;IAAyB,4BAAA;EAm6Ip2xF;EAn6Ig4xF;IAAmG,yBAAA;EAs6In+xF;EAt6I4/xF;IAAsG,4BAAA;EAy6IlmyF;AACF;AA16IioyF;EAAW,yCAAA;EAA0C,mCAAA;EAAoC,yKAAA;EAA0K,kDAAA;EAAmD,kDAAA;EAAmD,oDAAA;EAAqD,2FAAA;EAA4F,oCAAA;EAAqC,iCAAA;EAAkC,6CAAA;EAA8C,4CAAA;EAA6C,gEAAA;EAAwS,qCAAA;EAAsC,iDAAA;EAAkD,6DAAA;EAA8D,uEAAA;EAA+S,6CAAA;EAA8C,0EAAA;EAA2E,qCAAA;EAAsC,kCAAA;EAAmC,2DAAA;EAA4D,oDAAA;AAk8Ixw1F;;AAl8I6z1F;EAAkB,kBAAA;EAAkB,aAAA;EAAa,mBAAA;EAAmB,WAAA;EAAW,4EAAA;EAA4E,eAAA;EAAe,oCAAA;EAAoC,gBAAA;EAAgB,4CAAA;EAA4C,SAAA;EAAS,gBAAA;EAAgB,qBAAA;EAAqB,0CAAA;AAk9Irn2F;;AAl9I+p2F;EAAuC;IAAkB,gBAAA;EAu9Itt2F;AACF;AAx9Iyu2F;EAAkC,uCAAA;EAAuC,+CAAA;EAA+C,kGAAA;AA69Ij22F;;AA79Im82F;EAAyC,qDAAA;EAAqD,iDAAA;AAk+Iji3F;;AAl+Ikl3F;EAAyB,cAAA;EAAc,yCAAA;EAAyC,0CAAA;EAA0C,iBAAA;EAAiB,WAAA;EAAW,8CAAA;EAA8C,4BAAA;EAA4B,mDAAA;EAAmD,mDAAA;AA8+Ir23F;;AA9+Iw53F;EAAuC;IAAyB,gBAAA;EAm/It93F;AACF;AAp/Iy+3F;EAAwB,UAAA;AAu/Ijg4F;;AAv/I2g4F;EAAwB,UAAA;EAAU,wDAAA;EAAwD,UAAA;EAAU,oDAAA;AA8/I/m4F;;AA9/Imq4F;EAAkB,gBAAA;AAkgJrr4F;;AAlgJqs4F;EAAgB,gCAAA;EAAgC,wCAAA;EAAwC,+EAAA;AAwgJ7x4F;;AAxgJ424F;EAA8B,yDAAA;EAAyD,0DAAA;AA6gJn84F;;AA7gJ6/4F;EAAgD,+DAAA;EAA+D,gEAAA;AAkhJ5m5F;;AAlhJ4q5F;EAAoC,aAAA;AAshJht5F;;AAthJ6t5F;EAA6B,6DAAA;EAA6D,4DAAA;AA2hJvz5F;;AA3hJm35F;EAAyD,mEAAA;EAAmE,kEAAA;AAgiJ/+5F;;AAhiJij6F;EAAiD,6DAAA;EAA6D,4DAAA;AAqiJ/p6F;;AAriJ2t6F;EAAgB,8EAAA;AAyiJ3u6F;;AAziJyz6F;EAAqC,eAAA;AA6iJ916F;;AA7iJ626F;EAAiC,eAAA;EAAe,cAAA;EAAc,gBAAA;AAmjJ366F;;AAnjJ276F;EAA6C,aAAA;AAujJx+6F;;AAvjJq/6F;EAA4C,gBAAA;AA2jJji7F;;AA3jJij7F;EAAgH,gBAAA;AA+jJjq7F;;AA/jJir7F;EAA8C,gEAAA;EAAwS,uEAAA;AAokJvg8F;;AApkJsz8F;EAAY,2BAAA;EAA4B,2BAAA;EAA4B,kCAAA;EAAmC,oBAAA;EAAqB,+BAAA;EAAgC,uDAAA;EAAwD,qCAAA;EAAsC,2DAAA;EAA4D,aAAA;EAAa,eAAA;EAAe,sEAAA;EAAsE,iDAAA;EAAiD,yCAAA;EAAyC,gBAAA;EAAgB,yCAAA;EAAyC,iDAAA;AAulJj29F;;AAvlJk59F;EAAkC,iDAAA;AA2lJp79F;;AA3lJq+9F;EAA0C,WAAA;EAAW,kDAAA;EAAkD,yCAAA;EAAyC,0CAAA;AAkmJrn+F;;AAlmJ+p+F;EAAwB,6CAAA;AAsmJvr+F;;AAtmJou+F;EAAY,iCAAA;EAAkC,kCAAA;EAAmC,8BAAA;EAA+B,0CAAA;EAA2C,oCAAA;EAAqC,mDAAA;EAAoD,mDAAA;EAAoD,qDAAA;EAAsD,sDAAA;EAAuD,8CAAA;EAA+C,yDAAA;EAA0D,sDAAA;EAAuD,+CAAA;EAAgD,uEAAA;EAAwE,iCAAA;EAAkC,iCAAA;EAAkC,2CAAA;EAA4C,wDAAA;EAAyD,kDAAA;EAAmD,4DAAA;EAA6D,aAAA;EAAa,eAAA;EAAe,gBAAA;AAgoJtsgG;;AAhoJstgG;EAAW,kBAAA;EAAkB,cAAA;EAAc,sEAAA;EAAsE,yCAAA;EAAyC,iCAAA;EAAiC,qBAAA;EAAqB,yCAAA;EAAyC,iFAAA;EAAiF,qIAAA;AA4oJhihG;;AA5oJ8phG;EAAuC;IAAW,gBAAA;EAipJ9shG;AACF;AAlpJiuhG;EAAiB,UAAA;EAAU,uCAAA;EAAuC,+CAAA;EAA+C,qDAAA;AAwpJl1hG;;AAxpJu4hG;EAAiB,UAAA;EAAU,uCAAA;EAAuC,+CAAA;EAA+C,UAAA;EAAU,iDAAA;AAgqJlgiG;;AAhqJmjiG;EAAqC,UAAA;EAAU,wCAAA;EAAwC,gDAAA;EAAgD,sDAAA;AAuqJ1riG;;AAvqJgviG;EAAyC,0CAAA;EAA0C,oBAAA;EAAoB,kDAAA;EAAkD,wDAAA;AA8qJz4iG;;AA9qJi8iG;EAAwC,8CAAA;AAkrJz+iG;;AAlrJuhjG;EAAkC,0DAAA;EAA0D,6DAAA;AAurJnnjG;;AAvrJgrjG;EAAiC,2DAAA;EAA2D,8DAAA;AA4rJ5wjG;;AA5rJ00jG;EAAe,gCAAA;EAAiC,iCAAA;EAAkC,iCAAA;EAAkC,wDAAA;AAmsJ97jG;;AAnsJu/jG;EAAe,gCAAA;EAAiC,iCAAA;EAAkC,kCAAA;EAAmC,wDAAA;AA0sJ5mkG;;AA1sJqqkG;EAAO,2BAAA;EAA4B,2BAAA;EAA4B,2BAAA;EAA4B,0BAAA;EAA2B,qBAAA;EAAsB,gDAAA;EAAiD,qBAAA;EAAqB,4DAAA;EAA4D,oCAAA;EAAoC,wCAAA;EAAwC,cAAA;EAAc,4BAAA;EAA4B,kBAAA;EAAkB,mBAAA;EAAmB,wBAAA;EAAwB,4CAAA;AA6tJtmlG;;AA7tJkplG;EAAa,aAAA;AAiuJ/plG;;AAjuJ4qlG;EAAY,kBAAA;EAAkB,SAAA;AAsuJ1slG;;AAtuJmtlG;EAAO,yBAAA;EAA0B,yBAAA;EAA0B,yBAAA;EAA0B,6BAAA;EAA8B,wBAAA;EAAyB,mCAAA;EAAoC,2EAAA;EAA4E,gDAAA;EAAiD,6BAAA;EAA8B,kBAAA;EAAkB,4DAAA;EAA4D,4CAAA;EAA4C,4BAAA;EAA4B,oCAAA;EAAoC,8BAAA;EAA8B,4CAAA;AAyvJtvmG;;AAzvJkymG;EAAe,cAAA;AA6vJjzmG;;AA7vJ+zmG;EAAY,gBAAA;EAAgB,iCAAA;AAkwJ31mG;;AAlwJ43mG;EAAmB,mBAAA;AAswJ/4mG;;AAtwJk6mG;EAA8B,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,UAAA;EAAU,qBAAA;AA8wJ1+mG;;AA9wJ+/mG;EAAe,gDAAA;EAAiD,yCAAA;EAA0C,uDAAA;EAAwD,qDAAA;AAqxJjqnG;;AArxJutnG;EAAiB,kDAAA;EAAmD,2CAAA;EAA4C,yDAAA;EAA0D,uDAAA;AA4xJj4nG;;AA5xJy7nG;EAAe,gDAAA;EAAiD,yCAAA;EAA0C,uDAAA;EAAwD,qDAAA;AAmyJ3loG;;AAnyJipoG;EAAY,6CAAA;EAA8C,sCAAA;EAAuC,oDAAA;EAAqD,kDAAA;AA0yJvyoG;;AA1yJ01oG;EAAe,gDAAA;EAAiD,yCAAA;EAA0C,uDAAA;EAAwD,qDAAA;AAizJ5/oG;;AAjzJkjpG;EAAc,+CAAA;EAAgD,wCAAA;EAAyC,sDAAA;EAAuD,oDAAA;AAwzJhtpG;;AAxzJqwpG;EAAa,8CAAA;EAA+C,uCAAA;EAAwC,qDAAA;EAAsD,mDAAA;AA+zJ/5pG;;AA/zJm9pG;EAAY,6CAAA;EAA8C,sCAAA;EAAuC,oDAAA;EAAqD,kDAAA;AAs0JzmqG;;AAt0J4pqG;EAAgC;IAAG,2BAAA;EA20J7rqG;AACF;AA50J2tqG;EAA4B,yBAAA;EAA0B,+BAAA;EAAgC,uCAAA;EAAwC,mDAAA;EAAoD,mDAAA;EAAoD,4BAAA;EAA6B,4BAAA;EAA6B,4CAAA;EAA6C,aAAA;EAAa,iCAAA;EAAiC,gBAAA;EAAgB,uCAAA;EAAuC,uCAAA;EAAuC,+CAAA;AA41JprrG;;AA51JmurG;EAAc,aAAA;EAAa,sBAAA;EAAsB,uBAAA;EAAuB,gBAAA;EAAgB,mCAAA;EAAmC,kBAAA;EAAkB,mBAAA;EAAmB,2CAAA;EAA2C,6CAAA;AAw2J96rG;;AAx2J29rG;EAAuC;IAAc,gBAAA;EA62J9gsG;AACF;AA92JiisG;EAAsB,qMAAA;EAAkL,oEAAA;AAk3JzusG;;AAl3J6ysG;EAA4B,iBAAA;AAs3Jz0sG;;AAt3J01sG;EAA0C,WAAA;AA03Jp4sG;;AA13J+4sG;EAAuB,kDAAA;AA83Jt6sG;;AA93Jw9sG;EAAuC;IAAuB,eAAA;EAm4JphtG;AACF;AAp4JsitG;EAAY,0CAAA;EAA2C,oCAAA;EAAqC,mDAAA;EAAoD,mDAAA;EAAoD,qDAAA;EAAsD,mCAAA;EAAoC,qCAAA;EAAsC,sDAAA;EAAuD,2DAAA;EAA4D,qDAAA;EAAsD,wDAAA;EAAyD,uDAAA;EAAwD,wDAAA;EAAyD,6CAAA;EAA8C,iCAAA;EAAkC,iCAAA;EAAkC,2CAAA;EAA4C,aAAA;EAAa,sBAAA;EAAsB,eAAA;EAAe,gBAAA;EAAgB,iDAAA;AA45J75uG;;AA55J88uG;EAAqB,qBAAA;EAAqB,sBAAA;AAi6Jx/uG;;AAj6J8gvG;EAA8C,oCAAA;EAAoC,0BAAA;AAs6JhmvG;;AAt6J0nvG;EAAwB,WAAA;EAAW,wCAAA;EAAwC,mBAAA;AA46JrsvG;;AA56JwtvG;EAA4D,UAAA;EAAU,8CAAA;EAA8C,qBAAA;EAAqB,sDAAA;AAm7Jj2vG;;AAn7Ju5vG;EAA+B,+CAAA;EAA+C,uDAAA;AAw7Jr+vG;;AAx7J4hwG;EAAiB,kBAAA;EAAkB,cAAA;EAAc,gFAAA;EAAgF,iCAAA;EAAiC,qBAAA;EAAqB,yCAAA;EAAyC,iFAAA;AAk8J5vwG;;AAl8J60wG;EAA6B,+BAAA;EAA+B,gCAAA;AAu8Jz4wG;;AAv8Jy6wG;EAA4B,mCAAA;EAAmC,kCAAA;AA48Jx+wG;;AA58J0gxG;EAAoD,0CAAA;EAA0C,oBAAA;EAAoB,kDAAA;AAk9J5nxG;;AAl9J8qxG;EAAwB,UAAA;EAAU,wCAAA;EAAwC,gDAAA;EAAgD,sDAAA;AAy9JxyxG;;AAz9J81xG;EAAkC,mBAAA;AA69Jh4xG;;AA79Jm5xG;EAAyC,wDAAA;EAAwD,mDAAA;AAk+Jp/xG;;AAl+JuiyG;EAAuB,mBAAA;AAs+J9jyG;;AAt+JilyG;EAAqE,6DAAA;EAA6D,0BAAA;AA2+JntyG;;AA3+J6uyG;EAAqE,2DAAA;EAA2D,4BAAA;AAg/J72yG;;AAh/Jy4yG;EAA+C,aAAA;AAo/Jx7yG;;AAp/Jq8yG;EAAyD,mDAAA;EAAmD,oBAAA;AAy/JjjzG;;AAz/JqkzG;EAAgE,yDAAA;EAAyD,oDAAA;AA8/J9rzG;;AA9/JkvzG;EAAyB;IAA0B,mBAAA;EAmgKnyzG;EAngKszzG;IAAwE,6DAAA;IAA6D,0BAAA;EAugK37zG;EAvgKq9zG;IAAwE,2DAAA;IAA2D,4BAAA;EA2gKxl0G;EA3gKon0G;IAAkD,aAAA;EA8gKtq0G;EA9gKmr0G;IAA4D,mDAAA;IAAmD,oBAAA;EAkhKly0G;EAlhKsz0G;IAAmE,yDAAA;IAAyD,oDAAA;EAshKl70G;AACF;AAvhKy+0G;EAAyB;IAA0B,mBAAA;EA2hK1h1G;EA3hK6i1G;IAAwE,6DAAA;IAA6D,0BAAA;EA+hKlr1G;EA/hK4s1G;IAAwE,2DAAA;IAA2D,4BAAA;EAmiK/01G;EAniK221G;IAAkD,aAAA;EAsiK751G;EAtiK061G;IAA4D,mDAAA;IAAmD,oBAAA;EA0iKzh2G;EA1iK6i2G;IAAmE,yDAAA;IAAyD,oDAAA;EA8iKzq2G;AACF;AA/iKgu2G;EAAyB;IAA0B,mBAAA;EAmjKjx2G;EAnjKoy2G;IAAwE,6DAAA;IAA6D,0BAAA;EAujKz62G;EAvjKm82G;IAAwE,2DAAA;IAA2D,4BAAA;EA2jKtk3G;EA3jKkm3G;IAAkD,aAAA;EA8jKpp3G;EA9jKiq3G;IAA4D,mDAAA;IAAmD,oBAAA;EAkkKhx3G;EAlkKoy3G;IAAmE,yDAAA;IAAyD,oDAAA;EAskKh63G;AACF;AAvkKu93G;EAA0B;IAA0B,mBAAA;EA2kKzg4G;EA3kK4h4G;IAAwE,6DAAA;IAA6D,0BAAA;EA+kKjq4G;EA/kK2r4G;IAAwE,2DAAA;IAA2D,4BAAA;EAmlK9z4G;EAnlK014G;IAAkD,aAAA;EAslK544G;EAtlKy54G;IAA4D,mDAAA;IAAmD,oBAAA;EA0lKxg5G;EA1lK4h5G;IAAmE,yDAAA;IAAyD,oDAAA;EA8lKxp5G;AACF;AA/lK+s5G;EAA0B;IAA2B,mBAAA;EAmmKlw5G;EAnmKqx5G;IAAyE,6DAAA;IAA6D,0BAAA;EAumK355G;EAvmKq75G;IAAyE,2DAAA;IAA2D,4BAAA;EA2mKzj6G;EA3mKql6G;IAAmD,aAAA;EA8mKxo6G;EA9mKqp6G;IAA6D,mDAAA;IAAmD,oBAAA;EAknKrw6G;EAlnKyx6G;IAAoE,yDAAA;IAAyD,oDAAA;EAsnKt56G;AACF;AAvnK686G;EAAkB,gBAAA;AA0nK/96G;;AA1nK++6G;EAAmC,mDAAA;AA8nKlh7G;;AA9nKqk7G;EAA8C,sBAAA;AAkoKnn7G;;AAloKyo7G;EAAyB,qDAAA;EAAsD,8CAAA;EAA+C,4DAAA;EAA6D,2DAAA;EAA4D,+DAAA;EAAgE,4DAAA;EAA6D,gEAAA;EAAiE,wDAAA;EAAyD,yDAAA;EAA0D,mEAAA;AA+oKjr8G;;AA/oKqv8G;EAA2B,uDAAA;EAAwD,gDAAA;EAAiD,8DAAA;EAA+D,2DAAA;EAA4D,iEAAA;EAAkE,4DAAA;EAA6D,kEAAA;EAAmE,0DAAA;EAA2D,2DAAA;EAA4D,qEAAA;AA4pK7y9G;;AA5pKm39G;EAAyB,qDAAA;EAAsD,8CAAA;EAA+C,4DAAA;EAA6D,2DAAA;EAA4D,+DAAA;EAAgE,4DAAA;EAA6D,gEAAA;EAAiE,wDAAA;EAAyD,yDAAA;EAA0D,mEAAA;AAyqK35+G;;AAzqK+9+G;EAAsB,kDAAA;EAAmD,2CAAA;EAA4C,yDAAA;EAA0D,2DAAA;EAA4D,4DAAA;EAA6D,4DAAA;EAA6D,6DAAA;EAA8D,qDAAA;EAAsD,sDAAA;EAAuD,gEAAA;AAsrK/+/G;;AAtrKgjgH;EAAyB,qDAAA;EAAsD,8CAAA;EAA+C,4DAAA;EAA6D,2DAAA;EAA4D,+DAAA;EAAgE,4DAAA;EAA6D,gEAAA;EAAiE,wDAAA;EAAyD,yDAAA;EAA0D,mEAAA;AAmsKxlhH;;AAnsK4phH;EAAwB,oDAAA;EAAqD,6CAAA;EAA8C,2DAAA;EAA4D,2DAAA;EAA4D,8DAAA;EAA+D,4DAAA;EAA6D,+DAAA;EAAgE,uDAAA;EAAwD,wDAAA;EAAyD,kEAAA;AAgtK5riH;;AAhtK+viH;EAAuB,mDAAA;EAAoD,4CAAA;EAA6C,0DAAA;EAA2D,2DAAA;EAA4D,6DAAA;EAA8D,4DAAA;EAA6D,8DAAA;EAA+D,sDAAA;EAAuD,uDAAA;EAAwD,iEAAA;AA6tKvxjH;;AA7tKy1jH;EAAsB,kDAAA;EAAmD,2CAAA;EAA4C,yDAAA;EAA0D,2DAAA;EAA4D,4DAAA;EAA6D,4DAAA;EAA6D,6DAAA;EAA8D,qDAAA;EAAsD,sDAAA;EAAuD,gEAAA;AA0uKz2kH;;AA1uK06kH;EAAW,yBAAA;EAA0B,0DAAA;EAAoV,0BAAA;EAA2B,iCAAA;EAAkC,kEAAA;EAAmE,8BAAA;EAA+B,oCAAA;EAAqC,sEAAA;EAAuE,uBAAA;EAAuB,UAAA;EAAU,WAAA;EAAW,sBAAA;EAAoB,gCAAA;EAAgC,wEAAA;EAAwE,SAAA;EAAS,uBAAA;EAAsB,oCAAA;AA8vKrvmH;;AA9vKyxmH;EAAiB,gCAAA;EAAgC,qBAAA;EAAqB,0CAAA;AAowK/1mH;;AApwKy4mH;EAAiB,UAAA;EAAU,4CAAA;EAA4C,0CAAA;AA0wKh9mH;;AA1wK0/mH;EAAwC,oBAAA;EAAoB,yBAAA;EAA+C,iBAAA;EAAiB,6CAAA;AAkxKtnnH;;AAlxKmqnH;EAAiB,wCAAA;AAsxKprnH;;AAtxK4tnH;EAAgC,wCAAA;AA0xK5vnH;;AA1xKoynH;EAAO,sBAAA;EAAuB,4BAAA;EAA6B,2BAAA;EAA4B,yBAAA;EAA0B,0BAAA;EAA2B,6BAAA;EAA8B,kBAAA;EAAmB,+CAAA;EAAgD,8CAAA;EAA+C,0DAAA;EAA2D,gDAAA;EAAiD,0CAAA;EAA2C,iDAAA;EAAkD,sDAAA;EAAuD,iEAAA;EAAkE,gCAAA;EAAgC,eAAA;EAAe,oCAAA;EAAoC,4BAAA;EAA4B,oBAAA;EAAoB,oCAAA;EAAoC,4BAAA;EAA4B,uEAAA;EAAuE,sCAAA;EAAsC,4CAAA;AAszKlrpH;;AAtzK8tpH;EAAe,UAAA;AA0zK7upH;;AA1zKuvpH;EAAkB,aAAA;AA8zKzwpH;;AA9zKsxpH;EAAiB,sBAAA;EAAuB,kBAAA;EAAkB,+BAAA;EAAgF,kBAAA;EAAkB,eAAA;EAAe,oBAAA;AAy0Kj8pH;;AAz0Kq9pH;EAAmC,sCAAA;AA60Kx/pH;;AA70K8hqH;EAAc,aAAA;EAAa,mBAAA;EAAmB,4DAAA;EAA4D,mCAAA;EAAmC,2CAAA;EAA2C,4BAAA;EAA4B,qFAAA;EAAqF,0FAAA;EAA0F,2FAAA;AAy1Kj6qH;;AAz1K4/qH;EAAyB,oDAAA;EAAmD,sCAAA;AA81KxkrH;;AA91K8mrH;EAAY,kCAAA;EAAkC,qBAAA;AAm2K5prH;;AAn2KirrH;EAAO,sBAAA;EAAuB,sBAAA;EAAuB,uBAAA;EAAwB,wBAAA;EAAyB,kBAAA;EAAmB,+BAAA;EAAgC,0DAAA;EAA2D,8CAAA;EAA+C,mDAAA;EAAoD,6DAAA;EAA8D,0FAAA;EAA2F,gCAAA;EAAiC,gCAAA;EAAiC,mCAAA;EAAoC,qDAAA;EAAsD,qDAAA;EAAsD,gCAAA;EAAiC,4BAAA;EAA6B,sBAAA;EAAuB,qDAAA;EAAsD,qDAAA;EAAsD,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,+BAAA;EAA+B,aAAA;EAAa,WAAA;EAAW,YAAA;EAAY,kBAAA;EAAkB,gBAAA;EAAgB,UAAA;AAq4KrptH;;AAr4K+ptH;EAAc,kBAAA;EAAkB,WAAA;EAAW,8BAAA;EAA8B,oBAAA;AA44KxutH;;AA54K4vtH;EAA0B,mCAAA;EAAkC,8BAAA;AAi5KxztH;;AAj5Kq1tH;EAAuC;IAA0B,gBAAA;EAs5Kp5tH;AACF;AAv5Ku6tH;EAA0B,eAAA;AA05Kj8tH;;AA15Kg9tH;EAAkC,sBAAA;AA85Kl/tH;;AA95KwguH;EAAyB,+CAAA;AAk6KjiuH;;AAl6KgluH;EAAwC,gBAAA;EAAgB,gBAAA;AAu6KxouH;;AAv6KwpuH;EAAqC,gBAAA;AA26K7ruH;;AA36K6suH;EAAuB,aAAA;EAAa,mBAAA;EAAmB,mDAAA;AAi7KpwuH;;AAj7KuzuH;EAAe,kBAAA;EAAkB,aAAA;EAAa,sBAAA;EAAsB,WAAA;EAAW,4BAAA;EAA4B,oBAAA;EAAoB,oCAAA;EAAoC,4BAAA;EAA4B,uEAAA;EAAuE,4CAAA;EAA4C,UAAA;AA+7KzmvH;;AA/7KmnvH;EAAgB,yBAAA;EAA0B,qBAAA;EAAsB,yBAAA;EAA0B,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,kCAAA;EAAkC,YAAA;EAAY,aAAA;EAAa,uCAAA;AA48KpyvH;;AA58K20vH;EAAqB,UAAA;AAg9Kh2vH;;AAh9K02vH;EAAqB,mCAAA;AAo9K/3vH;;AAp9Kk6vH;EAAc,aAAA;EAAa,cAAA;EAAc,mBAAA;EAAmB,8BAAA;EAA8B,uCAAA;EAAuC,4FAAA;EAA4F,2DAAA;EAA2D,4DAAA;AA+9K1rwH;;AA/9KsvwH;EAAyB,kGAAA;EAAgG,sJAAA;AAo+K/2wH;;AAp+KkgxH;EAAa,gBAAA;EAAgB,8CAAA;AAy+K/hxH;;AAz+K6kxH;EAAY,kBAAA;EAAkB,cAAA;EAAc,gCAAA;AA++KznxH;;AA/+KypxH;EAAc,aAAA;EAAa,cAAA;EAAc,eAAA;EAAe,mBAAA;EAAmB,yBAAA;EAAyB,yEAAA;EAAwE,2CAAA;EAA2C,yFAAA;EAAyF,+DAAA;EAA+D,8DAAA;AA4/KxgyH;;AA5/KskyH;EAAgB,8CAAA;AAggLtlyH;;AAhgLmoyH;EAAyB;IAAO,yBAAA;IAA0B,uDAAA;EAsgL3ryH;EAtgLmvyH;IAAc,gCAAA;IAAgC,kBAAA;IAAkB,iBAAA;EA2gLnzyH;EA3gLo0yH;IAAU,sBAAA;EA8gL90yH;AACF;AA/gLw2yH;EAAyB;IAAoB,sBAAA;EAmhLn5yH;AACF;AAphL66yH;EAA0B;IAAU,uBAAA;EAwhL/8yH;AACF;AAzhL0+yH;EAAkB,YAAA;EAAY,eAAA;EAAe,YAAA;EAAY,SAAA;AA+hLnizH;;AA/hL4izH;EAAiC,YAAA;EAAY,SAAA;EAAS,gBAAA;AAqiLlmzH;;AAriLknzH;EAAgE,gBAAA;AAyiLlrzH;;AAziLkszH;EAA8B,gBAAA;AA6iLhuzH;;AA7iLgvzH;EAA4B;IAA0B,YAAA;IAAY,eAAA;IAAe,YAAA;IAAY,SAAA;EAqjL30zH;EArjLo1zH;IAAyC,YAAA;IAAY,SAAA;IAAS,gBAAA;EA0jLl5zH;EA1jLk6zH;IAAgF,gBAAA;EA6jLl/zH;EA7jLkg0H;IAAsC,gBAAA;EAgkLxi0H;AACF;AAjkL2j0H;EAA4B;IAA0B,YAAA;IAAY,eAAA;IAAe,YAAA;IAAY,SAAA;EAwkLtp0H;EAxkL+p0H;IAAyC,YAAA;IAAY,SAAA;IAAS,gBAAA;EA6kL7t0H;EA7kL6u0H;IAAgF,gBAAA;EAglL7z0H;EAhlL600H;IAAsC,gBAAA;EAmlLn30H;AACF;AAplLs40H;EAA4B;IAA0B,YAAA;IAAY,eAAA;IAAe,YAAA;IAAY,SAAA;EA2lLj+0H;EA3lL0+0H;IAAyC,YAAA;IAAY,SAAA;IAAS,gBAAA;EAgmLxi1H;EAhmLwj1H;IAAgF,gBAAA;EAmmLxo1H;EAnmLwp1H;IAAsC,gBAAA;EAsmL9r1H;AACF;AAvmLit1H;EAA6B;IAA0B,YAAA;IAAY,eAAA;IAAe,YAAA;IAAY,SAAA;EA8mL7y1H;EA9mLsz1H;IAAyC,YAAA;IAAY,SAAA;IAAS,gBAAA;EAmnLp31H;EAnnLo41H;IAAgF,gBAAA;EAsnLp91H;EAtnLo+1H;IAAsC,gBAAA;EAynL1g2H;AACF;AA1nL6h2H;EAA6B;IAA2B,YAAA;IAAY,eAAA;IAAe,YAAA;IAAY,SAAA;EAioL1n2H;EAjoLmo2H;IAA0C,YAAA;IAAY,SAAA;IAAS,gBAAA;EAsoLls2H;EAtoLkt2H;IAAkF,gBAAA;EAyoLpy2H;EAzoLoz2H;IAAuC,gBAAA;EA4oL312H;AACF;AA7oL822H;EAAS,wBAAA;EAAyB,4BAAA;EAA6B,6BAAA;EAA8B,8BAAA;EAA+B,qBAAA;EAAsB,+BAAA;EAAgC,oCAAA;EAAqC,wCAAA;EAAyC,kDAAA;EAAmD,wBAAA;EAAyB,+BAAA;EAAgC,gCAAA;EAAiC,iCAAA;EAAiC,cAAA;EAAc,gCAAA;EAAgC,sCAAA;EAAsC,kBAAA;EAAkB,gBAAA;EAAgB,gBAAA;EAAgB,gBAAA;EAAgB,iBAAA;EAAiB,qBAAA;EAAqB,iBAAA;EAAiB,oBAAA;EAAoB,sBAAA;EAAsB,kBAAA;EAAkB,mBAAA;EAAmB,oBAAA;EAAoB,gBAAA;EAAgB,sCAAA;EAAsC,qBAAA;EAAqB,UAAA;AA+qLvp4H;;AA/qLiq4H;EAAc,kCAAA;AAmrL/q4H;;AAnrLit4H;EAAwB,cAAA;EAAc,oCAAA;EAAoC,sCAAA;AAyrL3x4H;;AAzrLi04H;EAAgC,kBAAA;EAAkB,WAAA;EAAW,yBAAA;EAAyB,mBAAA;AAgsLv54H;;AAhsL064H;EAA2F,iDAAA;AAosLrg5H;;AApsLsj5H;EAA2G,SAAA;EAAS,wFAAA;EAAuF,sCAAA;AA0sLjw5H;;AA1sLuy5H;EAA6F,+CAAA;EAA+C,qCAAA;EAAqC,qCAAA;AAgtLx95H;;AAhtL6/5H;EAA6G,WAAA;EAAW,kIAAA;EAAgI,wCAAA;AAstLrv6H;;AAttL6x6H;EAAiG,8CAAA;AA0tL936H;;AA1tL466H;EAAiH,YAAA;EAAY,wFAAA;EAAuF,yCAAA;AAguLho7H;;AAhuLyq7H;EAA8F,gDAAA;EAAgD,qCAAA;EAAqC,qCAAA;AAsuL517H;;AAtuLi47H;EAA8G,UAAA;EAAU,kIAAA;EAAgI,uCAAA;AA4uLzn8H;;AA5uLgq8H;EAAe,sCAAA;EAAsC,gEAAA;EAAgE,8BAAA;EAA8B,kBAAA;EAAkB,sCAAA;EAAsC,8CAAA;AAqvL328H;;AArvLy58H;EAAS,wBAAA;EAAyB,4BAAA;EAA6B,+BAAA;EAAgC,iCAAA;EAAkC,gDAAA;EAAiD,4DAAA;EAA6D,qDAAA;EAAsD,0FAAA;EAA2F,yDAAA;EAA0D,kCAAA;EAAmC,oCAAA;EAAqC,kCAAA;EAAmC,iCAAA;EAAkC,6CAAA;EAA8C,gCAAA;EAAiC,gCAAA;EAAiC,4CAAA;EAA6C,6BAAA;EAA8B,gCAAA;EAAiC,wDAAA;EAAyD,iCAAA;EAAiC,cAAA;EAAc,sCAAA;EAAsC,sCAAA;EAAsC,kBAAA;EAAkB,gBAAA;EAAgB,gBAAA;EAAgB,gBAAA;EAAgB,iBAAA;EAAiB,qBAAA;EAAqB,iBAAA;EAAiB,oBAAA;EAAoB,sBAAA;EAAsB,kBAAA;EAAkB,mBAAA;EAAmB,oBAAA;EAAoB,gBAAA;EAAgB,sCAAA;EAAsC,qBAAA;EAAqB,sCAAA;EAAsC,4BAAA;EAA4B,2EAAA;EAA2E,8CAAA;AAmyLpy/H;;AAnyLk1/H;EAAwB,cAAA;EAAc,oCAAA;EAAoC,sCAAA;AAyyL55/H;;AAzyLk8/H;EAA+D,kBAAA;EAAkB,cAAA;EAAc,WAAA;EAAW,yBAAA;EAAyB,mBAAA;EAAmB,eAAA;AAkzLxlgI;;AAlzLumgI;EAA2F,oFAAA;AAszLlsgI;;AAtzLsxgI;EAAoN,wFAAA;AA0zL1+gI;;AA1zLikhI;EAA2G,SAAA;EAAS,gDAAA;AA+zLrrhI;;AA/zLquhI;EAAyG,sCAAA;EAAsC,sCAAA;AAo0Lp3hI;;AAp0L05hI;EAA6F,kFAAA;EAAkF,qCAAA;EAAqC,qCAAA;AA00L9miI;;AA10LmpiI;EAAwN,kIAAA;AA80L32iI;;AA90L2+iI;EAA6G,OAAA;EAAO,kDAAA;AAm1L/ljI;;AAn1LipjI;EAA2G,oCAAA;EAAoC,wCAAA;AAw1LhyjI;;AAx1Lw0jI;EAAiG,iFAAA;AA41Lz6jI;;AA51L0/jI;EAAgO,wFAAA;AAg2L1tkI;;AAh2LizkI;EAAiH,MAAA;EAAM,mDAAA;AAq2Lx6kI;;AAr2L29kI;EAA+G,mCAAA;EAAmC,yCAAA;AA02L7mlI;;AA12LsplI;EAAmH,kBAAA;EAAkB,MAAA;EAAM,SAAA;EAAS,cAAA;EAAc,oCAAA;EAAoC,uDAAA;EAAsD,WAAA;EAAW,+EAAA;AAq3L75lI;;AAr3L4+lI;EAA8F,mFAAA;EAAmF,qCAAA;EAAqC,qCAAA;AA23LlsmI;;AA33LuumI;EAA0N,kIAAA;AA+3Lj8mI;;AA/3LiknI;EAA8G,QAAA;EAAQ,iDAAA;AAo4LvrnI;;AAp4LwunI;EAA4G,qCAAA;EAAqC,uCAAA;AAy4Lz3nI;;AAz4Lg6nI;EAAgB,8EAAA;EAA8E,gBAAA;EAAgB,6CAAA;EAA6C,qCAAA;EAAqC,6CAAA;EAA6C,kFAAA;EAAkF,6DAAA;EAA6D,8DAAA;AAo5L5xoI;;AAp5L01oI;EAAsB,aAAA;AAw5Lh3oI;;AAx5L63oI;EAAc,0EAAA;EAA0E,mCAAA;AA65Lr9oI;;AA75Lw/oI;EAAU,kBAAA;AAi6LlgpI;;AAj6LohpI;EAAwB,mBAAA;AAq6L5ipI;;AAr6L+jpI;EAAgB,kBAAA;EAAkB,WAAA;EAAW,gBAAA;AA26L5mpI;;AA36L4npI;EAAuB,cAAA;EAAc,WAAA;EAAW,WAAA;AAi7L5qpI;;AAj7LurpI;EAAe,kBAAA;EAAkB,aAAA;EAAa,WAAA;EAAW,WAAA;EAAW,mBAAA;EAAsD,2BAAA;EAA2B,sCAAA;AA47L50pI;;AA57Li3pI;EAAuC;IAAe,gBAAA;EAi8Lr6pI;AACF;AAl8Lw7pI;EAA8D,cAAA;AAq8Lt/pI;;AAr8LogqI;EAAwE,2BAAA;AAy8L5kqI;;AAz8LumqI;EAAwE,4BAAA;AA68L/qqI;;AA78L2sqI;EAA8B,UAAA;EAAU,4BAAA;EAA4B,eAAA;AAm9L/wqI;;AAn9L8xqI;EAAiJ,UAAA;EAAU,UAAA;AAw9Lz7qI;;AAx9Lm8qI;EAAoF,UAAA;EAAU,UAAA;EAAU,2BAAA;AA89L3irI;;AA99LqkrI;EAAuC;IAAoF,gBAAA;EAm+L9rrI;AACF;AAp+LitrI;EAA8C,kBAAA;EAAkB,MAAA;EAAM,SAAA;EAAS,UAAA;EAAU,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,UAAA;EAAU,UAAA;EAAU,WAAA;EAAW,kBAAA;EAAkB,eAAA;EAAe,SAAA;EAAS,YAAA;EAAW,8BAAA;AAq/Lr7rI;;AAr/Lk9rI;EAAuC;IAA8C,gBAAA;EA0/LrisI;AACF;AA3/LwjsI;EAAoH,WAAA;EAAW,qBAAA;EAAqB,UAAA;EAAU,YAAA;AAigMttsI;;AAjgMiusI;EAAuB,OAAA;AAqgMxvsI;;AArgM+vsI;EAAuB,QAAA;AAygMtxsI;;AAzgM8xsI;EAAwD,qBAAA;EAAqB,WAAA;EAAW,YAAA;EAAY,4BAAA;EAA4B,wBAAA;EAAwB,0BAAA;AAkhMt7sI;;AAlhMg9sI;EAA4B,0DAAA;AAshM5+sI;;AAthMqvtI;EAA4B,0DAAA;AA0hMjxtI;;AA1hM2huI;EAAqB,kBAAA;EAAkB,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,UAAA;EAAU,aAAA;EAAa,uBAAA;EAAuB,UAAA;EAAU,iBAAA;EAAiB,mBAAA;EAAmB,gBAAA;AAwiMtruI;;AAxiMssuI;EAAsC,uBAAA;EAAuB,cAAA;EAAc,WAAA;EAAW,WAAA;EAAW,UAAA;EAAU,iBAAA;EAAiB,gBAAA;EAAgB,mBAAA;EAAmB,eAAA;EAAe,sBAAA;EAAsB,4BAAA;EAA4B,SAAA;EAAS,kCAAA;EAAkC,qCAAA;EAAqC,YAAA;EAAW,6BAAA;AA2jMjgvI;;AA3jM6hvI;EAAuC;IAAsC,gBAAA;EAgkMxmvI;AACF;AAjkM2nvI;EAA6B,UAAA;AAokMxpvI;;AApkMkqvI;EAAkB,kBAAA;EAAkB,UAAA;EAAU,eAAA;EAAe,SAAA;EAAS,oBAAA;EAAoB,uBAAA;EAAuB,WAAA;EAAW,kBAAA;AA+kM9xvI;;AA/kMgzvI;EAAsF,gCAAA;AAmlMt4vI;;AAnlMs6vI;EAAqD,sBAAA;AAulM39vI;;AAvlMi/vI;EAAiC,WAAA;AA2lMlhwI;;AA3lM6hwI;EAA0O,gCAAA;AA+lMvwwI;;AA/lMuywI;EAAyI,sBAAA;AAmmMh7wI;;AAnmMs8wI;EAAiG,WAAA;AAumMvixI;;AAvmMkjxI;EAA8B,qBAAA;EAAqB,8BAAA;EAA8B,gCAAA;EAAgC,gDAAA;EAAgD,kBAAA;EAAkB,6FAAA;AAgnMruxI;;AAhnMk0xI;EAA0B;IAAG,yBAAA;EAqnM71xI;AACF;AAtnMy3xI;EAAgB,uBAAA;EAAwB,wBAAA;EAAyB,oCAAA;EAAqC,gCAAA;EAAiC,kCAAA;EAAmC,0CAAA;EAA2C,yDAAA;EAAyD,+BAAA;AAgoMvoyI;;AAhoMsqyI;EAAmB,uBAAA;EAAwB,wBAAA;EAAyB,+BAAA;AAsoM1uyI;;AAtoM0wyI;EAAwB;IAAG,mBAAA;EA2oMnyyI;EA3oMszyI;IAAI,UAAA;IAAU,eAAA;EA+oMp0yI;AACF;AAhpMs1yI;EAAc,uBAAA;EAAwB,wBAAA;EAAyB,oCAAA;EAAqC,kCAAA;EAAmC,wCAAA;EAAyC,8BAAA;EAA8B,UAAA;AAypMpizI;;AAzpM8izI;EAAiB,uBAAA;EAAwB,wBAAA;AA8pMvlzI;;AA9pMgnzI;EAAuC;IAA8B,iCAAA;EAmqMnrzI;AACF;AApqMwtzI;EAAkF,0BAAA;EAA2B,0BAAA;EAA2B,0BAAA;EAA2B,6BAAA;EAA8B,6BAAA;EAA8B,yCAAA;EAA0C,mCAAA;EAAoC,kDAAA;EAAmD,8DAAA;EAA+D,iEAAA;EAAkE,oDAAA;EAAqD,oCAAA;AAkrM9u0I;;AAlrMmx0I;EAA4B;IAAc,eAAA;IAAe,SAAA;IAAS,mCAAA;IAAmC,aAAA;IAAa,sBAAA;IAAsB,eAAA;IAAe,gCAAA;IAAgC,kBAAA;IAAkB,wCAAA;IAAwC,4BAAA;IAA4B,UAAA;IAAU,0CAAA;EAksMxi1I;AACF;AAnsMql1I;EAAgE;IAAc,gBAAA;EAusMjq1I;AACF;AAxsMor1I;EAA4B;IAA8B,MAAA;IAAM,OAAA;IAAO,gCAAA;IAAgC,qFAAA;IAAqF,4BAAA;EAgtM921I;EAhtM041I;IAA4B,MAAA;IAAM,QAAA;IAAQ,gCAAA;IAAgC,oFAAA;IAAoF,2BAAA;EAutMxi2I;EAvtMmk2I;IAA4B,MAAA;IAAM,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,sFAAA;IAAsF,4BAAA;EAguM5v2I;EAhuMwx2I;IAA+B,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,mFAAA;IAAmF,2BAAA;EAwuM382I;EAxuMs+2I;IAAsD,eAAA;EA2uM5h3I;EA3uM2i3I;IAA8D,mBAAA;EA8uMzm3I;AACF;AA/uM+n3I;EAAyB;IAAc,0BAAA;IAA2B,6BAAA;IAA8B,wCAAA;EAqvM7t3I;EArvMow3I;IAAgC,aAAA;EAwvMpy3I;EAxvMiz3I;IAA8B,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;IAAmB,wCAAA;EA+vMr43I;AACF;AAhwM+63I;EAA4B;IAAc,eAAA;IAAe,SAAA;IAAS,mCAAA;IAAmC,aAAA;IAAa,sBAAA;IAAsB,eAAA;IAAe,gCAAA;IAAgC,kBAAA;IAAkB,wCAAA;IAAwC,4BAAA;IAA4B,UAAA;IAAU,0CAAA;EA+wMps4I;AACF;AAhxMiv4I;EAAgE;IAAc,gBAAA;EAoxM7z4I;AACF;AArxMg14I;EAA4B;IAA8B,MAAA;IAAM,OAAA;IAAO,gCAAA;IAAgC,qFAAA;IAAqF,4BAAA;EA6xM1g5I;EA7xMsi5I;IAA4B,MAAA;IAAM,QAAA;IAAQ,gCAAA;IAAgC,oFAAA;IAAoF,2BAAA;EAoyMps5I;EApyM+t5I;IAA4B,MAAA;IAAM,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,sFAAA;IAAsF,4BAAA;EA6yMx55I;EA7yMo75I;IAA+B,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,mFAAA;IAAmF,2BAAA;EAqzMvm6I;EArzMko6I;IAAsD,eAAA;EAwzMxr6I;EAxzMus6I;IAA8D,mBAAA;EA2zMrw6I;AACF;AA5zM2x6I;EAAyB;IAAc,0BAAA;IAA2B,6BAAA;IAA8B,wCAAA;EAk0Mz36I;EAl0Mg66I;IAAgC,aAAA;EAq0Mh86I;EAr0M686I;IAA8B,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;IAAmB,wCAAA;EA40Mji7I;AACF;AA70M2k7I;EAA4B;IAAc,eAAA;IAAe,SAAA;IAAS,mCAAA;IAAmC,aAAA;IAAa,sBAAA;IAAsB,eAAA;IAAe,gCAAA;IAAgC,kBAAA;IAAkB,wCAAA;IAAwC,4BAAA;IAA4B,UAAA;IAAU,0CAAA;EA41Mh27I;AACF;AA71M647I;EAAgE;IAAc,gBAAA;EAi2Mz97I;AACF;AAl2M4+7I;EAA4B;IAA8B,MAAA;IAAM,OAAA;IAAO,gCAAA;IAAgC,qFAAA;IAAqF,4BAAA;EA02Mtq8I;EA12Mks8I;IAA4B,MAAA;IAAM,QAAA;IAAQ,gCAAA;IAAgC,oFAAA;IAAoF,2BAAA;EAi3Mh28I;EAj3M238I;IAA4B,MAAA;IAAM,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,sFAAA;IAAsF,4BAAA;EA03Mpj9I;EA13Mgl9I;IAA+B,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,mFAAA;IAAmF,2BAAA;EAk4Mnw9I;EAl4M8x9I;IAAsD,eAAA;EAq4Mp19I;EAr4Mm29I;IAA8D,mBAAA;EAw4Mj69I;AACF;AAz4Mu79I;EAAyB;IAAc,0BAAA;IAA2B,6BAAA;IAA8B,wCAAA;EA+4Mrh+I;EA/4M4j+I;IAAgC,aAAA;EAk5M5l+I;EAl5Mym+I;IAA8B,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;IAAmB,wCAAA;EAy5M7r+I;AACF;AA15Muu+I;EAA6B;IAAc,eAAA;IAAe,SAAA;IAAS,mCAAA;IAAmC,aAAA;IAAa,sBAAA;IAAsB,eAAA;IAAe,gCAAA;IAAgC,kBAAA;IAAkB,wCAAA;IAAwC,4BAAA;IAA4B,UAAA;IAAU,0CAAA;EAy6M7/+I;AACF;AA16M0i/I;EAAiE;IAAc,gBAAA;EA86Mvn/I;AACF;AA/6M0o/I;EAA6B;IAA8B,MAAA;IAAM,OAAA;IAAO,gCAAA;IAAgC,qFAAA;IAAqF,4BAAA;EAu7Mr0/I;EAv7Mi2/I;IAA4B,MAAA;IAAM,QAAA;IAAQ,gCAAA;IAAgC,oFAAA;IAAoF,2BAAA;EA87M///I;EA97M0hgJ;IAA4B,MAAA;IAAM,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,sFAAA;IAAsF,4BAAA;EAu8MntgJ;EAv8M+ugJ;IAA+B,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,mFAAA;IAAmF,2BAAA;EA+8Ml6gJ;EA/8M67gJ;IAAsD,eAAA;EAk9Mn/gJ;EAl9MkghJ;IAA8D,mBAAA;EAq9MhkhJ;AACF;AAt9MslhJ;EAA0B;IAAc,0BAAA;IAA2B,6BAAA;IAA8B,wCAAA;EA49MrrhJ;EA59M4thJ;IAAgC,aAAA;EA+9M5vhJ;EA/9MywhJ;IAA8B,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;IAAmB,wCAAA;EAs+M71hJ;AACF;AAv+Mu4hJ;EAA6B;IAAe,eAAA;IAAe,SAAA;IAAS,mCAAA;IAAmC,aAAA;IAAa,sBAAA;IAAsB,eAAA;IAAe,gCAAA;IAAgC,kBAAA;IAAkB,wCAAA;IAAwC,4BAAA;IAA4B,UAAA;IAAU,0CAAA;EAs/M9piJ;AACF;AAv/M2siJ;EAAiE;IAAe,gBAAA;EA2/MzxiJ;AACF;AA5/M4yiJ;EAA6B;IAA+B,MAAA;IAAM,OAAA;IAAO,gCAAA;IAAgC,qFAAA;IAAqF,4BAAA;EAogNx+iJ;EApgNogjJ;IAA6B,MAAA;IAAM,QAAA;IAAQ,gCAAA;IAAgC,oFAAA;IAAoF,2BAAA;EA2gNnqjJ;EA3gN8rjJ;IAA6B,MAAA;IAAM,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,sFAAA;IAAsF,4BAAA;EAohNx3jJ;EAphNo5jJ;IAAgC,QAAA;IAAQ,OAAA;IAAO,kCAAA;IAAkC,gBAAA;IAAgB,mFAAA;IAAmF,2BAAA;EA4hNxkkJ;EA5hNmmkJ;IAAwD,eAAA;EA+hN3pkJ;EA/hN0qkJ;IAAiE,mBAAA;EAkiN3ukJ;AACF;AAniNiwkJ;EAA0B;IAAe,0BAAA;IAA2B,6BAAA;IAA8B,wCAAA;EAyiNj2kJ;EAziNw4kJ;IAAiC,aAAA;EA4iNz6kJ;EA5iNs7kJ;IAA+B,aAAA;IAAa,YAAA;IAAY,UAAA;IAAU,mBAAA;IAAmB,wCAAA;EAmjN3glJ;AACF;AApjNqjlJ;EAAW,eAAA;EAAe,SAAA;EAAS,mCAAA;EAAmC,aAAA;EAAa,sBAAA;EAAsB,eAAA;EAAe,gCAAA;EAAgC,kBAAA;EAAkB,wCAAA;EAAwC,4BAAA;EAA4B,UAAA;EAAU,0CAAA;AAkkN7ylJ;;AAlkNu1lJ;EAAuC;IAAW,gBAAA;EAukNv4lJ;AACF;AAxkN05lJ;EAA2B,MAAA;EAAM,OAAA;EAAO,gCAAA;EAAgC,qFAAA;EAAqF,4BAAA;AA+kNvjmJ;;AA/kNmlmJ;EAAyB,MAAA;EAAM,QAAA;EAAQ,gCAAA;EAAgC,oFAAA;EAAoF,2BAAA;AAulN9umJ;;AAvlNywmJ;EAAyB,MAAA;EAAM,QAAA;EAAQ,OAAA;EAAO,kCAAA;EAAkC,gBAAA;EAAgB,sFAAA;EAAsF,4BAAA;AAimN/7mJ;;AAjmN29mJ;EAA4B,QAAA;EAAQ,OAAA;EAAO,kCAAA;EAAkC,gBAAA;EAAgB,mFAAA;EAAmF,2BAAA;AA0mN3onJ;;AA1mNsqnJ;EAAgD,eAAA;AA8mNttnJ;;AA9mNqunJ;EAAqD,mBAAA;AAknN1xnJ;;AAlnN6ynJ;EAAoB,eAAA;EAAe,MAAA;EAAM,OAAA;EAAO,aAAA;EAAa,YAAA;EAAY,aAAA;EAAa,sBAAA;AA4nNn4nJ;;AA5nNy5nJ;EAAyB,UAAA;AAgoNl7nJ;;AAhoN47nJ;EAAyB,YAAA;AAooNr9nJ;;AApoNg+nJ;EAAkB,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,oEAAA;AA2oNhjoJ;;AA3oNonoJ;EAA6B,4FAAA;EAA0F,sDAAA;EAAqD,wDAAA;EAAuD,yDAAA;AAkpNv1oJ;;AAlpN+4oJ;EAAiB,gBAAA;EAAgB,kDAAA;AAupNh7oJ;;AAvpNk+oJ;EAAgB,YAAA;EAAY,oEAAA;EAAoE,gBAAA;AA6pNlkpJ;;AA7pNklpJ;EAAa,qBAAA;EAAqB,eAAA;EAAe,sBAAA;EAAsB,YAAA;EAAY,8BAAA;EAA8B,YAAA;AAsqNnspJ;;AAtqN8spJ;EAAyB,qBAAA;EAAqB,WAAA;AA2qN5vpJ;;AA3qNuwpJ;EAAgB,iBAAA;AA+qNvxpJ;;AA/qNuypJ;EAAgB,iBAAA;AAmrNvzpJ;;AAnrNu0pJ;EAAgB,iBAAA;AAurNv1pJ;;AAvrNw2pJ;EAA+B,mDAAA;AA2rNv4pJ;;AA3rN07pJ;EAA4B;IAAI,YAAA;EAgsNx9pJ;AACF;AAjsNs+pJ;EAAkB,uFAAA;EAAiF,+EAAA;EAAyE,4BAAA;EAA4B,oBAAA;EAAoB,8CAAA;AAwsNlsqJ;;AAxsNgvqJ;EAA4B;IAAK,+BAAA;IAA+B,uBAAA;EA8sN9yqJ;AACF;AA/sNw0qJ;EAAiB,cAAA;EAAc,WAAA;EAAW,WAAA;AAotNl3qJ;;AAptN63qJ;EAAiB,sBAAA;EAAqB,iFAAA;AAytNn6qJ;;AAztNi/qJ;EAAmB,sBAAA;EAAqB,mFAAA;AA8tNzhrJ;;AA9tNymrJ;EAAiB,sBAAA;EAAqB,iFAAA;AAmuN/orJ;;AAnuN6trJ;EAAc,sBAAA;EAAqB,8EAAA;AAwuNhwrJ;;AAxuN20rJ;EAAiB,sBAAA;EAAqB,iFAAA;AA6uNj3rJ;;AA7uN+7rJ;EAAgB,sBAAA;EAAqB,gFAAA;AAkvNp+rJ;;AAlvNijsJ;EAAe,sBAAA;EAAqB,+EAAA;AAuvNrlsJ;;AAvvNiqsJ;EAAc,sBAAA;EAAqB,8EAAA;AA4vNpssJ;;AA5vN+wsJ;EAAc,wEAAA;EAA4K,kGAAA;AAkwNz8sJ;;AAlwNwitJ;EAAwC,8DAAA;EAAoJ,wFAAA;AAwwNputJ;;AAxwNuztJ;EAAgB,0EAAA;EAAgL,oGAAA;AA8wNv/tJ;;AA9wNwluJ;EAA4C,8DAAA;EAAoJ,wFAAA;AAoxNxxuJ;;AApxN22uJ;EAAc,wEAAA;EAA4K,kGAAA;AA0xNrivJ;;AA1xNoovJ;EAAwC,8DAAA;EAAoJ,wFAAA;AAgyNh0vJ;;AAhyNm5vJ;EAAW,qEAAA;EAAsK,+FAAA;AAsyNpkwJ;;AAtyNgqwJ;EAAkC,+DAAA;EAAsJ,yFAAA;AA4yNx1wJ;;AA5yN46wJ;EAAc,wEAAA;EAA4K,kGAAA;AAkzNtmxJ;;AAlzNqsxJ;EAAwC,+DAAA;EAAsJ,yFAAA;AAwzNn4xJ;;AAxzNu9xJ;EAAa,uEAAA;EAA0K,iGAAA;AA8zN9oyJ;;AA9zN4uyJ;EAAsC,8DAAA;EAAoJ,wFAAA;AAo0Nt6yJ;;AAp0Ny/yJ;EAAY,sEAAA;EAAwK,gGAAA;AA00N7qzJ;;AA10N0wzJ;EAAoC,gEAAA;EAAwJ,0FAAA;AAg1Nt8zJ;;AAh1N2h0J;EAAW,qEAAA;EAAsK,+FAAA;AAs1N5s0J;;AAt1Nwy0J;EAAkC,6DAAA;EAAkJ,uFAAA;AA41N590J;;AA51N8i1J;EAAoB,+EAAA;EAA0L,yGAAA;AAk2N5v1J;;AAl2Nk21J;EAAoD,kFAAA;EAA+L,4GAAA;AAw2Nrl2J;;AAx2N8r2J;EAAkB,UAAA;EAAU,kJAAA;AA62N1t2J;;AA72Ny22J;EAAW,oBAAA;EAAoB,aAAA;EAAY,mBAAA;EAA2G,kFAAA;EAAgF,6BAAA;EAAgE,2BAAA;AAw3N/o3J;;AAx3N0q3J;EAAe,cAAA;EAAc,UAAA;EAAU,WAAA;EAAW,kBAAA;EAAkB,sCAAA;AAg4N9u3J;;AAh4Nmx3J;EAAuC;IAAe,gBAAA;EAq4Nv03J;AACF;AAt4N013J;EAA8D,mEAAA;AAy4Nx53J;;AAz4Nu93J;EAAO,kBAAA;EAAkB,WAAA;AA84Nh/3J;;AA94N2/3J;EAAe,cAAA;EAAc,mCAAA;EAAmC,WAAA;AAo5N3j4J;;AAp5Nsk4J;EAAS,kBAAA;EAAkB,MAAA;EAAM,OAAA;EAAO,WAAA;EAAW,YAAA;AA45Nzn4J;;AA55Nqo4J;EAAW,sBAAA;AAg6Nhp4J;;AAh6Nuq4J;EAAW,qBAAA;AAo6Nlr4J;;AAp6Nws4J;EAAY,wBAAA;AAw6Npt4J;;AAx6N6u4J;EAAY,gCAAA;AA46Nzv4J;;AA56N0x4J;EAAW,eAAA;EAAe,MAAA;EAAM,QAAA;EAAQ,OAAA;EAAO,aAAA;AAo7Nz04J;;AAp7Ns14J;EAAc,eAAA;EAAe,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,aAAA;AA47N344J;;AA57Nw54J;EAAoC,gBAAA;EAAgB,MAAA;EAAM,aAAA;AAm8Nl94J;;AAn8N+94J;EAAuC,gBAAA;EAAgB,SAAA;EAAS,aAAA;AA08N/h5J;;AA18N4i5J;EAAyB;IAAuC,gBAAA;IAAgB,MAAA;IAAM,aAAA;EAk9Nho5J;EAl9N6o5J;IAA0C,gBAAA;IAAgB,SAAA;IAAS,aAAA;EAw9Nht5J;AACF;AAz9Ngu5J;EAAyB;IAAuC,gBAAA;IAAgB,MAAA;IAAM,aAAA;EAg+Npz5J;EAh+Ni05J;IAA0C,gBAAA;IAAgB,SAAA;IAAS,aAAA;EAs+Np45J;AACF;AAv+No55J;EAAyB;IAAuC,gBAAA;IAAgB,MAAA;IAAM,aAAA;EA8+Nx+5J;EA9+Nq/5J;IAA0C,gBAAA;IAAgB,SAAA;IAAS,aAAA;EAo/Nxj6J;AACF;AAr/Nwk6J;EAA0B;IAAuC,gBAAA;IAAgB,MAAA;IAAM,aAAA;EA4/N7p6J;EA5/N0q6J;IAA0C,gBAAA;IAAgB,SAAA;IAAS,aAAA;EAkgO7u6J;AACF;AAngO6v6J;EAA0B;IAAwC,gBAAA;IAAgB,MAAA;IAAM,aAAA;EA0gOn16J;EA1gOg26J;IAA2C,gBAAA;IAAgB,SAAA;IAAS,aAAA;EAghOp66J;AACF;AAjhOo76J;EAAQ,aAAA;EAAa,mBAAA;EAAmB,mBAAA;EAAmB,mBAAA;AAuhO/+6J;;AAvhOkg7J;EAAQ,aAAA;EAAa,cAAA;EAAc,sBAAA;EAAsB,mBAAA;AA8hO3j7J;;AA9hO8k7J;EAA2E,qBAAA;EAAoB,sBAAA;EAAqB,qBAAA;EAAoB,uBAAA;EAAsB,2BAAA;EAA0B,iCAAA;EAA6B,8BAAA;EAA6B,oBAAA;AAyiOh07J;;AAziOm17J;EAAqG,6BAAA;AA6iOx77J;;AA7iOo97J;EAAuB,kBAAA;EAAkB,MAAA;EAAM,QAAA;EAAQ,SAAA;EAAS,OAAA;EAAO,UAAA;EAAU,WAAA;AAujOri8J;;AAvjOgj8J;EAAe,gBAAA;EAAgB,uBAAA;EAAuB,mBAAA;AA6jOtm8J;;AA7jOyn8J;EAAI,qBAAA;EAAqB,mBAAA;EAAmB,6BAAA;EAA6B,eAAA;EAAe,8BAAA;EAA8B,aAAA;AAskO/u8J;;AAtkO2v8J;EAAgB,mCAAA;AA0kO3w8J;;AA1kO6y8J;EAAW,8BAAA;AA8kOxz8J;;AA9kOq18J;EAAc,iCAAA;AAklOn28J;;AAllOm48J;EAAc,iCAAA;AAslOj58J;;AAtlOi78J;EAAmB,sCAAA;AA0lOp88J;;AA1lOy+8J;EAAgB,mCAAA;AA8lOz/8J;;AA9lO2h9J;EAAa,sBAAA;AAkmOxi9J;;AAlmO6j9J;EAAW,uBAAA;AAsmOxk9J;;AAtmO8l9J;EAAY,sBAAA;AA0mO1m9J;;AA1mO+n9J;EAAoD,8BAAA;AA+mOnr9J;;AA/mOgt9J;EAAgD,4BAAA;AAonOhw9J;;AApnO2x9J;EAA8C,2BAAA;AAynOz09J;;AAznOm29J;EAAqD,iCAAA;AA8nOx59J;;AA9nOw79J;EAA8C,2BAAA;AAmoOt+9J;;AAnoOgg+J;EAAW,qBAAA;AAuoO3g+J;;AAvoO+h+J;EAAY,wBAAA;AA2oO3i+J;;AA3oOik+J;EAAY,uBAAA;AA+oO7k+J;;AA/oOkm+J;EAAY,wBAAA;AAmpO9m+J;;AAnpOoo+J;EAAa,qBAAA;AAupOjp+J;;AAvpOqq+J;EAAe,yBAAA;AA2pOpr+J;;AA3pO4s+J;EAAiB,2BAAA;AA+pO7t+J;;AA/pOuv+J;EAAkB,4BAAA;AAmqOzw+J;;AAnqOoy+J;EAAiB,2BAAA;AAuqOrz+J;;AAvqO+0+J;EAAiB,2BAAA;AA2qOh2+J;;AA3qO03+J;EAAmB,6BAAA;AA+qO74+J;;AA/qOy6+J;EAAoB,8BAAA;AAmrO77+J;;AAnrO09+J;EAAmB,6BAAA;AAurO7++J;;AAvrOyg/J;EAAiB,2BAAA;AA2rO1h/J;;AA3rOoj/J;EAAmB,6BAAA;AA+rOvk/J;;AA/rOmm/J;EAAoB,8BAAA;AAmsOvn/J;;AAnsOop/J;EAAmB,6BAAA;AAusOvq/J;;AAvsOms/J;EAAU,0BAAA;AA2sO7s/J;;AA3sOsu/J;EAAgB,gCAAA;AA+sOtv/J;;AA/sOqx/J;EAAS,yBAAA;AAmtO9x/J;;AAntOsz/J;EAAQ,wBAAA;AAutO9z/J;;AAvtOq1/J;EAAe,+BAAA;AA2tOp2/J;;AA3tOk4/J;EAAS,yBAAA;AA+tO34/J;;AA/tOm6/J;EAAa,6BAAA;AAmuOh7/J;;AAnuO48/J;EAAc,8BAAA;AAuuO19/J;;AAvuOu//J;EAAQ,wBAAA;AA2uO///J;;AA3uOshgK;EAAe,+BAAA;AA+uOrigK;;AA/uOmkgK;EAAQ,wBAAA;AAmvO3kgK;;AAnvOkmgK;EAAQ,wDAAA;AAuvO1mgK;;AAvvO4pgK;EAAW,8DAAA;AA2vOvqgK;;AA3vO8tgK;EAAW,uDAAA;AA+vOzugK;;AA/vO2xgK;EAAa,2BAAA;AAmwOxygK;;AAnwOk0gK;EAAoB,+EAAA;AAuwOt1gK;;AAvwOs6gK;EAAsB,iFAAA;AA2wO57gK;;AA3wO8ghK;EAAoB,+EAAA;AA+wOlihK;;AA/wOknhK;EAAiB,4EAAA;AAmxOnohK;;AAnxOgthK;EAAoB,+EAAA;AAuxOpuhK;;AAvxOozhK;EAAmB,8EAAA;AA2xOv0hK;;AA3xOs5hK;EAAkB,6EAAA;AA+xOx6hK;;AA/xOs/hK;EAAiB,4EAAA;AAmyOvgiK;;AAnyOoliK;EAAiB,2BAAA;AAuyOrmiK;;AAvyO+niK;EAAmB,6BAAA;AA2yOlpiK;;AA3yO8qiK;EAAmB,6BAAA;AA+yOjsiK;;AA/yO6tiK;EAAgB,0BAAA;AAmzO7uiK;;AAnzOswiK;EAAmD,2BAAA;AAwzOzziK;;AAxzOm1iK;EAAO,iBAAA;AA4zO11iK;;AA5zO02iK;EAAQ,mBAAA;AAg0Ol3iK;;AAh0Oo4iK;EAAS,oBAAA;AAo0O74iK;;AAp0Og6iK;EAAU,oBAAA;AAw0O16iK;;AAx0O67iK;EAAW,sBAAA;AA40Ox8iK;;AA50O69iK;EAAY,uBAAA;AAg1Oz+iK;;AAh1O+/iK;EAAS,kBAAA;AAo1OxgjK;;AAp1OyhjK;EAAU,oBAAA;AAw1OnijK;;AAx1OsjjK;EAAW,qBAAA;AA41OjkjK;;AA51OqljK;EAAO,mBAAA;AAg2O5ljK;;AAh2O8mjK;EAAQ,qBAAA;AAo2OtnjK;;AAp2O0ojK;EAAS,sBAAA;AAw2OnpjK;;AAx2OwqjK;EAAkB,2CAAA;AA42O1rjK;;AA52OmujK;EAAoB,sCAAA;AAg3OvvjK;;AAh3O4xjK;EAAoB,sCAAA;AAo3OhzjK;;AAp3Oq1jK;EAAQ,uFAAA;AAw3O71jK;;AAx3Om7jK;EAAU,oBAAA;AA43O77jK;;AA53Og9jK;EAAY,2FAAA;AAg4O59jK;;AAh4OsjkK;EAAc,wBAAA;AAo4OpkkK;;AAp4O2lkK;EAAY,6FAAA;AAw4OvmkK;;AAx4OmskK;EAAc,0BAAA;AA44OjtkK;;AA54O0ukK;EAAe,8FAAA;AAg5OzvkK;;AAh5Os1kK;EAAiB,2BAAA;AAo5Ov2kK;;AAp5Oi4kK;EAAc,4FAAA;AAw5O/4kK;;AAx5O0+kK;EAAgB,yBAAA;AA45O1/kK;;AA55OkhlK;EAAgB,qBAAA;EAAsB,8EAAA;AAi6OxjlK;;AAj6OoolK;EAAkB,qBAAA;EAAsB,gFAAA;AAs6O5qlK;;AAt6O0vlK;EAAgB,qBAAA;EAAsB,8EAAA;AA26OhylK;;AA36O42lK;EAAa,qBAAA;EAAsB,2EAAA;AAg7O/4lK;;AAh7Ow9lK;EAAgB,qBAAA;EAAsB,8EAAA;AAq7O9/lK;;AAr7O0kmK;EAAe,qBAAA;EAAsB,6EAAA;AA07O/mmK;;AA17O0rmK;EAAc,qBAAA;EAAsB,4EAAA;AA+7O9tmK;;AA/7OwymK;EAAa,qBAAA;EAAsB,2EAAA;AAo8O30mK;;AAp8Oo5mK;EAAc,qBAAA;EAAsB,4EAAA;AAy8Ox7mK;;AAz8OkgnK;EAAc,qBAAA;EAAsB,4EAAA;AA88OtinK;;AA98OgnnK;EAAuB,wDAAA;AAk9OvonK;;AAl9O8rnK;EAAyB,0DAAA;AAs9OvtnK;;AAt9OgxnK;EAAuB,wDAAA;AA09OvynK;;AA19O81nK;EAAoB,qDAAA;AA89Ol3nK;;AA99Os6nK;EAAuB,wDAAA;AAk+O77nK;;AAl+Oo/nK;EAAsB,uDAAA;AAs+O1goK;;AAt+OgkoK;EAAqB,sDAAA;AA0+OrloK;;AA1+O0ooK;EAAoB,qDAAA;AA8+O9poK;;AA9+OktoK;EAAU,4BAAA;AAk/O5toK;;AAl/OuvoK;EAAU,4BAAA;AAs/OjwoK;;AAt/O4xoK;EAAU,4BAAA;AA0/OtyoK;;AA1/Oi0oK;EAAU,4BAAA;AA8/O30oK;;AA9/Os2oK;EAAU,4BAAA;AAkgPh3oK;;AAlgP24oK;EAAmB,uBAAA;AAsgP95oK;;AAtgPs7oK;EAAmB,wBAAA;AA0gPz8oK;;AA1gPk+oK;EAAmB,uBAAA;AA8gPr/oK;;AA9gP6gpK;EAAmB,wBAAA;AAkhPhipK;;AAlhPyjpK;EAAoB,qBAAA;AAshP7kpK;;AAthPmmpK;EAAM,qBAAA;AA0hPzmpK;;AA1hP6npK;EAAM,qBAAA;AA8hPnopK;;AA9hPuppK;EAAM,qBAAA;AAkiP7ppK;;AAliPirpK;EAAO,sBAAA;AAsiPxrpK;;AAtiP6spK;EAAQ,sBAAA;AA0iPrtpK;;AA1iP0upK;EAAQ,0BAAA;AA8iPlvpK;;AA9iP2wpK;EAAQ,uBAAA;AAkjPnxpK;;AAljPyypK;EAAY,2BAAA;AAsjPrzpK;;AAtjP+0pK;EAAM,sBAAA;AA0jPr1pK;;AA1jP02pK;EAAM,sBAAA;AA8jPh3pK;;AA9jPq4pK;EAAM,sBAAA;AAkkP34pK;;AAlkPg6pK;EAAO,uBAAA;AAskPv6pK;;AAtkP67pK;EAAQ,uBAAA;AA0kPr8pK;;AA1kP29pK;EAAQ,2BAAA;AA8kPn+pK;;AA9kP6/pK;EAAQ,wBAAA;AAklPrgqK;;AAllP4hqK;EAAY,4BAAA;AAslPxiqK;;AAtlPmkqK;EAAW,yBAAA;AA0lP9kqK;;AA1lPsmqK;EAAU,8BAAA;AA8lPhnqK;;AA9lP6oqK;EAAa,iCAAA;AAkmP1pqK;;AAlmP0rqK;EAAkB,sCAAA;AAsmP5sqK;;AAtmPivqK;EAAqB,yCAAA;AA0mPtwqK;;AA1mP8yqK;EAAa,uBAAA;AA8mP3zqK;;AA9mPi1qK;EAAa,uBAAA;AAknP91qK;;AAlnPo3qK;EAAe,yBAAA;AAsnPn4qK;;AAtnP25qK;EAAe,yBAAA;AA0nP16qK;;AA1nPk8qK;EAAW,0BAAA;AA8nP78qK;;AA9nPs+qK;EAAa,4BAAA;AAkoPn/qK;;AAloP8grK;EAAmB,kCAAA;AAsoPjirK;;AAtoPkkrK;EAAuB,sCAAA;AA0oPzlrK;;AA1oP8nrK;EAAqB,oCAAA;AA8oPnprK;;AA9oPsrrK;EAAwB,kCAAA;AAkpP9srK;;AAlpP+urK;EAAyB,yCAAA;AAspPxwrK;;AAtpPgzrK;EAAwB,wCAAA;AA0pPx0rK;;AA1pP+2rK;EAAwB,wCAAA;AA8pPv4rK;;AA9pP86rK;EAAmB,kCAAA;AAkqPj8rK;;AAlqPk+rK;EAAiB,gCAAA;AAsqPn/rK;;AAtqPkhsK;EAAoB,8BAAA;AA0qPtisK;;AA1qPmksK;EAAsB,gCAAA;AA8qPzlsK;;AA9qPwnsK;EAAqB,+BAAA;AAkrP7osK;;AAlrP2qsK;EAAqB,oCAAA;AAsrPhssK;;AAtrPmusK;EAAmB,kCAAA;AA0rPtvsK;;AA1rPuxsK;EAAsB,gCAAA;AA8rP7ysK;;AA9rP40sK;EAAuB,uCAAA;AAksPn2sK;;AAlsPy4sK;EAAsB,sCAAA;AAssP/5sK;;AAtsPo8sK;EAAuB,iCAAA;AA0sP39sK;;AA1sP2/sK;EAAiB,2BAAA;AA8sP5gtK;;AA9sPsitK;EAAkB,iCAAA;AAktPxjtK;;AAltPwltK;EAAgB,+BAAA;AAstPxmtK;;AAttPsotK;EAAmB,6BAAA;AA0tPzptK;;AA1tPqrtK;EAAqB,+BAAA;AA8tP1stK;;AA9tPwutK;EAAoB,8BAAA;AAkuP5vtK;;AAluPyxtK;EAAa,oBAAA;AAsuPtytK;;AAtuPyztK;EAAS,mBAAA;AA0uPl0tK;;AA1uPo1tK;EAAS,mBAAA;AA8uP71tK;;AA9uP+2tK;EAAS,mBAAA;AAkvPx3tK;;AAlvP04tK;EAAS,mBAAA;AAsvPn5tK;;AAtvPq6tK;EAAS,mBAAA;AA0vP96tK;;AA1vPg8tK;EAAS,mBAAA;AA8vPz8tK;;AA9vP29tK;EAAY,mBAAA;AAkwPv+tK;;AAlwPy/tK;EAAK,oBAAA;AAswP9/tK;;AAtwPihuK;EAAK,0BAAA;AA0wPthuK;;AA1wP8iuK;EAAK,yBAAA;AA8wPnjuK;;AA9wP0kuK;EAAK,uBAAA;AAkxP/kuK;;AAlxPqmuK;EAAK,yBAAA;AAsxP1muK;;AAtxPkouK;EAAK,uBAAA;AA0xPvouK;;AA1xP6puK;EAAQ,uBAAA;AA8xPrquK;;AA9xP2ruK;EAAM,0BAAA;EAAyB,yBAAA;AAmyP1tuK;;AAnyPkvuK;EAAM,gCAAA;EAA8B,+BAAA;AAwyPtxuK;;AAxyPmzuK;EAAM,+BAAA;EAA6B,8BAAA;AA6yPt1uK;;AA7yPk3uK;EAAM,6BAAA;EAA4B,4BAAA;AAkzPp5uK;;AAlzP+6uK;EAAM,+BAAA;EAA8B,8BAAA;AAuzPn9uK;;AAvzPg/uK;EAAM,6BAAA;EAA4B,4BAAA;AA4zPlhvK;;AA5zP6ivK;EAAS,6BAAA;EAA4B,4BAAA;AAi0PllvK;;AAj0P6mvK;EAAM,wBAAA;EAAuB,2BAAA;AAs0P1ovK;;AAt0PoqvK;EAAM,8BAAA;EAA4B,iCAAA;AA20PtsvK;;AA30PquvK;EAAM,6BAAA;EAA2B,gCAAA;AAg1PtwvK;;AAh1PoyvK;EAAM,2BAAA;EAA0B,8BAAA;AAq1Pp0vK;;AAr1Pi2vK;EAAM,6BAAA;EAA4B,gCAAA;AA01Pn4vK;;AA11Pk6vK;EAAM,2BAAA;EAA0B,8BAAA;AA+1Pl8vK;;AA/1P+9vK;EAAS,2BAAA;EAA0B,8BAAA;AAo2PlgwK;;AAp2P+hwK;EAAM,wBAAA;AAw2PriwK;;AAx2P4jwK;EAAM,8BAAA;AA42PlkwK;;AA52P8lwK;EAAM,6BAAA;AAg3PpmwK;;AAh3P+nwK;EAAM,2BAAA;AAo3ProwK;;AAp3P+pwK;EAAM,6BAAA;AAw3PrqwK;;AAx3PiswK;EAAM,2BAAA;AA43PvswK;;AA53PiuwK;EAAS,2BAAA;AAg4P1uwK;;AAh4PowwK;EAAM,0BAAA;AAo4P1wwK;;AAp4PmywK;EAAM,gCAAA;AAw4PzywK;;AAx4Pu0wK;EAAM,+BAAA;AA44P70wK;;AA54P02wK;EAAM,6BAAA;AAg5Ph3wK;;AAh5P44wK;EAAM,+BAAA;AAo5Pl5wK;;AAp5Pg7wK;EAAM,6BAAA;AAw5Pt7wK;;AAx5Pk9wK;EAAS,6BAAA;AA45P39wK;;AA55Pu/wK;EAAM,2BAAA;AAg6P7/wK;;AAh6PuhxK;EAAM,iCAAA;AAo6P7hxK;;AAp6P4jxK;EAAM,gCAAA;AAw6PlkxK;;AAx6PgmxK;EAAM,8BAAA;AA46PtmxK;;AA56PmoxK;EAAM,gCAAA;AAg7PzoxK;;AAh7PwqxK;EAAM,8BAAA;AAo7P9qxK;;AAp7P2sxK;EAAS,8BAAA;AAw7PptxK;;AAx7PivxK;EAAM,yBAAA;AA47PvvxK;;AA57P+wxK;EAAM,+BAAA;AAg8PrxxK;;AAh8PkzxK;EAAM,8BAAA;AAo8PxzxK;;AAp8Po1xK;EAAM,4BAAA;AAw8P11xK;;AAx8Pq3xK;EAAM,8BAAA;AA48P33xK;;AA58Pw5xK;EAAM,4BAAA;AAg9P95xK;;AAh9Py7xK;EAAS,4BAAA;AAo9Pl8xK;;AAp9P69xK;EAAK,qBAAA;AAw9Pl+xK;;AAx9Ps/xK;EAAK,2BAAA;AA49P3/xK;;AA59PohyK;EAAK,0BAAA;AAg+PzhyK;;AAh+PijyK;EAAK,wBAAA;AAo+PtjyK;;AAp+P6kyK;EAAK,0BAAA;AAw+PllyK;;AAx+P2myK;EAAK,wBAAA;AA4+PhnyK;;AA5+PuoyK;EAAM,2BAAA;EAA0B,0BAAA;AAi/PvqyK;;AAj/PgsyK;EAAM,iCAAA;EAA+B,gCAAA;AAs/PruyK;;AAt/PmwyK;EAAM,gCAAA;EAA8B,+BAAA;AA2/PvyyK;;AA3/Po0yK;EAAM,8BAAA;EAA6B,6BAAA;AAggQv2yK;;AAhgQm4yK;EAAM,gCAAA;EAA+B,+BAAA;AAqgQx6yK;;AArgQs8yK;EAAM,8BAAA;EAA6B,6BAAA;AA0gQz+yK;;AA1gQqgzK;EAAM,yBAAA;EAAwB,4BAAA;AA+gQnizK;;AA/gQ8jzK;EAAM,+BAAA;EAA6B,kCAAA;AAohQjmzK;;AAphQiozK;EAAM,8BAAA;EAA4B,iCAAA;AAyhQnqzK;;AAzhQkszK;EAAM,4BAAA;EAA2B,+BAAA;AA8hQnuzK;;AA9hQiwzK;EAAM,8BAAA;EAA6B,iCAAA;AAmiQpyzK;;AAniQo0zK;EAAM,4BAAA;EAA2B,+BAAA;AAwiQr2zK;;AAxiQm4zK;EAAM,yBAAA;AA4iQz4zK;;AA5iQi6zK;EAAM,+BAAA;AAgjQv6zK;;AAhjQo8zK;EAAM,8BAAA;AAojQ18zK;;AApjQs+zK;EAAM,4BAAA;AAwjQ5+zK;;AAxjQug0K;EAAM,8BAAA;AA4jQ7g0K;;AA5jQ0i0K;EAAM,4BAAA;AAgkQhj0K;;AAhkQ2k0K;EAAM,2BAAA;AAokQjl0K;;AApkQ2m0K;EAAM,iCAAA;AAwkQjn0K;;AAxkQgp0K;EAAM,gCAAA;AA4kQtp0K;;AA5kQor0K;EAAM,8BAAA;AAglQ1r0K;;AAhlQut0K;EAAM,gCAAA;AAolQ7t0K;;AAplQ4v0K;EAAM,8BAAA;AAwlQlw0K;;AAxlQ+x0K;EAAM,4BAAA;AA4lQry0K;;AA5lQg00K;EAAM,kCAAA;AAgmQt00K;;AAhmQs20K;EAAM,iCAAA;AAomQ520K;;AApmQ240K;EAAM,+BAAA;AAwmQj50K;;AAxmQ+60K;EAAM,iCAAA;AA4mQr70K;;AA5mQq90K;EAAM,+BAAA;AAgnQ390K;;AAhnQy/0K;EAAM,0BAAA;AAonQ//0K;;AApnQwh1K;EAAM,gCAAA;AAwnQ9h1K;;AAxnQ4j1K;EAAM,+BAAA;AA4nQlk1K;;AA5nQ+l1K;EAAM,6BAAA;AAgoQrm1K;;AAhoQio1K;EAAM,+BAAA;AAooQvo1K;;AApoQqq1K;EAAM,6BAAA;AAwoQ3q1K;;AAxoQus1K;EAAO,iBAAA;AA4oQ9s1K;;AA5oQ8t1K;EAAO,uBAAA;AAgpQru1K;;AAhpQ0v1K;EAAO,sBAAA;AAopQjw1K;;AAppQqx1K;EAAO,oBAAA;AAwpQ5x1K;;AAxpQ+y1K;EAAO,sBAAA;AA4pQtz1K;;AA5pQ201K;EAAO,oBAAA;AAgqQl11K;;AAhqQq21K;EAAW,qBAAA;AAoqQh31K;;AApqQo41K;EAAW,2BAAA;AAwqQ/41K;;AAxqQw61K;EAAW,0BAAA;AA4qQn71K;;AA5qQ281K;EAAW,wBAAA;AAgrQt91K;;AAhrQ6+1K;EAAW,0BAAA;AAorQx/1K;;AAprQih2K;EAAW,wBAAA;AAwrQ5h2K;;AAxrQmj2K;EAA0C,wBAAA;AA6rQ7l2K;;AA7rQon2K;EAAgD,8BAAA;AAksQpq2K;;AAlsQgs2K;EAA+C,6BAAA;AAusQ/u2K;;AAvsQ0w2K;EAA6C,2BAAA;AA4sQvz2K;;AA5sQi12K;EAA+C,6BAAA;AAitQh42K;;AAjtQ452K;EAA6C,2BAAA;AAstQz82K;;AAttQm+2K;EAAgB,gDAAA;AA0tQn/2K;;AA1tQki3K;EAAM,4CAAA;AA8tQxi3K;;AA9tQml3K;EAAM,4CAAA;AAkuQzl3K;;AAluQmo3K;EAAM,0CAAA;AAsuQzo3K;;AAtuQir3K;EAAM,4CAAA;AA0uQvr3K;;AA1uQiu3K;EAAM,6BAAA;AA8uQvu3K;;AA9uQmw3K;EAAM,0BAAA;AAkvQzw3K;;AAlvQky3K;EAAY,6BAAA;AAsvQ9y3K;;AAtvQ003K;EAAY,6BAAA;AA0vQt13K;;AA1vQk33K;EAAY,+BAAA;AA8vQ933K;;AA9vQ453K;EAAU,2BAAA;AAkwQt63K;;AAlwQg83K;EAAW,2BAAA;AAswQ383K;;AAtwQq+3K;EAAW,2BAAA;AA0wQh/3K;;AA1wQ0g4K;EAAa,2BAAA;AA8wQvh4K;;AA9wQij4K;EAAS,2BAAA;AAkxQ1j4K;;AAlxQol4K;EAAW,8BAAA;AAsxQ/l4K;;AAtxQ4n4K;EAAM,yBAAA;AA0xQlo4K;;AA1xQ0p4K;EAAO,4BAAA;AA8xQjq4K;;AA9xQ4r4K;EAAS,2BAAA;AAkyQrs4K;;AAlyQ+t4K;EAAO,yBAAA;AAsyQtu4K;;AAtyQ8v4K;EAAY,2BAAA;AA0yQ1w4K;;AA1yQoy4K;EAAU,4BAAA;AA8yQ9y4K;;AA9yQy04K;EAAa,6BAAA;AAkzQt14K;;AAlzQk34K;EAAsB,gCAAA;AAszQx44K;;AAtzQu64K;EAA2B,qCAAA;AA0zQl84K;;AA1zQs+4K;EAA8B,wCAAA;AA8zQpg5K;;AA9zQ2i5K;EAAgB,oCAAA;AAk0Q3j5K;;AAl0Q8l5K;EAAgB,oCAAA;AAs0Q9m5K;;AAt0Qip5K;EAAiB,qCAAA;AA00Qlq5K;;AA10Qss5K;EAAW,8BAAA;AA80Qjt5K;;AA90Q8u5K;EAAa,8BAAA;AAk1Q3v5K;;AAl1Qwx5K;EAAY,gCAAA;EAA+B,iCAAA;AAu1Qn05K;;AAv1Qm25K;EAAc,mBAAA;EAAoB,qEAAA;AA41Qr45K;;AA51Qw85K;EAAgB,mBAAA;EAAoB,uEAAA;AAi2Q5+5K;;AAj2Qij6K;EAAc,mBAAA;EAAoB,qEAAA;AAs2Qnl6K;;AAt2Qsp6K;EAAW,mBAAA;EAAoB,kEAAA;AA22Qrr6K;;AA32Qqv6K;EAAc,mBAAA;EAAoB,qEAAA;AAg3Qvx6K;;AAh3Q016K;EAAa,mBAAA;EAAoB,oEAAA;AAq3Q336K;;AAr3Q676K;EAAY,mBAAA;EAAoB,mEAAA;AA03Q796K;;AA13Q8h7K;EAAW,mBAAA;EAAoB,kEAAA;AA+3Q7j7K;;AA/3Q6n7K;EAAY,mBAAA;EAAoB,mEAAA;AAo4Q7p7K;;AAp4Q8t7K;EAAY,mBAAA;EAAoB,mEAAA;AAy4Q9v7K;;AAz4Q+z7K;EAAW,mBAAA;EAAoB,wEAAA;AA84Q917K;;AA94Qo67K;EAAY,mBAAA;EAAoB,2CAAA;AAm5Qp87K;;AAn5Q8+7K;EAAe,mBAAA;EAAoB,oCAAA;AAw5Qjh8K;;AAx5Qgj8K;EAAe,mBAAA;EAAoB,0CAAA;AA65Qnl8K;;AA75Qwn8K;EAAqB,mBAAA;EAAoB,2CAAA;AAk6Qjq8K;;AAl6Q2s8K;EAAoB,mBAAA;EAAoB,0CAAA;AAu6Qnv8K;;AAv6Q4x8K;EAAoB,mBAAA;EAAoB,0CAAA;AA46Qp08K;;AA56Q628K;EAAY,mBAAA;EAAoB,yBAAA;AAi7Q748K;;AAj7Qq68K;EAAiB,sBAAA;AAq7Qt78K;;AAr7Q688K;EAAiB,qBAAA;AAy7Q998K;;AAz7Qo/8K;EAAiB,sBAAA;AA67Qrg9K;;AA77Q4h9K;EAAkB,mBAAA;AAi8Q9i9K;;AAj8Qkk9K;EAAuB,iDAAA;AAq8Qzl9K;;AAr8Qyo9K;EAAyB,mDAAA;AAy8Qlq9K;;AAz8Qot9K;EAAuB,iDAAA;AA68Q3u9K;;AA78Q2x9K;EAAoB,8CAAA;AAi9Q/y9K;;AAj9Q419K;EAAuB,iDAAA;AAq9Qn39K;;AAr9Qm69K;EAAsB,gDAAA;AAy9Qz79K;;AAz9Qw+9K;EAAqB,+CAAA;AA69Q7/9K;;AA79Q2i+K;EAAoB,8CAAA;AAi+Q/j+K;;AAj+Q4m+K;EAAiB,qBAAA;AAq+Q7n+K;;AAr+Qmp+K;EAA6B,qBAAA;AAy+Qhr+K;;AAz+Qss+K;EAAiB,sBAAA;AA6+Qvt+K;;AA7+Q8u+K;EAA6B,sBAAA;AAi/Q3w+K;;AAj/Qky+K;EAAiB,qBAAA;AAq/Qnz+K;;AAr/Qy0+K;EAA6B,qBAAA;AAy/Qt2+K;;AAz/Q43+K;EAAiB,sBAAA;AA6/Q74+K;;AA7/Qo6+K;EAA6B,sBAAA;AAigRj8+K;;AAjgRw9+K;EAAkB,mBAAA;AAqgR1++K;;AArgR8/+K;EAA8B,mBAAA;AAygR5h/K;;AAzgRgj/K;EAAe,yCAAA;AA6gR/j/K;;AA7gRum/K;EAA2B,yCAAA;AAihRlo/K;;AAjhR0q/K;EAAe,wCAAA;AAqhRzr/K;;AArhRgu/K;EAA2B,wCAAA;AAyhR3v/K;;AAzhRky/K;EAAe,yCAAA;AA6hRjz/K;;AA7hRy1/K;EAA2B,yCAAA;AAiiRp3/K;;AAjiR45/K;EAAwB,6BAAA;EAAmI,+FAAA;AAuiRvjgL;;AAviRopgL;EAA0B,6BAAA;EAAqI,iGAAA;AA6iRnzgL;;AA7iRk5gL;EAAwB,6BAAA;EAAmI,+FAAA;AAmjR7ihL;;AAnjR0ohL;EAAqB,6BAAA;EAAgI,4FAAA;AAyjR/xhL;;AAzjRy3hL;EAAwB,6BAAA;EAAmI,+FAAA;AA+jRphiL;;AA/jRiniL;EAAuB,6BAAA;EAAkI,8FAAA;AAqkR1wiL;;AArkRs2iL;EAAsB,6BAAA;EAAiI,6FAAA;AA2kR7/iL;;AA3kRwljL;EAAqB,6BAAA;EAAgI,4FAAA;AAilR7ujL;;AAjlRu0jL;EAAgB,6BAAA;EAAwI,qGAAA;AAulR/9jL;;AAvlRikkL;EAA0B,6BAAA;AA2lR3lkL;;AA3lRynkL;EAAsC,6BAAA;AA+lR/pkL;;AA/lR6rkL;EAA2B,+BAAA;AAmmRxtkL;;AAnmRwvkL;EAAuC,+BAAA;AAumR/xkL;;AAvmR+zkL;EAA2B,gCAAA;AA2mR11kL;;AA3mR23kL;EAAuC,gCAAA;AA+mRl6kL;;AA/mRm8kL;EAA2B,+BAAA;AAmnR99kL;;AAnnR8/kL;EAAuC,+BAAA;AAunRrilL;;AAvnRqklL;EAA2B,gCAAA;AA2nRhmlL;;AA3nRiolL;EAAuC,gCAAA;AA+nRxqlL;;AA/nRyslL;EAA4B,6BAAA;AAmoRrulL;;AAnoRmwlL;EAAwC,6BAAA;AAuoR3ylL;;AAvoRy0lL;EAAY,iBAAA;EAAkB,8EAAA;AA4oRv2lL;;AA5oRm7lL;EAAc,iBAAA;EAAkB,gFAAA;AAipRn9lL;;AAjpRiimL;EAAY,iBAAA;EAAkB,8EAAA;AAspR/jmL;;AAtpR2omL;EAAS,iBAAA;EAAkB,2EAAA;AA2pRtqmL;;AA3pR+umL;EAAY,iBAAA;EAAkB,8EAAA;AAgqR7wmL;;AAhqRy1mL;EAAW,iBAAA;EAAkB,6EAAA;AAqqRt3mL;;AArqRi8mL;EAAU,iBAAA;EAAkB,4EAAA;AA0qR79mL;;AA1qRuinL;EAAS,iBAAA;EAAkB,2EAAA;AA+qRlknL;;AA/qR2onL;EAAU,iBAAA;EAAkB,4EAAA;AAorRvqnL;;AAprRivnL;EAAU,iBAAA;EAAkB,4EAAA;AAyrR7wnL;;AAzrRu1nL;EAAS,iBAAA;EAAkB,8EAAA;AA8rRl3nL;;AA9rR87nL;EAAgB,iBAAA;EAAkB,wCAAA;AAmsRh+nL;;AAnsRugoL;EAAmB,iBAAA;EAAkB,mFAAA;AAwsR5ioL;;AAxsR6noL;EAAkB,iBAAA;EAAkB,kFAAA;AA6sRjqoL;;AA7sRivoL;EAAe,mBAAA;AAitRhwoL;;AAjtRoxoL;EAAe,oBAAA;AAqtRnyoL;;AArtRwzoL;EAAe,mBAAA;AAytRv0oL;;AAztR21oL;EAAe,oBAAA;AA6tR12oL;;AA7tR+3oL;EAAgB,iBAAA;AAiuR/4oL;;AAjuRi6oL;EAAmB,wDAAA;AAquRp7oL;;AAruR2+oL;EAAqB,0DAAA;AAyuRhgpL;;AAzuRyjpL;EAAmB,wDAAA;AA6uR5kpL;;AA7uRmopL;EAAgB,qDAAA;AAivRnppL;;AAjvRuspL;EAAmB,wDAAA;AAqvR1tpL;;AArvRixpL;EAAkB,uDAAA;AAyvRnypL;;AAzvRy1pL;EAAiB,sDAAA;AA6vR12pL;;AA7vR+5pL;EAAgB,qDAAA;AAiwR/6pL;;AAjwRm+pL;EAAa,+CAAA;AAqwRh/pL;;AArwR8hqL;EAAiB,mCAAA;EAAiE,2BAAA;AA2wRhnqL;;AA3wR0oqL;EAAkB,oCAAA;EAAmE,4BAAA;AAixR/tqL;;AAjxR0vqL;EAAkB,oCAAA;EAAmE,4BAAA;AAuxR/0qL;;AAvxR02qL;EAAS,+BAAA;AA2xRn3qL;;AA3xRi5qL;EAAS,+BAAA;AA+xR15qL;;AA/xRw7qL;EAAS,iDAAA;AAmyRj8qL;;AAnyRi/qL;EAAW,2BAAA;AAuyR5/qL;;AAvyRshrL;EAAW,oDAAA;AA2yRjirL;;AA3yRolrL;EAAW,iDAAA;AA+yR/lrL;;AA/yR+orL;EAAW,oDAAA;AAmzR1prL;;AAnzR6srL;EAAW,oDAAA;AAuzRxtrL;;AAvzR2wrL;EAAW,qDAAA;AA2zRtxrL;;AA3zR00rL;EAAgB,6BAAA;AA+zR11rL;;AA/zRs3rL;EAAc,sDAAA;AAm0Rp4rL;;AAn0Ry7rL;EAAa,0DAAA;EAAyD,2DAAA;AAw0R//rL;;AAx0RyjsL;EAAe,oCAAA;EAAmC,qCAAA;AA60R3msL;;AA70R+osL;EAAe,6DAAA;EAA4D,8DAAA;AAk1R1tsL;;AAl1RuxsL;EAAe,0DAAA;EAAyD,2DAAA;AAu1R/1sL;;AAv1Ry5sL;EAAe,6DAAA;EAA4D,8DAAA;AA41Rp+sL;;AA51RiitL;EAAe,6DAAA;EAA4D,8DAAA;AAi2R5mtL;;AAj2RyqtL;EAAe,8DAAA;EAA6D,+DAAA;AAs2RrvtL;;AAt2RmztL;EAAoB,sCAAA;EAAqC,uCAAA;AA22R52tL;;AA32Rk5tL;EAAkB,+DAAA;EAA8D,gEAAA;AAg3Rl+tL;;AAh3RiiuL;EAAa,2DAAA;EAA0D,8DAAA;AAq3RxmuL;;AAr3RqquL;EAAe,qCAAA;EAAoC,wCAAA;AA03RxtuL;;AA13R+vuL;EAAe,8DAAA;EAA6D,iEAAA;AA+3R30uL;;AA/3R24uL;EAAe,2DAAA;EAA0D,8DAAA;AAo4Rp9uL;;AAp4RihvL;EAAe,8DAAA;EAA6D,iEAAA;AAy4R7lvL;;AAz4R6pvL;EAAe,8DAAA;EAA6D,iEAAA;AA84RzuvL;;AA94RyyvL;EAAe,+DAAA;EAA8D,kEAAA;AAm5Rt3vL;;AAn5Ru7vL;EAAoB,uCAAA;EAAsC,0CAAA;AAw5Rj/vL;;AAx5R0hwL;EAAkB,gEAAA;EAA+D,mEAAA;AA65R3mwL;;AA75R6qwL;EAAgB,8DAAA;EAA6D,6DAAA;AAk6R1vwL;;AAl6RszwL;EAAkB,wCAAA;EAAuC,uCAAA;AAu6R/2wL;;AAv6Rq5wL;EAAkB,iEAAA;EAAgE,gEAAA;AA46Rv+wL;;AA56RsixL;EAAkB,8DAAA;EAA6D,6DAAA;AAi7RrnxL;;AAj7RirxL;EAAkB,iEAAA;EAAgE,gEAAA;AAs7RnwxL;;AAt7Rk0xL;EAAkB,iEAAA;EAAgE,gEAAA;AA27Rp5xL;;AA37Rm9xL;EAAkB,kEAAA;EAAiE,iEAAA;AAg8RtiyL;;AAh8RsmyL;EAAuB,0CAAA;EAAyC,yCAAA;AAq8RtqyL;;AAr8R8syL;EAAqB,mEAAA;EAAkE,kEAAA;AA08RryyL;;AA18Rs2yL;EAAe,6DAAA;EAA4D,0DAAA;AA+8Rj7yL;;AA/8R0+yL;EAAiB,uCAAA;EAAsC,oCAAA;AAo9RjizL;;AAp9RokzL;EAAiB,gEAAA;EAA+D,6DAAA;AAy9RppzL;;AAz9RgtzL;EAAiB,6DAAA;EAA4D,0DAAA;AA89R7xzL;;AA99Rs1zL;EAAiB,gEAAA;EAA+D,6DAAA;AAm+Rt6zL;;AAn+Rk+zL;EAAiB,gEAAA;EAA+D,6DAAA;AAw+Rlj0L;;AAx+R8m0L;EAAiB,iEAAA;EAAgE,8DAAA;AA6+R/r0L;;AA7+R4v0L;EAAsB,yCAAA;EAAwC,sCAAA;AAk/R1z0L;;AAl/R+10L;EAAoB,kEAAA;EAAiE,+DAAA;AAu/Rp70L;;AAv/Rk/0L;EAAS,8BAAA;AA2/R3/0L;;AA3/Rwh1L;EAAW,6BAAA;AA+/Rni1L;;AA//R+j1L;EAAM,sBAAA;AAmgSrk1L;;AAngS0l1L;EAAK,qBAAA;AAugS/l1L;;AAvgSmn1L;EAAK,qBAAA;AA2gSxn1L;;AA3gS4o1L;EAAK,qBAAA;AA+gSjp1L;;AA/gSqq1L;EAAK,qBAAA;AAmhS1q1L;;AAnhS8r1L;EAAyB;IAAgB,sBAAA;EAwhSru1L;EAxhS0v1L;IAAc,uBAAA;EA2hSxw1L;EA3hS8x1L;IAAe,sBAAA;EA8hS7y1L;EA9hSk01L;IAAuD,8BAAA;EAkiSz31L;EAliSs51L;IAAmD,4BAAA;EAsiSz81L;EAtiSo+1L;IAAiD,2BAAA;EA0iSrh2L;EA1iS+i2L;IAAwD,iCAAA;EA8iSvm2L;EA9iSuo2L;IAAiD,2BAAA;EAkjSxr2L;EAljSkt2L;IAAa,0BAAA;EAqjS/t2L;EArjSwv2L;IAAmB,gCAAA;EAwjS3w2L;EAxjS0y2L;IAAY,yBAAA;EA2jStz2L;EA3jS802L;IAAW,wBAAA;EA8jSz12L;EA9jSg32L;IAAkB,+BAAA;EAikSl42L;EAjkSg62L;IAAY,yBAAA;EAokS562L;EApkSo82L;IAAgB,6BAAA;EAukSp92L;EAvkSg/2L;IAAiB,8BAAA;EA0kSjg3L;EA1kS8h3L;IAAW,wBAAA;EA6kSzi3L;EA7kSgk3L;IAAkB,+BAAA;EAglSll3L;EAhlSgn3L;IAAW,wBAAA;EAmlS3n3L;EAnlSkp3L;IAAc,yBAAA;EAslShq3L;EAtlSwr3L;IAAa,8BAAA;EAylSrs3L;EAzlSku3L;IAAgB,iCAAA;EA4lSlv3L;EA5lSkx3L;IAAqB,sCAAA;EA+lSvy3L;EA/lS403L;IAAwB,yCAAA;EAkmSp23L;EAlmS443L;IAAgB,uBAAA;EAqmS553L;EArmSk73L;IAAgB,uBAAA;EAwmSl83L;EAxmSw93L;IAAkB,yBAAA;EA2mS1+3L;EA3mSkg4L;IAAkB,yBAAA;EA8mSph4L;EA9mS4i4L;IAAc,0BAAA;EAinS1j4L;EAjnSml4L;IAAgB,4BAAA;EAonSnm4L;EApnS8n4L;IAAsB,kCAAA;EAunSpp4L;EAvnSqr4L;IAA0B,sCAAA;EA0nS/s4L;EA1nSov4L;IAAwB,oCAAA;EA6nS5w4L;EA7nS+y4L;IAA2B,kCAAA;EAgoS104L;EAhoS224L;IAA4B,yCAAA;EAmoSv44L;EAnoS+64L;IAA2B,wCAAA;EAsoS184L;EAtoSi/4L;IAA2B,wCAAA;EAyoS5g5L;EAzoSmj5L;IAAsB,kCAAA;EA4oSzk5L;EA5oS0m5L;IAAoB,gCAAA;EA+oS9n5L;EA/oS6p5L;IAAuB,8BAAA;EAkpSpr5L;EAlpSit5L;IAAyB,gCAAA;EAqpS1u5L;EArpSyw5L;IAAwB,+BAAA;EAwpSjy5L;EAxpS+z5L;IAAwB,oCAAA;EA2pSv15L;EA3pS035L;IAAsB,kCAAA;EA8pSh55L;EA9pSi75L;IAAyB,gCAAA;EAiqS185L;EAjqSy+5L;IAA0B,uCAAA;EAoqSng6L;EApqSyi6L;IAAyB,sCAAA;EAuqSlk6L;EAvqSum6L;IAA0B,iCAAA;EA0qSjo6L;EA1qSiq6L;IAAoB,2BAAA;EA6qSrr6L;EA7qS+s6L;IAAqB,iCAAA;EAgrSpu6L;EAhrSow6L;IAAmB,+BAAA;EAmrSvx6L;EAnrSqz6L;IAAsB,6BAAA;EAsrS306L;EAtrSu26L;IAAwB,+BAAA;EAyrS/36L;EAzrS656L;IAAuB,8BAAA;EA4rSp76L;EA5rSi96L;IAAgB,oBAAA;EA+rSj+6L;EA/rSo/6L;IAAY,mBAAA;EAksShg7L;EAlsSkh7L;IAAY,mBAAA;EAqsS9h7L;EArsSgj7L;IAAY,mBAAA;EAwsS5j7L;EAxsS8k7L;IAAY,mBAAA;EA2sS1l7L;EA3sS4m7L;IAAY,mBAAA;EA8sSxn7L;EA9sS0o7L;IAAY,mBAAA;EAitStp7L;EAjtSwq7L;IAAe,mBAAA;EAotSvr7L;EAptSys7L;IAAQ,oBAAA;EAutSjt7L;EAvtSou7L;IAAQ,0BAAA;EA0tS5u7L;EA1tSow7L;IAAQ,yBAAA;EA6tS5w7L;EA7tSmy7L;IAAQ,uBAAA;EAguS3y7L;EAhuSi07L;IAAQ,yBAAA;EAmuSz07L;EAnuSi27L;IAAQ,uBAAA;EAsuSz27L;EAtuS+37L;IAAW,uBAAA;EAyuS147L;EAzuSg67L;IAAS,0BAAA;IAAyB,yBAAA;EA6uSl87L;EA7uS097L;IAAS,gCAAA;IAA8B,+BAAA;EAivSjg8L;EAjvS8h8L;IAAS,+BAAA;IAA6B,8BAAA;EAqvSpk8L;EArvSgm8L;IAAS,6BAAA;IAA4B,4BAAA;EAyvSro8L;EAzvSgq8L;IAAS,+BAAA;IAA8B,8BAAA;EA6vSvs8L;EA7vSou8L;IAAS,6BAAA;IAA4B,4BAAA;EAiwSzw8L;EAjwSoy8L;IAAY,6BAAA;IAA4B,4BAAA;EAqwS508L;EArwSu28L;IAAS,wBAAA;IAAuB,2BAAA;EAywSv48L;EAzwSi68L;IAAS,8BAAA;IAA4B,iCAAA;EA6wSt88L;EA7wSq+8L;IAAS,6BAAA;IAA2B,gCAAA;EAixSzg9L;EAjxSui9L;IAAS,2BAAA;IAA0B,8BAAA;EAqxS1k9L;EArxSum9L;IAAS,6BAAA;IAA4B,gCAAA;EAyxS5o9L;EAzxS2q9L;IAAS,2BAAA;IAA0B,8BAAA;EA6xS9s9L;EA7xS2u9L;IAAY,2BAAA;IAA0B,8BAAA;EAiySjx9L;EAjyS8y9L;IAAS,wBAAA;EAoySvz9L;EApyS809L;IAAS,8BAAA;EAuySv19L;EAvySm39L;IAAS,6BAAA;EA0yS539L;EA1ySu59L;IAAS,2BAAA;EA6ySh69L;EA7yS079L;IAAS,6BAAA;EAgzSn89L;EAhzS+99L;IAAS,2BAAA;EAmzSx+9L;EAnzSkg+L;IAAY,2BAAA;EAszS9g+L;EAtzSwi+L;IAAS,0BAAA;EAyzSjj+L;EAzzS0k+L;IAAS,gCAAA;EA4zSnl+L;EA5zSin+L;IAAS,+BAAA;EA+zS1n+L;EA/zSup+L;IAAS,6BAAA;EAk0Shq+L;EAl0S4r+L;IAAS,+BAAA;EAq0Srs+L;EAr0Smu+L;IAAS,6BAAA;EAw0S5u+L;EAx0Sww+L;IAAY,6BAAA;EA20Spx+L;EA30Sgz+L;IAAS,2BAAA;EA80Szz+L;EA90Sm1+L;IAAS,iCAAA;EAi1S51+L;EAj1S23+L;IAAS,gCAAA;EAo1Sp4+L;EAp1Sk6+L;IAAS,8BAAA;EAu1S36+L;EAv1Sw8+L;IAAS,gCAAA;EA01Sj9+L;EA11Sg/+L;IAAS,8BAAA;EA61Sz/+L;EA71Ssh/L;IAAY,8BAAA;EAg2Sli/L;EAh2S+j/L;IAAS,yBAAA;EAm2Sxk/L;EAn2Sgm/L;IAAS,+BAAA;EAs2Szm/L;EAt2Sso/L;IAAS,8BAAA;EAy2S/o/L;EAz2S2q/L;IAAS,4BAAA;EA42Spr/L;EA52S+s/L;IAAS,8BAAA;EA+2Sxt/L;EA/2Sqv/L;IAAS,4BAAA;EAk3S9v/L;EAl3Syx/L;IAAY,4BAAA;EAq3Sry/L;EAr3Sg0/L;IAAQ,qBAAA;EAw3Sx0/L;EAx3S41/L;IAAQ,2BAAA;EA23Sp2/L;EA33S63/L;IAAQ,0BAAA;EA83Sr4/L;EA93S65/L;IAAQ,wBAAA;EAi4Sr6/L;EAj4S47/L;IAAQ,0BAAA;EAo4Sp8/L;EAp4S69/L;IAAQ,wBAAA;EAu4Sr+/L;EAv4S4//L;IAAS,2BAAA;IAA0B,0BAAA;EA24S/hgM;EA34SwjgM;IAAS,iCAAA;IAA+B,gCAAA;EA+4ShmgM;EA/4S8ngM;IAAS,gCAAA;IAA8B,+BAAA;EAm5SrqgM;EAn5SksgM;IAAS,8BAAA;IAA6B,6BAAA;EAu5SxugM;EAv5SowgM;IAAS,gCAAA;IAA+B,+BAAA;EA25S5ygM;EA35S00gM;IAAS,8BAAA;IAA6B,6BAAA;EA+5Sh3gM;EA/5S44gM;IAAS,yBAAA;IAAwB,4BAAA;EAm6S76gM;EAn6Sw8gM;IAAS,+BAAA;IAA6B,kCAAA;EAu6S9+gM;EAv6S8ghM;IAAS,8BAAA;IAA4B,iCAAA;EA26SnjhM;EA36SklhM;IAAS,4BAAA;IAA2B,+BAAA;EA+6StnhM;EA/6SophM;IAAS,8BAAA;IAA6B,iCAAA;EAm7S1rhM;EAn7S0thM;IAAS,4BAAA;IAA2B,+BAAA;EAu7S9vhM;EAv7S4xhM;IAAS,yBAAA;EA07SryhM;EA17S6zhM;IAAS,+BAAA;EA67St0hM;EA77Sm2hM;IAAS,8BAAA;EAg8S52hM;EAh8Sw4hM;IAAS,4BAAA;EAm8Sj5hM;EAn8S46hM;IAAS,8BAAA;EAs8Sr7hM;EAt8Sk9hM;IAAS,4BAAA;EAy8S39hM;EAz8Ss/hM;IAAS,2BAAA;EA48S//hM;EA58SyhiM;IAAS,iCAAA;EA+8SliiM;EA/8SikiM;IAAS,gCAAA;EAk9S1kiM;EAl9SwmiM;IAAS,8BAAA;EAq9SjniM;EAr9S8oiM;IAAS,gCAAA;EAw9SvpiM;EAx9SsriM;IAAS,8BAAA;EA29S/riM;EA39S4tiM;IAAS,4BAAA;EA89SruiM;EA99SgwiM;IAAS,kCAAA;EAi+SzwiM;EAj+SyyiM;IAAS,iCAAA;EAo+SlziM;EAp+Si1iM;IAAS,+BAAA;EAu+S11iM;EAv+Sw3iM;IAAS,iCAAA;EA0+Sj4iM;EA1+Si6iM;IAAS,+BAAA;EA6+S16iM;EA7+Sw8iM;IAAS,0BAAA;EAg/Sj9iM;EAh/S0+iM;IAAS,gCAAA;EAm/Sn/iM;EAn/SihjM;IAAS,+BAAA;EAs/S1hjM;EAt/SujjM;IAAS,6BAAA;EAy/ShkjM;EAz/S4ljM;IAAS,+BAAA;EA4/SrmjM;EA5/SmojM;IAAS,6BAAA;EA+/S5ojM;EA//SwqjM;IAAU,iBAAA;EAkgTlrjM;EAlgTksjM;IAAU,uBAAA;EAqgT5sjM;EArgTiujM;IAAU,sBAAA;EAwgT3ujM;EAxgT+vjM;IAAU,oBAAA;EA2gTzwjM;EA3gT4xjM;IAAU,sBAAA;EA8gTtyjM;EA9gT2zjM;IAAU,oBAAA;EAihTr0jM;EAjhTw1jM;IAAc,qBAAA;EAohTt2jM;EAphT03jM;IAAc,2BAAA;EAuhTx4jM;EAvhTi6jM;IAAc,0BAAA;EA0hT/6jM;EA1hTu8jM;IAAc,wBAAA;EA6hTr9jM;EA7hT4+jM;IAAc,0BAAA;EAgiT1/jM;EAhiTmhkM;IAAc,wBAAA;EAmiTjikM;EAniTwjkM;IAA6C,wBAAA;EAuiTrmkM;EAviT4nkM;IAAmD,8BAAA;EA2iT/qkM;EA3iT2skM;IAAkD,6BAAA;EA+iT7vkM;EA/iTwxkM;IAAgD,2BAAA;EAmjTx0kM;EAnjTk2kM;IAAkD,6BAAA;EAujTp5kM;EAvjTg7kM;IAAgD,2BAAA;EA2jTh+kM;EA3jT0/kM;IAAe,2BAAA;EA8jTzglM;EA9jTmilM;IAAa,4BAAA;EAikThjlM;EAjkT2klM;IAAgB,6BAAA;EAokT3llM;AACF;AArkT0nlM;EAAyB;IAAgB,sBAAA;EAykTjqlM;EAzkTsrlM;IAAc,uBAAA;EA4kTpslM;EA5kT0tlM;IAAe,sBAAA;EA+kTzulM;EA/kT8vlM;IAAuD,8BAAA;EAmlTrzlM;EAnlTk1lM;IAAmD,4BAAA;EAulTr4lM;EAvlTg6lM;IAAiD,2BAAA;EA2lTj9lM;EA3lT2+lM;IAAwD,iCAAA;EA+lTnimM;EA/lTmkmM;IAAiD,2BAAA;EAmmTpnmM;EAnmT8omM;IAAa,0BAAA;EAsmT3pmM;EAtmTormM;IAAmB,gCAAA;EAymTvsmM;EAzmTsumM;IAAY,yBAAA;EA4mTlvmM;EA5mT0wmM;IAAW,wBAAA;EA+mTrxmM;EA/mT4ymM;IAAkB,+BAAA;EAknT9zmM;EAlnT41mM;IAAY,yBAAA;EAqnTx2mM;EArnTg4mM;IAAgB,6BAAA;EAwnTh5mM;EAxnT46mM;IAAiB,8BAAA;EA2nT77mM;EA3nT09mM;IAAW,wBAAA;EA8nTr+mM;EA9nT4/mM;IAAkB,+BAAA;EAioT9gnM;EAjoT4inM;IAAW,wBAAA;EAooTvjnM;EApoT8knM;IAAc,yBAAA;EAuoT5lnM;EAvoTonnM;IAAa,8BAAA;EA0oTjonM;EA1oT8pnM;IAAgB,iCAAA;EA6oT9qnM;EA7oT8snM;IAAqB,sCAAA;EAgpTnunM;EAhpTwwnM;IAAwB,yCAAA;EAmpThynM;EAnpTw0nM;IAAgB,uBAAA;EAspTx1nM;EAtpT82nM;IAAgB,uBAAA;EAypT93nM;EAzpTo5nM;IAAkB,yBAAA;EA4pTt6nM;EA5pT87nM;IAAkB,yBAAA;EA+pTh9nM;EA/pTw+nM;IAAc,0BAAA;EAkqTt/nM;EAlqT+goM;IAAgB,4BAAA;EAqqT/hoM;EArqT0joM;IAAsB,kCAAA;EAwqThloM;EAxqTinoM;IAA0B,sCAAA;EA2qT3ooM;EA3qTgroM;IAAwB,oCAAA;EA8qTxsoM;EA9qT2uoM;IAA2B,kCAAA;EAirTtwoM;EAjrTuyoM;IAA4B,yCAAA;EAorTn0oM;EAprT22oM;IAA2B,wCAAA;EAurTt4oM;EAvrT66oM;IAA2B,wCAAA;EA0rTx8oM;EA1rT++oM;IAAsB,kCAAA;EA6rTrgpM;EA7rTsipM;IAAoB,gCAAA;EAgsT1jpM;EAhsTylpM;IAAuB,8BAAA;EAmsThnpM;EAnsT6opM;IAAyB,gCAAA;EAssTtqpM;EAtsTqspM;IAAwB,+BAAA;EAysT7tpM;EAzsT2vpM;IAAwB,oCAAA;EA4sTnxpM;EA5sTszpM;IAAsB,kCAAA;EA+sT50pM;EA/sT62pM;IAAyB,gCAAA;EAktTt4pM;EAltTq6pM;IAA0B,uCAAA;EAqtT/7pM;EArtTq+pM;IAAyB,sCAAA;EAwtT9/pM;EAxtTmiqM;IAA0B,iCAAA;EA2tT7jqM;EA3tT6lqM;IAAoB,2BAAA;EA8tTjnqM;EA9tT2oqM;IAAqB,iCAAA;EAiuThqqM;EAjuTgsqM;IAAmB,+BAAA;EAouTntqM;EApuTivqM;IAAsB,6BAAA;EAuuTvwqM;EAvuTmyqM;IAAwB,+BAAA;EA0uT3zqM;EA1uTy1qM;IAAuB,8BAAA;EA6uTh3qM;EA7uT64qM;IAAgB,oBAAA;EAgvT75qM;EAhvTg7qM;IAAY,mBAAA;EAmvT57qM;EAnvT88qM;IAAY,mBAAA;EAsvT19qM;EAtvT4+qM;IAAY,mBAAA;EAyvTx/qM;EAzvT0grM;IAAY,mBAAA;EA4vTthrM;EA5vTwirM;IAAY,mBAAA;EA+vTpjrM;EA/vTskrM;IAAY,mBAAA;EAkwTllrM;EAlwTomrM;IAAe,mBAAA;EAqwTnnrM;EArwTqorM;IAAQ,oBAAA;EAwwT7orM;EAxwTgqrM;IAAQ,0BAAA;EA2wTxqrM;EA3wTgsrM;IAAQ,yBAAA;EA8wTxsrM;EA9wT+trM;IAAQ,uBAAA;EAixTvurM;EAjxT6vrM;IAAQ,yBAAA;EAoxTrwrM;EApxT6xrM;IAAQ,uBAAA;EAuxTryrM;EAvxT2zrM;IAAW,uBAAA;EA0xTt0rM;EA1xT41rM;IAAS,0BAAA;IAAyB,yBAAA;EA8xT93rM;EA9xTs5rM;IAAS,gCAAA;IAA8B,+BAAA;EAkyT77rM;EAlyT09rM;IAAS,+BAAA;IAA6B,8BAAA;EAsyThgsM;EAtyT4hsM;IAAS,6BAAA;IAA4B,4BAAA;EA0yTjksM;EA1yT4lsM;IAAS,+BAAA;IAA8B,8BAAA;EA8yTnosM;EA9yTgqsM;IAAS,6BAAA;IAA4B,4BAAA;EAkzTrssM;EAlzTgusM;IAAY,6BAAA;IAA4B,4BAAA;EAszTxwsM;EAtzTmysM;IAAS,wBAAA;IAAuB,2BAAA;EA0zTn0sM;EA1zT61sM;IAAS,8BAAA;IAA4B,iCAAA;EA8zTl4sM;EA9zTi6sM;IAAS,6BAAA;IAA2B,gCAAA;EAk0Tr8sM;EAl0Tm+sM;IAAS,2BAAA;IAA0B,8BAAA;EAs0TtgtM;EAt0TmitM;IAAS,6BAAA;IAA4B,gCAAA;EA00TxktM;EA10TumtM;IAAS,2BAAA;IAA0B,8BAAA;EA80T1otM;EA90TuqtM;IAAY,2BAAA;IAA0B,8BAAA;EAk1T7stM;EAl1T0utM;IAAS,wBAAA;EAq1TnvtM;EAr1T0wtM;IAAS,8BAAA;EAw1TnxtM;EAx1T+ytM;IAAS,6BAAA;EA21TxztM;EA31Tm1tM;IAAS,2BAAA;EA81T51tM;EA91Ts3tM;IAAS,6BAAA;EAi2T/3tM;EAj2T25tM;IAAS,2BAAA;EAo2Tp6tM;EAp2T87tM;IAAY,2BAAA;EAu2T18tM;EAv2To+tM;IAAS,0BAAA;EA02T7+tM;EA12TsguM;IAAS,gCAAA;EA62T/guM;EA72T6iuM;IAAS,+BAAA;EAg3TtjuM;EAh3TmluM;IAAS,6BAAA;EAm3T5luM;EAn3TwnuM;IAAS,+BAAA;EAs3TjouM;EAt3T+puM;IAAS,6BAAA;EAy3TxquM;EAz3TosuM;IAAY,6BAAA;EA43ThtuM;EA53T4uuM;IAAS,2BAAA;EA+3TrvuM;EA/3T+wuM;IAAS,iCAAA;EAk4TxxuM;EAl4TuzuM;IAAS,gCAAA;EAq4Th0uM;EAr4T81uM;IAAS,8BAAA;EAw4Tv2uM;EAx4To4uM;IAAS,gCAAA;EA24T74uM;EA34T46uM;IAAS,8BAAA;EA84Tr7uM;EA94Tk9uM;IAAY,8BAAA;EAi5T99uM;EAj5T2/uM;IAAS,yBAAA;EAo5TpgvM;EAp5T4hvM;IAAS,+BAAA;EAu5TrivM;EAv5TkkvM;IAAS,8BAAA;EA05T3kvM;EA15TumvM;IAAS,4BAAA;EA65ThnvM;EA75T2ovM;IAAS,8BAAA;EAg6TppvM;EAh6TirvM;IAAS,4BAAA;EAm6T1rvM;EAn6TqtvM;IAAY,4BAAA;EAs6TjuvM;EAt6T4vvM;IAAQ,qBAAA;EAy6TpwvM;EAz6TwxvM;IAAQ,2BAAA;EA46ThyvM;EA56TyzvM;IAAQ,0BAAA;EA+6Tj0vM;EA/6Ty1vM;IAAQ,wBAAA;EAk7Tj2vM;EAl7Tw3vM;IAAQ,0BAAA;EAq7Th4vM;EAr7Ty5vM;IAAQ,wBAAA;EAw7Tj6vM;EAx7Tw7vM;IAAS,2BAAA;IAA0B,0BAAA;EA47T39vM;EA57To/vM;IAAS,iCAAA;IAA+B,gCAAA;EAg8T5hwM;EAh8T0jwM;IAAS,gCAAA;IAA8B,+BAAA;EAo8TjmwM;EAp8T8nwM;IAAS,8BAAA;IAA6B,6BAAA;EAw8TpqwM;EAx8TgswM;IAAS,gCAAA;IAA+B,+BAAA;EA48TxuwM;EA58TswwM;IAAS,8BAAA;IAA6B,6BAAA;EAg9T5ywM;EAh9Tw0wM;IAAS,yBAAA;IAAwB,4BAAA;EAo9Tz2wM;EAp9To4wM;IAAS,+BAAA;IAA6B,kCAAA;EAw9T16wM;EAx9T08wM;IAAS,8BAAA;IAA4B,iCAAA;EA49T/+wM;EA59T8gxM;IAAS,4BAAA;IAA2B,+BAAA;EAg+TljxM;EAh+TglxM;IAAS,8BAAA;IAA6B,iCAAA;EAo+TtnxM;EAp+TspxM;IAAS,4BAAA;IAA2B,+BAAA;EAw+T1rxM;EAx+TwtxM;IAAS,yBAAA;EA2+TjuxM;EA3+TyvxM;IAAS,+BAAA;EA8+TlwxM;EA9+T+xxM;IAAS,8BAAA;EAi/TxyxM;EAj/To0xM;IAAS,4BAAA;EAo/T70xM;EAp/Tw2xM;IAAS,8BAAA;EAu/Tj3xM;EAv/T84xM;IAAS,4BAAA;EA0/Tv5xM;EA1/Tk7xM;IAAS,2BAAA;EA6/T37xM;EA7/Tq9xM;IAAS,iCAAA;EAggU99xM;EAhgU6/xM;IAAS,gCAAA;EAmgUtgyM;EAngUoiyM;IAAS,8BAAA;EAsgU7iyM;EAtgU0kyM;IAAS,gCAAA;EAygUnlyM;EAzgUknyM;IAAS,8BAAA;EA4gU3nyM;EA5gUwpyM;IAAS,4BAAA;EA+gUjqyM;EA/gU4ryM;IAAS,kCAAA;EAkhUrsyM;EAlhUquyM;IAAS,iCAAA;EAqhU9uyM;EArhU6wyM;IAAS,+BAAA;EAwhUtxyM;EAxhUozyM;IAAS,iCAAA;EA2hU7zyM;EA3hU61yM;IAAS,+BAAA;EA8hUt2yM;EA9hUo4yM;IAAS,0BAAA;EAiiU74yM;EAjiUs6yM;IAAS,gCAAA;EAoiU/6yM;EApiU68yM;IAAS,+BAAA;EAuiUt9yM;EAviUm/yM;IAAS,6BAAA;EA0iU5/yM;EA1iUwhzM;IAAS,+BAAA;EA6iUjizM;EA7iU+jzM;IAAS,6BAAA;EAgjUxkzM;EAhjUomzM;IAAU,iBAAA;EAmjU9mzM;EAnjU8nzM;IAAU,uBAAA;EAsjUxozM;EAtjU6pzM;IAAU,sBAAA;EAyjUvqzM;EAzjU2rzM;IAAU,oBAAA;EA4jUrszM;EA5jUwtzM;IAAU,sBAAA;EA+jUluzM;EA/jUuvzM;IAAU,oBAAA;EAkkUjwzM;EAlkUoxzM;IAAc,qBAAA;EAqkUlyzM;EArkUszzM;IAAc,2BAAA;EAwkUp0zM;EAxkU61zM;IAAc,0BAAA;EA2kU32zM;EA3kUm4zM;IAAc,wBAAA;EA8kUj5zM;EA9kUw6zM;IAAc,0BAAA;EAilUt7zM;EAjlU+8zM;IAAc,wBAAA;EAolU79zM;EAplUo/zM;IAA6C,wBAAA;EAwlUji0M;EAxlUwj0M;IAAmD,8BAAA;EA4lU3m0M;EA5lUuo0M;IAAkD,6BAAA;EAgmUzr0M;EAhmUot0M;IAAgD,2BAAA;EAomUpw0M;EApmU8x0M;IAAkD,6BAAA;EAwmUh10M;EAxmU420M;IAAgD,2BAAA;EA4mU550M;EA5mUs70M;IAAe,2BAAA;EA+mUr80M;EA/mU+90M;IAAa,4BAAA;EAknU5+0M;EAlnUug1M;IAAgB,6BAAA;EAqnUvh1M;AACF;AAtnUsj1M;EAAyB;IAAgB,sBAAA;EA0nU7l1M;EA1nUkn1M;IAAc,uBAAA;EA6nUho1M;EA7nUsp1M;IAAe,sBAAA;EAgoUrq1M;EAhoU0r1M;IAAuD,8BAAA;EAooUjv1M;EApoU8w1M;IAAmD,4BAAA;EAwoUj01M;EAxoU411M;IAAiD,2BAAA;EA4oU741M;EA5oUu61M;IAAwD,iCAAA;EAgpU/91M;EAhpU+/1M;IAAiD,2BAAA;EAopUhj2M;EAppU0k2M;IAAa,0BAAA;EAupUvl2M;EAvpUgn2M;IAAmB,gCAAA;EA0pUno2M;EA1pUkq2M;IAAY,yBAAA;EA6pU9q2M;EA7pUss2M;IAAW,wBAAA;EAgqUjt2M;EAhqUwu2M;IAAkB,+BAAA;EAmqU1v2M;EAnqUwx2M;IAAY,yBAAA;EAsqUpy2M;EAtqU4z2M;IAAgB,6BAAA;EAyqU502M;EAzqUw22M;IAAiB,8BAAA;EA4qUz32M;EA5qUs52M;IAAW,wBAAA;EA+qUj62M;EA/qUw72M;IAAkB,+BAAA;EAkrU182M;EAlrUw+2M;IAAW,wBAAA;EAqrUn/2M;EArrU0g3M;IAAc,yBAAA;EAwrUxh3M;EAxrUgj3M;IAAa,8BAAA;EA2rU7j3M;EA3rU0l3M;IAAgB,iCAAA;EA8rU1m3M;EA9rU0o3M;IAAqB,sCAAA;EAisU/p3M;EAjsUos3M;IAAwB,yCAAA;EAosU5t3M;EApsUow3M;IAAgB,uBAAA;EAusUpx3M;EAvsU0y3M;IAAgB,uBAAA;EA0sU1z3M;EA1sUg13M;IAAkB,yBAAA;EA6sUl23M;EA7sU033M;IAAkB,yBAAA;EAgtU543M;EAhtUo63M;IAAc,0BAAA;EAmtUl73M;EAntU283M;IAAgB,4BAAA;EAstU393M;EAttUs/3M;IAAsB,kCAAA;EAytU5g4M;EAztU6i4M;IAA0B,sCAAA;EA4tUvk4M;EA5tU4m4M;IAAwB,oCAAA;EA+tUpo4M;EA/tUuq4M;IAA2B,kCAAA;EAkuUls4M;EAluUmu4M;IAA4B,yCAAA;EAquU/v4M;EAruUuy4M;IAA2B,wCAAA;EAwuUl04M;EAxuUy24M;IAA2B,wCAAA;EA2uUp44M;EA3uU264M;IAAsB,kCAAA;EA8uUj84M;EA9uUk+4M;IAAoB,gCAAA;EAivUt/4M;EAjvUqh5M;IAAuB,8BAAA;EAovU5i5M;EApvUyk5M;IAAyB,gCAAA;EAuvUlm5M;EAvvUio5M;IAAwB,+BAAA;EA0vUzp5M;EA1vUur5M;IAAwB,oCAAA;EA6vU/s5M;EA7vUkv5M;IAAsB,kCAAA;EAgwUxw5M;EAhwUyy5M;IAAyB,gCAAA;EAmwUl05M;EAnwUi25M;IAA0B,uCAAA;EAswU335M;EAtwUi65M;IAAyB,sCAAA;EAywU175M;EAzwU+95M;IAA0B,iCAAA;EA4wUz/5M;EA5wUyh6M;IAAoB,2BAAA;EA+wU7i6M;EA/wUuk6M;IAAqB,iCAAA;EAkxU5l6M;EAlxU4n6M;IAAmB,+BAAA;EAqxU/o6M;EArxU6q6M;IAAsB,6BAAA;EAwxUns6M;EAxxU+t6M;IAAwB,+BAAA;EA2xUvv6M;EA3xUqx6M;IAAuB,8BAAA;EA8xU5y6M;EA9xUy06M;IAAgB,oBAAA;EAiyUz16M;EAjyU426M;IAAY,mBAAA;EAoyUx36M;EApyU046M;IAAY,mBAAA;EAuyUt56M;EAvyUw66M;IAAY,mBAAA;EA0yUp76M;EA1yUs86M;IAAY,mBAAA;EA6yUl96M;EA7yUo+6M;IAAY,mBAAA;EAgzUh/6M;EAhzUkg7M;IAAY,mBAAA;EAmzU9g7M;EAnzUgi7M;IAAe,mBAAA;EAszU/i7M;EAtzUik7M;IAAQ,oBAAA;EAyzUzk7M;EAzzU4l7M;IAAQ,0BAAA;EA4zUpm7M;EA5zU4n7M;IAAQ,yBAAA;EA+zUpo7M;EA/zU2p7M;IAAQ,uBAAA;EAk0Unq7M;EAl0Uyr7M;IAAQ,yBAAA;EAq0Ujs7M;EAr0Uyt7M;IAAQ,uBAAA;EAw0Uju7M;EAx0Uuv7M;IAAW,uBAAA;EA20Ulw7M;EA30Uwx7M;IAAS,0BAAA;IAAyB,yBAAA;EA+0U1z7M;EA/0Uk17M;IAAS,gCAAA;IAA8B,+BAAA;EAm1Uz37M;EAn1Us57M;IAAS,+BAAA;IAA6B,8BAAA;EAu1U577M;EAv1Uw97M;IAAS,6BAAA;IAA4B,4BAAA;EA21U7/7M;EA31Uwh8M;IAAS,+BAAA;IAA8B,8BAAA;EA+1U/j8M;EA/1U4l8M;IAAS,6BAAA;IAA4B,4BAAA;EAm2Ujo8M;EAn2U4p8M;IAAY,6BAAA;IAA4B,4BAAA;EAu2Ups8M;EAv2U+t8M;IAAS,wBAAA;IAAuB,2BAAA;EA22U/v8M;EA32Uyx8M;IAAS,8BAAA;IAA4B,iCAAA;EA+2U9z8M;EA/2U618M;IAAS,6BAAA;IAA2B,gCAAA;EAm3Uj48M;EAn3U+58M;IAAS,2BAAA;IAA0B,8BAAA;EAu3Ul88M;EAv3U+98M;IAAS,6BAAA;IAA4B,gCAAA;EA23Upg9M;EA33Umi9M;IAAS,2BAAA;IAA0B,8BAAA;EA+3Utk9M;EA/3Umm9M;IAAY,2BAAA;IAA0B,8BAAA;EAm4Uzo9M;EAn4Usq9M;IAAS,wBAAA;EAs4U/q9M;EAt4Uss9M;IAAS,8BAAA;EAy4U/s9M;EAz4U2u9M;IAAS,6BAAA;EA44Upv9M;EA54U+w9M;IAAS,2BAAA;EA+4Uxx9M;EA/4Ukz9M;IAAS,6BAAA;EAk5U3z9M;EAl5Uu19M;IAAS,2BAAA;EAq5Uh29M;EAr5U039M;IAAY,2BAAA;EAw5Ut49M;EAx5Ug69M;IAAS,0BAAA;EA25Uz69M;EA35Uk89M;IAAS,gCAAA;EA85U389M;EA95Uy+9M;IAAS,+BAAA;EAi6Ul/9M;EAj6U+g+M;IAAS,6BAAA;EAo6Uxh+M;EAp6Uoj+M;IAAS,+BAAA;EAu6U7j+M;EAv6U2l+M;IAAS,6BAAA;EA06Upm+M;EA16Ugo+M;IAAY,6BAAA;EA66U5o+M;EA76Uwq+M;IAAS,2BAAA;EAg7Ujr+M;EAh7U2s+M;IAAS,iCAAA;EAm7Upt+M;EAn7Umv+M;IAAS,gCAAA;EAs7U5v+M;EAt7U0x+M;IAAS,8BAAA;EAy7Uny+M;EAz7Ug0+M;IAAS,gCAAA;EA47Uz0+M;EA57Uw2+M;IAAS,8BAAA;EA+7Uj3+M;EA/7U84+M;IAAY,8BAAA;EAk8U15+M;EAl8Uu7+M;IAAS,yBAAA;EAq8Uh8+M;EAr8Uw9+M;IAAS,+BAAA;EAw8Uj++M;EAx8U8/+M;IAAS,8BAAA;EA28Uvg/M;EA38Umi/M;IAAS,4BAAA;EA88U5i/M;EA98Uuk/M;IAAS,8BAAA;EAi9Uhl/M;EAj9U6m/M;IAAS,4BAAA;EAo9Utn/M;EAp9Uip/M;IAAY,4BAAA;EAu9U7p/M;EAv9Uwr/M;IAAQ,qBAAA;EA09Uhs/M;EA19Uot/M;IAAQ,2BAAA;EA69U5t/M;EA79Uqv/M;IAAQ,0BAAA;EAg+U7v/M;EAh+Uqx/M;IAAQ,wBAAA;EAm+U7x/M;EAn+Uoz/M;IAAQ,0BAAA;EAs+U5z/M;EAt+Uq1/M;IAAQ,wBAAA;EAy+U71/M;EAz+Uo3/M;IAAS,2BAAA;IAA0B,0BAAA;EA6+Uv5/M;EA7+Ug7/M;IAAS,iCAAA;IAA+B,gCAAA;EAi/Ux9/M;EAj/Us//M;IAAS,gCAAA;IAA8B,+BAAA;EAq/U7hgN;EAr/U0jgN;IAAS,8BAAA;IAA6B,6BAAA;EAy/UhmgN;EAz/U4ngN;IAAS,gCAAA;IAA+B,+BAAA;EA6/UpqgN;EA7/UksgN;IAAS,8BAAA;IAA6B,6BAAA;EAigVxugN;EAjgVowgN;IAAS,yBAAA;IAAwB,4BAAA;EAqgVrygN;EArgVg0gN;IAAS,+BAAA;IAA6B,kCAAA;EAygVt2gN;EAzgVs4gN;IAAS,8BAAA;IAA4B,iCAAA;EA6gV36gN;EA7gV08gN;IAAS,4BAAA;IAA2B,+BAAA;EAihV9+gN;EAjhV4ghN;IAAS,8BAAA;IAA6B,iCAAA;EAqhVljhN;EArhVklhN;IAAS,4BAAA;IAA2B,+BAAA;EAyhVtnhN;EAzhVophN;IAAS,yBAAA;EA4hV7phN;EA5hVqrhN;IAAS,+BAAA;EA+hV9rhN;EA/hV2thN;IAAS,8BAAA;EAkiVpuhN;EAliVgwhN;IAAS,4BAAA;EAqiVzwhN;EAriVoyhN;IAAS,8BAAA;EAwiV7yhN;EAxiV00hN;IAAS,4BAAA;EA2iVn1hN;EA3iV82hN;IAAS,2BAAA;EA8iVv3hN;EA9iVi5hN;IAAS,iCAAA;EAijV15hN;EAjjVy7hN;IAAS,gCAAA;EAojVl8hN;EApjVg+hN;IAAS,8BAAA;EAujVz+hN;EAvjVsgiN;IAAS,gCAAA;EA0jV/giN;EA1jV8iiN;IAAS,8BAAA;EA6jVvjiN;EA7jVoliN;IAAS,4BAAA;EAgkV7liN;EAhkVwniN;IAAS,kCAAA;EAmkVjoiN;EAnkViqiN;IAAS,iCAAA;EAskV1qiN;EAtkVysiN;IAAS,+BAAA;EAykVltiN;EAzkVgviN;IAAS,iCAAA;EA4kVzviN;EA5kVyxiN;IAAS,+BAAA;EA+kVlyiN;EA/kVg0iN;IAAS,0BAAA;EAklVz0iN;EAllVk2iN;IAAS,gCAAA;EAqlV32iN;EArlVy4iN;IAAS,+BAAA;EAwlVl5iN;EAxlV+6iN;IAAS,6BAAA;EA2lVx7iN;EA3lVo9iN;IAAS,+BAAA;EA8lV79iN;EA9lV2/iN;IAAS,6BAAA;EAimVpgjN;EAjmVgijN;IAAU,iBAAA;EAomV1ijN;EApmV0jjN;IAAU,uBAAA;EAumVpkjN;EAvmVyljN;IAAU,sBAAA;EA0mVnmjN;EA1mVunjN;IAAU,oBAAA;EA6mVjojN;EA7mVopjN;IAAU,sBAAA;EAgnV9pjN;EAhnVmrjN;IAAU,oBAAA;EAmnV7rjN;EAnnVgtjN;IAAc,qBAAA;EAsnV9tjN;EAtnVkvjN;IAAc,2BAAA;EAynVhwjN;EAznVyxjN;IAAc,0BAAA;EA4nVvyjN;EA5nV+zjN;IAAc,wBAAA;EA+nV70jN;EA/nVo2jN;IAAc,0BAAA;EAkoVl3jN;EAloV24jN;IAAc,wBAAA;EAqoVz5jN;EAroVg7jN;IAA6C,wBAAA;EAyoV79jN;EAzoVo/jN;IAAmD,8BAAA;EA6oVvikN;EA7oVmkkN;IAAkD,6BAAA;EAipVrnkN;EAjpVgpkN;IAAgD,2BAAA;EAqpVhskN;EArpV0tkN;IAAkD,6BAAA;EAypV5wkN;EAzpVwykN;IAAgD,2BAAA;EA6pVx1kN;EA7pVk3kN;IAAe,2BAAA;EAgqVj4kN;EAhqV25kN;IAAa,4BAAA;EAmqVx6kN;EAnqVm8kN;IAAgB,6BAAA;EAsqVn9kN;AACF;AAvqVk/kN;EAA0B;IAAgB,sBAAA;EA2qV1hlN;EA3qV+ilN;IAAc,uBAAA;EA8qV7jlN;EA9qVmllN;IAAe,sBAAA;EAirVlmlN;EAjrVunlN;IAAuD,8BAAA;EAqrV9qlN;EArrV2slN;IAAmD,4BAAA;EAyrV9vlN;EAzrVyxlN;IAAiD,2BAAA;EA6rV10lN;EA7rVo2lN;IAAwD,iCAAA;EAisV55lN;EAjsV47lN;IAAiD,2BAAA;EAqsV7+lN;EArsVugmN;IAAa,0BAAA;EAwsVphmN;EAxsV6imN;IAAmB,gCAAA;EA2sVhkmN;EA3sV+lmN;IAAY,yBAAA;EA8sV3mmN;EA9sVmomN;IAAW,wBAAA;EAitV9omN;EAjtVqqmN;IAAkB,+BAAA;EAotVvrmN;EAptVqtmN;IAAY,yBAAA;EAutVjumN;EAvtVyvmN;IAAgB,6BAAA;EA0tVzwmN;EA1tVqymN;IAAiB,8BAAA;EA6tVtzmN;EA7tVm1mN;IAAW,wBAAA;EAguV91mN;EAhuVq3mN;IAAkB,+BAAA;EAmuVv4mN;EAnuVq6mN;IAAW,wBAAA;EAsuVh7mN;EAtuVu8mN;IAAc,yBAAA;EAyuVr9mN;EAzuV6+mN;IAAa,8BAAA;EA4uV1/mN;EA5uVuhnN;IAAgB,iCAAA;EA+uVvinN;EA/uVuknN;IAAqB,sCAAA;EAkvV5lnN;EAlvVionN;IAAwB,yCAAA;EAqvVzpnN;EArvVisnN;IAAgB,uBAAA;EAwvVjtnN;EAxvVuunN;IAAgB,uBAAA;EA2vVvvnN;EA3vV6wnN;IAAkB,yBAAA;EA8vV/xnN;EA9vVuznN;IAAkB,yBAAA;EAiwVz0nN;EAjwVi2nN;IAAc,0BAAA;EAowV/2nN;EApwVw4nN;IAAgB,4BAAA;EAuwVx5nN;EAvwVm7nN;IAAsB,kCAAA;EA0wVz8nN;EA1wV0+nN;IAA0B,sCAAA;EA6wVpgoN;EA7wVyioN;IAAwB,oCAAA;EAgxVjkoN;EAhxVomoN;IAA2B,kCAAA;EAmxV/noN;EAnxVgqoN;IAA4B,yCAAA;EAsxV5roN;EAtxVouoN;IAA2B,wCAAA;EAyxV/voN;EAzxVsyoN;IAA2B,wCAAA;EA4xVj0oN;EA5xVw2oN;IAAsB,kCAAA;EA+xV93oN;EA/xV+5oN;IAAoB,gCAAA;EAkyVn7oN;EAlyVk9oN;IAAuB,8BAAA;EAqyVz+oN;EAryVsgpN;IAAyB,gCAAA;EAwyV/hpN;EAxyV8jpN;IAAwB,+BAAA;EA2yVtlpN;EA3yVonpN;IAAwB,oCAAA;EA8yV5opN;EA9yV+qpN;IAAsB,kCAAA;EAizVrspN;EAjzVsupN;IAAyB,gCAAA;EAozV/vpN;EApzV8xpN;IAA0B,uCAAA;EAuzVxzpN;EAvzV81pN;IAAyB,sCAAA;EA0zVv3pN;EA1zV45pN;IAA0B,iCAAA;EA6zVt7pN;EA7zVs9pN;IAAoB,2BAAA;EAg0V1+pN;EAh0VogqN;IAAqB,iCAAA;EAm0VzhqN;EAn0VyjqN;IAAmB,+BAAA;EAs0V5kqN;EAt0V0mqN;IAAsB,6BAAA;EAy0VhoqN;EAz0V4pqN;IAAwB,+BAAA;EA40VprqN;EA50VktqN;IAAuB,8BAAA;EA+0VzuqN;EA/0VswqN;IAAgB,oBAAA;EAk1VtxqN;EAl1VyyqN;IAAY,mBAAA;EAq1VrzqN;EAr1Vu0qN;IAAY,mBAAA;EAw1Vn1qN;EAx1Vq2qN;IAAY,mBAAA;EA21Vj3qN;EA31Vm4qN;IAAY,mBAAA;EA81V/4qN;EA91Vi6qN;IAAY,mBAAA;EAi2V76qN;EAj2V+7qN;IAAY,mBAAA;EAo2V38qN;EAp2V69qN;IAAe,mBAAA;EAu2V5+qN;EAv2V8/qN;IAAQ,oBAAA;EA02VtgrN;EA12VyhrN;IAAQ,0BAAA;EA62VjirN;EA72VyjrN;IAAQ,yBAAA;EAg3VjkrN;EAh3VwlrN;IAAQ,uBAAA;EAm3VhmrN;EAn3VsnrN;IAAQ,yBAAA;EAs3V9nrN;EAt3VsprN;IAAQ,uBAAA;EAy3V9prN;EAz3VorrN;IAAW,uBAAA;EA43V/rrN;EA53VqtrN;IAAS,0BAAA;IAAyB,yBAAA;EAg4VvvrN;EAh4V+wrN;IAAS,gCAAA;IAA8B,+BAAA;EAo4VtzrN;EAp4Vm1rN;IAAS,+BAAA;IAA6B,8BAAA;EAw4Vz3rN;EAx4Vq5rN;IAAS,6BAAA;IAA4B,4BAAA;EA44V17rN;EA54Vq9rN;IAAS,+BAAA;IAA8B,8BAAA;EAg5V5/rN;EAh5VyhsN;IAAS,6BAAA;IAA4B,4BAAA;EAo5V9jsN;EAp5VylsN;IAAY,6BAAA;IAA4B,4BAAA;EAw5VjosN;EAx5V4psN;IAAS,wBAAA;IAAuB,2BAAA;EA45V5rsN;EA55VstsN;IAAS,8BAAA;IAA4B,iCAAA;EAg6V3vsN;EAh6V0xsN;IAAS,6BAAA;IAA2B,gCAAA;EAo6V9zsN;EAp6V41sN;IAAS,2BAAA;IAA0B,8BAAA;EAw6V/3sN;EAx6V45sN;IAAS,6BAAA;IAA4B,gCAAA;EA46Vj8sN;EA56Vg+sN;IAAS,2BAAA;IAA0B,8BAAA;EAg7VngtN;EAh7VgitN;IAAY,2BAAA;IAA0B,8BAAA;EAo7VtktN;EAp7VmmtN;IAAS,wBAAA;EAu7V5mtN;EAv7VmotN;IAAS,8BAAA;EA07V5otN;EA17VwqtN;IAAS,6BAAA;EA67VjrtN;EA77V4stN;IAAS,2BAAA;EAg8VrttN;EAh8V+utN;IAAS,6BAAA;EAm8VxvtN;EAn8VoxtN;IAAS,2BAAA;EAs8V7xtN;EAt8VuztN;IAAY,2BAAA;EAy8Vn0tN;EAz8V61tN;IAAS,0BAAA;EA48Vt2tN;EA58V+3tN;IAAS,gCAAA;EA+8Vx4tN;EA/8Vs6tN;IAAS,+BAAA;EAk9V/6tN;EAl9V48tN;IAAS,6BAAA;EAq9Vr9tN;EAr9Vi/tN;IAAS,+BAAA;EAw9V1/tN;EAx9VwhuN;IAAS,6BAAA;EA29VjiuN;EA39V6juN;IAAY,6BAAA;EA89VzkuN;EA99VqmuN;IAAS,2BAAA;EAi+V9muN;EAj+VwouN;IAAS,iCAAA;EAo+VjpuN;EAp+VgruN;IAAS,gCAAA;EAu+VzruN;EAv+VutuN;IAAS,8BAAA;EA0+VhuuN;EA1+V6vuN;IAAS,gCAAA;EA6+VtwuN;EA7+VqyuN;IAAS,8BAAA;EAg/V9yuN;EAh/V20uN;IAAY,8BAAA;EAm/Vv1uN;EAn/Vo3uN;IAAS,yBAAA;EAs/V73uN;EAt/Vq5uN;IAAS,+BAAA;EAy/V95uN;EAz/V27uN;IAAS,8BAAA;EA4/Vp8uN;EA5/Vg+uN;IAAS,4BAAA;EA+/Vz+uN;EA//VogvN;IAAS,8BAAA;EAkgW7gvN;EAlgW0ivN;IAAS,4BAAA;EAqgWnjvN;EArgW8kvN;IAAY,4BAAA;EAwgW1lvN;EAxgWqnvN;IAAQ,qBAAA;EA2gW7nvN;EA3gWipvN;IAAQ,2BAAA;EA8gWzpvN;EA9gWkrvN;IAAQ,0BAAA;EAihW1rvN;EAjhWktvN;IAAQ,wBAAA;EAohW1tvN;EAphWivvN;IAAQ,0BAAA;EAuhWzvvN;EAvhWkxvN;IAAQ,wBAAA;EA0hW1xvN;EA1hWizvN;IAAS,2BAAA;IAA0B,0BAAA;EA8hWp1vN;EA9hW62vN;IAAS,iCAAA;IAA+B,gCAAA;EAkiWr5vN;EAliWm7vN;IAAS,gCAAA;IAA8B,+BAAA;EAsiW19vN;EAtiWu/vN;IAAS,8BAAA;IAA6B,6BAAA;EA0iW7hwN;EA1iWyjwN;IAAS,gCAAA;IAA+B,+BAAA;EA8iWjmwN;EA9iW+nwN;IAAS,8BAAA;IAA6B,6BAAA;EAkjWrqwN;EAljWiswN;IAAS,yBAAA;IAAwB,4BAAA;EAsjWluwN;EAtjW6vwN;IAAS,+BAAA;IAA6B,kCAAA;EA0jWnywN;EA1jWm0wN;IAAS,8BAAA;IAA4B,iCAAA;EA8jWx2wN;EA9jWu4wN;IAAS,4BAAA;IAA2B,+BAAA;EAkkW36wN;EAlkWy8wN;IAAS,8BAAA;IAA6B,iCAAA;EAskW/+wN;EAtkW+gxN;IAAS,4BAAA;IAA2B,+BAAA;EA0kWnjxN;EA1kWilxN;IAAS,yBAAA;EA6kW1lxN;EA7kWknxN;IAAS,+BAAA;EAglW3nxN;EAhlWwpxN;IAAS,8BAAA;EAmlWjqxN;EAnlW6rxN;IAAS,4BAAA;EAslWtsxN;EAtlWiuxN;IAAS,8BAAA;EAylW1uxN;EAzlWuwxN;IAAS,4BAAA;EA4lWhxxN;EA5lW2yxN;IAAS,2BAAA;EA+lWpzxN;EA/lW80xN;IAAS,iCAAA;EAkmWv1xN;EAlmWs3xN;IAAS,gCAAA;EAqmW/3xN;EArmW65xN;IAAS,8BAAA;EAwmWt6xN;EAxmWm8xN;IAAS,gCAAA;EA2mW58xN;EA3mW2+xN;IAAS,8BAAA;EA8mWp/xN;EA9mWihyN;IAAS,4BAAA;EAinW1hyN;EAjnWqjyN;IAAS,kCAAA;EAonW9jyN;EApnW8lyN;IAAS,iCAAA;EAunWvmyN;EAvnWsoyN;IAAS,+BAAA;EA0nW/oyN;EA1nW6qyN;IAAS,iCAAA;EA6nWtryN;EA7nWstyN;IAAS,+BAAA;EAgoW/tyN;EAhoW6vyN;IAAS,0BAAA;EAmoWtwyN;EAnoW+xyN;IAAS,gCAAA;EAsoWxyyN;EAtoWs0yN;IAAS,+BAAA;EAyoW/0yN;EAzoW42yN;IAAS,6BAAA;EA4oWr3yN;EA5oWi5yN;IAAS,+BAAA;EA+oW15yN;EA/oWw7yN;IAAS,6BAAA;EAkpWj8yN;EAlpW69yN;IAAU,iBAAA;EAqpWv+yN;EArpWu/yN;IAAU,uBAAA;EAwpWjgzN;EAxpWshzN;IAAU,sBAAA;EA2pWhizN;EA3pWojzN;IAAU,oBAAA;EA8pW9jzN;EA9pWilzN;IAAU,sBAAA;EAiqW3lzN;EAjqWgnzN;IAAU,oBAAA;EAoqW1nzN;EApqW6ozN;IAAc,qBAAA;EAuqW3pzN;EAvqW+qzN;IAAc,2BAAA;EA0qW7rzN;EA1qWstzN;IAAc,0BAAA;EA6qWpuzN;EA7qW4vzN;IAAc,wBAAA;EAgrW1wzN;EAhrWiyzN;IAAc,0BAAA;EAmrW/yzN;EAnrWw0zN;IAAc,wBAAA;EAsrWt1zN;EAtrW62zN;IAA6C,wBAAA;EA0rW15zN;EA1rWi7zN;IAAmD,8BAAA;EA8rWp+zN;EA9rWgg0N;IAAkD,6BAAA;EAksWlj0N;EAlsW6k0N;IAAgD,2BAAA;EAssW7n0N;EAtsWup0N;IAAkD,6BAAA;EA0sWzs0N;EA1sWqu0N;IAAgD,2BAAA;EA8sWrx0N;EA9sW+y0N;IAAe,2BAAA;EAitW9z0N;EAjtWw10N;IAAa,4BAAA;EAotWr20N;EAptWg40N;IAAgB,6BAAA;EAutWh50N;AACF;AAxtW+60N;EAA0B;IAAiB,sBAAA;EA4tWx90N;EA5tW6+0N;IAAe,uBAAA;EA+tW5/0N;EA/tWkh1N;IAAgB,sBAAA;EAkuWli1N;EAluWuj1N;IAAwD,8BAAA;EAsuW/m1N;EAtuW4o1N;IAAoD,4BAAA;EA0uWhs1N;EA1uW2t1N;IAAkD,2BAAA;EA8uW7w1N;EA9uWuy1N;IAAyD,iCAAA;EAkvWh21N;EAlvWg41N;IAAkD,2BAAA;EAsvWl71N;EAtvW481N;IAAc,0BAAA;EAyvW191N;EAzvWm/1N;IAAoB,gCAAA;EA4vWvg2N;EA5vWsi2N;IAAa,yBAAA;EA+vWnj2N;EA/vW2k2N;IAAY,wBAAA;EAkwWvl2N;EAlwW8m2N;IAAmB,+BAAA;EAqwWjo2N;EArwW+p2N;IAAa,yBAAA;EAwwW5q2N;EAxwWos2N;IAAiB,6BAAA;EA2wWrt2N;EA3wWiv2N;IAAkB,8BAAA;EA8wWnw2N;EA9wWgy2N;IAAY,wBAAA;EAixW5y2N;EAjxWm02N;IAAmB,+BAAA;EAoxWt12N;EApxWo32N;IAAY,wBAAA;EAuxWh42N;EAvxWu52N;IAAe,yBAAA;EA0xWt62N;EA1xW872N;IAAc,8BAAA;EA6xW582N;EA7xWy+2N;IAAiB,iCAAA;EAgyW1/2N;EAhyW0h3N;IAAsB,sCAAA;EAmyWhj3N;EAnyWql3N;IAAyB,yCAAA;EAsyW9m3N;EAtyWsp3N;IAAiB,uBAAA;EAyyWvq3N;EAzyW6r3N;IAAiB,uBAAA;EA4yW9s3N;EA5yWou3N;IAAmB,yBAAA;EA+yWvv3N;EA/yW+w3N;IAAmB,yBAAA;EAkzWly3N;EAlzW0z3N;IAAe,0BAAA;EAqzWz03N;EArzWk23N;IAAiB,4BAAA;EAwzWn33N;EAxzW843N;IAAuB,kCAAA;EA2zWr63N;EA3zWs83N;IAA2B,sCAAA;EA8zWj+3N;EA9zWsg4N;IAAyB,oCAAA;EAi0W/h4N;EAj0Wkk4N;IAA4B,kCAAA;EAo0W9l4N;EAp0W+n4N;IAA6B,yCAAA;EAu0W5p4N;EAv0Wos4N;IAA4B,wCAAA;EA00Whu4N;EA10Wuw4N;IAA4B,wCAAA;EA60Wny4N;EA70W004N;IAAuB,kCAAA;EAg1Wj24N;EAh1Wk44N;IAAqB,gCAAA;EAm1Wv54N;EAn1Ws74N;IAAwB,8BAAA;EAs1W984N;EAt1W2+4N;IAA0B,gCAAA;EAy1Wrg5N;EAz1Woi5N;IAAyB,+BAAA;EA41W7j5N;EA51W2l5N;IAAyB,oCAAA;EA+1Wpn5N;EA/1Wup5N;IAAuB,kCAAA;EAk2W9q5N;EAl2W+s5N;IAA0B,gCAAA;EAq2Wzu5N;EAr2Www5N;IAA2B,uCAAA;EAw2Wny5N;EAx2Wy05N;IAA0B,sCAAA;EA22Wn25N;EA32Ww45N;IAA2B,iCAAA;EA82Wn65N;EA92Wm85N;IAAqB,2BAAA;EAi3Wx95N;EAj3Wk/5N;IAAsB,iCAAA;EAo3Wxg6N;EAp3Wwi6N;IAAoB,+BAAA;EAu3W5j6N;EAv3W0l6N;IAAuB,6BAAA;EA03Wjn6N;EA13W6o6N;IAAyB,+BAAA;EA63Wtq6N;EA73Wos6N;IAAwB,8BAAA;EAg4W5t6N;EAh4Wyv6N;IAAiB,oBAAA;EAm4W1w6N;EAn4W6x6N;IAAa,mBAAA;EAs4W1y6N;EAt4W4z6N;IAAa,mBAAA;EAy4Wz06N;EAz4W216N;IAAa,mBAAA;EA44Wx26N;EA54W036N;IAAa,mBAAA;EA+4Wv46N;EA/4Wy56N;IAAa,mBAAA;EAk5Wt66N;EAl5Ww76N;IAAa,mBAAA;EAq5Wr86N;EAr5Wu96N;IAAgB,mBAAA;EAw5Wv+6N;EAx5Wy/6N;IAAS,oBAAA;EA25Wlg7N;EA35Wqh7N;IAAS,0BAAA;EA85W9h7N;EA95Wsj7N;IAAS,yBAAA;EAi6W/j7N;EAj6Wsl7N;IAAS,uBAAA;EAo6W/l7N;EAp6Wqn7N;IAAS,yBAAA;EAu6W9n7N;EAv6Wsp7N;IAAS,uBAAA;EA06W/p7N;EA16Wqr7N;IAAY,uBAAA;EA66Wjs7N;EA76Wut7N;IAAU,0BAAA;IAAyB,yBAAA;EAi7W1v7N;EAj7Wkx7N;IAAU,gCAAA;IAA8B,+BAAA;EAq7W1z7N;EAr7Wu17N;IAAU,+BAAA;IAA6B,8BAAA;EAy7W937N;EAz7W057N;IAAU,6BAAA;IAA4B,4BAAA;EA67Wh87N;EA77W297N;IAAU,+BAAA;IAA8B,8BAAA;EAi8Wng8N;EAj8Wgi8N;IAAU,6BAAA;IAA4B,4BAAA;EAq8Wtk8N;EAr8Wim8N;IAAa,6BAAA;IAA4B,4BAAA;EAy8W1o8N;EAz8Wqq8N;IAAU,wBAAA;IAAuB,2BAAA;EA68Wts8N;EA78Wgu8N;IAAU,8BAAA;IAA4B,iCAAA;EAi9Wtw8N;EAj9Wqy8N;IAAU,6BAAA;IAA2B,gCAAA;EAq9W108N;EAr9Ww28N;IAAU,2BAAA;IAA0B,8BAAA;EAy9W548N;EAz9Wy68N;IAAU,6BAAA;IAA4B,gCAAA;EA69W/88N;EA79W8+8N;IAAU,2BAAA;IAA0B,8BAAA;EAi+Wlh9N;EAj+W+i9N;IAAa,2BAAA;IAA0B,8BAAA;EAq+Wtl9N;EAr+Wmn9N;IAAU,wBAAA;EAw+W7n9N;EAx+Wop9N;IAAU,8BAAA;EA2+W9p9N;EA3+W0r9N;IAAU,6BAAA;EA8+Wps9N;EA9+W+t9N;IAAU,2BAAA;EAi/Wzu9N;EAj/Wmw9N;IAAU,6BAAA;EAo/W7w9N;EAp/Wyy9N;IAAU,2BAAA;EAu/Wnz9N;EAv/W609N;IAAa,2BAAA;EA0/W119N;EA1/Wo39N;IAAU,0BAAA;EA6/W939N;EA7/Wu59N;IAAU,gCAAA;EAggXj69N;EAhgX+79N;IAAU,+BAAA;EAmgXz89N;EAngXs+9N;IAAU,6BAAA;EAsgXh/9N;EAtgX4g+N;IAAU,+BAAA;EAygXth+N;EAzgXoj+N;IAAU,6BAAA;EA4gX9j+N;EA5gX0l+N;IAAa,6BAAA;EA+gXvm+N;EA/gXmo+N;IAAU,2BAAA;EAkhX7o+N;EAlhXuq+N;IAAU,iCAAA;EAqhXjr+N;EArhXgt+N;IAAU,gCAAA;EAwhX1t+N;EAxhXwv+N;IAAU,8BAAA;EA2hXlw+N;EA3hX+x+N;IAAU,gCAAA;EA8hXzy+N;EA9hXw0+N;IAAU,8BAAA;EAiiXl1+N;EAjiX+2+N;IAAa,8BAAA;EAoiX53+N;EApiXy5+N;IAAU,yBAAA;EAuiXn6+N;EAviX27+N;IAAU,+BAAA;EA0iXr8+N;EA1iXk++N;IAAU,8BAAA;EA6iX5++N;EA7iXwg/N;IAAU,4BAAA;EAgjXlh/N;EAhjX6i/N;IAAU,8BAAA;EAmjXvj/N;EAnjXol/N;IAAU,4BAAA;EAsjX9l/N;EAtjXyn/N;IAAa,4BAAA;EAyjXto/N;EAzjXiq/N;IAAS,qBAAA;EA4jX1q/N;EA5jX8r/N;IAAS,2BAAA;EA+jXvs/N;EA/jXgu/N;IAAS,0BAAA;EAkkXzu/N;EAlkXiw/N;IAAS,wBAAA;EAqkX1w/N;EArkXiy/N;IAAS,0BAAA;EAwkX1y/N;EAxkXm0/N;IAAS,wBAAA;EA2kX50/N;EA3kXm2/N;IAAU,2BAAA;IAA0B,0BAAA;EA+kXv4/N;EA/kXg6/N;IAAU,iCAAA;IAA+B,gCAAA;EAmlXz8/N;EAnlXu+/N;IAAU,gCAAA;IAA8B,+BAAA;EAulX/ggO;EAvlX4igO;IAAU,8BAAA;IAA6B,6BAAA;EA2lXnlgO;EA3lX+mgO;IAAU,gCAAA;IAA+B,+BAAA;EA+lXxpgO;EA/lXsrgO;IAAU,8BAAA;IAA6B,6BAAA;EAmmX7tgO;EAnmXyvgO;IAAU,yBAAA;IAAwB,4BAAA;EAumX3xgO;EAvmXszgO;IAAU,+BAAA;IAA6B,kCAAA;EA2mX71gO;EA3mX63gO;IAAU,8BAAA;IAA4B,iCAAA;EA+mXn6gO;EA/mXk8gO;IAAU,4BAAA;IAA2B,+BAAA;EAmnXv+gO;EAnnXqghO;IAAU,8BAAA;IAA6B,iCAAA;EAunX5ihO;EAvnX4khO;IAAU,4BAAA;IAA2B,+BAAA;EA2nXjnhO;EA3nX+ohO;IAAU,yBAAA;EA8nXzphO;EA9nXirhO;IAAU,+BAAA;EAioX3rhO;EAjoXwthO;IAAU,8BAAA;EAooXluhO;EApoX8vhO;IAAU,4BAAA;EAuoXxwhO;EAvoXmyhO;IAAU,8BAAA;EA0oX7yhO;EA1oX00hO;IAAU,4BAAA;EA6oXp1hO;EA7oX+2hO;IAAU,2BAAA;EAgpXz3hO;EAhpXm5hO;IAAU,iCAAA;EAmpX75hO;EAnpX47hO;IAAU,gCAAA;EAspXt8hO;EAtpXo+hO;IAAU,8BAAA;EAypX9+hO;EAzpX2giO;IAAU,gCAAA;EA4pXrhiO;EA5pXojiO;IAAU,8BAAA;EA+pX9jiO;EA/pX2liO;IAAU,4BAAA;EAkqXrmiO;EAlqXgoiO;IAAU,kCAAA;EAqqX1oiO;EArqX0qiO;IAAU,iCAAA;EAwqXpriO;EAxqXmtiO;IAAU,+BAAA;EA2qX7tiO;EA3qX2viO;IAAU,iCAAA;EA8qXrwiO;EA9qXqyiO;IAAU,+BAAA;EAirX/yiO;EAjrX60iO;IAAU,0BAAA;EAorXv1iO;EAprXg3iO;IAAU,gCAAA;EAurX13iO;EAvrXw5iO;IAAU,+BAAA;EA0rXl6iO;EA1rX+7iO;IAAU,6BAAA;EA6rXz8iO;EA7rXq+iO;IAAU,+BAAA;EAgsX/+iO;EAhsX6gjO;IAAU,6BAAA;EAmsXvhjO;EAnsXmjjO;IAAW,iBAAA;EAssX9jjO;EAtsX8kjO;IAAW,uBAAA;EAysXzljO;EAzsX8mjO;IAAW,sBAAA;EA4sXznjO;EA5sX6ojO;IAAW,oBAAA;EA+sXxpjO;EA/sX2qjO;IAAW,sBAAA;EAktXtrjO;EAltX2sjO;IAAW,oBAAA;EAqtXttjO;EArtXyujO;IAAe,qBAAA;EAwtXxvjO;EAxtX4wjO;IAAe,2BAAA;EA2tX3xjO;EA3tXozjO;IAAe,0BAAA;EA8tXn0jO;EA9tX21jO;IAAe,wBAAA;EAiuX12jO;EAjuXi4jO;IAAe,0BAAA;EAouXh5jO;EApuXy6jO;IAAe,wBAAA;EAuuXx7jO;EAvuX+8jO;IAA8C,wBAAA;EA2uX7/jO;EA3uXohkO;IAAoD,8BAAA;EA+uXxkkO;EA/uXomkO;IAAmD,6BAAA;EAmvXvpkO;EAnvXkrkO;IAAiD,2BAAA;EAuvXnukO;EAvvX6vkO;IAAmD,6BAAA;EA2vXhzkO;EA3vX40kO;IAAiD,2BAAA;EA+vX73kO;EA/vXu5kO;IAAgB,2BAAA;EAkwXv6kO;EAlwXi8kO;IAAc,4BAAA;EAqwX/8kO;EArwX0+kO;IAAiB,6BAAA;EAwwX3/kO;AACF;AAzwX0hlO;EAA0B;IAAM,4BAAA;EA6wXxjlO;EA7wXmllO;IAAM,0BAAA;EAgxXzllO;EAhxXknlO;IAAM,6BAAA;EAmxXxnlO;EAnxXoplO;IAAM,4BAAA;EAsxX1plO;AACF;AAvxXwrlO;EAAa;IAAgB,0BAAA;EA2xXntlO;EA3xX4ulO;IAAsB,gCAAA;EA8xXlwlO;EA9xXiylO;IAAe,yBAAA;EAiyXhzlO;EAjyXw0lO;IAAc,wBAAA;EAoyXt1lO;EApyX62lO;IAAqB,+BAAA;EAuyXl4lO;EAvyXg6lO;IAAe,yBAAA;EA0yX/6lO;EA1yXu8lO;IAAmB,6BAAA;EA6yX19lO;EA7yXs/lO;IAAoB,8BAAA;EAgzX1gmO;EAhzXuimO;IAAc,wBAAA;EAmzXrjmO;EAnzX4kmO;IAAqB,+BAAA;EAszXjmmO;EAtzX+nmO;IAAc,wBAAA;EAyzX7omO;AACF","sourcesContent":["@charset \"UTF-8\";/*!\n * Bootstrap  v5.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2023 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root,[data-bs-theme=light]{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-black:#000;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-primary-text-emphasis:#052c65;--bs-secondary-text-emphasis:#2b2f32;--bs-success-text-emphasis:#0a3622;--bs-info-text-emphasis:#055160;--bs-warning-text-emphasis:#664d03;--bs-danger-text-emphasis:#58151c;--bs-light-text-emphasis:#495057;--bs-dark-text-emphasis:#495057;--bs-primary-bg-subtle:#cfe2ff;--bs-secondary-bg-subtle:#e2e3e5;--bs-success-bg-subtle:#d1e7dd;--bs-info-bg-subtle:#cff4fc;--bs-warning-bg-subtle:#fff3cd;--bs-danger-bg-subtle:#f8d7da;--bs-light-bg-subtle:#fcfcfd;--bs-dark-bg-subtle:#ced4da;--bs-primary-border-subtle:#9ec5fe;--bs-secondary-border-subtle:#c4c8cb;--bs-success-border-subtle:#a3cfbb;--bs-info-border-subtle:#9eeaf9;--bs-warning-border-subtle:#ffe69c;--bs-danger-border-subtle:#f1aeb5;--bs-light-border-subtle:#e9ecef;--bs-dark-border-subtle:#adb5bd;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-color-rgb:33,37,41;--bs-body-bg:#fff;--bs-body-bg-rgb:255,255,255;--bs-emphasis-color:#000;--bs-emphasis-color-rgb:0,0,0;--bs-secondary-color:rgba(33, 37, 41, 0.75);--bs-secondary-color-rgb:33,37,41;--bs-secondary-bg:#e9ecef;--bs-secondary-bg-rgb:233,236,239;--bs-tertiary-color:rgba(33, 37, 41, 0.5);--bs-tertiary-color-rgb:33,37,41;--bs-tertiary-bg:#f8f9fa;--bs-tertiary-bg-rgb:248,249,250;--bs-heading-color:inherit;--bs-link-color:#0d6efd;--bs-link-color-rgb:13,110,253;--bs-link-decoration:underline;--bs-link-hover-color:#0a58ca;--bs-link-hover-color-rgb:10,88,202;--bs-code-color:#d63384;--bs-highlight-bg:#fff3cd;--bs-border-width:1px;--bs-border-style:solid;--bs-border-color:#dee2e6;--bs-border-color-translucent:rgba(0, 0, 0, 0.175);--bs-border-radius:0.375rem;--bs-border-radius-sm:0.25rem;--bs-border-radius-lg:0.5rem;--bs-border-radius-xl:1rem;--bs-border-radius-xxl:2rem;--bs-border-radius-2xl:var(--bs-border-radius-xxl);--bs-border-radius-pill:50rem;--bs-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-box-shadow-sm:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-box-shadow-lg:0 1rem 3rem rgba(0, 0, 0, 0.175);--bs-box-shadow-inset:inset 0 1px 2px rgba(0, 0, 0, 0.075);--bs-focus-ring-width:0.25rem;--bs-focus-ring-opacity:0.25;--bs-focus-ring-color:rgba(13, 110, 253, 0.25);--bs-form-valid-color:#198754;--bs-form-valid-border-color:#198754;--bs-form-invalid-color:#dc3545;--bs-form-invalid-border-color:#dc3545}[data-bs-theme=dark]{color-scheme:dark;--bs-body-color:#dee2e6;--bs-body-color-rgb:222,226,230;--bs-body-bg:#212529;--bs-body-bg-rgb:33,37,41;--bs-emphasis-color:#fff;--bs-emphasis-color-rgb:255,255,255;--bs-secondary-color:rgba(222, 226, 230, 0.75);--bs-secondary-color-rgb:222,226,230;--bs-secondary-bg:#343a40;--bs-secondary-bg-rgb:52,58,64;--bs-tertiary-color:rgba(222, 226, 230, 0.5);--bs-tertiary-color-rgb:222,226,230;--bs-tertiary-bg:#2b3035;--bs-tertiary-bg-rgb:43,48,53;--bs-primary-text-emphasis:#6ea8fe;--bs-secondary-text-emphasis:#a7acb1;--bs-success-text-emphasis:#75b798;--bs-info-text-emphasis:#6edff6;--bs-warning-text-emphasis:#ffda6a;--bs-danger-text-emphasis:#ea868f;--bs-light-text-emphasis:#f8f9fa;--bs-dark-text-emphasis:#dee2e6;--bs-primary-bg-subtle:#031633;--bs-secondary-bg-subtle:#161719;--bs-success-bg-subtle:#051b11;--bs-info-bg-subtle:#032830;--bs-warning-bg-subtle:#332701;--bs-danger-bg-subtle:#2c0b0e;--bs-light-bg-subtle:#343a40;--bs-dark-bg-subtle:#1a1d20;--bs-primary-border-subtle:#084298;--bs-secondary-border-subtle:#41464b;--bs-success-border-subtle:#0f5132;--bs-info-border-subtle:#087990;--bs-warning-border-subtle:#997404;--bs-danger-border-subtle:#842029;--bs-light-border-subtle:#495057;--bs-dark-border-subtle:#343a40;--bs-heading-color:inherit;--bs-link-color:#6ea8fe;--bs-link-hover-color:#8bb9fe;--bs-link-color-rgb:110,168,254;--bs-link-hover-color-rgb:139,185,254;--bs-code-color:#e685b5;--bs-border-color:#495057;--bs-border-color-translucent:rgba(255, 255, 255, 0.15);--bs-form-valid-color:#75b798;--bs-form-valid-border-color:#75b798;--bs-form-invalid-color:#ea868f;--bs-form-invalid-border-color:#ea868f}*,::after,::before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){:root{scroll-behavior:smooth}}body{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr{margin:1rem 0;color:inherit;border:0;border-top:var(--bs-border-width) solid;opacity:.25}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2;color:var(--bs-heading-color)}.h1,h1{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1,h1{font-size:2.5rem}}.h2,h2{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2,h2{font-size:2rem}}.h3,h3{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3,h3{font-size:1.75rem}}.h4,h4{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4,h4{font-size:1.5rem}}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}p{margin-top:0;margin-bottom:1rem}abbr[title]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol,ul{padding-left:2rem}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}.small,small{font-size:.875em}.mark,mark{padding:.1875em;background-color:var(--bs-highlight-bg)}sub,sup{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,1));text-decoration:underline}a:hover{--bs-link-color-rgb:var(--bs-link-hover-color-rgb)}a:not([href]):not([class]),a:not([href]):not([class]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:var(--bs-font-monospace);font-size:1em}pre{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code{font-size:inherit;color:inherit;word-break:normal}code{font-size:.875em;color:var(--bs-code-color);word-wrap:break-word}a>code{color:inherit}kbd{padding:.1875rem .375rem;font-size:.875em;color:var(--bs-body-bg);background-color:var(--bs-body-color);border-radius:.25rem}kbd kbd{padding:0;font-size:1em}figure{margin:0 0 1rem}img,svg{vertical-align:middle}table{caption-side:bottom;border-collapse:collapse}caption{padding-top:.5rem;padding-bottom:.5rem;color:var(--bs-secondary-color);text-align:left}th{text-align:inherit;text-align:-webkit-match-parent}tbody,td,tfoot,th,thead,tr{border-color:inherit;border-style:solid;border-width:0}label{display:inline-block}button{border-radius:0}button:focus:not(:focus-visible){outline:0}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}select:disabled{opacity:1}[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator{display:none!important}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}::-moz-focus-inner{padding:0;border-style:none}textarea{resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend{font-size:1.5rem}}legend+*{clear:left}::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-fields-wrapper,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-text,::-webkit-datetime-edit-year-field{padding:0}::-webkit-inner-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-color-swatch-wrapper{padding:0}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}::file-selector-button{font:inherit;-webkit-appearance:button}output{display:inline-block}iframe{border:0}summary{display:list-item;cursor:pointer}progress{vertical-align:baseline}[hidden]{display:none!important}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:calc(1.625rem + 4.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-1{font-size:5rem}}.display-2{font-size:calc(1.575rem + 3.9vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-2{font-size:4.5rem}}.display-3{font-size:calc(1.525rem + 3.3vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-3{font-size:4rem}}.display-4{font-size:calc(1.475rem + 2.7vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-4{font-size:3.5rem}}.display-5{font-size:calc(1.425rem + 2.1vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-5{font-size:3rem}}.display-6{font-size:calc(1.375rem + 1.5vw);font-weight:300;line-height:1.2}@media (min-width:1200px){.display-6{font-size:2.5rem}}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:.875em;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote>:last-child{margin-bottom:0}.blockquote-footer{margin-top:-1rem;margin-bottom:1rem;font-size:.875em;color:#6c757d}.blockquote-footer::before{content:\"— \"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:var(--bs-body-bg);border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:.875em;color:var(--bs-secondary-color)}.container,.container-fluid,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl{--bs-gutter-x:1.5rem;--bs-gutter-y:0;width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}@media (min-width:1400px){.container,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl{max-width:1320px}}:root{--bs-breakpoint-xs:0;--bs-breakpoint-sm:576px;--bs-breakpoint-md:768px;--bs-breakpoint-lg:992px;--bs-breakpoint-xl:1200px;--bs-breakpoint-xxl:1400px}.row{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>*{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col{flex:1 0 0%}.row-cols-auto>*{flex:0 0 auto;width:auto}.row-cols-1>*{flex:0 0 auto;width:100%}.row-cols-2>*{flex:0 0 auto;width:50%}.row-cols-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-4>*{flex:0 0 auto;width:25%}.row-cols-5>*{flex:0 0 auto;width:20%}.row-cols-6>*{flex:0 0 auto;width:16.6666666667%}.col-auto{flex:0 0 auto;width:auto}.col-1{flex:0 0 auto;width:8.33333333%}.col-2{flex:0 0 auto;width:16.66666667%}.col-3{flex:0 0 auto;width:25%}.col-4{flex:0 0 auto;width:33.33333333%}.col-5{flex:0 0 auto;width:41.66666667%}.col-6{flex:0 0 auto;width:50%}.col-7{flex:0 0 auto;width:58.33333333%}.col-8{flex:0 0 auto;width:66.66666667%}.col-9{flex:0 0 auto;width:75%}.col-10{flex:0 0 auto;width:83.33333333%}.col-11{flex:0 0 auto;width:91.66666667%}.col-12{flex:0 0 auto;width:100%}.offset-1{margin-left:8.33333333%}.offset-2{margin-left:16.66666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333333%}.offset-5{margin-left:41.66666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333333%}.offset-8{margin-left:66.66666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333333%}.offset-11{margin-left:91.66666667%}.g-0,.gx-0{--bs-gutter-x:0}.g-0,.gy-0{--bs-gutter-y:0}.g-1,.gx-1{--bs-gutter-x:0.25rem}.g-1,.gy-1{--bs-gutter-y:0.25rem}.g-2,.gx-2{--bs-gutter-x:0.5rem}.g-2,.gy-2{--bs-gutter-y:0.5rem}.g-3,.gx-3{--bs-gutter-x:1rem}.g-3,.gy-3{--bs-gutter-y:1rem}.g-4,.gx-4{--bs-gutter-x:1.5rem}.g-4,.gy-4{--bs-gutter-y:1.5rem}.g-5,.gx-5{--bs-gutter-x:3rem}.g-5,.gy-5{--bs-gutter-y:3rem}@media (min-width:576px){.col-sm{flex:1 0 0%}.row-cols-sm-auto>*{flex:0 0 auto;width:auto}.row-cols-sm-1>*{flex:0 0 auto;width:100%}.row-cols-sm-2>*{flex:0 0 auto;width:50%}.row-cols-sm-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-sm-4>*{flex:0 0 auto;width:25%}.row-cols-sm-5>*{flex:0 0 auto;width:20%}.row-cols-sm-6>*{flex:0 0 auto;width:16.6666666667%}.col-sm-auto{flex:0 0 auto;width:auto}.col-sm-1{flex:0 0 auto;width:8.33333333%}.col-sm-2{flex:0 0 auto;width:16.66666667%}.col-sm-3{flex:0 0 auto;width:25%}.col-sm-4{flex:0 0 auto;width:33.33333333%}.col-sm-5{flex:0 0 auto;width:41.66666667%}.col-sm-6{flex:0 0 auto;width:50%}.col-sm-7{flex:0 0 auto;width:58.33333333%}.col-sm-8{flex:0 0 auto;width:66.66666667%}.col-sm-9{flex:0 0 auto;width:75%}.col-sm-10{flex:0 0 auto;width:83.33333333%}.col-sm-11{flex:0 0 auto;width:91.66666667%}.col-sm-12{flex:0 0 auto;width:100%}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333333%}.offset-sm-2{margin-left:16.66666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333333%}.offset-sm-5{margin-left:41.66666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333333%}.offset-sm-8{margin-left:66.66666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333333%}.offset-sm-11{margin-left:91.66666667%}.g-sm-0,.gx-sm-0{--bs-gutter-x:0}.g-sm-0,.gy-sm-0{--bs-gutter-y:0}.g-sm-1,.gx-sm-1{--bs-gutter-x:0.25rem}.g-sm-1,.gy-sm-1{--bs-gutter-y:0.25rem}.g-sm-2,.gx-sm-2{--bs-gutter-x:0.5rem}.g-sm-2,.gy-sm-2{--bs-gutter-y:0.5rem}.g-sm-3,.gx-sm-3{--bs-gutter-x:1rem}.g-sm-3,.gy-sm-3{--bs-gutter-y:1rem}.g-sm-4,.gx-sm-4{--bs-gutter-x:1.5rem}.g-sm-4,.gy-sm-4{--bs-gutter-y:1.5rem}.g-sm-5,.gx-sm-5{--bs-gutter-x:3rem}.g-sm-5,.gy-sm-5{--bs-gutter-y:3rem}}@media (min-width:768px){.col-md{flex:1 0 0%}.row-cols-md-auto>*{flex:0 0 auto;width:auto}.row-cols-md-1>*{flex:0 0 auto;width:100%}.row-cols-md-2>*{flex:0 0 auto;width:50%}.row-cols-md-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-md-4>*{flex:0 0 auto;width:25%}.row-cols-md-5>*{flex:0 0 auto;width:20%}.row-cols-md-6>*{flex:0 0 auto;width:16.6666666667%}.col-md-auto{flex:0 0 auto;width:auto}.col-md-1{flex:0 0 auto;width:8.33333333%}.col-md-2{flex:0 0 auto;width:16.66666667%}.col-md-3{flex:0 0 auto;width:25%}.col-md-4{flex:0 0 auto;width:33.33333333%}.col-md-5{flex:0 0 auto;width:41.66666667%}.col-md-6{flex:0 0 auto;width:50%}.col-md-7{flex:0 0 auto;width:58.33333333%}.col-md-8{flex:0 0 auto;width:66.66666667%}.col-md-9{flex:0 0 auto;width:75%}.col-md-10{flex:0 0 auto;width:83.33333333%}.col-md-11{flex:0 0 auto;width:91.66666667%}.col-md-12{flex:0 0 auto;width:100%}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333333%}.offset-md-2{margin-left:16.66666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333333%}.offset-md-5{margin-left:41.66666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333333%}.offset-md-8{margin-left:66.66666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333333%}.offset-md-11{margin-left:91.66666667%}.g-md-0,.gx-md-0{--bs-gutter-x:0}.g-md-0,.gy-md-0{--bs-gutter-y:0}.g-md-1,.gx-md-1{--bs-gutter-x:0.25rem}.g-md-1,.gy-md-1{--bs-gutter-y:0.25rem}.g-md-2,.gx-md-2{--bs-gutter-x:0.5rem}.g-md-2,.gy-md-2{--bs-gutter-y:0.5rem}.g-md-3,.gx-md-3{--bs-gutter-x:1rem}.g-md-3,.gy-md-3{--bs-gutter-y:1rem}.g-md-4,.gx-md-4{--bs-gutter-x:1.5rem}.g-md-4,.gy-md-4{--bs-gutter-y:1.5rem}.g-md-5,.gx-md-5{--bs-gutter-x:3rem}.g-md-5,.gy-md-5{--bs-gutter-y:3rem}}@media (min-width:992px){.col-lg{flex:1 0 0%}.row-cols-lg-auto>*{flex:0 0 auto;width:auto}.row-cols-lg-1>*{flex:0 0 auto;width:100%}.row-cols-lg-2>*{flex:0 0 auto;width:50%}.row-cols-lg-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-lg-4>*{flex:0 0 auto;width:25%}.row-cols-lg-5>*{flex:0 0 auto;width:20%}.row-cols-lg-6>*{flex:0 0 auto;width:16.6666666667%}.col-lg-auto{flex:0 0 auto;width:auto}.col-lg-1{flex:0 0 auto;width:8.33333333%}.col-lg-2{flex:0 0 auto;width:16.66666667%}.col-lg-3{flex:0 0 auto;width:25%}.col-lg-4{flex:0 0 auto;width:33.33333333%}.col-lg-5{flex:0 0 auto;width:41.66666667%}.col-lg-6{flex:0 0 auto;width:50%}.col-lg-7{flex:0 0 auto;width:58.33333333%}.col-lg-8{flex:0 0 auto;width:66.66666667%}.col-lg-9{flex:0 0 auto;width:75%}.col-lg-10{flex:0 0 auto;width:83.33333333%}.col-lg-11{flex:0 0 auto;width:91.66666667%}.col-lg-12{flex:0 0 auto;width:100%}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333333%}.offset-lg-2{margin-left:16.66666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333333%}.offset-lg-5{margin-left:41.66666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333333%}.offset-lg-8{margin-left:66.66666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333333%}.offset-lg-11{margin-left:91.66666667%}.g-lg-0,.gx-lg-0{--bs-gutter-x:0}.g-lg-0,.gy-lg-0{--bs-gutter-y:0}.g-lg-1,.gx-lg-1{--bs-gutter-x:0.25rem}.g-lg-1,.gy-lg-1{--bs-gutter-y:0.25rem}.g-lg-2,.gx-lg-2{--bs-gutter-x:0.5rem}.g-lg-2,.gy-lg-2{--bs-gutter-y:0.5rem}.g-lg-3,.gx-lg-3{--bs-gutter-x:1rem}.g-lg-3,.gy-lg-3{--bs-gutter-y:1rem}.g-lg-4,.gx-lg-4{--bs-gutter-x:1.5rem}.g-lg-4,.gy-lg-4{--bs-gutter-y:1.5rem}.g-lg-5,.gx-lg-5{--bs-gutter-x:3rem}.g-lg-5,.gy-lg-5{--bs-gutter-y:3rem}}@media (min-width:1200px){.col-xl{flex:1 0 0%}.row-cols-xl-auto>*{flex:0 0 auto;width:auto}.row-cols-xl-1>*{flex:0 0 auto;width:100%}.row-cols-xl-2>*{flex:0 0 auto;width:50%}.row-cols-xl-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-xl-4>*{flex:0 0 auto;width:25%}.row-cols-xl-5>*{flex:0 0 auto;width:20%}.row-cols-xl-6>*{flex:0 0 auto;width:16.6666666667%}.col-xl-auto{flex:0 0 auto;width:auto}.col-xl-1{flex:0 0 auto;width:8.33333333%}.col-xl-2{flex:0 0 auto;width:16.66666667%}.col-xl-3{flex:0 0 auto;width:25%}.col-xl-4{flex:0 0 auto;width:33.33333333%}.col-xl-5{flex:0 0 auto;width:41.66666667%}.col-xl-6{flex:0 0 auto;width:50%}.col-xl-7{flex:0 0 auto;width:58.33333333%}.col-xl-8{flex:0 0 auto;width:66.66666667%}.col-xl-9{flex:0 0 auto;width:75%}.col-xl-10{flex:0 0 auto;width:83.33333333%}.col-xl-11{flex:0 0 auto;width:91.66666667%}.col-xl-12{flex:0 0 auto;width:100%}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333333%}.offset-xl-2{margin-left:16.66666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333333%}.offset-xl-5{margin-left:41.66666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333333%}.offset-xl-8{margin-left:66.66666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333333%}.offset-xl-11{margin-left:91.66666667%}.g-xl-0,.gx-xl-0{--bs-gutter-x:0}.g-xl-0,.gy-xl-0{--bs-gutter-y:0}.g-xl-1,.gx-xl-1{--bs-gutter-x:0.25rem}.g-xl-1,.gy-xl-1{--bs-gutter-y:0.25rem}.g-xl-2,.gx-xl-2{--bs-gutter-x:0.5rem}.g-xl-2,.gy-xl-2{--bs-gutter-y:0.5rem}.g-xl-3,.gx-xl-3{--bs-gutter-x:1rem}.g-xl-3,.gy-xl-3{--bs-gutter-y:1rem}.g-xl-4,.gx-xl-4{--bs-gutter-x:1.5rem}.g-xl-4,.gy-xl-4{--bs-gutter-y:1.5rem}.g-xl-5,.gx-xl-5{--bs-gutter-x:3rem}.g-xl-5,.gy-xl-5{--bs-gutter-y:3rem}}@media (min-width:1400px){.col-xxl{flex:1 0 0%}.row-cols-xxl-auto>*{flex:0 0 auto;width:auto}.row-cols-xxl-1>*{flex:0 0 auto;width:100%}.row-cols-xxl-2>*{flex:0 0 auto;width:50%}.row-cols-xxl-3>*{flex:0 0 auto;width:33.3333333333%}.row-cols-xxl-4>*{flex:0 0 auto;width:25%}.row-cols-xxl-5>*{flex:0 0 auto;width:20%}.row-cols-xxl-6>*{flex:0 0 auto;width:16.6666666667%}.col-xxl-auto{flex:0 0 auto;width:auto}.col-xxl-1{flex:0 0 auto;width:8.33333333%}.col-xxl-2{flex:0 0 auto;width:16.66666667%}.col-xxl-3{flex:0 0 auto;width:25%}.col-xxl-4{flex:0 0 auto;width:33.33333333%}.col-xxl-5{flex:0 0 auto;width:41.66666667%}.col-xxl-6{flex:0 0 auto;width:50%}.col-xxl-7{flex:0 0 auto;width:58.33333333%}.col-xxl-8{flex:0 0 auto;width:66.66666667%}.col-xxl-9{flex:0 0 auto;width:75%}.col-xxl-10{flex:0 0 auto;width:83.33333333%}.col-xxl-11{flex:0 0 auto;width:91.66666667%}.col-xxl-12{flex:0 0 auto;width:100%}.offset-xxl-0{margin-left:0}.offset-xxl-1{margin-left:8.33333333%}.offset-xxl-2{margin-left:16.66666667%}.offset-xxl-3{margin-left:25%}.offset-xxl-4{margin-left:33.33333333%}.offset-xxl-5{margin-left:41.66666667%}.offset-xxl-6{margin-left:50%}.offset-xxl-7{margin-left:58.33333333%}.offset-xxl-8{margin-left:66.66666667%}.offset-xxl-9{margin-left:75%}.offset-xxl-10{margin-left:83.33333333%}.offset-xxl-11{margin-left:91.66666667%}.g-xxl-0,.gx-xxl-0{--bs-gutter-x:0}.g-xxl-0,.gy-xxl-0{--bs-gutter-y:0}.g-xxl-1,.gx-xxl-1{--bs-gutter-x:0.25rem}.g-xxl-1,.gy-xxl-1{--bs-gutter-y:0.25rem}.g-xxl-2,.gx-xxl-2{--bs-gutter-x:0.5rem}.g-xxl-2,.gy-xxl-2{--bs-gutter-y:0.5rem}.g-xxl-3,.gx-xxl-3{--bs-gutter-x:1rem}.g-xxl-3,.gy-xxl-3{--bs-gutter-y:1rem}.g-xxl-4,.gx-xxl-4{--bs-gutter-x:1.5rem}.g-xxl-4,.gy-xxl-4{--bs-gutter-y:1.5rem}.g-xxl-5,.gx-xxl-5{--bs-gutter-x:3rem}.g-xxl-5,.gy-xxl-5{--bs-gutter-y:3rem}}.table{--bs-table-color-type:initial;--bs-table-bg-type:initial;--bs-table-color-state:initial;--bs-table-bg-state:initial;--bs-table-color:var(--bs-body-color);--bs-table-bg:var(--bs-body-bg);--bs-table-border-color:var(--bs-border-color);--bs-table-accent-bg:transparent;--bs-table-striped-color:var(--bs-body-color);--bs-table-striped-bg:rgba(0, 0, 0, 0.05);--bs-table-active-color:var(--bs-body-color);--bs-table-active-bg:rgba(0, 0, 0, 0.1);--bs-table-hover-color:var(--bs-body-color);--bs-table-hover-bg:rgba(0, 0, 0, 0.075);width:100%;margin-bottom:1rem;vertical-align:top;border-color:var(--bs-table-border-color)}.table>:not(caption)>*>*{padding:.5rem .5rem;color:var(--bs-table-color-state,var(--bs-table-color-type,var(--bs-table-color)));background-color:var(--bs-table-bg);border-bottom-width:var(--bs-border-width);box-shadow:inset 0 0 0 9999px var(--bs-table-bg-state,var(--bs-table-bg-type,var(--bs-table-accent-bg)))}.table>tbody{vertical-align:inherit}.table>thead{vertical-align:bottom}.table-group-divider{border-top:calc(var(--bs-border-width) * 2) solid currentcolor}.caption-top{caption-side:top}.table-sm>:not(caption)>*>*{padding:.25rem .25rem}.table-bordered>:not(caption)>*{border-width:var(--bs-border-width) 0}.table-bordered>:not(caption)>*>*{border-width:0 var(--bs-border-width)}.table-borderless>:not(caption)>*>*{border-bottom-width:0}.table-borderless>:not(:first-child){border-top-width:0}.table-striped>tbody>tr:nth-of-type(odd)>*{--bs-table-color-type:var(--bs-table-striped-color);--bs-table-bg-type:var(--bs-table-striped-bg)}.table-striped-columns>:not(caption)>tr>:nth-child(2n){--bs-table-color-type:var(--bs-table-striped-color);--bs-table-bg-type:var(--bs-table-striped-bg)}.table-active{--bs-table-color-state:var(--bs-table-active-color);--bs-table-bg-state:var(--bs-table-active-bg)}.table-hover>tbody>tr:hover>*{--bs-table-color-state:var(--bs-table-hover-color);--bs-table-bg-state:var(--bs-table-hover-bg)}.table-primary{--bs-table-color:#000;--bs-table-bg:#cfe2ff;--bs-table-border-color:#bacbe6;--bs-table-striped-bg:#c5d7f2;--bs-table-striped-color:#000;--bs-table-active-bg:#bacbe6;--bs-table-active-color:#000;--bs-table-hover-bg:#bfd1ec;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-secondary{--bs-table-color:#000;--bs-table-bg:#e2e3e5;--bs-table-border-color:#cbccce;--bs-table-striped-bg:#d7d8da;--bs-table-striped-color:#000;--bs-table-active-bg:#cbccce;--bs-table-active-color:#000;--bs-table-hover-bg:#d1d2d4;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-success{--bs-table-color:#000;--bs-table-bg:#d1e7dd;--bs-table-border-color:#bcd0c7;--bs-table-striped-bg:#c7dbd2;--bs-table-striped-color:#000;--bs-table-active-bg:#bcd0c7;--bs-table-active-color:#000;--bs-table-hover-bg:#c1d6cc;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-info{--bs-table-color:#000;--bs-table-bg:#cff4fc;--bs-table-border-color:#badce3;--bs-table-striped-bg:#c5e8ef;--bs-table-striped-color:#000;--bs-table-active-bg:#badce3;--bs-table-active-color:#000;--bs-table-hover-bg:#bfe2e9;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-warning{--bs-table-color:#000;--bs-table-bg:#fff3cd;--bs-table-border-color:#e6dbb9;--bs-table-striped-bg:#f2e7c3;--bs-table-striped-color:#000;--bs-table-active-bg:#e6dbb9;--bs-table-active-color:#000;--bs-table-hover-bg:#ece1be;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-danger{--bs-table-color:#000;--bs-table-bg:#f8d7da;--bs-table-border-color:#dfc2c4;--bs-table-striped-bg:#eccccf;--bs-table-striped-color:#000;--bs-table-active-bg:#dfc2c4;--bs-table-active-color:#000;--bs-table-hover-bg:#e5c7ca;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-light{--bs-table-color:#000;--bs-table-bg:#f8f9fa;--bs-table-border-color:#dfe0e1;--bs-table-striped-bg:#ecedee;--bs-table-striped-color:#000;--bs-table-active-bg:#dfe0e1;--bs-table-active-color:#000;--bs-table-hover-bg:#e5e6e7;--bs-table-hover-color:#000;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-dark{--bs-table-color:#fff;--bs-table-bg:#212529;--bs-table-border-color:#373b3e;--bs-table-striped-bg:#2c3034;--bs-table-striped-color:#fff;--bs-table-active-bg:#373b3e;--bs-table-active-color:#fff;--bs-table-hover-bg:#323539;--bs-table-hover-color:#fff;color:var(--bs-table-color);border-color:var(--bs-table-border-color)}.table-responsive{overflow-x:auto;-webkit-overflow-scrolling:touch}@media (max-width:575.98px){.table-responsive-sm{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:767.98px){.table-responsive-md{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:991.98px){.table-responsive-lg{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1199.98px){.table-responsive-xl{overflow-x:auto;-webkit-overflow-scrolling:touch}}@media (max-width:1399.98px){.table-responsive-xxl{overflow-x:auto;-webkit-overflow-scrolling:touch}}.form-label{margin-bottom:.5rem}.col-form-label{padding-top:calc(.375rem + var(--bs-border-width));padding-bottom:calc(.375rem + var(--bs-border-width));margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + var(--bs-border-width));padding-bottom:calc(.5rem + var(--bs-border-width));font-size:1.25rem}.col-form-label-sm{padding-top:calc(.25rem + var(--bs-border-width));padding-bottom:calc(.25rem + var(--bs-border-width));font-size:.875rem}.form-text{margin-top:.25rem;font-size:.875em;color:var(--bs-secondary-color)}.form-control{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bs-body-bg);background-clip:padding-box;border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control[type=file]{overflow:hidden}.form-control[type=file]:not(:disabled):not([readonly]){cursor:pointer}.form-control:focus{color:var(--bs-body-color);background-color:var(--bs-body-bg);border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control::-webkit-date-and-time-value{min-width:85px;height:1.5em;margin:0}.form-control::-webkit-datetime-edit{display:block;padding:0}.form-control::-moz-placeholder{color:var(--bs-secondary-color);opacity:1}.form-control::placeholder{color:var(--bs-secondary-color);opacity:1}.form-control:disabled{background-color:var(--bs-secondary-bg);opacity:1}.form-control::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:var(--bs-body-color);background-color:var(--bs-tertiary-bg);pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:var(--bs-border-width);border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:var(--bs-body-color);background-color:var(--bs-tertiary-bg);pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:var(--bs-border-width);border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control::file-selector-button{transition:none}}.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:var(--bs-secondary-bg)}.form-control:hover:not(:disabled):not([readonly])::file-selector-button{background-color:var(--bs-secondary-bg)}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;line-height:1.5;color:var(--bs-body-color);background-color:transparent;border:solid transparent;border-width:var(--bs-border-width) 0}.form-control-plaintext:focus{outline:0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm{padding-right:0;padding-left:0}.form-control-sm{min-height:calc(1.5em + .5rem + calc(var(--bs-border-width) * 2));padding:.25rem .5rem;font-size:.875rem;border-radius:var(--bs-border-radius-sm)}.form-control-sm::-webkit-file-upload-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-sm::file-selector-button{padding:.25rem .5rem;margin:-.25rem -.5rem;-webkit-margin-end:.5rem;margin-inline-end:.5rem}.form-control-lg{min-height:calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));padding:.5rem 1rem;font-size:1.25rem;border-radius:var(--bs-border-radius-lg)}.form-control-lg::-webkit-file-upload-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}.form-control-lg::file-selector-button{padding:.5rem 1rem;margin:-.5rem -1rem;-webkit-margin-end:1rem;margin-inline-end:1rem}textarea.form-control{min-height:calc(1.5em + .75rem + calc(var(--bs-border-width) * 2))}textarea.form-control-sm{min-height:calc(1.5em + .5rem + calc(var(--bs-border-width) * 2))}textarea.form-control-lg{min-height:calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))}.form-control-color{width:3rem;height:calc(1.5em + .75rem + calc(var(--bs-border-width) * 2));padding:.375rem}.form-control-color:not(:disabled):not([readonly]){cursor:pointer}.form-control-color::-moz-color-swatch{border:0!important;border-radius:var(--bs-border-radius)}.form-control-color::-webkit-color-swatch{border:0!important;border-radius:var(--bs-border-radius)}.form-control-color.form-control-sm{height:calc(1.5em + .5rem + calc(var(--bs-border-width) * 2))}.form-control-color.form-control-lg{height:calc(1.5em + 1rem + calc(var(--bs-border-width) * 2))}.form-select{--bs-form-select-bg-img:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bs-body-bg);background-image:var(--bs-form-select-bg-img),var(--bs-form-select-bg-icon,none);background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-select{transition:none}}.form-select:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple],.form-select[size]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select:disabled{background-color:var(--bs-secondary-bg)}.form-select:-moz-focusring{color:transparent;text-shadow:0 0 0 var(--bs-body-color)}.form-select-sm{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem;border-radius:var(--bs-border-radius-sm)}.form-select-lg{padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem;border-radius:var(--bs-border-radius-lg)}[data-bs-theme=dark] .form-select{--bs-form-select-bg-img:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\")}.form-check{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input{float:left;margin-left:-1.5em}.form-check-reverse{padding-right:1.5em;padding-left:0;text-align:right}.form-check-reverse .form-check-input{float:right;margin-right:-1.5em;margin-left:0}.form-check-input{--bs-form-check-bg:var(--bs-body-bg);width:1em;height:1em;margin-top:.25em;vertical-align:top;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--bs-form-check-bg);background-image:var(--bs-form-check-bg-image);background-repeat:no-repeat;background-position:center;background-size:contain;border:var(--bs-border-width) solid var(--bs-border-color);-webkit-print-color-adjust:exact;color-adjust:exact;print-color-adjust:exact}.form-check-input[type=checkbox]{border-radius:.25em}.form-check-input[type=radio]{border-radius:50%}.form-check-input:active{filter:brightness(90%)}.form-check-input:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox]{--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\")}.form-check-input:checked[type=radio]{--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\")}.form-check-input[type=checkbox]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\")}.form-check-input:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{cursor:default;opacity:.5}.form-switch{padding-left:2.5em}.form-switch .form-check-input{--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");width:2em;margin-left:-2.5em;background-image:var(--bs-form-switch-bg);background-position:left center;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input{transition:none}}.form-switch .form-check-input:focus{--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\")}.form-switch .form-check-input:checked{background-position:right center;--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.form-switch.form-check-reverse{padding-right:2.5em;padding-left:0}.form-switch.form-check-reverse .form-check-input{margin-right:-2.5em;margin-left:0}.form-check-inline{display:inline-block;margin-right:1rem}.btn-check{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.btn-check:disabled+.btn,.btn-check[disabled]+.btn{pointer-events:none;filter:none;opacity:.65}[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus){--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\")}.form-range{width:100%;height:1.5rem;padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent}.form-range:focus{outline:0}.form-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .25rem rgba(13,110,253,.25)}.form-range::-moz-focus-outer{border:0}.form-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;-webkit-appearance:none;appearance:none;background-color:#0d6efd;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-range::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.form-range::-webkit-slider-thumb:active{background-color:#b6d4fe}.form-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:var(--bs-tertiary-bg);border-color:transparent;border-radius:1rem}.form-range::-moz-range-thumb{width:1rem;height:1rem;-moz-appearance:none;appearance:none;background-color:#0d6efd;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-range::-moz-range-thumb{-moz-transition:none;transition:none}}.form-range::-moz-range-thumb:active{background-color:#b6d4fe}.form-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:var(--bs-tertiary-bg);border-color:transparent;border-radius:1rem}.form-range:disabled{pointer-events:none}.form-range:disabled::-webkit-slider-thumb{background-color:var(--bs-secondary-color)}.form-range:disabled::-moz-range-thumb{background-color:var(--bs-secondary-color)}.form-floating{position:relative}.form-floating>.form-control,.form-floating>.form-control-plaintext,.form-floating>.form-select{height:calc(3.5rem + calc(var(--bs-border-width) * 2));min-height:calc(3.5rem + calc(var(--bs-border-width) * 2));line-height:1.25}.form-floating>label{position:absolute;top:0;left:0;z-index:2;height:100%;padding:1rem .75rem;overflow:hidden;text-align:start;text-overflow:ellipsis;white-space:nowrap;pointer-events:none;border:var(--bs-border-width) solid transparent;transform-origin:0 0;transition:opacity .1s ease-in-out,transform .1s ease-in-out}@media (prefers-reduced-motion:reduce){.form-floating>label{transition:none}}.form-floating>.form-control,.form-floating>.form-control-plaintext{padding:1rem .75rem}.form-floating>.form-control-plaintext::-moz-placeholder,.form-floating>.form-control::-moz-placeholder{color:transparent}.form-floating>.form-control-plaintext::placeholder,.form-floating>.form-control::placeholder{color:transparent}.form-floating>.form-control-plaintext:not(:-moz-placeholder-shown),.form-floating>.form-control:not(:-moz-placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control-plaintext:focus,.form-floating>.form-control-plaintext:not(:placeholder-shown),.form-floating>.form-control:focus,.form-floating>.form-control:not(:placeholder-shown){padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control-plaintext:-webkit-autofill,.form-floating>.form-control:-webkit-autofill{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-select{padding-top:1.625rem;padding-bottom:.625rem}.form-floating>.form-control:not(:-moz-placeholder-shown)~label{color:rgba(var(--bs-body-color-rgb),.65);transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control-plaintext~label,.form-floating>.form-control:focus~label,.form-floating>.form-control:not(:placeholder-shown)~label,.form-floating>.form-select~label{color:rgba(var(--bs-body-color-rgb),.65);transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control:not(:-moz-placeholder-shown)~label::after{position:absolute;inset:1rem 0.375rem;z-index:-1;height:1.5em;content:\"\";background-color:var(--bs-body-bg);border-radius:var(--bs-border-radius)}.form-floating>.form-control-plaintext~label::after,.form-floating>.form-control:focus~label::after,.form-floating>.form-control:not(:placeholder-shown)~label::after,.form-floating>.form-select~label::after{position:absolute;inset:1rem 0.375rem;z-index:-1;height:1.5em;content:\"\";background-color:var(--bs-body-bg);border-radius:var(--bs-border-radius)}.form-floating>.form-control:-webkit-autofill~label{color:rgba(var(--bs-body-color-rgb),.65);transform:scale(.85) translateY(-.5rem) translateX(.15rem)}.form-floating>.form-control-plaintext~label{border-width:var(--bs-border-width) 0}.form-floating>.form-control:disabled~label,.form-floating>:disabled~label{color:#6c757d}.form-floating>.form-control:disabled~label::after,.form-floating>:disabled~label::after{background-color:var(--bs-secondary-bg)}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control,.input-group>.form-floating,.input-group>.form-select{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control:focus,.input-group>.form-floating:focus-within,.input-group>.form-select:focus{z-index:5}.input-group .btn{position:relative;z-index:2}.input-group .btn:focus{z-index:5}.input-group-text{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);text-align:center;white-space:nowrap;background-color:var(--bs-tertiary-bg);border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius)}.input-group-lg>.btn,.input-group-lg>.form-control,.input-group-lg>.form-select,.input-group-lg>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;border-radius:var(--bs-border-radius-lg)}.input-group-sm>.btn,.input-group-sm>.form-control,.input-group-sm>.form-select,.input-group-sm>.input-group-text{padding:.25rem .5rem;font-size:.875rem;border-radius:var(--bs-border-radius-sm)}.input-group-lg>.form-select,.input-group-sm>.form-select{padding-right:3rem}.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select,.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){border-top-right-radius:0;border-bottom-right-radius:0}.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select,.input-group.has-validation>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback){margin-left:calc(var(--bs-border-width) * -1);border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.form-floating:not(:first-child)>.form-control,.input-group>.form-floating:not(:first-child)>.form-select{border-top-left-radius:0;border-bottom-left-radius:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:var(--bs-form-valid-color)}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:var(--bs-success);border-radius:var(--bs-border-radius)}.is-valid~.valid-feedback,.is-valid~.valid-tooltip,.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip{display:block}.form-control.is-valid,.was-validated .form-control:valid{border-color:var(--bs-form-valid-border-color);padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{border-color:var(--bs-form-valid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-success-rgb),.25)}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-valid,.was-validated .form-select:valid{border-color:var(--bs-form-valid-border-color)}.form-select.is-valid:not([multiple]):not([size]),.form-select.is-valid:not([multiple])[size=\"1\"],.was-validated .form-select:valid:not([multiple]):not([size]),.was-validated .form-select:valid:not([multiple])[size=\"1\"]{--bs-form-select-bg-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");padding-right:4.125rem;background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-valid:focus,.was-validated .form-select:valid:focus{border-color:var(--bs-form-valid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-success-rgb),.25)}.form-control-color.is-valid,.was-validated .form-control-color:valid{width:calc(3rem + calc(1.5em + .75rem))}.form-check-input.is-valid,.was-validated .form-check-input:valid{border-color:var(--bs-form-valid-border-color)}.form-check-input.is-valid:checked,.was-validated .form-check-input:valid:checked{background-color:var(--bs-form-valid-color)}.form-check-input.is-valid:focus,.was-validated .form-check-input:valid:focus{box-shadow:0 0 0 .25rem rgba(var(--bs-success-rgb),.25)}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:var(--bs-form-valid-color)}.form-check-inline .form-check-input~.valid-feedback{margin-left:.5em}.input-group>.form-control:not(:focus).is-valid,.input-group>.form-floating:not(:focus-within).is-valid,.input-group>.form-select:not(:focus).is-valid,.was-validated .input-group>.form-control:not(:focus):valid,.was-validated .input-group>.form-floating:not(:focus-within):valid,.was-validated .input-group>.form-select:not(:focus):valid{z-index:3}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:.875em;color:var(--bs-form-invalid-color)}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;color:#fff;background-color:var(--bs-danger);border-radius:var(--bs-border-radius)}.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip,.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip{display:block}.form-control.is-invalid,.was-validated .form-control:invalid{border-color:var(--bs-form-invalid-border-color);padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid:focus,.was-validated .form-control:invalid:focus{border-color:var(--bs-form-invalid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-danger-rgb),.25)}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.form-select.is-invalid,.was-validated .form-select:invalid{border-color:var(--bs-form-invalid-border-color)}.form-select.is-invalid:not([multiple]):not([size]),.form-select.is-invalid:not([multiple])[size=\"1\"],.was-validated .form-select:invalid:not([multiple]):not([size]),.was-validated .form-select:invalid:not([multiple])[size=\"1\"]{--bs-form-select-bg-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");padding-right:4.125rem;background-position:right .75rem center,center right 2.25rem;background-size:16px 12px,calc(.75em + .375rem) calc(.75em + .375rem)}.form-select.is-invalid:focus,.was-validated .form-select:invalid:focus{border-color:var(--bs-form-invalid-border-color);box-shadow:0 0 0 .25rem rgba(var(--bs-danger-rgb),.25)}.form-control-color.is-invalid,.was-validated .form-control-color:invalid{width:calc(3rem + calc(1.5em + .75rem))}.form-check-input.is-invalid,.was-validated .form-check-input:invalid{border-color:var(--bs-form-invalid-border-color)}.form-check-input.is-invalid:checked,.was-validated .form-check-input:invalid:checked{background-color:var(--bs-form-invalid-color)}.form-check-input.is-invalid:focus,.was-validated .form-check-input:invalid:focus{box-shadow:0 0 0 .25rem rgba(var(--bs-danger-rgb),.25)}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:var(--bs-form-invalid-color)}.form-check-inline .form-check-input~.invalid-feedback{margin-left:.5em}.input-group>.form-control:not(:focus).is-invalid,.input-group>.form-floating:not(:focus-within).is-invalid,.input-group>.form-select:not(:focus).is-invalid,.was-validated .input-group>.form-control:not(:focus):invalid,.was-validated .input-group>.form-floating:not(:focus-within):invalid,.was-validated .input-group>.form-select:not(:focus):invalid{z-index:4}.btn{--bs-btn-padding-x:0.75rem;--bs-btn-padding-y:0.375rem;--bs-btn-font-family: ;--bs-btn-font-size:1rem;--bs-btn-font-weight:400;--bs-btn-line-height:1.5;--bs-btn-color:var(--bs-body-color);--bs-btn-bg:transparent;--bs-btn-border-width:var(--bs-border-width);--bs-btn-border-color:transparent;--bs-btn-border-radius:var(--bs-border-radius);--bs-btn-hover-border-color:transparent;--bs-btn-box-shadow:inset 0 1px 0 rgba(255, 255, 255, 0.15),0 1px 1px rgba(0, 0, 0, 0.075);--bs-btn-disabled-opacity:0.65;--bs-btn-focus-box-shadow:0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);display:inline-block;padding:var(--bs-btn-padding-y) var(--bs-btn-padding-x);font-family:var(--bs-btn-font-family);font-size:var(--bs-btn-font-size);font-weight:var(--bs-btn-font-weight);line-height:var(--bs-btn-line-height);color:var(--bs-btn-color);text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;border:var(--bs-btn-border-width) solid var(--bs-btn-border-color);border-radius:var(--bs-btn-border-radius);background-color:var(--bs-btn-bg);transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color)}.btn-check+.btn:hover{color:var(--bs-btn-color);background-color:var(--bs-btn-bg);border-color:var(--bs-btn-border-color)}.btn:focus-visible{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color);outline:0;box-shadow:var(--bs-btn-focus-box-shadow)}.btn-check:focus-visible+.btn{border-color:var(--bs-btn-hover-border-color);outline:0;box-shadow:var(--bs-btn-focus-box-shadow)}.btn-check:checked+.btn,.btn.active,.btn.show,.btn:first-child:active,:not(.btn-check)+.btn:active{color:var(--bs-btn-active-color);background-color:var(--bs-btn-active-bg);border-color:var(--bs-btn-active-border-color)}.btn-check:checked+.btn:focus-visible,.btn.active:focus-visible,.btn.show:focus-visible,.btn:first-child:active:focus-visible,:not(.btn-check)+.btn:active:focus-visible{box-shadow:var(--bs-btn-focus-box-shadow)}.btn.disabled,.btn:disabled,fieldset:disabled .btn{color:var(--bs-btn-disabled-color);pointer-events:none;background-color:var(--bs-btn-disabled-bg);border-color:var(--bs-btn-disabled-border-color);opacity:var(--bs-btn-disabled-opacity)}.btn-primary{--bs-btn-color:#fff;--bs-btn-bg:#0d6efd;--bs-btn-border-color:#0d6efd;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#0b5ed7;--bs-btn-hover-border-color:#0a58ca;--bs-btn-focus-shadow-rgb:49,132,253;--bs-btn-active-color:#fff;--bs-btn-active-bg:#0a58ca;--bs-btn-active-border-color:#0a53be;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#0d6efd;--bs-btn-disabled-border-color:#0d6efd}.btn-secondary{--bs-btn-color:#fff;--bs-btn-bg:#6c757d;--bs-btn-border-color:#6c757d;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#5c636a;--bs-btn-hover-border-color:#565e64;--bs-btn-focus-shadow-rgb:130,138,145;--bs-btn-active-color:#fff;--bs-btn-active-bg:#565e64;--bs-btn-active-border-color:#51585e;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#6c757d;--bs-btn-disabled-border-color:#6c757d}.btn-success{--bs-btn-color:#fff;--bs-btn-bg:#198754;--bs-btn-border-color:#198754;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#157347;--bs-btn-hover-border-color:#146c43;--bs-btn-focus-shadow-rgb:60,153,110;--bs-btn-active-color:#fff;--bs-btn-active-bg:#146c43;--bs-btn-active-border-color:#13653f;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#198754;--bs-btn-disabled-border-color:#198754}.btn-info{--bs-btn-color:#000;--bs-btn-bg:#0dcaf0;--bs-btn-border-color:#0dcaf0;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#31d2f2;--bs-btn-hover-border-color:#25cff2;--bs-btn-focus-shadow-rgb:11,172,204;--bs-btn-active-color:#000;--bs-btn-active-bg:#3dd5f3;--bs-btn-active-border-color:#25cff2;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#000;--bs-btn-disabled-bg:#0dcaf0;--bs-btn-disabled-border-color:#0dcaf0}.btn-warning{--bs-btn-color:#000;--bs-btn-bg:#ffc107;--bs-btn-border-color:#ffc107;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#ffca2c;--bs-btn-hover-border-color:#ffc720;--bs-btn-focus-shadow-rgb:217,164,6;--bs-btn-active-color:#000;--bs-btn-active-bg:#ffcd39;--bs-btn-active-border-color:#ffc720;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#000;--bs-btn-disabled-bg:#ffc107;--bs-btn-disabled-border-color:#ffc107}.btn-danger{--bs-btn-color:#fff;--bs-btn-bg:#dc3545;--bs-btn-border-color:#dc3545;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#bb2d3b;--bs-btn-hover-border-color:#b02a37;--bs-btn-focus-shadow-rgb:225,83,97;--bs-btn-active-color:#fff;--bs-btn-active-bg:#b02a37;--bs-btn-active-border-color:#a52834;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#dc3545;--bs-btn-disabled-border-color:#dc3545}.btn-light{--bs-btn-color:#000;--bs-btn-bg:#f8f9fa;--bs-btn-border-color:#f8f9fa;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#d3d4d5;--bs-btn-hover-border-color:#c6c7c8;--bs-btn-focus-shadow-rgb:211,212,213;--bs-btn-active-color:#000;--bs-btn-active-bg:#c6c7c8;--bs-btn-active-border-color:#babbbc;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#000;--bs-btn-disabled-bg:#f8f9fa;--bs-btn-disabled-border-color:#f8f9fa}.btn-dark{--bs-btn-color:#fff;--bs-btn-bg:#212529;--bs-btn-border-color:#212529;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#424649;--bs-btn-hover-border-color:#373b3e;--bs-btn-focus-shadow-rgb:66,70,73;--bs-btn-active-color:#fff;--bs-btn-active-bg:#4d5154;--bs-btn-active-border-color:#373b3e;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#212529;--bs-btn-disabled-border-color:#212529}.btn-outline-primary{--bs-btn-color:#0d6efd;--bs-btn-border-color:#0d6efd;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#0d6efd;--bs-btn-hover-border-color:#0d6efd;--bs-btn-focus-shadow-rgb:13,110,253;--bs-btn-active-color:#fff;--bs-btn-active-bg:#0d6efd;--bs-btn-active-border-color:#0d6efd;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#0d6efd;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#0d6efd;--bs-gradient:none}.btn-outline-secondary{--bs-btn-color:#6c757d;--bs-btn-border-color:#6c757d;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#6c757d;--bs-btn-hover-border-color:#6c757d;--bs-btn-focus-shadow-rgb:108,117,125;--bs-btn-active-color:#fff;--bs-btn-active-bg:#6c757d;--bs-btn-active-border-color:#6c757d;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#6c757d;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#6c757d;--bs-gradient:none}.btn-outline-success{--bs-btn-color:#198754;--bs-btn-border-color:#198754;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#198754;--bs-btn-hover-border-color:#198754;--bs-btn-focus-shadow-rgb:25,135,84;--bs-btn-active-color:#fff;--bs-btn-active-bg:#198754;--bs-btn-active-border-color:#198754;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#198754;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#198754;--bs-gradient:none}.btn-outline-info{--bs-btn-color:#0dcaf0;--bs-btn-border-color:#0dcaf0;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#0dcaf0;--bs-btn-hover-border-color:#0dcaf0;--bs-btn-focus-shadow-rgb:13,202,240;--bs-btn-active-color:#000;--bs-btn-active-bg:#0dcaf0;--bs-btn-active-border-color:#0dcaf0;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#0dcaf0;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#0dcaf0;--bs-gradient:none}.btn-outline-warning{--bs-btn-color:#ffc107;--bs-btn-border-color:#ffc107;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#ffc107;--bs-btn-hover-border-color:#ffc107;--bs-btn-focus-shadow-rgb:255,193,7;--bs-btn-active-color:#000;--bs-btn-active-bg:#ffc107;--bs-btn-active-border-color:#ffc107;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#ffc107;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#ffc107;--bs-gradient:none}.btn-outline-danger{--bs-btn-color:#dc3545;--bs-btn-border-color:#dc3545;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#dc3545;--bs-btn-hover-border-color:#dc3545;--bs-btn-focus-shadow-rgb:220,53,69;--bs-btn-active-color:#fff;--bs-btn-active-bg:#dc3545;--bs-btn-active-border-color:#dc3545;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#dc3545;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#dc3545;--bs-gradient:none}.btn-outline-light{--bs-btn-color:#f8f9fa;--bs-btn-border-color:#f8f9fa;--bs-btn-hover-color:#000;--bs-btn-hover-bg:#f8f9fa;--bs-btn-hover-border-color:#f8f9fa;--bs-btn-focus-shadow-rgb:248,249,250;--bs-btn-active-color:#000;--bs-btn-active-bg:#f8f9fa;--bs-btn-active-border-color:#f8f9fa;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#f8f9fa;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#f8f9fa;--bs-gradient:none}.btn-outline-dark{--bs-btn-color:#212529;--bs-btn-border-color:#212529;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#212529;--bs-btn-hover-border-color:#212529;--bs-btn-focus-shadow-rgb:33,37,41;--bs-btn-active-color:#fff;--bs-btn-active-bg:#212529;--bs-btn-active-border-color:#212529;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#212529;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#212529;--bs-gradient:none}.btn-link{--bs-btn-font-weight:400;--bs-btn-color:var(--bs-link-color);--bs-btn-bg:transparent;--bs-btn-border-color:transparent;--bs-btn-hover-color:var(--bs-link-hover-color);--bs-btn-hover-border-color:transparent;--bs-btn-active-color:var(--bs-link-hover-color);--bs-btn-active-border-color:transparent;--bs-btn-disabled-color:#6c757d;--bs-btn-disabled-border-color:transparent;--bs-btn-box-shadow:0 0 0 #000;--bs-btn-focus-shadow-rgb:49,132,253;text-decoration:underline}.btn-link:focus-visible{color:var(--bs-btn-color)}.btn-link:hover{color:var(--bs-btn-hover-color)}.btn-group-lg>.btn,.btn-lg{--bs-btn-padding-y:0.5rem;--bs-btn-padding-x:1rem;--bs-btn-font-size:1.25rem;--bs-btn-border-radius:var(--bs-border-radius-lg)}.btn-group-sm>.btn,.btn-sm{--bs-btn-padding-y:0.25rem;--bs-btn-padding-x:0.5rem;--bs-btn-font-size:0.875rem;--bs-btn-border-radius:var(--bs-border-radius-sm)}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing{transition:none}}.collapsing.collapse-horizontal{width:0;height:auto;transition:width .35s ease}@media (prefers-reduced-motion:reduce){.collapsing.collapse-horizontal{transition:none}}.dropdown,.dropdown-center,.dropend,.dropstart,.dropup,.dropup-center{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{--bs-dropdown-zindex:1000;--bs-dropdown-min-width:10rem;--bs-dropdown-padding-x:0;--bs-dropdown-padding-y:0.5rem;--bs-dropdown-spacer:0.125rem;--bs-dropdown-font-size:1rem;--bs-dropdown-color:var(--bs-body-color);--bs-dropdown-bg:var(--bs-body-bg);--bs-dropdown-border-color:var(--bs-border-color-translucent);--bs-dropdown-border-radius:var(--bs-border-radius);--bs-dropdown-border-width:var(--bs-border-width);--bs-dropdown-inner-border-radius:calc(var(--bs-border-radius) - var(--bs-border-width));--bs-dropdown-divider-bg:var(--bs-border-color-translucent);--bs-dropdown-divider-margin-y:0.5rem;--bs-dropdown-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-dropdown-link-color:var(--bs-body-color);--bs-dropdown-link-hover-color:var(--bs-body-color);--bs-dropdown-link-hover-bg:var(--bs-tertiary-bg);--bs-dropdown-link-active-color:#fff;--bs-dropdown-link-active-bg:#0d6efd;--bs-dropdown-link-disabled-color:var(--bs-tertiary-color);--bs-dropdown-item-padding-x:1rem;--bs-dropdown-item-padding-y:0.25rem;--bs-dropdown-header-color:#6c757d;--bs-dropdown-header-padding-x:1rem;--bs-dropdown-header-padding-y:0.5rem;position:absolute;z-index:var(--bs-dropdown-zindex);display:none;min-width:var(--bs-dropdown-min-width);padding:var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);margin:0;font-size:var(--bs-dropdown-font-size);color:var(--bs-dropdown-color);text-align:left;list-style:none;background-color:var(--bs-dropdown-bg);background-clip:padding-box;border:var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);border-radius:var(--bs-dropdown-border-radius)}.dropdown-menu[data-bs-popper]{top:100%;left:0;margin-top:var(--bs-dropdown-spacer)}.dropdown-menu-start{--bs-position:start}.dropdown-menu-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-end{--bs-position:end}.dropdown-menu-end[data-bs-popper]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-start{--bs-position:start}.dropdown-menu-sm-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-sm-end{--bs-position:end}.dropdown-menu-sm-end[data-bs-popper]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-start{--bs-position:start}.dropdown-menu-md-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-md-end{--bs-position:end}.dropdown-menu-md-end[data-bs-popper]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-start{--bs-position:start}.dropdown-menu-lg-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-lg-end{--bs-position:end}.dropdown-menu-lg-end[data-bs-popper]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-start{--bs-position:start}.dropdown-menu-xl-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-xl-end{--bs-position:end}.dropdown-menu-xl-end[data-bs-popper]{right:0;left:auto}}@media (min-width:1400px){.dropdown-menu-xxl-start{--bs-position:start}.dropdown-menu-xxl-start[data-bs-popper]{right:auto;left:0}.dropdown-menu-xxl-end{--bs-position:end}.dropdown-menu-xxl-end[data-bs-popper]{right:0;left:auto}}.dropup .dropdown-menu[data-bs-popper]{top:auto;bottom:100%;margin-top:0;margin-bottom:var(--bs-dropdown-spacer)}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropend .dropdown-menu[data-bs-popper]{top:0;right:auto;left:100%;margin-top:0;margin-left:var(--bs-dropdown-spacer)}.dropend .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropend .dropdown-toggle:empty::after{margin-left:0}.dropend .dropdown-toggle::after{vertical-align:0}.dropstart .dropdown-menu[data-bs-popper]{top:0;right:100%;left:auto;margin-top:0;margin-right:var(--bs-dropdown-spacer)}.dropstart .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropstart .dropdown-toggle::after{display:none}.dropstart .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropstart .dropdown-toggle:empty::after{margin-left:0}.dropstart .dropdown-toggle::before{vertical-align:0}.dropdown-divider{height:0;margin:var(--bs-dropdown-divider-margin-y) 0;overflow:hidden;border-top:1px solid var(--bs-dropdown-divider-bg);opacity:1}.dropdown-item{display:block;width:100%;padding:var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);clear:both;font-weight:400;color:var(--bs-dropdown-link-color);text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0;border-radius:var(--bs-dropdown-item-border-radius,0)}.dropdown-item:focus,.dropdown-item:hover{color:var(--bs-dropdown-link-hover-color);background-color:var(--bs-dropdown-link-hover-bg)}.dropdown-item.active,.dropdown-item:active{color:var(--bs-dropdown-link-active-color);text-decoration:none;background-color:var(--bs-dropdown-link-active-bg)}.dropdown-item.disabled,.dropdown-item:disabled{color:var(--bs-dropdown-link-disabled-color);pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);margin-bottom:0;font-size:.875rem;color:var(--bs-dropdown-header-color);white-space:nowrap}.dropdown-item-text{display:block;padding:var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);color:var(--bs-dropdown-link-color)}.dropdown-menu-dark{--bs-dropdown-color:#dee2e6;--bs-dropdown-bg:#343a40;--bs-dropdown-border-color:var(--bs-border-color-translucent);--bs-dropdown-box-shadow: ;--bs-dropdown-link-color:#dee2e6;--bs-dropdown-link-hover-color:#fff;--bs-dropdown-divider-bg:var(--bs-border-color-translucent);--bs-dropdown-link-hover-bg:rgba(255, 255, 255, 0.15);--bs-dropdown-link-active-color:#fff;--bs-dropdown-link-active-bg:#0d6efd;--bs-dropdown-link-disabled-color:#adb5bd;--bs-dropdown-header-color:#adb5bd}.btn-group,.btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;flex:1 1 auto}.btn-group-vertical>.btn-check:checked+.btn,.btn-group-vertical>.btn-check:focus+.btn,.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn-check:checked+.btn,.btn-group>.btn-check:focus+.btn,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group{border-radius:var(--bs-border-radius)}.btn-group>.btn-group:not(:first-child),.btn-group>:not(.btn-check:first-child)+.btn{margin-left:calc(var(--bs-border-width) * -1)}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn.dropdown-toggle-split:first-child,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:nth-child(n+3),.btn-group>:not(.btn-check)+.btn{border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropend .dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after{margin-left:0}.dropstart .dropdown-toggle-split::before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn-group:not(:first-child),.btn-group-vertical>.btn:not(:first-child){margin-top:calc(var(--bs-border-width) * -1)}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn~.btn{border-top-left-radius:0;border-top-right-radius:0}.nav{--bs-nav-link-padding-x:1rem;--bs-nav-link-padding-y:0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color:var(--bs-link-color);--bs-nav-link-hover-color:var(--bs-link-hover-color);--bs-nav-link-disabled-color:var(--bs-secondary-color);display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);font-size:var(--bs-nav-link-font-size);font-weight:var(--bs-nav-link-font-weight);color:var(--bs-nav-link-color);text-decoration:none;background:0 0;border:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link{transition:none}}.nav-link:focus,.nav-link:hover{color:var(--bs-nav-link-hover-color)}.nav-link:focus-visible{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.nav-link.disabled,.nav-link:disabled{color:var(--bs-nav-link-disabled-color);pointer-events:none;cursor:default}.nav-tabs{--bs-nav-tabs-border-width:var(--bs-border-width);--bs-nav-tabs-border-color:var(--bs-border-color);--bs-nav-tabs-border-radius:var(--bs-border-radius);--bs-nav-tabs-link-hover-border-color:var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);--bs-nav-tabs-link-active-color:var(--bs-emphasis-color);--bs-nav-tabs-link-active-bg:var(--bs-body-bg);--bs-nav-tabs-link-active-border-color:var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);border-bottom:var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color)}.nav-tabs .nav-link{margin-bottom:calc(-1 * var(--bs-nav-tabs-border-width));border:var(--bs-nav-tabs-border-width) solid transparent;border-top-left-radius:var(--bs-nav-tabs-border-radius);border-top-right-radius:var(--bs-nav-tabs-border-radius)}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{isolation:isolate;border-color:var(--bs-nav-tabs-link-hover-border-color)}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:var(--bs-nav-tabs-link-active-color);background-color:var(--bs-nav-tabs-link-active-bg);border-color:var(--bs-nav-tabs-link-active-border-color)}.nav-tabs .dropdown-menu{margin-top:calc(-1 * var(--bs-nav-tabs-border-width));border-top-left-radius:0;border-top-right-radius:0}.nav-pills{--bs-nav-pills-border-radius:var(--bs-border-radius);--bs-nav-pills-link-active-color:#fff;--bs-nav-pills-link-active-bg:#0d6efd}.nav-pills .nav-link{border-radius:var(--bs-nav-pills-border-radius)}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:var(--bs-nav-pills-link-active-color);background-color:var(--bs-nav-pills-link-active-bg)}.nav-underline{--bs-nav-underline-gap:1rem;--bs-nav-underline-border-width:0.125rem;--bs-nav-underline-link-active-color:var(--bs-emphasis-color);gap:var(--bs-nav-underline-gap)}.nav-underline .nav-link{padding-right:0;padding-left:0;border-bottom:var(--bs-nav-underline-border-width) solid transparent}.nav-underline .nav-link:focus,.nav-underline .nav-link:hover{border-bottom-color:currentcolor}.nav-underline .nav-link.active,.nav-underline .show>.nav-link{font-weight:700;color:var(--bs-nav-underline-link-active-color);border-bottom-color:currentcolor}.nav-fill .nav-item,.nav-fill>.nav-link{flex:1 1 auto;text-align:center}.nav-justified .nav-item,.nav-justified>.nav-link{flex-basis:0;flex-grow:1;text-align:center}.nav-fill .nav-item .nav-link,.nav-justified .nav-item .nav-link{width:100%}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{--bs-navbar-padding-x:0;--bs-navbar-padding-y:0.5rem;--bs-navbar-color:rgba(var(--bs-emphasis-color-rgb), 0.65);--bs-navbar-hover-color:rgba(var(--bs-emphasis-color-rgb), 0.8);--bs-navbar-disabled-color:rgba(var(--bs-emphasis-color-rgb), 0.3);--bs-navbar-active-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-padding-y:0.3125rem;--bs-navbar-brand-margin-end:1rem;--bs-navbar-brand-font-size:1.25rem;--bs-navbar-brand-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-hover-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-nav-link-padding-x:0.5rem;--bs-navbar-toggler-padding-y:0.25rem;--bs-navbar-toggler-padding-x:0.75rem;--bs-navbar-toggler-font-size:1.25rem;--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");--bs-navbar-toggler-border-color:rgba(var(--bs-emphasis-color-rgb), 0.15);--bs-navbar-toggler-border-radius:var(--bs-border-radius);--bs-navbar-toggler-focus-width:0.25rem;--bs-navbar-toggler-transition:box-shadow 0.15s ease-in-out;position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)}.navbar>.container,.navbar>.container-fluid,.navbar>.container-lg,.navbar>.container-md,.navbar>.container-sm,.navbar>.container-xl,.navbar>.container-xxl{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand{padding-top:var(--bs-navbar-brand-padding-y);padding-bottom:var(--bs-navbar-brand-padding-y);margin-right:var(--bs-navbar-brand-margin-end);font-size:var(--bs-navbar-brand-font-size);color:var(--bs-navbar-brand-color);text-decoration:none;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{color:var(--bs-navbar-brand-hover-color)}.navbar-nav{--bs-nav-link-padding-x:0;--bs-nav-link-padding-y:0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color:var(--bs-navbar-color);--bs-nav-link-hover-color:var(--bs-navbar-hover-color);--bs-nav-link-disabled-color:var(--bs-navbar-disabled-color);display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link.active,.navbar-nav .nav-link.show{color:var(--bs-navbar-active-color)}.navbar-nav .dropdown-menu{position:static}.navbar-text{padding-top:.5rem;padding-bottom:.5rem;color:var(--bs-navbar-color)}.navbar-text a,.navbar-text a:focus,.navbar-text a:hover{color:var(--bs-navbar-active-color)}.navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler{padding:var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);font-size:var(--bs-navbar-toggler-font-size);line-height:1;color:var(--bs-navbar-color);background-color:transparent;border:var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);border-radius:var(--bs-navbar-toggler-border-radius);transition:var(--bs-navbar-toggler-transition)}@media (prefers-reduced-motion:reduce){.navbar-toggler{transition:none}}.navbar-toggler:hover{text-decoration:none}.navbar-toggler:focus{text-decoration:none;outline:0;box-shadow:0 0 0 var(--bs-navbar-toggler-focus-width)}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-image:var(--bs-navbar-toggler-icon-bg);background-repeat:no-repeat;background-position:center;background-size:100%}.navbar-nav-scroll{max-height:var(--bs-scroll-height,75vh);overflow-y:auto}@media (min-width:576px){.navbar-expand-sm{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-sm .navbar-nav{flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-sm .navbar-nav-scroll{overflow:visible}.navbar-expand-sm .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-sm .offcanvas .offcanvas-header{display:none}.navbar-expand-sm .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:768px){.navbar-expand-md{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-md .navbar-nav{flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-md .navbar-nav-scroll{overflow:visible}.navbar-expand-md .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-md .offcanvas .offcanvas-header{display:none}.navbar-expand-md .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:992px){.navbar-expand-lg{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav{flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-lg .navbar-nav-scroll{overflow:visible}.navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-lg .offcanvas .offcanvas-header{display:none}.navbar-expand-lg .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1200px){.navbar-expand-xl{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xl .navbar-nav{flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-xl .navbar-nav-scroll{overflow:visible}.navbar-expand-xl .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-xl .offcanvas .offcanvas-header{display:none}.navbar-expand-xl .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}@media (min-width:1400px){.navbar-expand-xxl{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-xxl .navbar-nav{flex-direction:row}.navbar-expand-xxl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xxl .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-xxl .navbar-nav-scroll{overflow:visible}.navbar-expand-xxl .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-xxl .navbar-toggler{display:none}.navbar-expand-xxl .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand-xxl .offcanvas .offcanvas-header{display:none}.navbar-expand-xxl .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}}.navbar-expand{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand .navbar-nav{flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand .navbar-nav-scroll{overflow:visible}.navbar-expand .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}.navbar-expand .offcanvas .offcanvas-header{display:none}.navbar-expand .offcanvas .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible}.navbar-dark,.navbar[data-bs-theme=dark]{--bs-navbar-color:rgba(255, 255, 255, 0.55);--bs-navbar-hover-color:rgba(255, 255, 255, 0.75);--bs-navbar-disabled-color:rgba(255, 255, 255, 0.25);--bs-navbar-active-color:#fff;--bs-navbar-brand-color:#fff;--bs-navbar-brand-hover-color:#fff;--bs-navbar-toggler-border-color:rgba(255, 255, 255, 0.1);--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}[data-bs-theme=dark] .navbar-toggler-icon{--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.card{--bs-card-spacer-y:1rem;--bs-card-spacer-x:1rem;--bs-card-title-spacer-y:0.5rem;--bs-card-title-color: ;--bs-card-subtitle-color: ;--bs-card-border-width:var(--bs-border-width);--bs-card-border-color:var(--bs-border-color-translucent);--bs-card-border-radius:var(--bs-border-radius);--bs-card-box-shadow: ;--bs-card-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));--bs-card-cap-padding-y:0.5rem;--bs-card-cap-padding-x:1rem;--bs-card-cap-bg:rgba(var(--bs-body-color-rgb), 0.03);--bs-card-cap-color: ;--bs-card-height: ;--bs-card-color: ;--bs-card-bg:var(--bs-body-bg);--bs-card-img-overlay-padding:1rem;--bs-card-group-margin:0.75rem;position:relative;display:flex;flex-direction:column;min-width:0;height:var(--bs-card-height);color:var(--bs-body-color);word-wrap:break-word;background-color:var(--bs-card-bg);background-clip:border-box;border:var(--bs-card-border-width) solid var(--bs-card-border-color);border-radius:var(--bs-card-border-radius)}.card>hr{margin-right:0;margin-left:0}.card>.list-group{border-top:inherit;border-bottom:inherit}.card>.list-group:first-child{border-top-width:0;border-top-left-radius:var(--bs-card-inner-border-radius);border-top-right-radius:var(--bs-card-inner-border-radius)}.card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:var(--bs-card-inner-border-radius);border-bottom-left-radius:var(--bs-card-inner-border-radius)}.card>.card-header+.list-group,.card>.list-group+.card-footer{border-top:0}.card-body{flex:1 1 auto;padding:var(--bs-card-spacer-y) var(--bs-card-spacer-x);color:var(--bs-card-color)}.card-title{margin-bottom:var(--bs-card-title-spacer-y);color:var(--bs-card-title-color)}.card-subtitle{margin-top:calc(-.5 * var(--bs-card-title-spacer-y));margin-bottom:0;color:var(--bs-card-subtitle-color)}.card-text:last-child{margin-bottom:0}.card-link+.card-link{margin-left:var(--bs-card-spacer-x)}.card-header{padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);margin-bottom:0;color:var(--bs-card-cap-color);background-color:var(--bs-card-cap-bg);border-bottom:var(--bs-card-border-width) solid var(--bs-card-border-color)}.card-header:first-child{border-radius:var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0}.card-footer{padding:var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);color:var(--bs-card-cap-color);background-color:var(--bs-card-cap-bg);border-top:var(--bs-card-border-width) solid var(--bs-card-border-color)}.card-footer:last-child{border-radius:0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius)}.card-header-tabs{margin-right:calc(-.5 * var(--bs-card-cap-padding-x));margin-bottom:calc(-1 * var(--bs-card-cap-padding-y));margin-left:calc(-.5 * var(--bs-card-cap-padding-x));border-bottom:0}.card-header-tabs .nav-link.active{background-color:var(--bs-card-bg);border-bottom-color:var(--bs-card-bg)}.card-header-pills{margin-right:calc(-.5 * var(--bs-card-cap-padding-x));margin-left:calc(-.5 * var(--bs-card-cap-padding-x))}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:var(--bs-card-img-overlay-padding);border-radius:var(--bs-card-inner-border-radius)}.card-img,.card-img-bottom,.card-img-top{width:100%}.card-img,.card-img-top{border-top-left-radius:var(--bs-card-inner-border-radius);border-top-right-radius:var(--bs-card-inner-border-radius)}.card-img,.card-img-bottom{border-bottom-right-radius:var(--bs-card-inner-border-radius);border-bottom-left-radius:var(--bs-card-inner-border-radius)}.card-group>.card{margin-bottom:var(--bs-card-group-margin)}@media (min-width:576px){.card-group{display:flex;flex-flow:row wrap}.card-group>.card{flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom{border-bottom-left-radius:0}}.accordion{--bs-accordion-color:var(--bs-body-color);--bs-accordion-bg:var(--bs-body-bg);--bs-accordion-transition:color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,border-radius 0.15s ease;--bs-accordion-border-color:var(--bs-border-color);--bs-accordion-border-width:var(--bs-border-width);--bs-accordion-border-radius:var(--bs-border-radius);--bs-accordion-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));--bs-accordion-btn-padding-x:1.25rem;--bs-accordion-btn-padding-y:1rem;--bs-accordion-btn-color:var(--bs-body-color);--bs-accordion-btn-bg:var(--bs-accordion-bg);--bs-accordion-btn-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-icon-width:1.25rem;--bs-accordion-btn-icon-transform:rotate(-180deg);--bs-accordion-btn-icon-transition:transform 0.2s ease-in-out;--bs-accordion-btn-active-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23052c65'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-focus-border-color:#86b7fe;--bs-accordion-btn-focus-box-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-accordion-body-padding-x:1.25rem;--bs-accordion-body-padding-y:1rem;--bs-accordion-active-color:var(--bs-primary-text-emphasis);--bs-accordion-active-bg:var(--bs-primary-bg-subtle)}.accordion-button{position:relative;display:flex;align-items:center;width:100%;padding:var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);font-size:1rem;color:var(--bs-accordion-btn-color);text-align:left;background-color:var(--bs-accordion-btn-bg);border:0;border-radius:0;overflow-anchor:none;transition:var(--bs-accordion-transition)}@media (prefers-reduced-motion:reduce){.accordion-button{transition:none}}.accordion-button:not(.collapsed){color:var(--bs-accordion-active-color);background-color:var(--bs-accordion-active-bg);box-shadow:inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color)}.accordion-button:not(.collapsed)::after{background-image:var(--bs-accordion-btn-active-icon);transform:var(--bs-accordion-btn-icon-transform)}.accordion-button::after{flex-shrink:0;width:var(--bs-accordion-btn-icon-width);height:var(--bs-accordion-btn-icon-width);margin-left:auto;content:\"\";background-image:var(--bs-accordion-btn-icon);background-repeat:no-repeat;background-size:var(--bs-accordion-btn-icon-width);transition:var(--bs-accordion-btn-icon-transition)}@media (prefers-reduced-motion:reduce){.accordion-button::after{transition:none}}.accordion-button:hover{z-index:2}.accordion-button:focus{z-index:3;border-color:var(--bs-accordion-btn-focus-border-color);outline:0;box-shadow:var(--bs-accordion-btn-focus-box-shadow)}.accordion-header{margin-bottom:0}.accordion-item{color:var(--bs-accordion-color);background-color:var(--bs-accordion-bg);border:var(--bs-accordion-border-width) solid var(--bs-accordion-border-color)}.accordion-item:first-of-type{border-top-left-radius:var(--bs-accordion-border-radius);border-top-right-radius:var(--bs-accordion-border-radius)}.accordion-item:first-of-type .accordion-button{border-top-left-radius:var(--bs-accordion-inner-border-radius);border-top-right-radius:var(--bs-accordion-inner-border-radius)}.accordion-item:not(:first-of-type){border-top:0}.accordion-item:last-of-type{border-bottom-right-radius:var(--bs-accordion-border-radius);border-bottom-left-radius:var(--bs-accordion-border-radius)}.accordion-item:last-of-type .accordion-button.collapsed{border-bottom-right-radius:var(--bs-accordion-inner-border-radius);border-bottom-left-radius:var(--bs-accordion-inner-border-radius)}.accordion-item:last-of-type .accordion-collapse{border-bottom-right-radius:var(--bs-accordion-border-radius);border-bottom-left-radius:var(--bs-accordion-border-radius)}.accordion-body{padding:var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x)}.accordion-flush .accordion-collapse{border-width:0}.accordion-flush .accordion-item{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item:first-child{border-top:0}.accordion-flush .accordion-item:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button,.accordion-flush .accordion-item .accordion-button.collapsed{border-radius:0}[data-bs-theme=dark] .accordion-button::after{--bs-accordion-btn-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-active-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")}.breadcrumb{--bs-breadcrumb-padding-x:0;--bs-breadcrumb-padding-y:0;--bs-breadcrumb-margin-bottom:1rem;--bs-breadcrumb-bg: ;--bs-breadcrumb-border-radius: ;--bs-breadcrumb-divider-color:var(--bs-secondary-color);--bs-breadcrumb-item-padding-x:0.5rem;--bs-breadcrumb-item-active-color:var(--bs-secondary-color);display:flex;flex-wrap:wrap;padding:var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);margin-bottom:var(--bs-breadcrumb-margin-bottom);font-size:var(--bs-breadcrumb-font-size);list-style:none;background-color:var(--bs-breadcrumb-bg);border-radius:var(--bs-breadcrumb-border-radius)}.breadcrumb-item+.breadcrumb-item{padding-left:var(--bs-breadcrumb-item-padding-x)}.breadcrumb-item+.breadcrumb-item::before{float:left;padding-right:var(--bs-breadcrumb-item-padding-x);color:var(--bs-breadcrumb-divider-color);content:var(--bs-breadcrumb-divider, \"/\")}.breadcrumb-item.active{color:var(--bs-breadcrumb-item-active-color)}.pagination{--bs-pagination-padding-x:0.75rem;--bs-pagination-padding-y:0.375rem;--bs-pagination-font-size:1rem;--bs-pagination-color:var(--bs-link-color);--bs-pagination-bg:var(--bs-body-bg);--bs-pagination-border-width:var(--bs-border-width);--bs-pagination-border-color:var(--bs-border-color);--bs-pagination-border-radius:var(--bs-border-radius);--bs-pagination-hover-color:var(--bs-link-hover-color);--bs-pagination-hover-bg:var(--bs-tertiary-bg);--bs-pagination-hover-border-color:var(--bs-border-color);--bs-pagination-focus-color:var(--bs-link-hover-color);--bs-pagination-focus-bg:var(--bs-secondary-bg);--bs-pagination-focus-box-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-pagination-active-color:#fff;--bs-pagination-active-bg:#0d6efd;--bs-pagination-active-border-color:#0d6efd;--bs-pagination-disabled-color:var(--bs-secondary-color);--bs-pagination-disabled-bg:var(--bs-secondary-bg);--bs-pagination-disabled-border-color:var(--bs-border-color);display:flex;padding-left:0;list-style:none}.page-link{position:relative;display:block;padding:var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);font-size:var(--bs-pagination-font-size);color:var(--bs-pagination-color);text-decoration:none;background-color:var(--bs-pagination-bg);border:var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.page-link{transition:none}}.page-link:hover{z-index:2;color:var(--bs-pagination-hover-color);background-color:var(--bs-pagination-hover-bg);border-color:var(--bs-pagination-hover-border-color)}.page-link:focus{z-index:3;color:var(--bs-pagination-focus-color);background-color:var(--bs-pagination-focus-bg);outline:0;box-shadow:var(--bs-pagination-focus-box-shadow)}.active>.page-link,.page-link.active{z-index:3;color:var(--bs-pagination-active-color);background-color:var(--bs-pagination-active-bg);border-color:var(--bs-pagination-active-border-color)}.disabled>.page-link,.page-link.disabled{color:var(--bs-pagination-disabled-color);pointer-events:none;background-color:var(--bs-pagination-disabled-bg);border-color:var(--bs-pagination-disabled-border-color)}.page-item:not(:first-child) .page-link{margin-left:calc(var(--bs-border-width) * -1)}.page-item:first-child .page-link{border-top-left-radius:var(--bs-pagination-border-radius);border-bottom-left-radius:var(--bs-pagination-border-radius)}.page-item:last-child .page-link{border-top-right-radius:var(--bs-pagination-border-radius);border-bottom-right-radius:var(--bs-pagination-border-radius)}.pagination-lg{--bs-pagination-padding-x:1.5rem;--bs-pagination-padding-y:0.75rem;--bs-pagination-font-size:1.25rem;--bs-pagination-border-radius:var(--bs-border-radius-lg)}.pagination-sm{--bs-pagination-padding-x:0.5rem;--bs-pagination-padding-y:0.25rem;--bs-pagination-font-size:0.875rem;--bs-pagination-border-radius:var(--bs-border-radius-sm)}.badge{--bs-badge-padding-x:0.65em;--bs-badge-padding-y:0.35em;--bs-badge-font-size:0.75em;--bs-badge-font-weight:700;--bs-badge-color:#fff;--bs-badge-border-radius:var(--bs-border-radius);display:inline-block;padding:var(--bs-badge-padding-y) var(--bs-badge-padding-x);font-size:var(--bs-badge-font-size);font-weight:var(--bs-badge-font-weight);line-height:1;color:var(--bs-badge-color);text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:var(--bs-badge-border-radius)}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.alert{--bs-alert-bg:transparent;--bs-alert-padding-x:1rem;--bs-alert-padding-y:1rem;--bs-alert-margin-bottom:1rem;--bs-alert-color:inherit;--bs-alert-border-color:transparent;--bs-alert-border:var(--bs-border-width) solid var(--bs-alert-border-color);--bs-alert-border-radius:var(--bs-border-radius);--bs-alert-link-color:inherit;position:relative;padding:var(--bs-alert-padding-y) var(--bs-alert-padding-x);margin-bottom:var(--bs-alert-margin-bottom);color:var(--bs-alert-color);background-color:var(--bs-alert-bg);border:var(--bs-alert-border);border-radius:var(--bs-alert-border-radius)}.alert-heading{color:inherit}.alert-link{font-weight:700;color:var(--bs-alert-link-color)}.alert-dismissible{padding-right:3rem}.alert-dismissible .btn-close{position:absolute;top:0;right:0;z-index:2;padding:1.25rem 1rem}.alert-primary{--bs-alert-color:var(--bs-primary-text-emphasis);--bs-alert-bg:var(--bs-primary-bg-subtle);--bs-alert-border-color:var(--bs-primary-border-subtle);--bs-alert-link-color:var(--bs-primary-text-emphasis)}.alert-secondary{--bs-alert-color:var(--bs-secondary-text-emphasis);--bs-alert-bg:var(--bs-secondary-bg-subtle);--bs-alert-border-color:var(--bs-secondary-border-subtle);--bs-alert-link-color:var(--bs-secondary-text-emphasis)}.alert-success{--bs-alert-color:var(--bs-success-text-emphasis);--bs-alert-bg:var(--bs-success-bg-subtle);--bs-alert-border-color:var(--bs-success-border-subtle);--bs-alert-link-color:var(--bs-success-text-emphasis)}.alert-info{--bs-alert-color:var(--bs-info-text-emphasis);--bs-alert-bg:var(--bs-info-bg-subtle);--bs-alert-border-color:var(--bs-info-border-subtle);--bs-alert-link-color:var(--bs-info-text-emphasis)}.alert-warning{--bs-alert-color:var(--bs-warning-text-emphasis);--bs-alert-bg:var(--bs-warning-bg-subtle);--bs-alert-border-color:var(--bs-warning-border-subtle);--bs-alert-link-color:var(--bs-warning-text-emphasis)}.alert-danger{--bs-alert-color:var(--bs-danger-text-emphasis);--bs-alert-bg:var(--bs-danger-bg-subtle);--bs-alert-border-color:var(--bs-danger-border-subtle);--bs-alert-link-color:var(--bs-danger-text-emphasis)}.alert-light{--bs-alert-color:var(--bs-light-text-emphasis);--bs-alert-bg:var(--bs-light-bg-subtle);--bs-alert-border-color:var(--bs-light-border-subtle);--bs-alert-link-color:var(--bs-light-text-emphasis)}.alert-dark{--bs-alert-color:var(--bs-dark-text-emphasis);--bs-alert-bg:var(--bs-dark-bg-subtle);--bs-alert-border-color:var(--bs-dark-border-subtle);--bs-alert-link-color:var(--bs-dark-text-emphasis)}@keyframes progress-bar-stripes{0%{background-position-x:1rem}}.progress,.progress-stacked{--bs-progress-height:1rem;--bs-progress-font-size:0.75rem;--bs-progress-bg:var(--bs-secondary-bg);--bs-progress-border-radius:var(--bs-border-radius);--bs-progress-box-shadow:var(--bs-box-shadow-inset);--bs-progress-bar-color:#fff;--bs-progress-bar-bg:#0d6efd;--bs-progress-bar-transition:width 0.6s ease;display:flex;height:var(--bs-progress-height);overflow:hidden;font-size:var(--bs-progress-font-size);background-color:var(--bs-progress-bg);border-radius:var(--bs-progress-border-radius)}.progress-bar{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:var(--bs-progress-bar-color);text-align:center;white-space:nowrap;background-color:var(--bs-progress-bar-bg);transition:var(--bs-progress-bar-transition)}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:var(--bs-progress-height) var(--bs-progress-height)}.progress-stacked>.progress{overflow:visible}.progress-stacked>.progress>.progress-bar{width:100%}.progress-bar-animated{animation:1s linear infinite progress-bar-stripes}@media (prefers-reduced-motion:reduce){.progress-bar-animated{animation:none}}.list-group{--bs-list-group-color:var(--bs-body-color);--bs-list-group-bg:var(--bs-body-bg);--bs-list-group-border-color:var(--bs-border-color);--bs-list-group-border-width:var(--bs-border-width);--bs-list-group-border-radius:var(--bs-border-radius);--bs-list-group-item-padding-x:1rem;--bs-list-group-item-padding-y:0.5rem;--bs-list-group-action-color:var(--bs-secondary-color);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-tertiary-bg);--bs-list-group-action-active-color:var(--bs-body-color);--bs-list-group-action-active-bg:var(--bs-secondary-bg);--bs-list-group-disabled-color:var(--bs-secondary-color);--bs-list-group-disabled-bg:var(--bs-body-bg);--bs-list-group-active-color:#fff;--bs-list-group-active-bg:#0d6efd;--bs-list-group-active-border-color:#0d6efd;display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:var(--bs-list-group-border-radius)}.list-group-numbered{list-style-type:none;counter-reset:section}.list-group-numbered>.list-group-item::before{content:counters(section, \".\") \". \";counter-increment:section}.list-group-item-action{width:100%;color:var(--bs-list-group-action-color);text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{z-index:1;color:var(--bs-list-group-action-hover-color);text-decoration:none;background-color:var(--bs-list-group-action-hover-bg)}.list-group-item-action:active{color:var(--bs-list-group-action-active-color);background-color:var(--bs-list-group-action-active-bg)}.list-group-item{position:relative;display:block;padding:var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);color:var(--bs-list-group-color);text-decoration:none;background-color:var(--bs-list-group-bg);border:var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)}.list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled,.list-group-item:disabled{color:var(--bs-list-group-disabled-color);pointer-events:none;background-color:var(--bs-list-group-disabled-bg)}.list-group-item.active{z-index:2;color:var(--bs-list-group-active-color);background-color:var(--bs-list-group-active-bg);border-color:var(--bs-list-group-active-border-color)}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:calc(-1 * var(--bs-list-group-border-width));border-top-width:var(--bs-list-group-border-width)}.list-group-horizontal{flex-direction:row}.list-group-horizontal>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}@media (min-width:576px){.list-group-horizontal-sm{flex-direction:row}.list-group-horizontal-sm>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:768px){.list-group-horizontal-md{flex-direction:row}.list-group-horizontal-md>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-md>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:992px){.list-group-horizontal-lg{flex-direction:row}.list-group-horizontal-lg>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:1200px){.list-group-horizontal-xl{flex-direction:row}.list-group-horizontal-xl>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}@media (min-width:1400px){.list-group-horizontal-xxl{flex-direction:row}.list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child){border-bottom-left-radius:var(--bs-list-group-border-radius);border-top-right-radius:0}.list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child){border-top-right-radius:var(--bs-list-group-border-radius);border-bottom-left-radius:0}.list-group-horizontal-xxl>.list-group-item.active{margin-top:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item{border-top-width:var(--bs-list-group-border-width);border-left-width:0}.list-group-horizontal-xxl>.list-group-item+.list-group-item.active{margin-left:calc(-1 * var(--bs-list-group-border-width));border-left-width:var(--bs-list-group-border-width)}}.list-group-flush{border-radius:0}.list-group-flush>.list-group-item{border-width:0 0 var(--bs-list-group-border-width)}.list-group-flush>.list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{--bs-list-group-color:var(--bs-primary-text-emphasis);--bs-list-group-bg:var(--bs-primary-bg-subtle);--bs-list-group-border-color:var(--bs-primary-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-primary-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-primary-border-subtle);--bs-list-group-active-color:var(--bs-primary-bg-subtle);--bs-list-group-active-bg:var(--bs-primary-text-emphasis);--bs-list-group-active-border-color:var(--bs-primary-text-emphasis)}.list-group-item-secondary{--bs-list-group-color:var(--bs-secondary-text-emphasis);--bs-list-group-bg:var(--bs-secondary-bg-subtle);--bs-list-group-border-color:var(--bs-secondary-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-secondary-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-secondary-border-subtle);--bs-list-group-active-color:var(--bs-secondary-bg-subtle);--bs-list-group-active-bg:var(--bs-secondary-text-emphasis);--bs-list-group-active-border-color:var(--bs-secondary-text-emphasis)}.list-group-item-success{--bs-list-group-color:var(--bs-success-text-emphasis);--bs-list-group-bg:var(--bs-success-bg-subtle);--bs-list-group-border-color:var(--bs-success-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-success-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-success-border-subtle);--bs-list-group-active-color:var(--bs-success-bg-subtle);--bs-list-group-active-bg:var(--bs-success-text-emphasis);--bs-list-group-active-border-color:var(--bs-success-text-emphasis)}.list-group-item-info{--bs-list-group-color:var(--bs-info-text-emphasis);--bs-list-group-bg:var(--bs-info-bg-subtle);--bs-list-group-border-color:var(--bs-info-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-info-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-info-border-subtle);--bs-list-group-active-color:var(--bs-info-bg-subtle);--bs-list-group-active-bg:var(--bs-info-text-emphasis);--bs-list-group-active-border-color:var(--bs-info-text-emphasis)}.list-group-item-warning{--bs-list-group-color:var(--bs-warning-text-emphasis);--bs-list-group-bg:var(--bs-warning-bg-subtle);--bs-list-group-border-color:var(--bs-warning-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-warning-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-warning-border-subtle);--bs-list-group-active-color:var(--bs-warning-bg-subtle);--bs-list-group-active-bg:var(--bs-warning-text-emphasis);--bs-list-group-active-border-color:var(--bs-warning-text-emphasis)}.list-group-item-danger{--bs-list-group-color:var(--bs-danger-text-emphasis);--bs-list-group-bg:var(--bs-danger-bg-subtle);--bs-list-group-border-color:var(--bs-danger-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-danger-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-danger-border-subtle);--bs-list-group-active-color:var(--bs-danger-bg-subtle);--bs-list-group-active-bg:var(--bs-danger-text-emphasis);--bs-list-group-active-border-color:var(--bs-danger-text-emphasis)}.list-group-item-light{--bs-list-group-color:var(--bs-light-text-emphasis);--bs-list-group-bg:var(--bs-light-bg-subtle);--bs-list-group-border-color:var(--bs-light-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-light-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-light-border-subtle);--bs-list-group-active-color:var(--bs-light-bg-subtle);--bs-list-group-active-bg:var(--bs-light-text-emphasis);--bs-list-group-active-border-color:var(--bs-light-text-emphasis)}.list-group-item-dark{--bs-list-group-color:var(--bs-dark-text-emphasis);--bs-list-group-bg:var(--bs-dark-bg-subtle);--bs-list-group-border-color:var(--bs-dark-border-subtle);--bs-list-group-action-hover-color:var(--bs-emphasis-color);--bs-list-group-action-hover-bg:var(--bs-dark-border-subtle);--bs-list-group-action-active-color:var(--bs-emphasis-color);--bs-list-group-action-active-bg:var(--bs-dark-border-subtle);--bs-list-group-active-color:var(--bs-dark-bg-subtle);--bs-list-group-active-bg:var(--bs-dark-text-emphasis);--bs-list-group-active-border-color:var(--bs-dark-text-emphasis)}.btn-close{--bs-btn-close-color:#000;--bs-btn-close-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");--bs-btn-close-opacity:0.5;--bs-btn-close-hover-opacity:0.75;--bs-btn-close-focus-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-btn-close-focus-opacity:1;--bs-btn-close-disabled-opacity:0.25;--bs-btn-close-white-filter:invert(1) grayscale(100%) brightness(200%);box-sizing:content-box;width:1em;height:1em;padding:.25em .25em;color:var(--bs-btn-close-color);background:transparent var(--bs-btn-close-bg) center/1em auto no-repeat;border:0;border-radius:.375rem;opacity:var(--bs-btn-close-opacity)}.btn-close:hover{color:var(--bs-btn-close-color);text-decoration:none;opacity:var(--bs-btn-close-hover-opacity)}.btn-close:focus{outline:0;box-shadow:var(--bs-btn-close-focus-shadow);opacity:var(--bs-btn-close-focus-opacity)}.btn-close.disabled,.btn-close:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:var(--bs-btn-close-disabled-opacity)}.btn-close-white{filter:var(--bs-btn-close-white-filter)}[data-bs-theme=dark] .btn-close{filter:var(--bs-btn-close-white-filter)}.toast{--bs-toast-zindex:1090;--bs-toast-padding-x:0.75rem;--bs-toast-padding-y:0.5rem;--bs-toast-spacing:1.5rem;--bs-toast-max-width:350px;--bs-toast-font-size:0.875rem;--bs-toast-color: ;--bs-toast-bg:rgba(var(--bs-body-bg-rgb), 0.85);--bs-toast-border-width:var(--bs-border-width);--bs-toast-border-color:var(--bs-border-color-translucent);--bs-toast-border-radius:var(--bs-border-radius);--bs-toast-box-shadow:var(--bs-box-shadow);--bs-toast-header-color:var(--bs-secondary-color);--bs-toast-header-bg:rgba(var(--bs-body-bg-rgb), 0.85);--bs-toast-header-border-color:var(--bs-border-color-translucent);width:var(--bs-toast-max-width);max-width:100%;font-size:var(--bs-toast-font-size);color:var(--bs-toast-color);pointer-events:auto;background-color:var(--bs-toast-bg);background-clip:padding-box;border:var(--bs-toast-border-width) solid var(--bs-toast-border-color);box-shadow:var(--bs-toast-box-shadow);border-radius:var(--bs-toast-border-radius)}.toast.showing{opacity:0}.toast:not(.show){display:none}.toast-container{--bs-toast-zindex:1090;position:absolute;z-index:var(--bs-toast-zindex);width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:100%;pointer-events:none}.toast-container>:not(:last-child){margin-bottom:var(--bs-toast-spacing)}.toast-header{display:flex;align-items:center;padding:var(--bs-toast-padding-y) var(--bs-toast-padding-x);color:var(--bs-toast-header-color);background-color:var(--bs-toast-header-bg);background-clip:padding-box;border-bottom:var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);border-top-left-radius:calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));border-top-right-radius:calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width))}.toast-header .btn-close{margin-right:calc(-.5 * var(--bs-toast-padding-x));margin-left:var(--bs-toast-padding-x)}.toast-body{padding:var(--bs-toast-padding-x);word-wrap:break-word}.modal{--bs-modal-zindex:1055;--bs-modal-width:500px;--bs-modal-padding:1rem;--bs-modal-margin:0.5rem;--bs-modal-color: ;--bs-modal-bg:var(--bs-body-bg);--bs-modal-border-color:var(--bs-border-color-translucent);--bs-modal-border-width:var(--bs-border-width);--bs-modal-border-radius:var(--bs-border-radius-lg);--bs-modal-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-modal-inner-border-radius:calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));--bs-modal-header-padding-x:1rem;--bs-modal-header-padding-y:1rem;--bs-modal-header-padding:1rem 1rem;--bs-modal-header-border-color:var(--bs-border-color);--bs-modal-header-border-width:var(--bs-border-width);--bs-modal-title-line-height:1.5;--bs-modal-footer-gap:0.5rem;--bs-modal-footer-bg: ;--bs-modal-footer-border-color:var(--bs-border-color);--bs-modal-footer-border-width:var(--bs-border-width);position:fixed;top:0;left:0;z-index:var(--bs-modal-zindex);display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-dialog{position:relative;width:auto;margin:var(--bs-modal-margin);pointer-events:none}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{transform:none}.modal.modal-static .modal-dialog{transform:scale(1.02)}.modal-dialog-scrollable{height:calc(100% - var(--bs-modal-margin) * 2)}.modal-dialog-scrollable .modal-content{max-height:100%;overflow:hidden}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - var(--bs-modal-margin) * 2)}.modal-content{position:relative;display:flex;flex-direction:column;width:100%;color:var(--bs-modal-color);pointer-events:auto;background-color:var(--bs-modal-bg);background-clip:padding-box;border:var(--bs-modal-border-width) solid var(--bs-modal-border-color);border-radius:var(--bs-modal-border-radius);outline:0}.modal-backdrop{--bs-backdrop-zindex:1050;--bs-backdrop-bg:#000;--bs-backdrop-opacity:0.5;position:fixed;top:0;left:0;z-index:var(--bs-backdrop-zindex);width:100vw;height:100vh;background-color:var(--bs-backdrop-bg)}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:var(--bs-backdrop-opacity)}.modal-header{display:flex;flex-shrink:0;align-items:center;justify-content:space-between;padding:var(--bs-modal-header-padding);border-bottom:var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);border-top-left-radius:var(--bs-modal-inner-border-radius);border-top-right-radius:var(--bs-modal-inner-border-radius)}.modal-header .btn-close{padding:calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);margin:calc(-.5 * var(--bs-modal-header-padding-y)) calc(-.5 * var(--bs-modal-header-padding-x)) calc(-.5 * var(--bs-modal-header-padding-y)) auto}.modal-title{margin-bottom:0;line-height:var(--bs-modal-title-line-height)}.modal-body{position:relative;flex:1 1 auto;padding:var(--bs-modal-padding)}.modal-footer{display:flex;flex-shrink:0;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);background-color:var(--bs-modal-footer-bg);border-top:var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);border-bottom-right-radius:var(--bs-modal-inner-border-radius);border-bottom-left-radius:var(--bs-modal-inner-border-radius)}.modal-footer>*{margin:calc(var(--bs-modal-footer-gap) * .5)}@media (min-width:576px){.modal{--bs-modal-margin:1.75rem;--bs-modal-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15)}.modal-dialog{max-width:var(--bs-modal-width);margin-right:auto;margin-left:auto}.modal-sm{--bs-modal-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{--bs-modal-width:800px}}@media (min-width:1200px){.modal-xl{--bs-modal-width:1140px}}.modal-fullscreen{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen .modal-footer,.modal-fullscreen .modal-header{border-radius:0}.modal-fullscreen .modal-body{overflow-y:auto}@media (max-width:575.98px){.modal-fullscreen-sm-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-sm-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-sm-down .modal-footer,.modal-fullscreen-sm-down .modal-header{border-radius:0}.modal-fullscreen-sm-down .modal-body{overflow-y:auto}}@media (max-width:767.98px){.modal-fullscreen-md-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-md-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-md-down .modal-footer,.modal-fullscreen-md-down .modal-header{border-radius:0}.modal-fullscreen-md-down .modal-body{overflow-y:auto}}@media (max-width:991.98px){.modal-fullscreen-lg-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-lg-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-lg-down .modal-footer,.modal-fullscreen-lg-down .modal-header{border-radius:0}.modal-fullscreen-lg-down .modal-body{overflow-y:auto}}@media (max-width:1199.98px){.modal-fullscreen-xl-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xl-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-xl-down .modal-footer,.modal-fullscreen-xl-down .modal-header{border-radius:0}.modal-fullscreen-xl-down .modal-body{overflow-y:auto}}@media (max-width:1399.98px){.modal-fullscreen-xxl-down{width:100vw;max-width:none;height:100%;margin:0}.modal-fullscreen-xxl-down .modal-content{height:100%;border:0;border-radius:0}.modal-fullscreen-xxl-down .modal-footer,.modal-fullscreen-xxl-down .modal-header{border-radius:0}.modal-fullscreen-xxl-down .modal-body{overflow-y:auto}}.tooltip{--bs-tooltip-zindex:1080;--bs-tooltip-max-width:200px;--bs-tooltip-padding-x:0.5rem;--bs-tooltip-padding-y:0.25rem;--bs-tooltip-margin: ;--bs-tooltip-font-size:0.875rem;--bs-tooltip-color:var(--bs-body-bg);--bs-tooltip-bg:var(--bs-emphasis-color);--bs-tooltip-border-radius:var(--bs-border-radius);--bs-tooltip-opacity:0.9;--bs-tooltip-arrow-width:0.8rem;--bs-tooltip-arrow-height:0.4rem;z-index:var(--bs-tooltip-zindex);display:block;margin:var(--bs-tooltip-margin);font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:var(--bs-tooltip-font-size);word-wrap:break-word;opacity:0}.tooltip.show{opacity:var(--bs-tooltip-opacity)}.tooltip .tooltip-arrow{display:block;width:var(--bs-tooltip-arrow-width);height:var(--bs-tooltip-arrow-height)}.tooltip .tooltip-arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow,.bs-tooltip-top .tooltip-arrow{bottom:calc(-1 * var(--bs-tooltip-arrow-height))}.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,.bs-tooltip-top .tooltip-arrow::before{top:-1px;border-width:var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;border-top-color:var(--bs-tooltip-bg)}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow,.bs-tooltip-end .tooltip-arrow{left:calc(-1 * var(--bs-tooltip-arrow-height));width:var(--bs-tooltip-arrow-height);height:var(--bs-tooltip-arrow-width)}.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before,.bs-tooltip-end .tooltip-arrow::before{right:-1px;border-width:calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;border-right-color:var(--bs-tooltip-bg)}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow,.bs-tooltip-bottom .tooltip-arrow{top:calc(-1 * var(--bs-tooltip-arrow-height))}.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before,.bs-tooltip-bottom .tooltip-arrow::before{bottom:-1px;border-width:0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);border-bottom-color:var(--bs-tooltip-bg)}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow,.bs-tooltip-start .tooltip-arrow{right:calc(-1 * var(--bs-tooltip-arrow-height));width:var(--bs-tooltip-arrow-height);height:var(--bs-tooltip-arrow-width)}.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before,.bs-tooltip-start .tooltip-arrow::before{left:-1px;border-width:calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);border-left-color:var(--bs-tooltip-bg)}.tooltip-inner{max-width:var(--bs-tooltip-max-width);padding:var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);color:var(--bs-tooltip-color);text-align:center;background-color:var(--bs-tooltip-bg);border-radius:var(--bs-tooltip-border-radius)}.popover{--bs-popover-zindex:1070;--bs-popover-max-width:276px;--bs-popover-font-size:0.875rem;--bs-popover-bg:var(--bs-body-bg);--bs-popover-border-width:var(--bs-border-width);--bs-popover-border-color:var(--bs-border-color-translucent);--bs-popover-border-radius:var(--bs-border-radius-lg);--bs-popover-inner-border-radius:calc(var(--bs-border-radius-lg) - var(--bs-border-width));--bs-popover-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-popover-header-padding-x:1rem;--bs-popover-header-padding-y:0.5rem;--bs-popover-header-font-size:1rem;--bs-popover-header-color:inherit;--bs-popover-header-bg:var(--bs-secondary-bg);--bs-popover-body-padding-x:1rem;--bs-popover-body-padding-y:1rem;--bs-popover-body-color:var(--bs-body-color);--bs-popover-arrow-width:1rem;--bs-popover-arrow-height:0.5rem;--bs-popover-arrow-border:var(--bs-popover-border-color);z-index:var(--bs-popover-zindex);display:block;max-width:var(--bs-popover-max-width);font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:var(--bs-popover-font-size);word-wrap:break-word;background-color:var(--bs-popover-bg);background-clip:padding-box;border:var(--bs-popover-border-width) solid var(--bs-popover-border-color);border-radius:var(--bs-popover-border-radius)}.popover .popover-arrow{display:block;width:var(--bs-popover-arrow-width);height:var(--bs-popover-arrow-height)}.popover .popover-arrow::after,.popover .popover-arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid;border-width:0}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow,.bs-popover-top>.popover-arrow{bottom:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,.bs-popover-top>.popover-arrow::after,.bs-popover-top>.popover-arrow::before{border-width:var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,.bs-popover-top>.popover-arrow::before{bottom:0;border-top-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after,.bs-popover-top>.popover-arrow::after{bottom:var(--bs-popover-border-width);border-top-color:var(--bs-popover-bg)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow,.bs-popover-end>.popover-arrow{left:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));width:var(--bs-popover-arrow-height);height:var(--bs-popover-arrow-width)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,.bs-popover-end>.popover-arrow::after,.bs-popover-end>.popover-arrow::before{border-width:calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,.bs-popover-end>.popover-arrow::before{left:0;border-right-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after,.bs-popover-end>.popover-arrow::after{left:var(--bs-popover-border-width);border-right-color:var(--bs-popover-bg)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow,.bs-popover-bottom>.popover-arrow{top:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width))}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,.bs-popover-bottom>.popover-arrow::after,.bs-popover-bottom>.popover-arrow::before{border-width:0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,.bs-popover-bottom>.popover-arrow::before{top:0;border-bottom-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after,.bs-popover-bottom>.popover-arrow::after{top:var(--bs-popover-border-width);border-bottom-color:var(--bs-popover-bg)}.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:var(--bs-popover-arrow-width);margin-left:calc(-.5 * var(--bs-popover-arrow-width));content:\"\";border-bottom:var(--bs-popover-border-width) solid var(--bs-popover-header-bg)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow,.bs-popover-start>.popover-arrow{right:calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));width:var(--bs-popover-arrow-height);height:var(--bs-popover-arrow-width)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after,.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,.bs-popover-start>.popover-arrow::after,.bs-popover-start>.popover-arrow::before{border-width:calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,.bs-popover-start>.popover-arrow::before{right:0;border-left-color:var(--bs-popover-arrow-border)}.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after,.bs-popover-start>.popover-arrow::after{right:var(--bs-popover-border-width);border-left-color:var(--bs-popover-bg)}.popover-header{padding:var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);margin-bottom:0;font-size:var(--bs-popover-header-font-size);color:var(--bs-popover-header-color);background-color:var(--bs-popover-header-bg);border-bottom:var(--bs-popover-border-width) solid var(--bs-popover-border-color);border-top-left-radius:var(--bs-popover-inner-border-radius);border-top-right-radius:var(--bs-popover-inner-border-radius)}.popover-header:empty{display:none}.popover-body{padding:var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);color:var(--bs-popover-body-color)}.carousel{position:relative}.carousel.pointer-event{touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:\"\"}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item{transition:none}}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.active.carousel-item-end,.carousel-item-next:not(.carousel-item-start){transform:translateX(100%)}.active.carousel-item-start,.carousel-item-prev:not(.carousel-item-end){transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;transform:none}.carousel-fade .carousel-item-next.carousel-item-start,.carousel-fade .carousel-item-prev.carousel-item-end,.carousel-fade .carousel-item.active{z-index:1;opacity:1}.carousel-fade .active.carousel-item-end,.carousel-fade .active.carousel-item-start{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-end,.carousel-fade .active.carousel-item-start{transition:none}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;padding:0;color:#fff;text-align:center;background:0 0;border:0;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next,.carousel-control-prev{transition:none}}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:2rem;height:2rem;background-repeat:no-repeat;background-position:50%;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:2;display:flex;justify-content:center;padding:0;margin-right:15%;margin-bottom:1rem;margin-left:15%}.carousel-indicators [data-bs-target]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;padding:0;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border:0;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators [data-bs-target]{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:1.25rem;left:15%;padding-top:1.25rem;padding-bottom:1.25rem;color:#fff;text-align:center}.carousel-dark .carousel-control-next-icon,.carousel-dark .carousel-control-prev-icon{filter:invert(1) grayscale(100)}.carousel-dark .carousel-indicators [data-bs-target]{background-color:#000}.carousel-dark .carousel-caption{color:#000}[data-bs-theme=dark] .carousel .carousel-control-next-icon,[data-bs-theme=dark] .carousel .carousel-control-prev-icon,[data-bs-theme=dark].carousel .carousel-control-next-icon,[data-bs-theme=dark].carousel .carousel-control-prev-icon{filter:invert(1) grayscale(100)}[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target],[data-bs-theme=dark].carousel .carousel-indicators [data-bs-target]{background-color:#000}[data-bs-theme=dark] .carousel .carousel-caption,[data-bs-theme=dark].carousel .carousel-caption{color:#000}.spinner-border,.spinner-grow{display:inline-block;width:var(--bs-spinner-width);height:var(--bs-spinner-height);vertical-align:var(--bs-spinner-vertical-align);border-radius:50%;animation:var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name)}@keyframes spinner-border{to{transform:rotate(360deg)}}.spinner-border{--bs-spinner-width:2rem;--bs-spinner-height:2rem;--bs-spinner-vertical-align:-0.125em;--bs-spinner-border-width:0.25em;--bs-spinner-animation-speed:0.75s;--bs-spinner-animation-name:spinner-border;border:var(--bs-spinner-border-width) solid currentcolor;border-right-color:transparent}.spinner-border-sm{--bs-spinner-width:1rem;--bs-spinner-height:1rem;--bs-spinner-border-width:0.2em}@keyframes spinner-grow{0%{transform:scale(0)}50%{opacity:1;transform:none}}.spinner-grow{--bs-spinner-width:2rem;--bs-spinner-height:2rem;--bs-spinner-vertical-align:-0.125em;--bs-spinner-animation-speed:0.75s;--bs-spinner-animation-name:spinner-grow;background-color:currentcolor;opacity:0}.spinner-grow-sm{--bs-spinner-width:1rem;--bs-spinner-height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border,.spinner-grow{--bs-spinner-animation-speed:1.5s}}.offcanvas,.offcanvas-lg,.offcanvas-md,.offcanvas-sm,.offcanvas-xl,.offcanvas-xxl{--bs-offcanvas-zindex:1045;--bs-offcanvas-width:400px;--bs-offcanvas-height:30vh;--bs-offcanvas-padding-x:1rem;--bs-offcanvas-padding-y:1rem;--bs-offcanvas-color:var(--bs-body-color);--bs-offcanvas-bg:var(--bs-body-bg);--bs-offcanvas-border-width:var(--bs-border-width);--bs-offcanvas-border-color:var(--bs-border-color-translucent);--bs-offcanvas-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-offcanvas-transition:transform 0.3s ease-in-out;--bs-offcanvas-title-line-height:1.5}@media (max-width:575.98px){.offcanvas-sm{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:575.98px) and (prefers-reduced-motion:reduce){.offcanvas-sm{transition:none}}@media (max-width:575.98px){.offcanvas-sm.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-sm.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-sm.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-sm.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-sm.show:not(.hiding),.offcanvas-sm.showing{transform:none}.offcanvas-sm.hiding,.offcanvas-sm.show,.offcanvas-sm.showing{visibility:visible}}@media (min-width:576px){.offcanvas-sm{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-sm .offcanvas-header{display:none}.offcanvas-sm .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:767.98px){.offcanvas-md{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:767.98px) and (prefers-reduced-motion:reduce){.offcanvas-md{transition:none}}@media (max-width:767.98px){.offcanvas-md.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-md.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-md.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-md.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-md.show:not(.hiding),.offcanvas-md.showing{transform:none}.offcanvas-md.hiding,.offcanvas-md.show,.offcanvas-md.showing{visibility:visible}}@media (min-width:768px){.offcanvas-md{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-md .offcanvas-header{display:none}.offcanvas-md .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:991.98px){.offcanvas-lg{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:991.98px) and (prefers-reduced-motion:reduce){.offcanvas-lg{transition:none}}@media (max-width:991.98px){.offcanvas-lg.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-lg.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-lg.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-lg.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-lg.show:not(.hiding),.offcanvas-lg.showing{transform:none}.offcanvas-lg.hiding,.offcanvas-lg.show,.offcanvas-lg.showing{visibility:visible}}@media (min-width:992px){.offcanvas-lg{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-lg .offcanvas-header{display:none}.offcanvas-lg .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:1199.98px){.offcanvas-xl{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:1199.98px) and (prefers-reduced-motion:reduce){.offcanvas-xl{transition:none}}@media (max-width:1199.98px){.offcanvas-xl.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-xl.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-xl.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-xl.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-xl.show:not(.hiding),.offcanvas-xl.showing{transform:none}.offcanvas-xl.hiding,.offcanvas-xl.show,.offcanvas-xl.showing{visibility:visible}}@media (min-width:1200px){.offcanvas-xl{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-xl .offcanvas-header{display:none}.offcanvas-xl .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}@media (max-width:1399.98px){.offcanvas-xxl{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}}@media (max-width:1399.98px) and (prefers-reduced-motion:reduce){.offcanvas-xxl{transition:none}}@media (max-width:1399.98px){.offcanvas-xxl.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas-xxl.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas-xxl.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas-xxl.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas-xxl.show:not(.hiding),.offcanvas-xxl.showing{transform:none}.offcanvas-xxl.hiding,.offcanvas-xxl.show,.offcanvas-xxl.showing{visibility:visible}}@media (min-width:1400px){.offcanvas-xxl{--bs-offcanvas-height:auto;--bs-offcanvas-border-width:0;background-color:transparent!important}.offcanvas-xxl .offcanvas-header{display:none}.offcanvas-xxl .offcanvas-body{display:flex;flex-grow:0;padding:0;overflow-y:visible;background-color:transparent!important}}.offcanvas{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}@media (prefers-reduced-motion:reduce){.offcanvas{transition:none}}.offcanvas.offcanvas-start{top:0;left:0;width:var(--bs-offcanvas-width);border-right:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(-100%)}.offcanvas.offcanvas-end{top:0;right:0;width:var(--bs-offcanvas-width);border-left:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateX(100%)}.offcanvas.offcanvas-top{top:0;right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-bottom:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(-100%)}.offcanvas.offcanvas-bottom{right:0;left:0;height:var(--bs-offcanvas-height);max-height:100%;border-top:var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);transform:translateY(100%)}.offcanvas.show:not(.hiding),.offcanvas.showing{transform:none}.offcanvas.hiding,.offcanvas.show,.offcanvas.showing{visibility:visible}.offcanvas-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.offcanvas-backdrop.fade{opacity:0}.offcanvas-backdrop.show{opacity:.5}.offcanvas-header{display:flex;align-items:center;justify-content:space-between;padding:var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x)}.offcanvas-header .btn-close{padding:calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);margin-top:calc(-.5 * var(--bs-offcanvas-padding-y));margin-right:calc(-.5 * var(--bs-offcanvas-padding-x));margin-bottom:calc(-.5 * var(--bs-offcanvas-padding-y))}.offcanvas-title{margin-bottom:0;line-height:var(--bs-offcanvas-title-line-height)}.offcanvas-body{flex-grow:1;padding:var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);overflow-y:auto}.placeholder{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentcolor;opacity:.5}.placeholder.btn::before{display:inline-block;content:\"\"}.placeholder-xs{min-height:.6em}.placeholder-sm{min-height:.8em}.placeholder-lg{min-height:1.2em}.placeholder-glow .placeholder{animation:placeholder-glow 2s ease-in-out infinite}@keyframes placeholder-glow{50%{opacity:.2}}.placeholder-wave{-webkit-mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,0.8) 75%,#000 95%);mask-image:linear-gradient(130deg,#000 55%,rgba(0,0,0,0.8) 75%,#000 95%);-webkit-mask-size:200% 100%;mask-size:200% 100%;animation:placeholder-wave 2s linear infinite}@keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0%;mask-position:-200% 0%}}.clearfix::after{display:block;clear:both;content:\"\"}.text-bg-primary{color:#fff!important;background-color:RGBA(var(--bs-primary-rgb),var(--bs-bg-opacity,1))!important}.text-bg-secondary{color:#fff!important;background-color:RGBA(var(--bs-secondary-rgb),var(--bs-bg-opacity,1))!important}.text-bg-success{color:#fff!important;background-color:RGBA(var(--bs-success-rgb),var(--bs-bg-opacity,1))!important}.text-bg-info{color:#000!important;background-color:RGBA(var(--bs-info-rgb),var(--bs-bg-opacity,1))!important}.text-bg-warning{color:#000!important;background-color:RGBA(var(--bs-warning-rgb),var(--bs-bg-opacity,1))!important}.text-bg-danger{color:#fff!important;background-color:RGBA(var(--bs-danger-rgb),var(--bs-bg-opacity,1))!important}.text-bg-light{color:#000!important;background-color:RGBA(var(--bs-light-rgb),var(--bs-bg-opacity,1))!important}.text-bg-dark{color:#fff!important;background-color:RGBA(var(--bs-dark-rgb),var(--bs-bg-opacity,1))!important}.link-primary{color:RGBA(var(--bs-primary-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-primary-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-primary-rgb),var(--bs-link-underline-opacity,1))!important}.link-primary:focus,.link-primary:hover{color:RGBA(10,88,202,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(10,88,202,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(10,88,202,var(--bs-link-underline-opacity,1))!important}.link-secondary{color:RGBA(var(--bs-secondary-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-secondary-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-secondary-rgb),var(--bs-link-underline-opacity,1))!important}.link-secondary:focus,.link-secondary:hover{color:RGBA(86,94,100,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(86,94,100,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(86,94,100,var(--bs-link-underline-opacity,1))!important}.link-success{color:RGBA(var(--bs-success-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-success-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-success-rgb),var(--bs-link-underline-opacity,1))!important}.link-success:focus,.link-success:hover{color:RGBA(20,108,67,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(20,108,67,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(20,108,67,var(--bs-link-underline-opacity,1))!important}.link-info{color:RGBA(var(--bs-info-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-info-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-info-rgb),var(--bs-link-underline-opacity,1))!important}.link-info:focus,.link-info:hover{color:RGBA(61,213,243,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(61,213,243,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(61,213,243,var(--bs-link-underline-opacity,1))!important}.link-warning{color:RGBA(var(--bs-warning-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-warning-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-warning-rgb),var(--bs-link-underline-opacity,1))!important}.link-warning:focus,.link-warning:hover{color:RGBA(255,205,57,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(255,205,57,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(255,205,57,var(--bs-link-underline-opacity,1))!important}.link-danger{color:RGBA(var(--bs-danger-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-danger-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-danger-rgb),var(--bs-link-underline-opacity,1))!important}.link-danger:focus,.link-danger:hover{color:RGBA(176,42,55,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(176,42,55,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(176,42,55,var(--bs-link-underline-opacity,1))!important}.link-light{color:RGBA(var(--bs-light-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-light-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-light-rgb),var(--bs-link-underline-opacity,1))!important}.link-light:focus,.link-light:hover{color:RGBA(249,250,251,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(249,250,251,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(249,250,251,var(--bs-link-underline-opacity,1))!important}.link-dark{color:RGBA(var(--bs-dark-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-dark-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-dark-rgb),var(--bs-link-underline-opacity,1))!important}.link-dark:focus,.link-dark:hover{color:RGBA(26,30,33,var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(26,30,33,var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(26,30,33,var(--bs-link-underline-opacity,1))!important}.link-body-emphasis{color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-opacity,1))!important;-webkit-text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,1))!important}.link-body-emphasis:focus,.link-body-emphasis:hover{color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-opacity,.75))!important;-webkit-text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,0.75))!important;text-decoration-color:RGBA(var(--bs-emphasis-color-rgb),var(--bs-link-underline-opacity,0.75))!important}.focus-ring:focus{outline:0;box-shadow:var(--bs-focus-ring-x,0) var(--bs-focus-ring-y,0) var(--bs-focus-ring-blur,0) var(--bs-focus-ring-width) var(--bs-focus-ring-color)}.icon-link{display:inline-flex;gap:.375rem;align-items:center;-webkit-text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,0.5));text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,0.5));text-underline-offset:0.25em;-webkit-backface-visibility:hidden;backface-visibility:hidden}.icon-link>.bi{flex-shrink:0;width:1em;height:1em;fill:currentcolor;transition:.2s ease-in-out transform}@media (prefers-reduced-motion:reduce){.icon-link>.bi{transition:none}}.icon-link-hover:focus-visible>.bi,.icon-link-hover:hover>.bi{transform:var(--bs-icon-link-transform,translate3d(.25em,0,0))}.ratio{position:relative;width:100%}.ratio::before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>*{position:absolute;top:0;left:0;width:100%;height:100%}.ratio-1x1{--bs-aspect-ratio:100%}.ratio-4x3{--bs-aspect-ratio:75%}.ratio-16x9{--bs-aspect-ratio:56.25%}.ratio-21x9{--bs-aspect-ratio:42.8571428571%}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}@media (min-width:576px){.sticky-sm-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-sm-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:768px){.sticky-md-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-md-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:992px){.sticky-lg-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-lg-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:1200px){.sticky-xl-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-xl-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}@media (min-width:1400px){.sticky-xxl-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}.sticky-xxl-bottom{position:-webkit-sticky;position:sticky;bottom:0;z-index:1020}}.hstack{display:flex;flex-direction:row;align-items:center;align-self:stretch}.vstack{display:flex;flex:1 1 auto;flex-direction:column;align-self:stretch}.visually-hidden,.visually-hidden-focusable:not(:focus):not(:focus-within){width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption),.visually-hidden:not(caption){position:absolute!important}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;content:\"\"}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vr{display:inline-block;align-self:stretch;width:var(--bs-border-width);min-height:1em;background-color:currentcolor;opacity:.25}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.float-start{float:left!important}.float-end{float:right!important}.float-none{float:none!important}.object-fit-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-none{-o-object-fit:none!important;object-fit:none!important}.opacity-0{opacity:0!important}.opacity-25{opacity:.25!important}.opacity-50{opacity:.5!important}.opacity-75{opacity:.75!important}.opacity-100{opacity:1!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.overflow-visible{overflow:visible!important}.overflow-scroll{overflow:scroll!important}.overflow-x-auto{overflow-x:auto!important}.overflow-x-hidden{overflow-x:hidden!important}.overflow-x-visible{overflow-x:visible!important}.overflow-x-scroll{overflow-x:scroll!important}.overflow-y-auto{overflow-y:auto!important}.overflow-y-hidden{overflow-y:hidden!important}.overflow-y-visible{overflow-y:visible!important}.overflow-y-scroll{overflow-y:scroll!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-grid{display:grid!important}.d-inline-grid{display:inline-grid!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}.d-none{display:none!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.focus-ring-primary{--bs-focus-ring-color:rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity))}.focus-ring-secondary{--bs-focus-ring-color:rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity))}.focus-ring-success{--bs-focus-ring-color:rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity))}.focus-ring-info{--bs-focus-ring-color:rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity))}.focus-ring-warning{--bs-focus-ring-color:rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity))}.focus-ring-danger{--bs-focus-ring-color:rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity))}.focus-ring-light{--bs-focus-ring-color:rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity))}.focus-ring-dark{--bs-focus-ring-color:rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity))}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.top-0{top:0!important}.top-50{top:50%!important}.top-100{top:100%!important}.bottom-0{bottom:0!important}.bottom-50{bottom:50%!important}.bottom-100{bottom:100%!important}.start-0{left:0!important}.start-50{left:50%!important}.start-100{left:100%!important}.end-0{right:0!important}.end-50{right:50%!important}.end-100{right:100%!important}.translate-middle{transform:translate(-50%,-50%)!important}.translate-middle-x{transform:translateX(-50%)!important}.translate-middle-y{transform:translateY(-50%)!important}.border{border:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-0{border:0!important}.border-top{border-top:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-top-0{border-top:0!important}.border-end{border-right:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-end-0{border-right:0!important}.border-bottom{border-bottom:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-bottom-0{border-bottom:0!important}.border-start{border-left:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-start-0{border-left:0!important}.border-primary{--bs-border-opacity:1;border-color:rgba(var(--bs-primary-rgb),var(--bs-border-opacity))!important}.border-secondary{--bs-border-opacity:1;border-color:rgba(var(--bs-secondary-rgb),var(--bs-border-opacity))!important}.border-success{--bs-border-opacity:1;border-color:rgba(var(--bs-success-rgb),var(--bs-border-opacity))!important}.border-info{--bs-border-opacity:1;border-color:rgba(var(--bs-info-rgb),var(--bs-border-opacity))!important}.border-warning{--bs-border-opacity:1;border-color:rgba(var(--bs-warning-rgb),var(--bs-border-opacity))!important}.border-danger{--bs-border-opacity:1;border-color:rgba(var(--bs-danger-rgb),var(--bs-border-opacity))!important}.border-light{--bs-border-opacity:1;border-color:rgba(var(--bs-light-rgb),var(--bs-border-opacity))!important}.border-dark{--bs-border-opacity:1;border-color:rgba(var(--bs-dark-rgb),var(--bs-border-opacity))!important}.border-black{--bs-border-opacity:1;border-color:rgba(var(--bs-black-rgb),var(--bs-border-opacity))!important}.border-white{--bs-border-opacity:1;border-color:rgba(var(--bs-white-rgb),var(--bs-border-opacity))!important}.border-primary-subtle{border-color:var(--bs-primary-border-subtle)!important}.border-secondary-subtle{border-color:var(--bs-secondary-border-subtle)!important}.border-success-subtle{border-color:var(--bs-success-border-subtle)!important}.border-info-subtle{border-color:var(--bs-info-border-subtle)!important}.border-warning-subtle{border-color:var(--bs-warning-border-subtle)!important}.border-danger-subtle{border-color:var(--bs-danger-border-subtle)!important}.border-light-subtle{border-color:var(--bs-light-border-subtle)!important}.border-dark-subtle{border-color:var(--bs-dark-border-subtle)!important}.border-1{border-width:1px!important}.border-2{border-width:2px!important}.border-3{border-width:3px!important}.border-4{border-width:4px!important}.border-5{border-width:5px!important}.border-opacity-10{--bs-border-opacity:0.1}.border-opacity-25{--bs-border-opacity:0.25}.border-opacity-50{--bs-border-opacity:0.5}.border-opacity-75{--bs-border-opacity:0.75}.border-opacity-100{--bs-border-opacity:1}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.mw-100{max-width:100%!important}.vw-100{width:100vw!important}.min-vw-100{min-width:100vw!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mh-100{max-height:100%!important}.vh-100{height:100vh!important}.min-vh-100{min-height:100vh!important}.flex-fill{flex:1 1 auto!important}.flex-row{flex-direction:row!important}.flex-column{flex-direction:column!important}.flex-row-reverse{flex-direction:row-reverse!important}.flex-column-reverse{flex-direction:column-reverse!important}.flex-grow-0{flex-grow:0!important}.flex-grow-1{flex-grow:1!important}.flex-shrink-0{flex-shrink:0!important}.flex-shrink-1{flex-shrink:1!important}.flex-wrap{flex-wrap:wrap!important}.flex-nowrap{flex-wrap:nowrap!important}.flex-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-start{justify-content:flex-start!important}.justify-content-end{justify-content:flex-end!important}.justify-content-center{justify-content:center!important}.justify-content-between{justify-content:space-between!important}.justify-content-around{justify-content:space-around!important}.justify-content-evenly{justify-content:space-evenly!important}.align-items-start{align-items:flex-start!important}.align-items-end{align-items:flex-end!important}.align-items-center{align-items:center!important}.align-items-baseline{align-items:baseline!important}.align-items-stretch{align-items:stretch!important}.align-content-start{align-content:flex-start!important}.align-content-end{align-content:flex-end!important}.align-content-center{align-content:center!important}.align-content-between{align-content:space-between!important}.align-content-around{align-content:space-around!important}.align-content-stretch{align-content:stretch!important}.align-self-auto{align-self:auto!important}.align-self-start{align-self:flex-start!important}.align-self-end{align-self:flex-end!important}.align-self-center{align-self:center!important}.align-self-baseline{align-self:baseline!important}.align-self-stretch{align-self:stretch!important}.order-first{order:-1!important}.order-0{order:0!important}.order-1{order:1!important}.order-2{order:2!important}.order-3{order:3!important}.order-4{order:4!important}.order-5{order:5!important}.order-last{order:6!important}.m-0{margin:0!important}.m-1{margin:.25rem!important}.m-2{margin:.5rem!important}.m-3{margin:1rem!important}.m-4{margin:1.5rem!important}.m-5{margin:3rem!important}.m-auto{margin:auto!important}.mx-0{margin-right:0!important;margin-left:0!important}.mx-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3{margin-right:1rem!important;margin-left:1rem!important}.mx-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5{margin-right:3rem!important;margin-left:3rem!important}.mx-auto{margin-right:auto!important;margin-left:auto!important}.my-0{margin-top:0!important;margin-bottom:0!important}.my-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-0{margin-top:0!important}.mt-1{margin-top:.25rem!important}.mt-2{margin-top:.5rem!important}.mt-3{margin-top:1rem!important}.mt-4{margin-top:1.5rem!important}.mt-5{margin-top:3rem!important}.mt-auto{margin-top:auto!important}.me-0{margin-right:0!important}.me-1{margin-right:.25rem!important}.me-2{margin-right:.5rem!important}.me-3{margin-right:1rem!important}.me-4{margin-right:1.5rem!important}.me-5{margin-right:3rem!important}.me-auto{margin-right:auto!important}.mb-0{margin-bottom:0!important}.mb-1{margin-bottom:.25rem!important}.mb-2{margin-bottom:.5rem!important}.mb-3{margin-bottom:1rem!important}.mb-4{margin-bottom:1.5rem!important}.mb-5{margin-bottom:3rem!important}.mb-auto{margin-bottom:auto!important}.ms-0{margin-left:0!important}.ms-1{margin-left:.25rem!important}.ms-2{margin-left:.5rem!important}.ms-3{margin-left:1rem!important}.ms-4{margin-left:1.5rem!important}.ms-5{margin-left:3rem!important}.ms-auto{margin-left:auto!important}.p-0{padding:0!important}.p-1{padding:.25rem!important}.p-2{padding:.5rem!important}.p-3{padding:1rem!important}.p-4{padding:1.5rem!important}.p-5{padding:3rem!important}.px-0{padding-right:0!important;padding-left:0!important}.px-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-3{padding-right:1rem!important;padding-left:1rem!important}.px-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5{padding-right:3rem!important;padding-left:3rem!important}.py-0{padding-top:0!important;padding-bottom:0!important}.py-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-0{padding-top:0!important}.pt-1{padding-top:.25rem!important}.pt-2{padding-top:.5rem!important}.pt-3{padding-top:1rem!important}.pt-4{padding-top:1.5rem!important}.pt-5{padding-top:3rem!important}.pe-0{padding-right:0!important}.pe-1{padding-right:.25rem!important}.pe-2{padding-right:.5rem!important}.pe-3{padding-right:1rem!important}.pe-4{padding-right:1.5rem!important}.pe-5{padding-right:3rem!important}.pb-0{padding-bottom:0!important}.pb-1{padding-bottom:.25rem!important}.pb-2{padding-bottom:.5rem!important}.pb-3{padding-bottom:1rem!important}.pb-4{padding-bottom:1.5rem!important}.pb-5{padding-bottom:3rem!important}.ps-0{padding-left:0!important}.ps-1{padding-left:.25rem!important}.ps-2{padding-left:.5rem!important}.ps-3{padding-left:1rem!important}.ps-4{padding-left:1.5rem!important}.ps-5{padding-left:3rem!important}.gap-0{gap:0!important}.gap-1{gap:.25rem!important}.gap-2{gap:.5rem!important}.gap-3{gap:1rem!important}.gap-4{gap:1.5rem!important}.gap-5{gap:3rem!important}.row-gap-0{row-gap:0!important}.row-gap-1{row-gap:.25rem!important}.row-gap-2{row-gap:.5rem!important}.row-gap-3{row-gap:1rem!important}.row-gap-4{row-gap:1.5rem!important}.row-gap-5{row-gap:3rem!important}.column-gap-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.font-monospace{font-family:var(--bs-font-monospace)!important}.fs-1{font-size:calc(1.375rem + 1.5vw)!important}.fs-2{font-size:calc(1.325rem + .9vw)!important}.fs-3{font-size:calc(1.3rem + .6vw)!important}.fs-4{font-size:calc(1.275rem + .3vw)!important}.fs-5{font-size:1.25rem!important}.fs-6{font-size:1rem!important}.fst-italic{font-style:italic!important}.fst-normal{font-style:normal!important}.fw-lighter{font-weight:lighter!important}.fw-light{font-weight:300!important}.fw-normal{font-weight:400!important}.fw-medium{font-weight:500!important}.fw-semibold{font-weight:600!important}.fw-bold{font-weight:700!important}.fw-bolder{font-weight:bolder!important}.lh-1{line-height:1!important}.lh-sm{line-height:1.25!important}.lh-base{line-height:1.5!important}.lh-lg{line-height:2!important}.text-start{text-align:left!important}.text-end{text-align:right!important}.text-center{text-align:center!important}.text-decoration-none{text-decoration:none!important}.text-decoration-underline{text-decoration:underline!important}.text-decoration-line-through{text-decoration:line-through!important}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-break{word-wrap:break-word!important;word-break:break-word!important}.text-primary{--bs-text-opacity:1;color:rgba(var(--bs-primary-rgb),var(--bs-text-opacity))!important}.text-secondary{--bs-text-opacity:1;color:rgba(var(--bs-secondary-rgb),var(--bs-text-opacity))!important}.text-success{--bs-text-opacity:1;color:rgba(var(--bs-success-rgb),var(--bs-text-opacity))!important}.text-info{--bs-text-opacity:1;color:rgba(var(--bs-info-rgb),var(--bs-text-opacity))!important}.text-warning{--bs-text-opacity:1;color:rgba(var(--bs-warning-rgb),var(--bs-text-opacity))!important}.text-danger{--bs-text-opacity:1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}.text-light{--bs-text-opacity:1;color:rgba(var(--bs-light-rgb),var(--bs-text-opacity))!important}.text-dark{--bs-text-opacity:1;color:rgba(var(--bs-dark-rgb),var(--bs-text-opacity))!important}.text-black{--bs-text-opacity:1;color:rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important}.text-white{--bs-text-opacity:1;color:rgba(var(--bs-white-rgb),var(--bs-text-opacity))!important}.text-body{--bs-text-opacity:1;color:rgba(var(--bs-body-color-rgb),var(--bs-text-opacity))!important}.text-muted{--bs-text-opacity:1;color:var(--bs-secondary-color)!important}.text-black-50{--bs-text-opacity:1;color:rgba(0,0,0,.5)!important}.text-white-50{--bs-text-opacity:1;color:rgba(255,255,255,.5)!important}.text-body-secondary{--bs-text-opacity:1;color:var(--bs-secondary-color)!important}.text-body-tertiary{--bs-text-opacity:1;color:var(--bs-tertiary-color)!important}.text-body-emphasis{--bs-text-opacity:1;color:var(--bs-emphasis-color)!important}.text-reset{--bs-text-opacity:1;color:inherit!important}.text-opacity-25{--bs-text-opacity:0.25}.text-opacity-50{--bs-text-opacity:0.5}.text-opacity-75{--bs-text-opacity:0.75}.text-opacity-100{--bs-text-opacity:1}.text-primary-emphasis{color:var(--bs-primary-text-emphasis)!important}.text-secondary-emphasis{color:var(--bs-secondary-text-emphasis)!important}.text-success-emphasis{color:var(--bs-success-text-emphasis)!important}.text-info-emphasis{color:var(--bs-info-text-emphasis)!important}.text-warning-emphasis{color:var(--bs-warning-text-emphasis)!important}.text-danger-emphasis{color:var(--bs-danger-text-emphasis)!important}.text-light-emphasis{color:var(--bs-light-text-emphasis)!important}.text-dark-emphasis{color:var(--bs-dark-text-emphasis)!important}.link-opacity-10{--bs-link-opacity:0.1}.link-opacity-10-hover:hover{--bs-link-opacity:0.1}.link-opacity-25{--bs-link-opacity:0.25}.link-opacity-25-hover:hover{--bs-link-opacity:0.25}.link-opacity-50{--bs-link-opacity:0.5}.link-opacity-50-hover:hover{--bs-link-opacity:0.5}.link-opacity-75{--bs-link-opacity:0.75}.link-opacity-75-hover:hover{--bs-link-opacity:0.75}.link-opacity-100{--bs-link-opacity:1}.link-opacity-100-hover:hover{--bs-link-opacity:1}.link-offset-1{text-underline-offset:0.125em!important}.link-offset-1-hover:hover{text-underline-offset:0.125em!important}.link-offset-2{text-underline-offset:0.25em!important}.link-offset-2-hover:hover{text-underline-offset:0.25em!important}.link-offset-3{text-underline-offset:0.375em!important}.link-offset-3-hover:hover{text-underline-offset:0.375em!important}.link-underline-primary{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-primary-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-primary-rgb),var(--bs-link-underline-opacity))!important}.link-underline-secondary{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-secondary-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-secondary-rgb),var(--bs-link-underline-opacity))!important}.link-underline-success{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-success-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-success-rgb),var(--bs-link-underline-opacity))!important}.link-underline-info{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-info-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-info-rgb),var(--bs-link-underline-opacity))!important}.link-underline-warning{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-warning-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-warning-rgb),var(--bs-link-underline-opacity))!important}.link-underline-danger{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-danger-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-danger-rgb),var(--bs-link-underline-opacity))!important}.link-underline-light{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-light-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-light-rgb),var(--bs-link-underline-opacity))!important}.link-underline-dark{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-dark-rgb),var(--bs-link-underline-opacity))!important;text-decoration-color:rgba(var(--bs-dark-rgb),var(--bs-link-underline-opacity))!important}.link-underline{--bs-link-underline-opacity:1;-webkit-text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-underline-opacity,1))!important;text-decoration-color:rgba(var(--bs-link-color-rgb),var(--bs-link-underline-opacity,1))!important}.link-underline-opacity-0{--bs-link-underline-opacity:0}.link-underline-opacity-0-hover:hover{--bs-link-underline-opacity:0}.link-underline-opacity-10{--bs-link-underline-opacity:0.1}.link-underline-opacity-10-hover:hover{--bs-link-underline-opacity:0.1}.link-underline-opacity-25{--bs-link-underline-opacity:0.25}.link-underline-opacity-25-hover:hover{--bs-link-underline-opacity:0.25}.link-underline-opacity-50{--bs-link-underline-opacity:0.5}.link-underline-opacity-50-hover:hover{--bs-link-underline-opacity:0.5}.link-underline-opacity-75{--bs-link-underline-opacity:0.75}.link-underline-opacity-75-hover:hover{--bs-link-underline-opacity:0.75}.link-underline-opacity-100{--bs-link-underline-opacity:1}.link-underline-opacity-100-hover:hover{--bs-link-underline-opacity:1}.bg-primary{--bs-bg-opacity:1;background-color:rgba(var(--bs-primary-rgb),var(--bs-bg-opacity))!important}.bg-secondary{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-rgb),var(--bs-bg-opacity))!important}.bg-success{--bs-bg-opacity:1;background-color:rgba(var(--bs-success-rgb),var(--bs-bg-opacity))!important}.bg-info{--bs-bg-opacity:1;background-color:rgba(var(--bs-info-rgb),var(--bs-bg-opacity))!important}.bg-warning{--bs-bg-opacity:1;background-color:rgba(var(--bs-warning-rgb),var(--bs-bg-opacity))!important}.bg-danger{--bs-bg-opacity:1;background-color:rgba(var(--bs-danger-rgb),var(--bs-bg-opacity))!important}.bg-light{--bs-bg-opacity:1;background-color:rgba(var(--bs-light-rgb),var(--bs-bg-opacity))!important}.bg-dark{--bs-bg-opacity:1;background-color:rgba(var(--bs-dark-rgb),var(--bs-bg-opacity))!important}.bg-black{--bs-bg-opacity:1;background-color:rgba(var(--bs-black-rgb),var(--bs-bg-opacity))!important}.bg-white{--bs-bg-opacity:1;background-color:rgba(var(--bs-white-rgb),var(--bs-bg-opacity))!important}.bg-body{--bs-bg-opacity:1;background-color:rgba(var(--bs-body-bg-rgb),var(--bs-bg-opacity))!important}.bg-transparent{--bs-bg-opacity:1;background-color:transparent!important}.bg-body-secondary{--bs-bg-opacity:1;background-color:rgba(var(--bs-secondary-bg-rgb),var(--bs-bg-opacity))!important}.bg-body-tertiary{--bs-bg-opacity:1;background-color:rgba(var(--bs-tertiary-bg-rgb),var(--bs-bg-opacity))!important}.bg-opacity-10{--bs-bg-opacity:0.1}.bg-opacity-25{--bs-bg-opacity:0.25}.bg-opacity-50{--bs-bg-opacity:0.5}.bg-opacity-75{--bs-bg-opacity:0.75}.bg-opacity-100{--bs-bg-opacity:1}.bg-primary-subtle{background-color:var(--bs-primary-bg-subtle)!important}.bg-secondary-subtle{background-color:var(--bs-secondary-bg-subtle)!important}.bg-success-subtle{background-color:var(--bs-success-bg-subtle)!important}.bg-info-subtle{background-color:var(--bs-info-bg-subtle)!important}.bg-warning-subtle{background-color:var(--bs-warning-bg-subtle)!important}.bg-danger-subtle{background-color:var(--bs-danger-bg-subtle)!important}.bg-light-subtle{background-color:var(--bs-light-bg-subtle)!important}.bg-dark-subtle{background-color:var(--bs-dark-bg-subtle)!important}.bg-gradient{background-image:var(--bs-gradient)!important}.user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.pe-none{pointer-events:none!important}.pe-auto{pointer-events:auto!important}.rounded{border-radius:var(--bs-border-radius)!important}.rounded-0{border-radius:0!important}.rounded-1{border-radius:var(--bs-border-radius-sm)!important}.rounded-2{border-radius:var(--bs-border-radius)!important}.rounded-3{border-radius:var(--bs-border-radius-lg)!important}.rounded-4{border-radius:var(--bs-border-radius-xl)!important}.rounded-5{border-radius:var(--bs-border-radius-xxl)!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:var(--bs-border-radius-pill)!important}.rounded-top{border-top-left-radius:var(--bs-border-radius)!important;border-top-right-radius:var(--bs-border-radius)!important}.rounded-top-0{border-top-left-radius:0!important;border-top-right-radius:0!important}.rounded-top-1{border-top-left-radius:var(--bs-border-radius-sm)!important;border-top-right-radius:var(--bs-border-radius-sm)!important}.rounded-top-2{border-top-left-radius:var(--bs-border-radius)!important;border-top-right-radius:var(--bs-border-radius)!important}.rounded-top-3{border-top-left-radius:var(--bs-border-radius-lg)!important;border-top-right-radius:var(--bs-border-radius-lg)!important}.rounded-top-4{border-top-left-radius:var(--bs-border-radius-xl)!important;border-top-right-radius:var(--bs-border-radius-xl)!important}.rounded-top-5{border-top-left-radius:var(--bs-border-radius-xxl)!important;border-top-right-radius:var(--bs-border-radius-xxl)!important}.rounded-top-circle{border-top-left-radius:50%!important;border-top-right-radius:50%!important}.rounded-top-pill{border-top-left-radius:var(--bs-border-radius-pill)!important;border-top-right-radius:var(--bs-border-radius-pill)!important}.rounded-end{border-top-right-radius:var(--bs-border-radius)!important;border-bottom-right-radius:var(--bs-border-radius)!important}.rounded-end-0{border-top-right-radius:0!important;border-bottom-right-radius:0!important}.rounded-end-1{border-top-right-radius:var(--bs-border-radius-sm)!important;border-bottom-right-radius:var(--bs-border-radius-sm)!important}.rounded-end-2{border-top-right-radius:var(--bs-border-radius)!important;border-bottom-right-radius:var(--bs-border-radius)!important}.rounded-end-3{border-top-right-radius:var(--bs-border-radius-lg)!important;border-bottom-right-radius:var(--bs-border-radius-lg)!important}.rounded-end-4{border-top-right-radius:var(--bs-border-radius-xl)!important;border-bottom-right-radius:var(--bs-border-radius-xl)!important}.rounded-end-5{border-top-right-radius:var(--bs-border-radius-xxl)!important;border-bottom-right-radius:var(--bs-border-radius-xxl)!important}.rounded-end-circle{border-top-right-radius:50%!important;border-bottom-right-radius:50%!important}.rounded-end-pill{border-top-right-radius:var(--bs-border-radius-pill)!important;border-bottom-right-radius:var(--bs-border-radius-pill)!important}.rounded-bottom{border-bottom-right-radius:var(--bs-border-radius)!important;border-bottom-left-radius:var(--bs-border-radius)!important}.rounded-bottom-0{border-bottom-right-radius:0!important;border-bottom-left-radius:0!important}.rounded-bottom-1{border-bottom-right-radius:var(--bs-border-radius-sm)!important;border-bottom-left-radius:var(--bs-border-radius-sm)!important}.rounded-bottom-2{border-bottom-right-radius:var(--bs-border-radius)!important;border-bottom-left-radius:var(--bs-border-radius)!important}.rounded-bottom-3{border-bottom-right-radius:var(--bs-border-radius-lg)!important;border-bottom-left-radius:var(--bs-border-radius-lg)!important}.rounded-bottom-4{border-bottom-right-radius:var(--bs-border-radius-xl)!important;border-bottom-left-radius:var(--bs-border-radius-xl)!important}.rounded-bottom-5{border-bottom-right-radius:var(--bs-border-radius-xxl)!important;border-bottom-left-radius:var(--bs-border-radius-xxl)!important}.rounded-bottom-circle{border-bottom-right-radius:50%!important;border-bottom-left-radius:50%!important}.rounded-bottom-pill{border-bottom-right-radius:var(--bs-border-radius-pill)!important;border-bottom-left-radius:var(--bs-border-radius-pill)!important}.rounded-start{border-bottom-left-radius:var(--bs-border-radius)!important;border-top-left-radius:var(--bs-border-radius)!important}.rounded-start-0{border-bottom-left-radius:0!important;border-top-left-radius:0!important}.rounded-start-1{border-bottom-left-radius:var(--bs-border-radius-sm)!important;border-top-left-radius:var(--bs-border-radius-sm)!important}.rounded-start-2{border-bottom-left-radius:var(--bs-border-radius)!important;border-top-left-radius:var(--bs-border-radius)!important}.rounded-start-3{border-bottom-left-radius:var(--bs-border-radius-lg)!important;border-top-left-radius:var(--bs-border-radius-lg)!important}.rounded-start-4{border-bottom-left-radius:var(--bs-border-radius-xl)!important;border-top-left-radius:var(--bs-border-radius-xl)!important}.rounded-start-5{border-bottom-left-radius:var(--bs-border-radius-xxl)!important;border-top-left-radius:var(--bs-border-radius-xxl)!important}.rounded-start-circle{border-bottom-left-radius:50%!important;border-top-left-radius:50%!important}.rounded-start-pill{border-bottom-left-radius:var(--bs-border-radius-pill)!important;border-top-left-radius:var(--bs-border-radius-pill)!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}.z-n1{z-index:-1!important}.z-0{z-index:0!important}.z-1{z-index:1!important}.z-2{z-index:2!important}.z-3{z-index:3!important}@media (min-width:576px){.float-sm-start{float:left!important}.float-sm-end{float:right!important}.float-sm-none{float:none!important}.object-fit-sm-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-sm-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-sm-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-sm-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-sm-none{-o-object-fit:none!important;object-fit:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-grid{display:grid!important}.d-sm-inline-grid{display:inline-grid!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}.d-sm-none{display:none!important}.flex-sm-fill{flex:1 1 auto!important}.flex-sm-row{flex-direction:row!important}.flex-sm-column{flex-direction:column!important}.flex-sm-row-reverse{flex-direction:row-reverse!important}.flex-sm-column-reverse{flex-direction:column-reverse!important}.flex-sm-grow-0{flex-grow:0!important}.flex-sm-grow-1{flex-grow:1!important}.flex-sm-shrink-0{flex-shrink:0!important}.flex-sm-shrink-1{flex-shrink:1!important}.flex-sm-wrap{flex-wrap:wrap!important}.flex-sm-nowrap{flex-wrap:nowrap!important}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-sm-start{justify-content:flex-start!important}.justify-content-sm-end{justify-content:flex-end!important}.justify-content-sm-center{justify-content:center!important}.justify-content-sm-between{justify-content:space-between!important}.justify-content-sm-around{justify-content:space-around!important}.justify-content-sm-evenly{justify-content:space-evenly!important}.align-items-sm-start{align-items:flex-start!important}.align-items-sm-end{align-items:flex-end!important}.align-items-sm-center{align-items:center!important}.align-items-sm-baseline{align-items:baseline!important}.align-items-sm-stretch{align-items:stretch!important}.align-content-sm-start{align-content:flex-start!important}.align-content-sm-end{align-content:flex-end!important}.align-content-sm-center{align-content:center!important}.align-content-sm-between{align-content:space-between!important}.align-content-sm-around{align-content:space-around!important}.align-content-sm-stretch{align-content:stretch!important}.align-self-sm-auto{align-self:auto!important}.align-self-sm-start{align-self:flex-start!important}.align-self-sm-end{align-self:flex-end!important}.align-self-sm-center{align-self:center!important}.align-self-sm-baseline{align-self:baseline!important}.align-self-sm-stretch{align-self:stretch!important}.order-sm-first{order:-1!important}.order-sm-0{order:0!important}.order-sm-1{order:1!important}.order-sm-2{order:2!important}.order-sm-3{order:3!important}.order-sm-4{order:4!important}.order-sm-5{order:5!important}.order-sm-last{order:6!important}.m-sm-0{margin:0!important}.m-sm-1{margin:.25rem!important}.m-sm-2{margin:.5rem!important}.m-sm-3{margin:1rem!important}.m-sm-4{margin:1.5rem!important}.m-sm-5{margin:3rem!important}.m-sm-auto{margin:auto!important}.mx-sm-0{margin-right:0!important;margin-left:0!important}.mx-sm-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-sm-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-sm-3{margin-right:1rem!important;margin-left:1rem!important}.mx-sm-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-sm-5{margin-right:3rem!important;margin-left:3rem!important}.mx-sm-auto{margin-right:auto!important;margin-left:auto!important}.my-sm-0{margin-top:0!important;margin-bottom:0!important}.my-sm-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-sm-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-sm-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-sm-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-sm-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-sm-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-sm-0{margin-top:0!important}.mt-sm-1{margin-top:.25rem!important}.mt-sm-2{margin-top:.5rem!important}.mt-sm-3{margin-top:1rem!important}.mt-sm-4{margin-top:1.5rem!important}.mt-sm-5{margin-top:3rem!important}.mt-sm-auto{margin-top:auto!important}.me-sm-0{margin-right:0!important}.me-sm-1{margin-right:.25rem!important}.me-sm-2{margin-right:.5rem!important}.me-sm-3{margin-right:1rem!important}.me-sm-4{margin-right:1.5rem!important}.me-sm-5{margin-right:3rem!important}.me-sm-auto{margin-right:auto!important}.mb-sm-0{margin-bottom:0!important}.mb-sm-1{margin-bottom:.25rem!important}.mb-sm-2{margin-bottom:.5rem!important}.mb-sm-3{margin-bottom:1rem!important}.mb-sm-4{margin-bottom:1.5rem!important}.mb-sm-5{margin-bottom:3rem!important}.mb-sm-auto{margin-bottom:auto!important}.ms-sm-0{margin-left:0!important}.ms-sm-1{margin-left:.25rem!important}.ms-sm-2{margin-left:.5rem!important}.ms-sm-3{margin-left:1rem!important}.ms-sm-4{margin-left:1.5rem!important}.ms-sm-5{margin-left:3rem!important}.ms-sm-auto{margin-left:auto!important}.p-sm-0{padding:0!important}.p-sm-1{padding:.25rem!important}.p-sm-2{padding:.5rem!important}.p-sm-3{padding:1rem!important}.p-sm-4{padding:1.5rem!important}.p-sm-5{padding:3rem!important}.px-sm-0{padding-right:0!important;padding-left:0!important}.px-sm-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-sm-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-sm-3{padding-right:1rem!important;padding-left:1rem!important}.px-sm-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-sm-5{padding-right:3rem!important;padding-left:3rem!important}.py-sm-0{padding-top:0!important;padding-bottom:0!important}.py-sm-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-sm-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-sm-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-sm-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-sm-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-sm-0{padding-top:0!important}.pt-sm-1{padding-top:.25rem!important}.pt-sm-2{padding-top:.5rem!important}.pt-sm-3{padding-top:1rem!important}.pt-sm-4{padding-top:1.5rem!important}.pt-sm-5{padding-top:3rem!important}.pe-sm-0{padding-right:0!important}.pe-sm-1{padding-right:.25rem!important}.pe-sm-2{padding-right:.5rem!important}.pe-sm-3{padding-right:1rem!important}.pe-sm-4{padding-right:1.5rem!important}.pe-sm-5{padding-right:3rem!important}.pb-sm-0{padding-bottom:0!important}.pb-sm-1{padding-bottom:.25rem!important}.pb-sm-2{padding-bottom:.5rem!important}.pb-sm-3{padding-bottom:1rem!important}.pb-sm-4{padding-bottom:1.5rem!important}.pb-sm-5{padding-bottom:3rem!important}.ps-sm-0{padding-left:0!important}.ps-sm-1{padding-left:.25rem!important}.ps-sm-2{padding-left:.5rem!important}.ps-sm-3{padding-left:1rem!important}.ps-sm-4{padding-left:1.5rem!important}.ps-sm-5{padding-left:3rem!important}.gap-sm-0{gap:0!important}.gap-sm-1{gap:.25rem!important}.gap-sm-2{gap:.5rem!important}.gap-sm-3{gap:1rem!important}.gap-sm-4{gap:1.5rem!important}.gap-sm-5{gap:3rem!important}.row-gap-sm-0{row-gap:0!important}.row-gap-sm-1{row-gap:.25rem!important}.row-gap-sm-2{row-gap:.5rem!important}.row-gap-sm-3{row-gap:1rem!important}.row-gap-sm-4{row-gap:1.5rem!important}.row-gap-sm-5{row-gap:3rem!important}.column-gap-sm-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-sm-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-sm-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-sm-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-sm-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-sm-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-sm-start{text-align:left!important}.text-sm-end{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.float-md-start{float:left!important}.float-md-end{float:right!important}.float-md-none{float:none!important}.object-fit-md-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-md-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-md-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-md-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-md-none{-o-object-fit:none!important;object-fit:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-grid{display:grid!important}.d-md-inline-grid{display:inline-grid!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}.d-md-none{display:none!important}.flex-md-fill{flex:1 1 auto!important}.flex-md-row{flex-direction:row!important}.flex-md-column{flex-direction:column!important}.flex-md-row-reverse{flex-direction:row-reverse!important}.flex-md-column-reverse{flex-direction:column-reverse!important}.flex-md-grow-0{flex-grow:0!important}.flex-md-grow-1{flex-grow:1!important}.flex-md-shrink-0{flex-shrink:0!important}.flex-md-shrink-1{flex-shrink:1!important}.flex-md-wrap{flex-wrap:wrap!important}.flex-md-nowrap{flex-wrap:nowrap!important}.flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-md-start{justify-content:flex-start!important}.justify-content-md-end{justify-content:flex-end!important}.justify-content-md-center{justify-content:center!important}.justify-content-md-between{justify-content:space-between!important}.justify-content-md-around{justify-content:space-around!important}.justify-content-md-evenly{justify-content:space-evenly!important}.align-items-md-start{align-items:flex-start!important}.align-items-md-end{align-items:flex-end!important}.align-items-md-center{align-items:center!important}.align-items-md-baseline{align-items:baseline!important}.align-items-md-stretch{align-items:stretch!important}.align-content-md-start{align-content:flex-start!important}.align-content-md-end{align-content:flex-end!important}.align-content-md-center{align-content:center!important}.align-content-md-between{align-content:space-between!important}.align-content-md-around{align-content:space-around!important}.align-content-md-stretch{align-content:stretch!important}.align-self-md-auto{align-self:auto!important}.align-self-md-start{align-self:flex-start!important}.align-self-md-end{align-self:flex-end!important}.align-self-md-center{align-self:center!important}.align-self-md-baseline{align-self:baseline!important}.align-self-md-stretch{align-self:stretch!important}.order-md-first{order:-1!important}.order-md-0{order:0!important}.order-md-1{order:1!important}.order-md-2{order:2!important}.order-md-3{order:3!important}.order-md-4{order:4!important}.order-md-5{order:5!important}.order-md-last{order:6!important}.m-md-0{margin:0!important}.m-md-1{margin:.25rem!important}.m-md-2{margin:.5rem!important}.m-md-3{margin:1rem!important}.m-md-4{margin:1.5rem!important}.m-md-5{margin:3rem!important}.m-md-auto{margin:auto!important}.mx-md-0{margin-right:0!important;margin-left:0!important}.mx-md-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-md-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-md-3{margin-right:1rem!important;margin-left:1rem!important}.mx-md-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-md-5{margin-right:3rem!important;margin-left:3rem!important}.mx-md-auto{margin-right:auto!important;margin-left:auto!important}.my-md-0{margin-top:0!important;margin-bottom:0!important}.my-md-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-md-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-md-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-md-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-md-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-md-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-md-0{margin-top:0!important}.mt-md-1{margin-top:.25rem!important}.mt-md-2{margin-top:.5rem!important}.mt-md-3{margin-top:1rem!important}.mt-md-4{margin-top:1.5rem!important}.mt-md-5{margin-top:3rem!important}.mt-md-auto{margin-top:auto!important}.me-md-0{margin-right:0!important}.me-md-1{margin-right:.25rem!important}.me-md-2{margin-right:.5rem!important}.me-md-3{margin-right:1rem!important}.me-md-4{margin-right:1.5rem!important}.me-md-5{margin-right:3rem!important}.me-md-auto{margin-right:auto!important}.mb-md-0{margin-bottom:0!important}.mb-md-1{margin-bottom:.25rem!important}.mb-md-2{margin-bottom:.5rem!important}.mb-md-3{margin-bottom:1rem!important}.mb-md-4{margin-bottom:1.5rem!important}.mb-md-5{margin-bottom:3rem!important}.mb-md-auto{margin-bottom:auto!important}.ms-md-0{margin-left:0!important}.ms-md-1{margin-left:.25rem!important}.ms-md-2{margin-left:.5rem!important}.ms-md-3{margin-left:1rem!important}.ms-md-4{margin-left:1.5rem!important}.ms-md-5{margin-left:3rem!important}.ms-md-auto{margin-left:auto!important}.p-md-0{padding:0!important}.p-md-1{padding:.25rem!important}.p-md-2{padding:.5rem!important}.p-md-3{padding:1rem!important}.p-md-4{padding:1.5rem!important}.p-md-5{padding:3rem!important}.px-md-0{padding-right:0!important;padding-left:0!important}.px-md-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-md-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-md-3{padding-right:1rem!important;padding-left:1rem!important}.px-md-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-md-5{padding-right:3rem!important;padding-left:3rem!important}.py-md-0{padding-top:0!important;padding-bottom:0!important}.py-md-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-md-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-md-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-md-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-md-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-md-0{padding-top:0!important}.pt-md-1{padding-top:.25rem!important}.pt-md-2{padding-top:.5rem!important}.pt-md-3{padding-top:1rem!important}.pt-md-4{padding-top:1.5rem!important}.pt-md-5{padding-top:3rem!important}.pe-md-0{padding-right:0!important}.pe-md-1{padding-right:.25rem!important}.pe-md-2{padding-right:.5rem!important}.pe-md-3{padding-right:1rem!important}.pe-md-4{padding-right:1.5rem!important}.pe-md-5{padding-right:3rem!important}.pb-md-0{padding-bottom:0!important}.pb-md-1{padding-bottom:.25rem!important}.pb-md-2{padding-bottom:.5rem!important}.pb-md-3{padding-bottom:1rem!important}.pb-md-4{padding-bottom:1.5rem!important}.pb-md-5{padding-bottom:3rem!important}.ps-md-0{padding-left:0!important}.ps-md-1{padding-left:.25rem!important}.ps-md-2{padding-left:.5rem!important}.ps-md-3{padding-left:1rem!important}.ps-md-4{padding-left:1.5rem!important}.ps-md-5{padding-left:3rem!important}.gap-md-0{gap:0!important}.gap-md-1{gap:.25rem!important}.gap-md-2{gap:.5rem!important}.gap-md-3{gap:1rem!important}.gap-md-4{gap:1.5rem!important}.gap-md-5{gap:3rem!important}.row-gap-md-0{row-gap:0!important}.row-gap-md-1{row-gap:.25rem!important}.row-gap-md-2{row-gap:.5rem!important}.row-gap-md-3{row-gap:1rem!important}.row-gap-md-4{row-gap:1.5rem!important}.row-gap-md-5{row-gap:3rem!important}.column-gap-md-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-md-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-md-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-md-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-md-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-md-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-md-start{text-align:left!important}.text-md-end{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.float-lg-start{float:left!important}.float-lg-end{float:right!important}.float-lg-none{float:none!important}.object-fit-lg-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-lg-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-lg-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-lg-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-lg-none{-o-object-fit:none!important;object-fit:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-grid{display:grid!important}.d-lg-inline-grid{display:inline-grid!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}.d-lg-none{display:none!important}.flex-lg-fill{flex:1 1 auto!important}.flex-lg-row{flex-direction:row!important}.flex-lg-column{flex-direction:column!important}.flex-lg-row-reverse{flex-direction:row-reverse!important}.flex-lg-column-reverse{flex-direction:column-reverse!important}.flex-lg-grow-0{flex-grow:0!important}.flex-lg-grow-1{flex-grow:1!important}.flex-lg-shrink-0{flex-shrink:0!important}.flex-lg-shrink-1{flex-shrink:1!important}.flex-lg-wrap{flex-wrap:wrap!important}.flex-lg-nowrap{flex-wrap:nowrap!important}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-lg-start{justify-content:flex-start!important}.justify-content-lg-end{justify-content:flex-end!important}.justify-content-lg-center{justify-content:center!important}.justify-content-lg-between{justify-content:space-between!important}.justify-content-lg-around{justify-content:space-around!important}.justify-content-lg-evenly{justify-content:space-evenly!important}.align-items-lg-start{align-items:flex-start!important}.align-items-lg-end{align-items:flex-end!important}.align-items-lg-center{align-items:center!important}.align-items-lg-baseline{align-items:baseline!important}.align-items-lg-stretch{align-items:stretch!important}.align-content-lg-start{align-content:flex-start!important}.align-content-lg-end{align-content:flex-end!important}.align-content-lg-center{align-content:center!important}.align-content-lg-between{align-content:space-between!important}.align-content-lg-around{align-content:space-around!important}.align-content-lg-stretch{align-content:stretch!important}.align-self-lg-auto{align-self:auto!important}.align-self-lg-start{align-self:flex-start!important}.align-self-lg-end{align-self:flex-end!important}.align-self-lg-center{align-self:center!important}.align-self-lg-baseline{align-self:baseline!important}.align-self-lg-stretch{align-self:stretch!important}.order-lg-first{order:-1!important}.order-lg-0{order:0!important}.order-lg-1{order:1!important}.order-lg-2{order:2!important}.order-lg-3{order:3!important}.order-lg-4{order:4!important}.order-lg-5{order:5!important}.order-lg-last{order:6!important}.m-lg-0{margin:0!important}.m-lg-1{margin:.25rem!important}.m-lg-2{margin:.5rem!important}.m-lg-3{margin:1rem!important}.m-lg-4{margin:1.5rem!important}.m-lg-5{margin:3rem!important}.m-lg-auto{margin:auto!important}.mx-lg-0{margin-right:0!important;margin-left:0!important}.mx-lg-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-lg-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-lg-3{margin-right:1rem!important;margin-left:1rem!important}.mx-lg-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-lg-5{margin-right:3rem!important;margin-left:3rem!important}.mx-lg-auto{margin-right:auto!important;margin-left:auto!important}.my-lg-0{margin-top:0!important;margin-bottom:0!important}.my-lg-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-lg-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-lg-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-lg-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-lg-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-lg-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-lg-0{margin-top:0!important}.mt-lg-1{margin-top:.25rem!important}.mt-lg-2{margin-top:.5rem!important}.mt-lg-3{margin-top:1rem!important}.mt-lg-4{margin-top:1.5rem!important}.mt-lg-5{margin-top:3rem!important}.mt-lg-auto{margin-top:auto!important}.me-lg-0{margin-right:0!important}.me-lg-1{margin-right:.25rem!important}.me-lg-2{margin-right:.5rem!important}.me-lg-3{margin-right:1rem!important}.me-lg-4{margin-right:1.5rem!important}.me-lg-5{margin-right:3rem!important}.me-lg-auto{margin-right:auto!important}.mb-lg-0{margin-bottom:0!important}.mb-lg-1{margin-bottom:.25rem!important}.mb-lg-2{margin-bottom:.5rem!important}.mb-lg-3{margin-bottom:1rem!important}.mb-lg-4{margin-bottom:1.5rem!important}.mb-lg-5{margin-bottom:3rem!important}.mb-lg-auto{margin-bottom:auto!important}.ms-lg-0{margin-left:0!important}.ms-lg-1{margin-left:.25rem!important}.ms-lg-2{margin-left:.5rem!important}.ms-lg-3{margin-left:1rem!important}.ms-lg-4{margin-left:1.5rem!important}.ms-lg-5{margin-left:3rem!important}.ms-lg-auto{margin-left:auto!important}.p-lg-0{padding:0!important}.p-lg-1{padding:.25rem!important}.p-lg-2{padding:.5rem!important}.p-lg-3{padding:1rem!important}.p-lg-4{padding:1.5rem!important}.p-lg-5{padding:3rem!important}.px-lg-0{padding-right:0!important;padding-left:0!important}.px-lg-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-lg-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-lg-3{padding-right:1rem!important;padding-left:1rem!important}.px-lg-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-lg-5{padding-right:3rem!important;padding-left:3rem!important}.py-lg-0{padding-top:0!important;padding-bottom:0!important}.py-lg-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-lg-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-lg-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-lg-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-lg-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-lg-0{padding-top:0!important}.pt-lg-1{padding-top:.25rem!important}.pt-lg-2{padding-top:.5rem!important}.pt-lg-3{padding-top:1rem!important}.pt-lg-4{padding-top:1.5rem!important}.pt-lg-5{padding-top:3rem!important}.pe-lg-0{padding-right:0!important}.pe-lg-1{padding-right:.25rem!important}.pe-lg-2{padding-right:.5rem!important}.pe-lg-3{padding-right:1rem!important}.pe-lg-4{padding-right:1.5rem!important}.pe-lg-5{padding-right:3rem!important}.pb-lg-0{padding-bottom:0!important}.pb-lg-1{padding-bottom:.25rem!important}.pb-lg-2{padding-bottom:.5rem!important}.pb-lg-3{padding-bottom:1rem!important}.pb-lg-4{padding-bottom:1.5rem!important}.pb-lg-5{padding-bottom:3rem!important}.ps-lg-0{padding-left:0!important}.ps-lg-1{padding-left:.25rem!important}.ps-lg-2{padding-left:.5rem!important}.ps-lg-3{padding-left:1rem!important}.ps-lg-4{padding-left:1.5rem!important}.ps-lg-5{padding-left:3rem!important}.gap-lg-0{gap:0!important}.gap-lg-1{gap:.25rem!important}.gap-lg-2{gap:.5rem!important}.gap-lg-3{gap:1rem!important}.gap-lg-4{gap:1.5rem!important}.gap-lg-5{gap:3rem!important}.row-gap-lg-0{row-gap:0!important}.row-gap-lg-1{row-gap:.25rem!important}.row-gap-lg-2{row-gap:.5rem!important}.row-gap-lg-3{row-gap:1rem!important}.row-gap-lg-4{row-gap:1.5rem!important}.row-gap-lg-5{row-gap:3rem!important}.column-gap-lg-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-lg-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-lg-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-lg-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-lg-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-lg-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-lg-start{text-align:left!important}.text-lg-end{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.float-xl-start{float:left!important}.float-xl-end{float:right!important}.float-xl-none{float:none!important}.object-fit-xl-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-xl-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-xl-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-xl-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-xl-none{-o-object-fit:none!important;object-fit:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-grid{display:grid!important}.d-xl-inline-grid{display:inline-grid!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}.d-xl-none{display:none!important}.flex-xl-fill{flex:1 1 auto!important}.flex-xl-row{flex-direction:row!important}.flex-xl-column{flex-direction:column!important}.flex-xl-row-reverse{flex-direction:row-reverse!important}.flex-xl-column-reverse{flex-direction:column-reverse!important}.flex-xl-grow-0{flex-grow:0!important}.flex-xl-grow-1{flex-grow:1!important}.flex-xl-shrink-0{flex-shrink:0!important}.flex-xl-shrink-1{flex-shrink:1!important}.flex-xl-wrap{flex-wrap:wrap!important}.flex-xl-nowrap{flex-wrap:nowrap!important}.flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xl-start{justify-content:flex-start!important}.justify-content-xl-end{justify-content:flex-end!important}.justify-content-xl-center{justify-content:center!important}.justify-content-xl-between{justify-content:space-between!important}.justify-content-xl-around{justify-content:space-around!important}.justify-content-xl-evenly{justify-content:space-evenly!important}.align-items-xl-start{align-items:flex-start!important}.align-items-xl-end{align-items:flex-end!important}.align-items-xl-center{align-items:center!important}.align-items-xl-baseline{align-items:baseline!important}.align-items-xl-stretch{align-items:stretch!important}.align-content-xl-start{align-content:flex-start!important}.align-content-xl-end{align-content:flex-end!important}.align-content-xl-center{align-content:center!important}.align-content-xl-between{align-content:space-between!important}.align-content-xl-around{align-content:space-around!important}.align-content-xl-stretch{align-content:stretch!important}.align-self-xl-auto{align-self:auto!important}.align-self-xl-start{align-self:flex-start!important}.align-self-xl-end{align-self:flex-end!important}.align-self-xl-center{align-self:center!important}.align-self-xl-baseline{align-self:baseline!important}.align-self-xl-stretch{align-self:stretch!important}.order-xl-first{order:-1!important}.order-xl-0{order:0!important}.order-xl-1{order:1!important}.order-xl-2{order:2!important}.order-xl-3{order:3!important}.order-xl-4{order:4!important}.order-xl-5{order:5!important}.order-xl-last{order:6!important}.m-xl-0{margin:0!important}.m-xl-1{margin:.25rem!important}.m-xl-2{margin:.5rem!important}.m-xl-3{margin:1rem!important}.m-xl-4{margin:1.5rem!important}.m-xl-5{margin:3rem!important}.m-xl-auto{margin:auto!important}.mx-xl-0{margin-right:0!important;margin-left:0!important}.mx-xl-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xl-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xl-3{margin-right:1rem!important;margin-left:1rem!important}.mx-xl-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xl-5{margin-right:3rem!important;margin-left:3rem!important}.mx-xl-auto{margin-right:auto!important;margin-left:auto!important}.my-xl-0{margin-top:0!important;margin-bottom:0!important}.my-xl-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xl-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xl-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-xl-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xl-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-xl-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-xl-0{margin-top:0!important}.mt-xl-1{margin-top:.25rem!important}.mt-xl-2{margin-top:.5rem!important}.mt-xl-3{margin-top:1rem!important}.mt-xl-4{margin-top:1.5rem!important}.mt-xl-5{margin-top:3rem!important}.mt-xl-auto{margin-top:auto!important}.me-xl-0{margin-right:0!important}.me-xl-1{margin-right:.25rem!important}.me-xl-2{margin-right:.5rem!important}.me-xl-3{margin-right:1rem!important}.me-xl-4{margin-right:1.5rem!important}.me-xl-5{margin-right:3rem!important}.me-xl-auto{margin-right:auto!important}.mb-xl-0{margin-bottom:0!important}.mb-xl-1{margin-bottom:.25rem!important}.mb-xl-2{margin-bottom:.5rem!important}.mb-xl-3{margin-bottom:1rem!important}.mb-xl-4{margin-bottom:1.5rem!important}.mb-xl-5{margin-bottom:3rem!important}.mb-xl-auto{margin-bottom:auto!important}.ms-xl-0{margin-left:0!important}.ms-xl-1{margin-left:.25rem!important}.ms-xl-2{margin-left:.5rem!important}.ms-xl-3{margin-left:1rem!important}.ms-xl-4{margin-left:1.5rem!important}.ms-xl-5{margin-left:3rem!important}.ms-xl-auto{margin-left:auto!important}.p-xl-0{padding:0!important}.p-xl-1{padding:.25rem!important}.p-xl-2{padding:.5rem!important}.p-xl-3{padding:1rem!important}.p-xl-4{padding:1.5rem!important}.p-xl-5{padding:3rem!important}.px-xl-0{padding-right:0!important;padding-left:0!important}.px-xl-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-xl-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-xl-3{padding-right:1rem!important;padding-left:1rem!important}.px-xl-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xl-5{padding-right:3rem!important;padding-left:3rem!important}.py-xl-0{padding-top:0!important;padding-bottom:0!important}.py-xl-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xl-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xl-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-xl-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xl-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xl-0{padding-top:0!important}.pt-xl-1{padding-top:.25rem!important}.pt-xl-2{padding-top:.5rem!important}.pt-xl-3{padding-top:1rem!important}.pt-xl-4{padding-top:1.5rem!important}.pt-xl-5{padding-top:3rem!important}.pe-xl-0{padding-right:0!important}.pe-xl-1{padding-right:.25rem!important}.pe-xl-2{padding-right:.5rem!important}.pe-xl-3{padding-right:1rem!important}.pe-xl-4{padding-right:1.5rem!important}.pe-xl-5{padding-right:3rem!important}.pb-xl-0{padding-bottom:0!important}.pb-xl-1{padding-bottom:.25rem!important}.pb-xl-2{padding-bottom:.5rem!important}.pb-xl-3{padding-bottom:1rem!important}.pb-xl-4{padding-bottom:1.5rem!important}.pb-xl-5{padding-bottom:3rem!important}.ps-xl-0{padding-left:0!important}.ps-xl-1{padding-left:.25rem!important}.ps-xl-2{padding-left:.5rem!important}.ps-xl-3{padding-left:1rem!important}.ps-xl-4{padding-left:1.5rem!important}.ps-xl-5{padding-left:3rem!important}.gap-xl-0{gap:0!important}.gap-xl-1{gap:.25rem!important}.gap-xl-2{gap:.5rem!important}.gap-xl-3{gap:1rem!important}.gap-xl-4{gap:1.5rem!important}.gap-xl-5{gap:3rem!important}.row-gap-xl-0{row-gap:0!important}.row-gap-xl-1{row-gap:.25rem!important}.row-gap-xl-2{row-gap:.5rem!important}.row-gap-xl-3{row-gap:1rem!important}.row-gap-xl-4{row-gap:1.5rem!important}.row-gap-xl-5{row-gap:3rem!important}.column-gap-xl-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-xl-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-xl-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-xl-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-xl-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-xl-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-xl-start{text-align:left!important}.text-xl-end{text-align:right!important}.text-xl-center{text-align:center!important}}@media (min-width:1400px){.float-xxl-start{float:left!important}.float-xxl-end{float:right!important}.float-xxl-none{float:none!important}.object-fit-xxl-contain{-o-object-fit:contain!important;object-fit:contain!important}.object-fit-xxl-cover{-o-object-fit:cover!important;object-fit:cover!important}.object-fit-xxl-fill{-o-object-fit:fill!important;object-fit:fill!important}.object-fit-xxl-scale{-o-object-fit:scale-down!important;object-fit:scale-down!important}.object-fit-xxl-none{-o-object-fit:none!important;object-fit:none!important}.d-xxl-inline{display:inline!important}.d-xxl-inline-block{display:inline-block!important}.d-xxl-block{display:block!important}.d-xxl-grid{display:grid!important}.d-xxl-inline-grid{display:inline-grid!important}.d-xxl-table{display:table!important}.d-xxl-table-row{display:table-row!important}.d-xxl-table-cell{display:table-cell!important}.d-xxl-flex{display:flex!important}.d-xxl-inline-flex{display:inline-flex!important}.d-xxl-none{display:none!important}.flex-xxl-fill{flex:1 1 auto!important}.flex-xxl-row{flex-direction:row!important}.flex-xxl-column{flex-direction:column!important}.flex-xxl-row-reverse{flex-direction:row-reverse!important}.flex-xxl-column-reverse{flex-direction:column-reverse!important}.flex-xxl-grow-0{flex-grow:0!important}.flex-xxl-grow-1{flex-grow:1!important}.flex-xxl-shrink-0{flex-shrink:0!important}.flex-xxl-shrink-1{flex-shrink:1!important}.flex-xxl-wrap{flex-wrap:wrap!important}.flex-xxl-nowrap{flex-wrap:nowrap!important}.flex-xxl-wrap-reverse{flex-wrap:wrap-reverse!important}.justify-content-xxl-start{justify-content:flex-start!important}.justify-content-xxl-end{justify-content:flex-end!important}.justify-content-xxl-center{justify-content:center!important}.justify-content-xxl-between{justify-content:space-between!important}.justify-content-xxl-around{justify-content:space-around!important}.justify-content-xxl-evenly{justify-content:space-evenly!important}.align-items-xxl-start{align-items:flex-start!important}.align-items-xxl-end{align-items:flex-end!important}.align-items-xxl-center{align-items:center!important}.align-items-xxl-baseline{align-items:baseline!important}.align-items-xxl-stretch{align-items:stretch!important}.align-content-xxl-start{align-content:flex-start!important}.align-content-xxl-end{align-content:flex-end!important}.align-content-xxl-center{align-content:center!important}.align-content-xxl-between{align-content:space-between!important}.align-content-xxl-around{align-content:space-around!important}.align-content-xxl-stretch{align-content:stretch!important}.align-self-xxl-auto{align-self:auto!important}.align-self-xxl-start{align-self:flex-start!important}.align-self-xxl-end{align-self:flex-end!important}.align-self-xxl-center{align-self:center!important}.align-self-xxl-baseline{align-self:baseline!important}.align-self-xxl-stretch{align-self:stretch!important}.order-xxl-first{order:-1!important}.order-xxl-0{order:0!important}.order-xxl-1{order:1!important}.order-xxl-2{order:2!important}.order-xxl-3{order:3!important}.order-xxl-4{order:4!important}.order-xxl-5{order:5!important}.order-xxl-last{order:6!important}.m-xxl-0{margin:0!important}.m-xxl-1{margin:.25rem!important}.m-xxl-2{margin:.5rem!important}.m-xxl-3{margin:1rem!important}.m-xxl-4{margin:1.5rem!important}.m-xxl-5{margin:3rem!important}.m-xxl-auto{margin:auto!important}.mx-xxl-0{margin-right:0!important;margin-left:0!important}.mx-xxl-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-xxl-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-xxl-3{margin-right:1rem!important;margin-left:1rem!important}.mx-xxl-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-xxl-5{margin-right:3rem!important;margin-left:3rem!important}.mx-xxl-auto{margin-right:auto!important;margin-left:auto!important}.my-xxl-0{margin-top:0!important;margin-bottom:0!important}.my-xxl-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-xxl-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-xxl-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-xxl-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-xxl-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-xxl-auto{margin-top:auto!important;margin-bottom:auto!important}.mt-xxl-0{margin-top:0!important}.mt-xxl-1{margin-top:.25rem!important}.mt-xxl-2{margin-top:.5rem!important}.mt-xxl-3{margin-top:1rem!important}.mt-xxl-4{margin-top:1.5rem!important}.mt-xxl-5{margin-top:3rem!important}.mt-xxl-auto{margin-top:auto!important}.me-xxl-0{margin-right:0!important}.me-xxl-1{margin-right:.25rem!important}.me-xxl-2{margin-right:.5rem!important}.me-xxl-3{margin-right:1rem!important}.me-xxl-4{margin-right:1.5rem!important}.me-xxl-5{margin-right:3rem!important}.me-xxl-auto{margin-right:auto!important}.mb-xxl-0{margin-bottom:0!important}.mb-xxl-1{margin-bottom:.25rem!important}.mb-xxl-2{margin-bottom:.5rem!important}.mb-xxl-3{margin-bottom:1rem!important}.mb-xxl-4{margin-bottom:1.5rem!important}.mb-xxl-5{margin-bottom:3rem!important}.mb-xxl-auto{margin-bottom:auto!important}.ms-xxl-0{margin-left:0!important}.ms-xxl-1{margin-left:.25rem!important}.ms-xxl-2{margin-left:.5rem!important}.ms-xxl-3{margin-left:1rem!important}.ms-xxl-4{margin-left:1.5rem!important}.ms-xxl-5{margin-left:3rem!important}.ms-xxl-auto{margin-left:auto!important}.p-xxl-0{padding:0!important}.p-xxl-1{padding:.25rem!important}.p-xxl-2{padding:.5rem!important}.p-xxl-3{padding:1rem!important}.p-xxl-4{padding:1.5rem!important}.p-xxl-5{padding:3rem!important}.px-xxl-0{padding-right:0!important;padding-left:0!important}.px-xxl-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-xxl-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-xxl-3{padding-right:1rem!important;padding-left:1rem!important}.px-xxl-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-xxl-5{padding-right:3rem!important;padding-left:3rem!important}.py-xxl-0{padding-top:0!important;padding-bottom:0!important}.py-xxl-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-xxl-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-xxl-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-xxl-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-xxl-5{padding-top:3rem!important;padding-bottom:3rem!important}.pt-xxl-0{padding-top:0!important}.pt-xxl-1{padding-top:.25rem!important}.pt-xxl-2{padding-top:.5rem!important}.pt-xxl-3{padding-top:1rem!important}.pt-xxl-4{padding-top:1.5rem!important}.pt-xxl-5{padding-top:3rem!important}.pe-xxl-0{padding-right:0!important}.pe-xxl-1{padding-right:.25rem!important}.pe-xxl-2{padding-right:.5rem!important}.pe-xxl-3{padding-right:1rem!important}.pe-xxl-4{padding-right:1.5rem!important}.pe-xxl-5{padding-right:3rem!important}.pb-xxl-0{padding-bottom:0!important}.pb-xxl-1{padding-bottom:.25rem!important}.pb-xxl-2{padding-bottom:.5rem!important}.pb-xxl-3{padding-bottom:1rem!important}.pb-xxl-4{padding-bottom:1.5rem!important}.pb-xxl-5{padding-bottom:3rem!important}.ps-xxl-0{padding-left:0!important}.ps-xxl-1{padding-left:.25rem!important}.ps-xxl-2{padding-left:.5rem!important}.ps-xxl-3{padding-left:1rem!important}.ps-xxl-4{padding-left:1.5rem!important}.ps-xxl-5{padding-left:3rem!important}.gap-xxl-0{gap:0!important}.gap-xxl-1{gap:.25rem!important}.gap-xxl-2{gap:.5rem!important}.gap-xxl-3{gap:1rem!important}.gap-xxl-4{gap:1.5rem!important}.gap-xxl-5{gap:3rem!important}.row-gap-xxl-0{row-gap:0!important}.row-gap-xxl-1{row-gap:.25rem!important}.row-gap-xxl-2{row-gap:.5rem!important}.row-gap-xxl-3{row-gap:1rem!important}.row-gap-xxl-4{row-gap:1.5rem!important}.row-gap-xxl-5{row-gap:3rem!important}.column-gap-xxl-0{-moz-column-gap:0!important;column-gap:0!important}.column-gap-xxl-1{-moz-column-gap:0.25rem!important;column-gap:.25rem!important}.column-gap-xxl-2{-moz-column-gap:0.5rem!important;column-gap:.5rem!important}.column-gap-xxl-3{-moz-column-gap:1rem!important;column-gap:1rem!important}.column-gap-xxl-4{-moz-column-gap:1.5rem!important;column-gap:1.5rem!important}.column-gap-xxl-5{-moz-column-gap:3rem!important;column-gap:3rem!important}.text-xxl-start{text-align:left!important}.text-xxl-end{text-align:right!important}.text-xxl-center{text-align:center!important}}@media (min-width:1200px){.fs-1{font-size:2.5rem!important}.fs-2{font-size:2rem!important}.fs-3{font-size:1.75rem!important}.fs-4{font-size:1.5rem!important}}@media print{.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-grid{display:grid!important}.d-print-inline-grid{display:inline-grid!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}.d-print-none{display:none!important}}\n/*# sourceMappingURL=bootstrap.min.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
